import _slicedToArray from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toConsumableArray from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["cleanWorryFree"],
  _excluded2 = ["anonymouUser"],
  _excluded3 = ["totalOneTimeCalculatedPrice", "totalRecurringCalculatedPrice", "oneTimeCalculatedPrices"],
  _excluded4 = ["contactId", "allocationId", "allocationStatus", "isOrderConfirm"],
  _excluded5 = ["contactId"],
  _excluded6 = ["skuId"],
  _excluded7 = ["quoteInfo", "deliveryAddress"],
  _excluded8 = ["type"],
  _excluded9 = ["contactExists", "contactId"],
  _excluded10 = ["voucherIds"],
  _excluded11 = ["voucherIds"];
var _d2;
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e106) { throw _e106; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e107) { didErr = true; err = _e107; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import "core-js/modules/esnext.global-this.js";
import "core-js/modules/esnext.string.replace-all.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/regenerator/index.js";
var e = process.env.GATSBY_MCSS_HOST,
  t = process.env.GATSBY_MCSS_SUB_DOMAIN,
  r = "true" === process.env.GATSBY_APIGEE_GATE_MANAGER,
  n = {
    SUCCESS: "SUCCESS"
  },
  o = {
    SINGTEL: "SINGTEL"
  },
  i = "".concat(e, "/").concat(t),
  a = "D2519",
  c = "5G3IN1",
  d = (_d2 = {
    "3IN1": "381187130N"
  }, _defineProperty(_d2, c, "381187630N"), _defineProperty(_d2, "eSIM5GPost", null), _d2),
  s = {
    DEVICE_CONTRACT_END_DATE: "8692",
    DEVICE_CONTRACT_START_DATE: "8682",
    SERVICE_CONTRACT_END_DATE: "8252",
    SERVICE_CONTRACT_START_DATE: "8242",
    SERVICE_CONTRACT_DURATION: "8232",
    CI_STATUS: "8469052",
    CI_STATUS_6: "8425832",
    CI_STATUS_12: "8425842",
    CI_STATUS_18: "8425852",
    CI_STATUS_21: "8425862",
    PLAN_SERVICES_ITEM: "8026582"
  },
  u = ["12022", "19363151", "4531655", "4561405", "4681825", "4620925", "4650795"],
  l = ["8472832", "4681805", "4650775", "4620905"],
  p = ["8178471", "8622642"],
  I = ["9722", "9609763", "9610343", "9610243", "8625512", "8635202", "9607933", "9607833", "12650391", "11982", "12374571", "14396101", "8613482", "9622523", "9622623", "10247821", "8625502", "8625472", "8625492", "8625532", "8625582", "14396081", "12358201", "12360611", "8472832", "18659731", "18661641", "18733721", "18727471", "18659731", "14438091", "8472632", "18985921", "4140405"].concat(l),
  m = ["9722", "9609763", "9610343", "9610243", "8625512", "8635202", "9607933", "9607833", "12650391", "11982", "12374571", "14396101", "8613482", "9622523", "9622623", "10247821", "8625502", "8625472", "8625492", "8625532", "8625582", "14396081", "12358201", "12360611", "8472832", "18659731", "18661641", "18733721", "18727471", "18659731", "14438091", "8472632", "18985921", "10141011", "4140405", "11952", "17987931"].concat(l),
  E = ["11495061", "11495051", "8635122", "8635142", "17498491", "18708221", "26560004", "17498471", "17498451", "17498461", "17498481"],
  R = ["2448236", "71957955"],
  S = {
    rebate: "Rebate",
    immediate: "Immediate"
  },
  _ = {
    "National Registration ID Card (NRIC)": "NRIC",
    "Foreign Identification Number (FIN)": "4",
    "Foreigner Dependent Pass": "4",
    "Foreigner Employment Pass": "4",
    "Foreigner S Pass": "4",
    "Foreigner Student Pass": "4",
    "Passport Number": "6",
    "Foreigner Social Visit Pass": "7",
    "Foreigner Work Permit": "4",
    Diplomat: "600",
    Others: "99"
  },
  O = {
    "National Registration ID Card (NRIC)": "National Registration Identity Card",
    FIN: "FIN",
    "Foreign Identification Number (FIN)": "Foreign Identification Number",
    "Foreigner Dependent Pass": "Dependent Pass",
    "Foreigner Employment Pass": "Employment Pass",
    "Foreigner S Pass": "Special Pass",
    "Foreigner Student Pass": "Student Pass",
    "Passport Number": "Passport Number",
    "Foreigner Social Visit Pass": "Social Visit Pass / Long Term Visit Pass",
    "Foreigner Work Permit": "Work Permit",
    Diplomat: "Diplomat Pass",
    "Entre Pass": "EntrePass",
    "Non-diplomatic": "Non Diplomat Pass",
    "Unique Entity Number (UEN)": "Unique Entity Number (UEN)"
  },
  C = {
    "National Registration ID Card (NRIC)": "NRIC",
    "Foreign Identification Number": "NRIC",
    "Foreign Identification Number (FIN)": "FIN",
    "Foreigner Dependent Pass": "FDP",
    "Foreigner Employment Pass": "FEP",
    "Foreigner S Pass": "FSP",
    "Foreigner Student Pass": "FSTP",
    "Passport Number": "PASSPORT",
    "Foreigner Social Visit Pass": "VSVP",
    "Foreigner Work Permit": "FWP",
    Diplomat: "DIPLOMAT"
  },
  f = {
    E_BILL: {
      billType: "E_BILL",
      deliveryMethod: "METH_NON_PAPER",
      intFlowType: "ebill"
    },
    PAPER_BILL: {
      billType: "E_BILL",
      deliveryMethod: "METH_PAPER",
      intFlowType: "paperBill"
    }
  },
  y = {
    OPEN: "O",
    TENTATIVE: "T",
    INITIATE: "I"
  },
  T = {
    SINGTELPOSTPAID: "SINGTELPOSTPAID",
    SINGTELPREPAID: "SINGTELPREPAID",
    SUCCESS: "OTHER"
  },
  A = {
    Change: "CH",
    Remove: "RM",
    Add: "AD",
    Resume: "RS",
    Suspend: "SU",
    Reestablish: "ES"
  },
  D = {
    SPOTIFY: "SPOTIFY",
    APPLEMUSIC: "APPLEMUSIC"
  },
  P = {
    M: "M",
    RRP: "R",
    N: "N"
  },
  v = {
    M: "M",
    R: "RRP",
    N: "N"
  },
  h = {
    LOGISTIC: {
      RRP: 2,
      OTHER: 2
    },
    SELF_COLLECTION: {
      RRP: 2,
      OTHER: 1
    }
  };
var g = Object.freeze({
    __proto__: null,
    baseHost: e,
    mcssSubDomain: t,
    apigeeAuthToken: "ApigeeAuthToken",
    deviceAgentId: "visitor-agent-id",
    apigeeContentType: "application/x-www-form-urlencoded",
    apigeeClientCredentials: "grant_type=client_credentials",
    clientID: "SPRINGD",
    apigeeGateManagerEnabled: r,
    mcssResult: n,
    rrpPromoType: {
      STOCKCODE: "StockCode",
      WAIVER: "Waiver"
    },
    rrpPromoSubType: {
      ATL: "ATL",
      COUPON: "COUPON"
    },
    rrpVendor: o,
    baseUrl: i,
    dealerId: a,
    vendorId: "T0001",
    dataProductSpecContainmentId: "9742",
    queryParamsSC: "SS",
    queryParamsLO: "en_US",
    simCardNfcAttributeId: 10382891,
    simCard3In1AttributeId: "8022652",
    simCardLogicalResourceAttributeId: 132395,
    simCardSerialAttributeId: "8858992",
    simCardProductSpecContainmentId: "8363722",
    simCardSku: "381187130N",
    simCard5GSku: "381187630N",
    simCatalogItemId: "8027872",
    simType4G: "3IN1",
    simType5G: c,
    simTypeESim: "eSIM5GPost",
    physicalFeeName: "SIM CARD FEE",
    eSIMFeeName: "ESIM FEE",
    simTypeToStockCode: d,
    isReservedCharacteristicId: "8425972",
    reservationCharacteristicId: "8425962",
    storeCharacteristicId: "8322",
    collectNowCharacteristicId: "8302",
    catalogIds: s,
    staffProductSpecContainmentId: "11822",
    cisProductSpecContainmentId: "11762",
    cisCompanyBrnCharacteristicId: 8480012,
    cisCompanyNameCharacteristicId: 8582,
    cisChildCompanyNameCharacteristicId: 8592,
    silverComponentCharacteristicId: "2089835",
    deviceCareProductSpecContainmentId: "8472632",
    planProductSpecContainmentId: "8363712",
    discountStockProductSpecContainmentId: "10381311",
    dataXProductSpecContainmentId: "14438091",
    dataXContractProductSpecContainmentId: "14438101",
    freebieProductSpecContainmentId: u,
    voucherProductSpecContainmentId: "9117142",
    callerIDProductSpecContainmentId: "9722",
    tradeInProductSpecContainmentId: "11952",
    guaranteeTradeInProductSpecContainmentId: "4140405",
    accessoryProductSpecContainmentId: "17987931",
    bibRedemptionStartDateCharacteristicId: "4140525",
    bibRedemptionEndDateCharacteristicId: "4140535",
    imeiCharacteristicId: "8302",
    accessoryDeliveryMethodProductSpecCharacteristicId: "8182",
    accessoryStartDateProductSpecCharacteristicId: "8128572",
    accessoryEndDateProductSpecCharacteristicId: "8128562",
    accessoryMonthlyTermProductSpecCharacteristicId: "8034942",
    voucherCharacteristicID: "8511922",
    discountStockProductSpecCharacteristicId: "10383541",
    freebieProductSpecCharacteristicId: "8620482",
    discountAmountProductSpecCharacteristicId: "10381191",
    stockCodeProductSpecCharacteristicId: "8832",
    discountStockCodeProductSpecCharacteristicId: "10381181",
    mobileShareCharacteristicId: 8518342,
    deviceInformationContainmentId: "10482",
    mobileMainProductSpecContainmentId: "8363682",
    ciStatusProductSpecContainmentId: "8469052",
    numberPortabilityProductSpecContainmentId: "11812",
    deviceSkuProductSpecContainmentId: "8832",
    deviceBrandProductSpecContainmentId: "8842",
    deviceModelProductSpecContainmentId: "8852",
    deviceTradeInPriceProductSpecContainmentId: "8382",
    redemptionTypeCharacteristicId: "2852255",
    redemptionCharacteristicTypeImmediate: "Immediate",
    redemptionCharacteristicTypeRebate: "Rebate",
    voucherMonthlyTermCharacteristicId: "2852265",
    voucherStartDateCharacteristicId: "2852275",
    voucherEndDateCharacteristicId: "2852285",
    voucherAmountCharacteristicId: "10902231",
    voucherSummaryCharacteristicId: "8511912",
    mobileContentProductSpecContainmentId: "10141011",
    mobileContentProductSpecCharacteristicId: "10048781",
    orderSummaryPromoProductSpecCharacteristicID: "18059091",
    mifProductSpecContainmentId: "11982",
    mifProductCharacteristicId: "12373531",
    mifDecisionIndicatorId: "12373511",
    freeInternetFilterBoIds: ["12357521", "14652366", "12357531"],
    mbbProductTitleCap: "FREE MOBILE BROADBAND",
    appleCareProductSpecContainmentId: l,
    appleCareEmailCharacteristicIds: p,
    deviceChargesSpecPricingId: "8428912",
    deviceRepaymentSpecPricingId: "14253191",
    deviceRepaymentSpecPricingId2: "26208904",
    simOnlyOneTimeBillRebatePricingId: "4769425",
    equipmentProductSpecCharacteristicId: "8822",
    deviceCareProductSpecCharacteristicId: "8607542",
    deviceContractProductSpecCharacteristicId: "12012",
    serviceContractProductSpecCharacteristicId: "11782",
    dataXProductSpecCharacteristicId: "14438091",
    addonContractStartDateProductSpecCharacteristicId: "8242",
    addonContractEndDateProductSpecCharacteristicId: "8252",
    mbbProductSpecPricingId: "71957955",
    monthlyTermCharacteristicId: "8272",
    paymentSolutionCharacteristicId: "13897781",
    paymentSolutionCharacteristicTypeInstalments: "Instalments",
    paymentSolutionCharacteristicTypeUpfront: "Upfront",
    deviceStartDateProductSpecCharacteristicId: "8022112",
    ippSpecPricingId: "14317891",
    ippSpecPricingId2: "19226141",
    cisMonthlySubsProductSpecCharacteristicId: "8478572",
    voiceProductSpecContainmentId: "9732",
    contractDurProductSpecContainmentId1: "12102",
    contractDurProductSpecContainmentId2: "10026181",
    campaignProductSpecContainmentId: "18059161",
    specialDiscProductSpecContainmentId: "9404693",
    freebieSpecPricingId: "13674081",
    promoDescSpecPricingId1: "11337471",
    promoDescSpecPricingId2: "11344731",
    promoDescSpecPricingId3: "11343321",
    addComponentList: I,
    removeComponentList: m,
    removeExistingProductsList: ["2175705", "2175805", "2175815"],
    removeParentForLastChildList: E,
    disableDisplayInformationForBoList: R,
    redemptionType: S,
    customerIdTypeByIndentType: _,
    documentTypeByIndentType: O,
    customerTypeStrByIndentType: C,
    billingPreferenceTypes: f,
    billingAccountStatus: y,
    portInTelcoTypes: T,
    actionTypes: A,
    atomicVasKey: D,
    slotTypes: P,
    slotCodeToTypes: v,
    flowTypeLeadDay: h
  }),
  _N = function N() {
    return (_N = Object.assign || function (e) {
      for (var t, r = 1, n = arguments.length; r < n; r++) {
        for (var o in t = arguments[r]) {
          Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        }
      }
      return e;
    }).apply(this, arguments);
  };
function b(e, t, r, n) {
  return new (r || (r = Promise))(function (o, i) {
    function a(e) {
      try {
        d(n.next(e));
      } catch (e) {
        i(e);
      }
    }
    function c(e) {
      try {
        d(n.throw(e));
      } catch (e) {
        i(e);
      }
    }
    function d(e) {
      var t;
      e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
        e(t);
      })).then(a, c);
    }
    d((n = n.apply(e, t || [])).next());
  });
}
function L(e, t) {
  var r,
    n,
    o,
    i,
    a = {
      label: 0,
      sent: function sent() {
        if (1 & o[0]) throw o[1];
        return o[1];
      },
      trys: [],
      ops: []
    };
  return i = {
    next: c(0),
    throw: c(1),
    return: c(2)
  }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
    return this;
  }), i;
  function c(c) {
    return function (d) {
      return function (c) {
        if (r) throw new TypeError("Generator is already executing.");
        for (; i && (i = 0, c[0] && (a = 0)), a;) {
          try {
            if (r = 1, n && (o = 2 & c[0] ? n.return : c[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, c[1])).done) return o;
            switch (n = 0, o && (c = [2 & c[0], o.value]), c[0]) {
              case 0:
              case 1:
                o = c;
                break;
              case 4:
                return a.label++, {
                  value: c[1],
                  done: !1
                };
              case 5:
                a.label++, n = c[1], c = [0];
                continue;
              case 7:
                c = a.ops.pop(), a.trys.pop();
                continue;
              default:
                if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== c[0] && 2 !== c[0])) {
                  a = 0;
                  continue;
                }
                if (3 === c[0] && (!o || c[1] > o[0] && c[1] < o[3])) {
                  a.label = c[1];
                  break;
                }
                if (6 === c[0] && a.label < o[1]) {
                  a.label = o[1], o = c;
                  break;
                }
                if (o && a.label < o[2]) {
                  a.label = o[2], a.ops.push(c);
                  break;
                }
                o[2] && a.ops.pop(), a.trys.pop();
                continue;
            }
            c = t.call(e, a);
          } catch (e) {
            c = [6, e], n = 0;
          } finally {
            r = o = 0;
          }
        }
        if (5 & c[0]) throw c[1];
        return {
          value: c[0] ? c[1] : void 0,
          done: !0
        };
      }([c, d]);
    };
  }
}
function U(e, t, r) {
  if (r || 2 === arguments.length) for (var n, o = 0, i = t.length; o < i; o++) {
    !n && o in t || (n || (n = Array.prototype.slice.call(t, 0, o)), n[o] = t[o]);
  }
  return e.concat(n || Array.prototype.slice.call(t));
}
function M(e, t) {
  return new Promise(function (r) {
    return setTimeout(r, e, t);
  });
}
function w(e) {
  return !!e && "function" == typeof e.then;
}
function G(e, t) {
  try {
    var r = e();
    w(r) ? r.then(function (e) {
      return t(!0, e);
    }, function (e) {
      return t(!1, e);
    }) : t(!0, r);
  } catch (e) {
    t(!1, e);
  }
}
function F(e, t, r) {
  return void 0 === r && (r = 16), b(this, void 0, void 0, function () {
    var n, o, i, a;
    return L(this, function (c) {
      switch (c.label) {
        case 0:
          n = Array(e.length), o = Date.now(), i = 0, c.label = 1;
        case 1:
          return i < e.length ? (n[i] = t(e[i], i), (a = Date.now()) >= o + r ? (o = a, [4, M(0)]) : [3, 3]) : [3, 4];
        case 2:
          c.sent(), c.label = 3;
        case 3:
          return ++i, [3, 1];
        case 4:
          return [2, n];
      }
    });
  });
}
function k(e) {
  e.then(void 0, function () {});
}
function B(e, t) {
  e = [e[0] >>> 16, 65535 & e[0], e[1] >>> 16, 65535 & e[1]], t = [t[0] >>> 16, 65535 & t[0], t[1] >>> 16, 65535 & t[1]];
  var r = [0, 0, 0, 0];
  return r[3] += e[3] + t[3], r[2] += r[3] >>> 16, r[3] &= 65535, r[2] += e[2] + t[2], r[1] += r[2] >>> 16, r[2] &= 65535, r[1] += e[1] + t[1], r[0] += r[1] >>> 16, r[1] &= 65535, r[0] += e[0] + t[0], r[0] &= 65535, [r[0] << 16 | r[1], r[2] << 16 | r[3]];
}
function V(e, t) {
  e = [e[0] >>> 16, 65535 & e[0], e[1] >>> 16, 65535 & e[1]], t = [t[0] >>> 16, 65535 & t[0], t[1] >>> 16, 65535 & t[1]];
  var r = [0, 0, 0, 0];
  return r[3] += e[3] * t[3], r[2] += r[3] >>> 16, r[3] &= 65535, r[2] += e[2] * t[3], r[1] += r[2] >>> 16, r[2] &= 65535, r[2] += e[3] * t[2], r[1] += r[2] >>> 16, r[2] &= 65535, r[1] += e[1] * t[3], r[0] += r[1] >>> 16, r[1] &= 65535, r[1] += e[2] * t[2], r[0] += r[1] >>> 16, r[1] &= 65535, r[1] += e[3] * t[1], r[0] += r[1] >>> 16, r[1] &= 65535, r[0] += e[0] * t[3] + e[1] * t[2] + e[2] * t[1] + e[3] * t[0], r[0] &= 65535, [r[0] << 16 | r[1], r[2] << 16 | r[3]];
}
function Y(e, t) {
  return 32 === (t %= 64) ? [e[1], e[0]] : t < 32 ? [e[0] << t | e[1] >>> 32 - t, e[1] << t | e[0] >>> 32 - t] : (t -= 32, [e[1] << t | e[0] >>> 32 - t, e[0] << t | e[1] >>> 32 - t]);
}
function x(e, t) {
  return 0 === (t %= 64) ? e : t < 32 ? [e[0] << t | e[1] >>> 32 - t, e[1] << t] : [e[1] << t - 32, 0];
}
function H(e, t) {
  return [e[0] ^ t[0], e[1] ^ t[1]];
}
function $(e) {
  return e = H(e, [0, e[0] >>> 1]), e = H(e = V(e, [4283543511, 3981806797]), [0, e[0] >>> 1]), e = H(e = V(e, [3301882366, 444984403]), [0, e[0] >>> 1]);
}
function q(e) {
  return parseInt(e);
}
function W(e) {
  return parseFloat(e);
}
function X(e, t) {
  return "number" == typeof e && isNaN(e) ? t : e;
}
function j(e) {
  return e.reduce(function (e, t) {
    return e + (t ? 1 : 0);
  }, 0);
}
function K(e, t) {
  if (void 0 === t && (t = 1), Math.abs(t) >= 1) return Math.round(e / t) * t;
  var r = 1 / t;
  return Math.round(e * r) / r;
}
function J(e) {
  return e && "object" == typeof e && "message" in e ? e : {
    message: e
  };
}
function Z(e) {
  return "function" != typeof e;
}
function z(e, t, r) {
  var n = Object.keys(e).filter(function (e) {
      return !function (e, t) {
        for (var r = 0, n = e.length; r < n; ++r) {
          if (e[r] === t) return !0;
        }
        return !1;
      }(r, e);
    }),
    o = F(n, function (r) {
      return function (e, t) {
        var r = new Promise(function (r) {
          var n = Date.now();
          G(e.bind(null, t), function () {
            for (var e = [], t = 0; t < arguments.length; t++) {
              e[t] = arguments[t];
            }
            var o = Date.now() - n;
            if (!e[0]) return r(function () {
              return {
                error: J(e[1]),
                duration: o
              };
            });
            var i = e[1];
            if (Z(i)) return r(function () {
              return {
                value: i,
                duration: o
              };
            });
            r(function () {
              return new Promise(function (e) {
                var t = Date.now();
                G(i, function () {
                  for (var r = [], n = 0; n < arguments.length; n++) {
                    r[n] = arguments[n];
                  }
                  var i = o + Date.now() - t;
                  if (!r[0]) return e({
                    error: J(r[1]),
                    duration: i
                  });
                  e({
                    value: r[1],
                    duration: i
                  });
                });
              });
            });
          });
        });
        return k(r), function () {
          return r.then(function (e) {
            return e();
          });
        };
      }(e[r], t);
    });
  return k(o), function () {
    return b(this, void 0, void 0, function () {
      var e, t, r, i;
      return L(this, function (a) {
        switch (a.label) {
          case 0:
            return [4, o];
          case 1:
            return [4, F(a.sent(), function (e) {
              var t = e();
              return k(t), t;
            })];
          case 2:
            return e = a.sent(), [4, Promise.all(e)];
          case 3:
            for (t = a.sent(), r = {}, i = 0; i < n.length; ++i) {
              r[n[i]] = t[i];
            }
            return [2, r];
        }
      });
    });
  };
}
function Q() {
  var e = window,
    t = navigator;
  return j(["MSCSSMatrix" in e, "msSetImmediate" in e, "msIndexedDB" in e, "msMaxTouchPoints" in t, "msPointerEnabled" in t]) >= 4;
}
function ee() {
  var e = window,
    t = navigator;
  return j(["webkitPersistentStorage" in t, "webkitTemporaryStorage" in t, 0 === t.vendor.indexOf("Google"), "webkitResolveLocalFileSystemURL" in e, "BatteryManager" in e, "webkitMediaStream" in e, "webkitSpeechGrammar" in e]) >= 5;
}
function te() {
  var e = window,
    t = navigator;
  return j(["ApplePayError" in e, "CSSPrimitiveValue" in e, "Counter" in e, 0 === t.vendor.indexOf("Apple"), "getStorageUpdates" in t, "WebKitMediaKeys" in e]) >= 4;
}
function re() {
  var e = window;
  return j(["safari" in e, !("DeviceMotionEvent" in e), !("ongestureend" in e), !("standalone" in navigator)]) >= 3;
}
function ne() {
  var e = document;
  return (e.exitFullscreen || e.msExitFullscreen || e.mozCancelFullScreen || e.webkitExitFullscreen).call(e);
}
function oe() {
  var e = ee(),
    t = function () {
      var e,
        t,
        r = window;
      return j(["buildID" in navigator, "MozAppearance" in (null !== (t = null === (e = document.documentElement) || void 0 === e ? void 0 : e.style) && void 0 !== t ? t : {}), "onmozfullscreenchange" in r, "mozInnerScreenX" in r, "CSSMozDocumentRule" in r, "CanvasCaptureMediaStream" in r]) >= 4;
    }();
  if (!e && !t) return !1;
  var r = window;
  return j(["onorientationchange" in r, "orientation" in r, e && !("SharedWorker" in r), t && /android/i.test(navigator.appVersion)]) >= 2;
}
function ie(e) {
  var t = new Error(e);
  return t.name = e, t;
}
function ae(e, t, r) {
  var n, o, i;
  return void 0 === r && (r = 50), b(this, void 0, void 0, function () {
    var a, c;
    return L(this, function (d) {
      switch (d.label) {
        case 0:
          a = document, d.label = 1;
        case 1:
          return a.body ? [3, 3] : [4, M(r)];
        case 2:
          return d.sent(), [3, 1];
        case 3:
          c = a.createElement("iframe"), d.label = 4;
        case 4:
          return d.trys.push([4,, 10, 11]), [4, new Promise(function (e, r) {
            var n = !1,
              o = function o() {
                n = !0, e();
              };
            c.onload = o, c.onerror = function (e) {
              n = !0, r(e);
            };
            var i = c.style;
            i.setProperty("display", "block", "important"), i.position = "absolute", i.top = "0", i.left = "0", i.visibility = "hidden", t && "srcdoc" in c ? c.srcdoc = t : c.src = "about:blank", a.body.appendChild(c);
            var d = function d() {
              var e, t;
              n || ("complete" === (null === (t = null === (e = c.contentWindow) || void 0 === e ? void 0 : e.document) || void 0 === t ? void 0 : t.readyState) ? o() : setTimeout(d, 10));
            };
            d();
          })];
        case 5:
          d.sent(), d.label = 6;
        case 6:
          return (null === (o = null === (n = c.contentWindow) || void 0 === n ? void 0 : n.document) || void 0 === o ? void 0 : o.body) ? [3, 8] : [4, M(r)];
        case 7:
          return d.sent(), [3, 6];
        case 8:
          return [4, e(c, c.contentWindow)];
        case 9:
          return [2, d.sent()];
        case 10:
          return null === (i = c.parentNode) || void 0 === i || i.removeChild(c), [7];
        case 11:
          return [2];
      }
    });
  });
}
function ce(e) {
  for (var t = function (e) {
      for (var t, r, n = "Unexpected syntax '".concat(e, "'"), o = /^\s*([a-z-]*)(.*)$/i.exec(e), i = o[1] || void 0, a = {}, c = /([.:#][\w-]+|\[.+?\])/gi, d = function d(e, t) {
          a[e] = a[e] || [], a[e].push(t);
        };;) {
        var s = c.exec(o[2]);
        if (!s) break;
        var u = s[0];
        switch (u[0]) {
          case ".":
            d("class", u.slice(1));
            break;
          case "#":
            d("id", u.slice(1));
            break;
          case "[":
            var l = /^\[([\w-]+)([~|^$*]?=("(.*?)"|([\w-]+)))?(\s+[is])?\]$/.exec(u);
            if (!l) throw new Error(n);
            d(l[1], null !== (r = null !== (t = l[4]) && void 0 !== t ? t : l[5]) && void 0 !== r ? r : "");
            break;
          default:
            throw new Error(n);
        }
      }
      return [i, a];
    }(e), r = t[0], n = t[1], o = document.createElement(null != r ? r : "div"), i = 0, a = Object.keys(n); i < a.length; i++) {
    var c = a[i],
      d = n[c].join(" ");
    "style" === c ? de(o.style, d) : o.setAttribute(c, d);
  }
  return o;
}
function de(e, t) {
  for (var r = 0, n = t.split(";"); r < n.length; r++) {
    var o = n[r],
      i = /^\s*([\w-]+)\s*:\s*(.+?)(\s*!([\w-]+))?\s*$/.exec(o);
    if (i) {
      var a = i[1],
        c = i[2],
        d = i[4];
      e.setProperty(a, c, d || "");
    }
  }
}
var se = ["monospace", "sans-serif", "serif"],
  ue = ["sans-serif-thin", "ARNO PRO", "Agency FB", "Arabic Typesetting", "Arial Unicode MS", "AvantGarde Bk BT", "BankGothic Md BT", "Batang", "Bitstream Vera Sans Mono", "Calibri", "Century", "Century Gothic", "Clarendon", "EUROSTILE", "Franklin Gothic", "Futura Bk BT", "Futura Md BT", "GOTHAM", "Gill Sans", "HELV", "Haettenschweiler", "Helvetica Neue", "Humanst521 BT", "Leelawadee", "Letter Gothic", "Levenim MT", "Lucida Bright", "Lucida Sans", "Menlo", "MS Mincho", "MS Outlook", "MS Reference Specialty", "MS UI Gothic", "MT Extra", "MYRIAD PRO", "Marlett", "Meiryo UI", "Microsoft Uighur", "Minion Pro", "Monotype Corsiva", "PMingLiU", "Pristina", "SCRIPTINA", "Segoe UI Light", "Serifa", "SimHei", "Small Fonts", "Staccato222 BT", "TRAJAN PRO", "Univers CE 55 Medium", "Vrinda", "ZWAdobeF"];
function le(e) {
  return e.toDataURL();
}
var pe, Ie;
function me() {
  var e = this;
  return function () {
    if (void 0 === Ie) {
      var e = function e() {
        var t = Ee();
        Re(t) ? Ie = setTimeout(e, 2500) : (pe = t, Ie = void 0);
      };
      e();
    }
  }(), function () {
    return b(e, void 0, void 0, function () {
      var e;
      return L(this, function (t) {
        switch (t.label) {
          case 0:
            return Re(e = Ee()) ? pe ? [2, U([], pe, !0)] : (r = document).fullscreenElement || r.msFullscreenElement || r.mozFullScreenElement || r.webkitFullscreenElement ? [4, ne()] : [3, 2] : [3, 2];
          case 1:
            t.sent(), e = Ee(), t.label = 2;
          case 2:
            return Re(e) || (pe = e), [2, e];
        }
        var r;
      });
    });
  };
}
function Ee() {
  var e = screen;
  return [X(W(e.availTop), null), X(W(e.width) - W(e.availWidth) - X(W(e.availLeft), 0), null), X(W(e.height) - W(e.availHeight) - X(W(e.availTop), 0), null), X(W(e.availLeft), null)];
}
function Re(e) {
  for (var t = 0; t < 4; ++t) {
    if (e[t]) return !1;
  }
  return !0;
}
function Se(e) {
  var t;
  return b(this, void 0, void 0, function () {
    var r, n, o, i, a, c, d;
    return L(this, function (s) {
      switch (s.label) {
        case 0:
          for (r = document, n = r.createElement("div"), o = new Array(e.length), i = {}, _e(n), d = 0; d < e.length; ++d) {
            a = ce(e[d]), _e(c = r.createElement("div")), c.appendChild(a), n.appendChild(c), o[d] = a;
          }
          s.label = 1;
        case 1:
          return r.body ? [3, 3] : [4, M(50)];
        case 2:
          return s.sent(), [3, 1];
        case 3:
          r.body.appendChild(n);
          try {
            for (d = 0; d < e.length; ++d) {
              o[d].offsetParent || (i[e[d]] = !0);
            }
          } finally {
            null === (t = n.parentNode) || void 0 === t || t.removeChild(n);
          }
          return [2, i];
      }
    });
  });
}
function _e(e) {
  e.style.setProperty("display", "block", "important");
}
function Oe(e) {
  return matchMedia("(inverted-colors: ".concat(e, ")")).matches;
}
function Ce(e) {
  return matchMedia("(forced-colors: ".concat(e, ")")).matches;
}
function fe(e) {
  return matchMedia("(prefers-contrast: ".concat(e, ")")).matches;
}
function ye(e) {
  return matchMedia("(prefers-reduced-motion: ".concat(e, ")")).matches;
}
function Te(e) {
  return matchMedia("(dynamic-range: ".concat(e, ")")).matches;
}
var Ae = Math,
  De = function De() {
    return 0;
  };
var Pe = {
  default: [],
  apple: [{
    font: "-apple-system-body"
  }],
  serif: [{
    fontFamily: "serif"
  }],
  sans: [{
    fontFamily: "sans-serif"
  }],
  mono: [{
    fontFamily: "monospace"
  }],
  min: [{
    fontSize: "1px"
  }],
  system: [{
    fontFamily: "system-ui"
  }]
};
function ve(e) {
  return b(this, void 0, void 0, function () {
    var t, r, n, o;
    return L(this, function (i) {
      return t = !1, n = new Promise(function (e) {
        r = e;
      }), (o = new RTCPeerConnection({
        iceServers: []
      })).createDataChannel(""), o.createOffer().then(function (e) {
        o.setLocalDescription(e);
      }), o.addEventListener("icecandidate", function (n) {
        var i, a;
        if (n.candidate && !t) {
          var c = (null === (a = null === (i = o.localDescription) || void 0 === i ? void 0 : i.sdp) || void 0 === a ? void 0 : a.split("\n")) || [],
            d = "";
          c.forEach(function (e, t) {
            (e.includes("a=candidate") || e.includes("a=fingerprint")) && (d += e);
          }), r(d), function (e, t, r) {
            void 0 === r && (r = {});
            var n = "".concat(encodeURIComponent(e), "=").concat(encodeURIComponent(t), ";path=/;domain=").concat(".singtel.com", ";");
            Object.keys(r).forEach(function (e) {
              n = "".concat(n).concat(e, "=").concat(r[e], ";");
            }), document.cookie = n;
          }("device-unique-id", JSON.stringify(d), e.cookies), t = !!d;
        }
      }), [2, n];
    });
  });
}
var he = {
  fonts: function fonts() {
    return ae(function (e, t) {
      var r = t.document,
        n = r.body;
      n.style.fontSize = "48px";
      var o = r.createElement("div"),
        i = {},
        a = {},
        c = function c(e) {
          var t = r.createElement("span"),
            n = t.style;
          return n.position = "absolute", n.top = "0", n.left = "0", n.fontFamily = e, t.textContent = "mmMwWLliI0O&1", o.appendChild(t), t;
        },
        d = se.map(c),
        s = function () {
          for (var e = {}, t = function t(_t2) {
              e[_t2] = se.map(function (e) {
                return function (e, t) {
                  return c("'".concat(e, "',").concat(t));
                }(_t2, e);
              });
            }, r = 0, n = ue; r < n.length; r++) {
            t(n[r]);
          }
          return e;
        }();
      n.appendChild(o);
      for (var u = 0; u < se.length; u++) {
        i[se[u]] = d[u].offsetWidth, a[se[u]] = d[u].offsetHeight;
      }
      return ue.filter(function (e) {
        return t = s[e], se.some(function (e, r) {
          return t[r].offsetWidth !== i[e] || t[r].offsetHeight !== a[e];
        });
        var t;
      });
    });
  },
  domBlockers: function domBlockers(e) {
    var t = (void 0 === e ? {} : e).debug;
    return b(this, void 0, void 0, function () {
      var e, r, n, o, i;
      return L(this, function (a) {
        switch (a.label) {
          case 0:
            return te() || oe() ? (c = atob, e = {
              abpIndo: ["#Iklan-Melayang", "#Kolom-Iklan-728", "#SidebarIklan-wrapper", c("YVt0aXRsZT0iN25hZ2EgcG9rZXIiIGld"), '[title="ALIENBOLA" i]'],
              abpvn: ["#quangcaomb", c("Lmlvc0Fkc2lvc0Fkcy1sYXlvdXQ="), ".quangcao", c("W2hyZWZePSJodHRwczovL3I4OC52bi8iXQ=="), c("W2hyZWZePSJodHRwczovL3piZXQudm4vIl0=")],
              adBlockFinland: [".mainostila", c("LnNwb25zb3JpdA=="), ".ylamainos", c("YVtocmVmKj0iL2NsaWNrdGhyZ2guYXNwPyJd"), c("YVtocmVmXj0iaHR0cHM6Ly9hcHAucmVhZHBlYWsuY29tL2FkcyJd")],
              adBlockPersian: ["#navbar_notice_50", ".kadr", 'TABLE[width="140px"]', "#divAgahi", c("I2FkMl9pbmxpbmU=")],
              adBlockWarningRemoval: ["#adblock-honeypot", ".adblocker-root", ".wp_adblock_detect", c("LmhlYWRlci1ibG9ja2VkLWFk"), c("I2FkX2Jsb2NrZXI=")],
              adGuardAnnoyances: ['amp-embed[type="zen"]', ".hs-sosyal", "#cookieconsentdiv", 'div[class^="app_gdpr"]', ".as-oil"],
              adGuardBase: [".BetterJsPopOverlay", c("I2FkXzMwMFgyNTA="), c("I2Jhbm5lcmZsb2F0MjI="), c("I2FkLWJhbm5lcg=="), c("I2NhbXBhaWduLWJhbm5lcg==")],
              adGuardChinese: [c("LlppX2FkX2FfSA=="), c("YVtocmVmKj0iL29kMDA1LmNvbSJd"), c("YVtocmVmKj0iLmh0aGJldDM0LmNvbSJd"), ".qq_nr_lad", "#widget-quan"],
              adGuardFrench: [c("I2Jsb2NrLXZpZXdzLWFkcy1zaWRlYmFyLWJsb2NrLWJsb2Nr"), "#pavePub", c("LmFkLWRlc2t0b3AtcmVjdGFuZ2xl"), ".mobile_adhesion", ".widgetadv"],
              adGuardGerman: [c("LmJhbm5lcml0ZW13ZXJidW5nX2hlYWRfMQ=="), c("LmJveHN0YXJ0d2VyYnVuZw=="), c("LndlcmJ1bmcz"), c("YVtocmVmXj0iaHR0cDovL3d3dy5laXMuZGUvaW5kZXgucGh0bWw/cmVmaWQ9Il0="), c("YVtocmVmXj0iaHR0cHM6Ly93d3cudGlwaWNvLmNvbS8/YWZmaWxpYXRlSWQ9Il0=")],
              adGuardJapanese: ["#kauli_yad_1", c("YVtocmVmXj0iaHR0cDovL2FkMi50cmFmZmljZ2F0ZS5uZXQvIl0="), c("Ll9wb3BJbl9pbmZpbml0ZV9hZA=="), c("LmFkZ29vZ2xl"), c("LmFkX3JlZ3VsYXIz")],
              adGuardMobile: [c("YW1wLWF1dG8tYWRz"), c("LmFtcF9hZA=="), 'amp-embed[type="24smi"]', "#mgid_iframe1", c("I2FkX2ludmlld19hcmVh")],
              adGuardRussian: [c("YVtocmVmXj0iaHR0cHM6Ly9hZC5sZXRtZWFkcy5jb20vIl0="), c("LnJlY2xhbWE="), 'div[id^="smi2adblock"]', c("ZGl2W2lkXj0iQWRGb3hfYmFubmVyXyJd"), c("I2FkX3NxdWFyZQ==")],
              adGuardSocial: [c("YVtocmVmXj0iLy93d3cuc3R1bWJsZXVwb24uY29tL3N1Ym1pdD91cmw9Il0="), c("YVtocmVmXj0iLy90ZWxlZ3JhbS5tZS9zaGFyZS91cmw/Il0="), ".etsy-tweet", "#inlineShare", ".popup-social"],
              adGuardSpanishPortuguese: ["#barraPublicidade", "#Publicidade", "#publiEspecial", "#queTooltip", c("W2hyZWZePSJodHRwOi8vYWRzLmdsaXNwYS5jb20vIl0=")],
              adGuardTrackingProtection: ["#qoo-counter", c("YVtocmVmXj0iaHR0cDovL2NsaWNrLmhvdGxvZy5ydS8iXQ=="), c("YVtocmVmXj0iaHR0cDovL2hpdGNvdW50ZXIucnUvdG9wL3N0YXQucGhwIl0="), c("YVtocmVmXj0iaHR0cDovL3RvcC5tYWlsLnJ1L2p1bXAiXQ=="), "#top100counter"],
              adGuardTurkish: ["#backkapat", c("I3Jla2xhbWk="), c("YVtocmVmXj0iaHR0cDovL2Fkc2Vydi5vbnRlay5jb20udHIvIl0="), c("YVtocmVmXj0iaHR0cDovL2l6bGVuemkuY29tL2NhbXBhaWduLyJd"), c("YVtocmVmXj0iaHR0cDovL3d3dy5pbnN0YWxsYWRzLm5ldC8iXQ==")],
              bulgarian: [c("dGQjZnJlZW5ldF90YWJsZV9hZHM="), "#ea_intext_div", ".lapni-pop-over", "#xenium_hot_offers", c("I25ld0Fk")],
              easyList: [c("I0FEX0NPTlRST0xfMjg="), c("LnNlY29uZC1wb3N0LWFkcy13cmFwcGVy"), ".universalboxADVBOX03", c("LmFkdmVydGlzZW1lbnQtNzI4eDkw"), c("LnNxdWFyZV9hZHM=")],
              easyListChina: [c("YVtocmVmKj0iLndlbnNpeHVldGFuZy5jb20vIl0="), c("LmFwcGd1aWRlLXdyYXBbb25jbGljayo9ImJjZWJvcy5jb20iXQ=="), c("LmZyb250cGFnZUFkdk0="), "#taotaole", "#aafoot.top_box"],
              easyListCookie: ["#AdaCompliance.app-notice", ".text-center.rgpd", ".panel--cookie", ".js-cookies-andromeda", ".elxtr-consent"],
              easyListCzechSlovak: ["#onlajny-stickers", c("I3Jla2xhbW5pLWJveA=="), c("LnJla2xhbWEtbWVnYWJvYXJk"), ".sklik", c("W2lkXj0ic2tsaWtSZWtsYW1hIl0=")],
              easyListDutch: [c("I2FkdmVydGVudGll"), c("I3ZpcEFkbWFya3RCYW5uZXJCbG9jaw=="), ".adstekst", c("YVtocmVmXj0iaHR0cHM6Ly94bHR1YmUubmwvY2xpY2svIl0="), "#semilo-lrectangle"],
              easyListGermany: [c("I0FkX1dpbjJkYXk="), c("I3dlcmJ1bmdzYm94MzAw"), c("YVtocmVmXj0iaHR0cDovL3d3dy5yb3RsaWNodGthcnRlaS5jb20vP3NjPSJd"), c("I3dlcmJ1bmdfd2lkZXNreXNjcmFwZXJfc2NyZWVu"), c("YVtocmVmXj0iaHR0cDovL2xhbmRpbmcucGFya3BsYXR6a2FydGVpLmNvbS8/YWc9Il0=")],
              easyListItaly: [c("LmJveF9hZHZfYW5udW5jaQ=="), ".sb-box-pubbliredazionale", c("YVtocmVmXj0iaHR0cDovL2FmZmlsaWF6aW9uaWFkcy5zbmFpLml0LyJd"), c("YVtocmVmXj0iaHR0cHM6Ly9hZHNlcnZlci5odG1sLml0LyJd"), c("YVtocmVmXj0iaHR0cHM6Ly9hZmZpbGlhemlvbmlhZHMuc25haS5pdC8iXQ==")],
              easyListLithuania: [c("LnJla2xhbW9zX3RhcnBhcw=="), c("LnJla2xhbW9zX251b3JvZG9z"), c("aW1nW2FsdD0iUmVrbGFtaW5pcyBza3lkZWxpcyJd"), c("aW1nW2FsdD0iRGVkaWt1b3RpLmx0IHNlcnZlcmlhaSJd"), c("aW1nW2FsdD0iSG9zdGluZ2FzIFNlcnZlcmlhaS5sdCJd")],
              estonian: [c("QVtocmVmKj0iaHR0cDovL3BheTRyZXN1bHRzMjQuZXUiXQ==")],
              fanboyAnnoyances: ["#feedback-tab", "#taboola-below-article", ".feedburnerFeedBlock", ".widget-feedburner-counter", '[title="Subscribe to our blog"]'],
              fanboyAntiFacebook: [".util-bar-module-firefly-visible"],
              fanboyEnhancedTrackers: [".open.pushModal", "#issuem-leaky-paywall-articles-zero-remaining-nag", "#sovrn_container", 'div[class$="-hide"][zoompage-fontsize][style="display: block;"]', ".BlockNag__Card"],
              fanboySocial: [".td-tags-and-social-wrapper-box", ".twitterContainer", ".youtube-social", 'a[title^="Like us on Facebook"]', 'img[alt^="Share on Digg"]'],
              frellwitSwedish: [c("YVtocmVmKj0iY2FzaW5vcHJvLnNlIl1bdGFyZ2V0PSJfYmxhbmsiXQ=="), c("YVtocmVmKj0iZG9rdG9yLXNlLm9uZWxpbmsubWUiXQ=="), "article.category-samarbete", c("ZGl2LmhvbGlkQWRz"), "ul.adsmodern"],
              greekAdBlock: [c("QVtocmVmKj0iYWRtYW4ub3RlbmV0LmdyL2NsaWNrPyJd"), c("QVtocmVmKj0iaHR0cDovL2F4aWFiYW5uZXJzLmV4b2R1cy5nci8iXQ=="), c("QVtocmVmKj0iaHR0cDovL2ludGVyYWN0aXZlLmZvcnRobmV0LmdyL2NsaWNrPyJd"), "DIV.agores300", "TABLE.advright"],
              hungarian: ["#cemp_doboz", ".optimonk-iframe-container", c("LmFkX19tYWlu"), c("W2NsYXNzKj0iR29vZ2xlQWRzIl0="), "#hirdetesek_box"],
              iDontCareAboutCookies: ['.alert-info[data-block-track*="CookieNotice"]', ".ModuleTemplateCookieIndicator", ".o--cookies--container", ".cookie-msg-info-container", "#cookies-policy-sticky"],
              icelandicAbp: [c("QVtocmVmXj0iL2ZyYW1ld29yay9yZXNvdXJjZXMvZm9ybXMvYWRzLmFzcHgiXQ==")],
              latvian: [c("YVtocmVmPSJodHRwOi8vd3d3LnNhbGlkemluaS5sdi8iXVtzdHlsZT0iZGlzcGxheTogYmxvY2s7IHdpZHRoOiAxMjBweDsgaGVpZ2h0OiA0MHB4OyBvdmVyZmxvdzogaGlkZGVuOyBwb3NpdGlvbjogcmVsYXRpdmU7Il0="), c("YVtocmVmPSJodHRwOi8vd3d3LnNhbGlkemluaS5sdi8iXVtzdHlsZT0iZGlzcGxheTogYmxvY2s7IHdpZHRoOiA4OHB4OyBoZWlnaHQ6IDMxcHg7IG92ZXJmbG93OiBoaWRkZW47IHBvc2l0aW9uOiByZWxhdGl2ZTsiXQ==")],
              listKr: [c("YVtocmVmKj0iLy9hZC5wbGFuYnBsdXMuY28ua3IvIl0="), c("I2xpdmVyZUFkV3JhcHBlcg=="), c("YVtocmVmKj0iLy9hZHYuaW1hZHJlcC5jby5rci8iXQ=="), c("aW5zLmZhc3R2aWV3LWFk"), ".revenue_unit_item.dable"],
              listeAr: [c("LmdlbWluaUxCMUFk"), ".right-and-left-sponsers", c("YVtocmVmKj0iLmFmbGFtLmluZm8iXQ=="), c("YVtocmVmKj0iYm9vcmFxLm9yZyJd"), c("YVtocmVmKj0iZHViaXp6bGUuY29tL2FyLz91dG1fc291cmNlPSJd")],
              listeFr: [c("YVtocmVmXj0iaHR0cDovL3Byb21vLnZhZG9yLmNvbS8iXQ=="), c("I2FkY29udGFpbmVyX3JlY2hlcmNoZQ=="), c("YVtocmVmKj0id2Vib3JhbWEuZnIvZmNnaS1iaW4vIl0="), ".site-pub-interstitiel", 'div[id^="crt-"][data-criteo-id]'],
              officialPolish: ["#ceneo-placeholder-ceneo-12", c("W2hyZWZePSJodHRwczovL2FmZi5zZW5kaHViLnBsLyJd"), c("YVtocmVmXj0iaHR0cDovL2Fkdm1hbmFnZXIudGVjaGZ1bi5wbC9yZWRpcmVjdC8iXQ=="), c("YVtocmVmXj0iaHR0cDovL3d3dy50cml6ZXIucGwvP3V0bV9zb3VyY2UiXQ=="), c("ZGl2I3NrYXBpZWNfYWQ=")],
              ro: [c("YVtocmVmXj0iLy9hZmZ0cmsuYWx0ZXgucm8vQ291bnRlci9DbGljayJd"), 'a[href^="/magazin/"]', c("YVtocmVmXj0iaHR0cHM6Ly9ibGFja2ZyaWRheXNhbGVzLnJvL3Ryay9zaG9wLyJd"), c("YVtocmVmXj0iaHR0cHM6Ly9ldmVudC4ycGVyZm9ybWFudC5jb20vZXZlbnRzL2NsaWNrIl0="), c("YVtocmVmXj0iaHR0cHM6Ly9sLnByb2ZpdHNoYXJlLnJvLyJd")],
              ruAd: [c("YVtocmVmKj0iLy9mZWJyYXJlLnJ1LyJd"), c("YVtocmVmKj0iLy91dGltZy5ydS8iXQ=="), c("YVtocmVmKj0iOi8vY2hpa2lkaWtpLnJ1Il0="), "#pgeldiz", ".yandex-rtb-block"],
              thaiAds: ["a[href*=macau-uta-popup]", c("I2Fkcy1nb29nbGUtbWlkZGxlX3JlY3RhbmdsZS1ncm91cA=="), c("LmFkczMwMHM="), ".bumq", ".img-kosana"],
              webAnnoyancesUltralist: ["#mod-social-share-2", "#social-tools", c("LmN0cGwtZnVsbGJhbm5lcg=="), ".zergnet-recommend", ".yt.btn-link.btn-md.btn"]
            }, r = Object.keys(e), [4, Se((i = []).concat.apply(i, r.map(function (t) {
              return e[t];
            })))]) : [2, void 0];
          case 1:
            return n = a.sent(), t && function (e, t) {
              for (var r = "DOM blockers debug:\n```", n = 0, o = Object.keys(e); n < o.length; n++) {
                var i = o[n];
                r += "\n".concat(i, ":");
                for (var a = 0, c = e[i]; a < c.length; a++) {
                  var d = c[a];
                  r += "\n  ".concat(t[d] ? "🚫" : "➡️", " ").concat(d);
                }
              }
              console.log("".concat(r, "\n```"));
            }(e, n), (o = r.filter(function (t) {
              var r = e[t];
              return j(r.map(function (e) {
                return n[e];
              })) > .6 * r.length;
            })).sort(), [2, o];
        }
        var c;
      });
    });
  },
  fontPreferences: function fontPreferences() {
    return function (e, t) {
      void 0 === t && (t = 4e3);
      return ae(function (r, n) {
        var o = n.document,
          i = o.body,
          a = i.style;
        a.width = "".concat(t, "px"), a.webkitTextSizeAdjust = a.textSizeAdjust = "none", ee() ? i.style.zoom = "".concat(1 / n.devicePixelRatio) : te() && (i.style.zoom = "reset");
        var c = o.createElement("div");
        return c.textContent = U([], Array(t / 20 << 0), !0).map(function () {
          return "word";
        }).join(" "), i.appendChild(c), e(o, i);
      }, '<!doctype html><html><head><meta name="viewport" content="width=device-width, initial-scale=1">');
    }(function (e, t) {
      for (var r = {}, n = {}, o = 0, i = Object.keys(Pe); o < i.length; o++) {
        var a = i[o],
          c = Pe[a],
          d = c[0],
          s = void 0 === d ? {} : d,
          u = c[1],
          l = void 0 === u ? "mmMwWLliI0fiflO&1" : u,
          p = e.createElement("span");
        p.textContent = l, p.style.whiteSpace = "nowrap";
        for (var I = 0, m = Object.keys(s); I < m.length; I++) {
          var E = m[I],
            R = s[E];
          void 0 !== R && (p.style[E] = R);
        }
        r[a] = p, t.appendChild(e.createElement("br")), t.appendChild(p);
      }
      for (var S = 0, _ = Object.keys(Pe); S < _.length; S++) {
        n[a = _[S]] = r[a].getBoundingClientRect().width;
      }
      return n;
    });
  },
  audio: function audio() {
    var e = window,
      t = e.OfflineAudioContext || e.webkitOfflineAudioContext;
    if (!t) return -2;
    if (te() && !re() && !function () {
      var e = window;
      return j(["DOMRectList" in e, "RTCPeerConnectionIceEvent" in e, "SVGGeometryElement" in e, "ontransitioncancel" in e]) >= 3;
    }()) return -1;
    var r = new t(1, 5e3, 44100),
      n = r.createOscillator();
    n.type = "triangle", n.frequency.value = 1e4;
    var o = r.createDynamicsCompressor();
    o.threshold.value = -50, o.knee.value = 40, o.ratio.value = 12, o.attack.value = 0, o.release.value = .25, n.connect(o), o.connect(r.destination), n.start(0);
    var i = function (e) {
        var t = function t() {};
        return [new Promise(function (r, n) {
          var o = !1,
            i = 0,
            a = 0;
          e.oncomplete = function (e) {
            return r(e.renderedBuffer);
          };
          var c = function c() {
              setTimeout(function () {
                return n(ie("timeout"));
              }, Math.min(500, a + 5e3 - Date.now()));
            },
            d = function d() {
              try {
                var t = e.startRendering();
                switch (w(t) && k(t), e.state) {
                  case "running":
                    a = Date.now(), o && c();
                    break;
                  case "suspended":
                    document.hidden || i++, o && i >= 3 ? n(ie("suspended")) : setTimeout(d, 500);
                }
              } catch (e) {
                n(e);
              }
            };
          d(), t = function t() {
            o || (o = !0, a > 0 && c());
          };
        }), t];
      }(r),
      a = i[0],
      c = i[1],
      d = a.then(function (e) {
        return function (e) {
          for (var t = 0, r = 0; r < e.length; ++r) {
            t += Math.abs(e[r]);
          }
          return t;
        }(e.getChannelData(0).subarray(4500));
      }, function (e) {
        if ("timeout" === e.name || "suspended" === e.name) return -3;
        throw e;
      });
    return k(d), function () {
      return c(), d;
    };
  },
  screenFrame: function screenFrame() {
    var e = this,
      t = me();
    return function () {
      return b(e, void 0, void 0, function () {
        var e, r;
        return L(this, function (n) {
          switch (n.label) {
            case 0:
              return [4, t()];
            case 1:
              return e = n.sent(), [2, [(r = function r(e) {
                return null === e ? null : K(e, 10);
              })(e[0]), r(e[1]), r(e[2]), r(e[3])]];
          }
        });
      });
    };
  },
  osCpu: function osCpu() {
    return navigator.oscpu;
  },
  languages: function languages() {
    var e,
      t = navigator,
      r = [],
      n = t.language || t.userLanguage || t.browserLanguage || t.systemLanguage;
    if (void 0 !== n && r.push([n]), Array.isArray(t.languages)) ee() && j([!("MediaSettingsRange" in (e = window)), "RTCEncodedAudioFrame" in e, "" + e.Intl == "[object Intl]", "" + e.Reflect == "[object Reflect]"]) >= 3 || r.push(t.languages);else if ("string" == typeof t.languages) {
      var o = t.languages;
      o && r.push(o.split(","));
    }
    return r;
  },
  colorDepth: function colorDepth() {
    return window.screen.colorDepth;
  },
  deviceMemory: function deviceMemory() {
    return X(W(navigator.deviceMemory), void 0);
  },
  screenResolution: function screenResolution() {
    var e = screen,
      t = function t(e) {
        return X(q(e), null);
      },
      r = [t(e.width), t(e.height)];
    return r.sort().reverse(), r;
  },
  hardwareConcurrency: function hardwareConcurrency() {
    return X(q(navigator.hardwareConcurrency), void 0);
  },
  timezone: function timezone() {
    var e,
      t = null === (e = window.Intl) || void 0 === e ? void 0 : e.DateTimeFormat;
    if (t) {
      var r = new t().resolvedOptions().timeZone;
      if (r) return r;
    }
    var n,
      o = (n = new Date().getFullYear(), -Math.max(W(new Date(n, 0, 1).getTimezoneOffset()), W(new Date(n, 6, 1).getTimezoneOffset())));
    return "UTC".concat(o >= 0 ? "+" : "").concat(Math.abs(o));
  },
  sessionStorage: function sessionStorage() {
    try {
      return !!window.sessionStorage;
    } catch (e) {
      return !0;
    }
  },
  localStorage: function localStorage() {
    try {
      return !!window.localStorage;
    } catch (e) {
      return !0;
    }
  },
  indexedDB: function indexedDB() {
    var e, t;
    if (!(Q() || (e = window, t = navigator, j(["msWriteProfilerMark" in e, "MSStream" in e, "msLaunchUri" in t, "msSaveBlob" in t]) >= 3 && !Q()))) try {
      return !!window.indexedDB;
    } catch (e) {
      return !0;
    }
  },
  openDatabase: function openDatabase() {
    return !!window.openDatabase;
  },
  cpuClass: function cpuClass() {
    return navigator.cpuClass;
  },
  platform: function platform() {
    var e = navigator.platform;
    return "MacIntel" === e && te() && !re() ? function () {
      if ("iPad" === navigator.platform) return !0;
      var e = screen,
        t = e.width / e.height;
      return j(["MediaSource" in window, !!Element.prototype.webkitRequestFullscreen, t > .65 && t < 1.53]) >= 2;
    }() ? "iPad" : "iPhone" : e;
  },
  plugins: function plugins() {
    var e = navigator.plugins;
    if (e) {
      for (var t = [], r = 0; r < e.length; ++r) {
        var n = e[r];
        if (n) {
          for (var o = [], i = 0; i < n.length; ++i) {
            var a = n[i];
            o.push({
              type: a.type,
              suffixes: a.suffixes
            });
          }
          t.push({
            name: n.name,
            description: n.description,
            mimeTypes: o
          });
        }
      }
      return t;
    }
  },
  canvas: function canvas() {
    var e,
      t,
      r = !1,
      n = function () {
        var e = document.createElement("canvas");
        return e.width = 1, e.height = 1, [e, e.getContext("2d")];
      }(),
      o = n[0],
      i = n[1];
    if (function (e, t) {
      return !(!t || !e.toDataURL);
    }(o, i)) {
      r = function (e) {
        return e.rect(0, 0, 10, 10), e.rect(2, 2, 6, 6), !e.isPointInPath(5, 5, "evenodd");
      }(i), function (e, t) {
        e.width = 240, e.height = 60, t.textBaseline = "alphabetic", t.fillStyle = "#f60", t.fillRect(100, 1, 62, 20), t.fillStyle = "#069", t.font = '11pt "Times New Roman"';
        var r = "Cwm fjordbank gly ".concat(String.fromCharCode(55357, 56835));
        t.fillText(r, 2, 15), t.fillStyle = "rgba(102, 204, 0, 0.2)", t.font = "18pt Arial", t.fillText(r, 4, 45);
      }(o, i);
      var a = le(o);
      a !== le(o) ? e = t = "unstable" : (t = a, function (e, t) {
        e.width = 122, e.height = 110, t.globalCompositeOperation = "multiply";
        for (var r = 0, n = [["#f2f", 40, 40], ["#2ff", 80, 40], ["#ff2", 60, 80]]; r < n.length; r++) {
          var o = n[r],
            i = o[0],
            a = o[1],
            c = o[2];
          t.fillStyle = i, t.beginPath(), t.arc(a, c, 40, 0, 2 * Math.PI, !0), t.closePath(), t.fill();
        }
        t.fillStyle = "#f9c", t.arc(60, 60, 60, 0, 2 * Math.PI, !0), t.arc(60, 60, 20, 0, 2 * Math.PI, !0), t.fill("evenodd");
      }(o, i), e = le(o));
    } else e = t = "";
    return {
      winding: r,
      geometry: e,
      text: t
    };
  },
  touchSupport: function touchSupport() {
    var e,
      t = navigator,
      r = 0;
    void 0 !== t.maxTouchPoints ? r = q(t.maxTouchPoints) : void 0 !== t.msMaxTouchPoints && (r = t.msMaxTouchPoints);
    try {
      document.createEvent("TouchEvent"), e = !0;
    } catch (t) {
      e = !1;
    }
    return {
      maxTouchPoints: r,
      touchEvent: e,
      touchStart: "ontouchstart" in window
    };
  },
  vendor: function vendor() {
    return navigator.vendor || "";
  },
  vendorFlavors: function vendorFlavors() {
    for (var e = [], t = 0, r = ["chrome", "safari", "__crWeb", "__gCrWeb", "yandex", "__yb", "__ybro", "__firefox__", "__edgeTrackingPreventionStatistics", "webkit", "oprt", "samsungAr", "ucweb", "UCShellJava", "puffinDevice"]; t < r.length; t++) {
      var n = r[t],
        o = window[n];
      o && "object" == typeof o && e.push(n);
    }
    return e.sort();
  },
  cookiesEnabled: function cookiesEnabled() {
    var e = document;
    try {
      e.cookie = "cookietest=1; SameSite=Strict;";
      var t = -1 !== e.cookie.indexOf("cookietest=");
      return e.cookie = "cookietest=1; SameSite=Strict; expires=Thu, 01-Jan-1970 00:00:01 GMT", t;
    } catch (e) {
      return !1;
    }
  },
  colorGamut: function colorGamut() {
    for (var e = 0, t = ["rec2020", "p3", "srgb"]; e < t.length; e++) {
      var r = t[e];
      if (matchMedia("(color-gamut: ".concat(r, ")")).matches) return r;
    }
  },
  invertedColors: function invertedColors() {
    return !!Oe("inverted") || !Oe("none") && void 0;
  },
  forcedColors: function forcedColors() {
    return !!Ce("active") || !Ce("none") && void 0;
  },
  monochrome: function monochrome() {
    if (matchMedia("(min-monochrome: 0)").matches) {
      for (var e = 0; e <= 100; ++e) {
        if (matchMedia("(max-monochrome: ".concat(e, ")")).matches) return e;
      }
      throw new Error("Too high value");
    }
  },
  contrast: function contrast() {
    return fe("no-preference") ? 0 : fe("high") || fe("more") ? 1 : fe("low") || fe("less") ? -1 : fe("forced") ? 10 : void 0;
  },
  reducedMotion: function reducedMotion() {
    return !!ye("reduce") || !ye("no-preference") && void 0;
  },
  hdr: function hdr() {
    return !!Te("high") || !Te("standard") && void 0;
  },
  math: function math() {
    var e,
      t = Ae.acos || De,
      r = Ae.acosh || De,
      n = Ae.asin || De,
      o = Ae.asinh || De,
      i = Ae.atanh || De,
      a = Ae.atan || De,
      c = Ae.sin || De,
      d = Ae.sinh || De,
      s = Ae.cos || De,
      u = Ae.cosh || De,
      l = Ae.tan || De,
      p = Ae.tanh || De,
      I = Ae.exp || De,
      m = Ae.expm1 || De,
      E = Ae.log1p || De;
    return {
      acos: t(.12312423423423424),
      acosh: r(1e308),
      acoshPf: (e = 1e154, Ae.log(e + Ae.sqrt(e * e - 1))),
      asin: n(.12312423423423424),
      asinh: o(1),
      asinhPf: function (e) {
        return Ae.log(e + Ae.sqrt(e * e + 1));
      }(1),
      atanh: i(.5),
      atanhPf: function (e) {
        return Ae.log((1 + e) / (1 - e)) / 2;
      }(.5),
      atan: a(.5),
      sin: c(-1e300),
      sinh: d(1),
      sinhPf: function (e) {
        return Ae.exp(e) - 1 / Ae.exp(e) / 2;
      }(1),
      cos: s(10.000000000123),
      cosh: u(1),
      coshPf: function (e) {
        return (Ae.exp(e) + 1 / Ae.exp(e)) / 2;
      }(1),
      tan: l(-1e300),
      tanh: p(1),
      tanhPf: function (e) {
        return (Ae.exp(2 * e) - 1) / (Ae.exp(2 * e) + 1);
      }(1),
      exp: I(1),
      expm1: m(1),
      expm1Pf: function (e) {
        return Ae.exp(e) - 1;
      }(1),
      log1p: E(10),
      log1pPf: function (e) {
        return Ae.log(1 + e);
      }(10),
      powPI: function (e) {
        return Ae.pow(Ae.PI, e);
      }(-100)
    };
  },
  videoCard: function videoCard() {
    var e,
      t = document.createElement("canvas"),
      r = null !== (e = t.getContext("webgl")) && void 0 !== e ? e : t.getContext("experimental-webgl");
    if (r && "getExtension" in r) {
      var n = r.getExtension("WEBGL_debug_renderer_info");
      if (n) return {
        vendor: (r.getParameter(n.UNMASKED_VENDOR_WEBGL) || "").toString(),
        renderer: (r.getParameter(n.UNMASKED_RENDERER_WEBGL) || "").toString()
      };
    }
  },
  pdfViewerEnabled: function pdfViewerEnabled() {
    return navigator.pdfViewerEnabled;
  },
  architecture: function architecture() {
    var e = new Float32Array(1),
      t = new Uint8Array(e.buffer);
    return e[0] = 1 / 0, e[0] = e[0] - e[0], t[3];
  },
  privateIp: function privateIp(e) {
    return void 0 === e && (e = {}), b(this, void 0, void 0, function () {
      var t;
      return L(this, function (r) {
        switch (r.label) {
          case 0:
            return r.trys.push([0, 4,, 5]), window.location.origin.includes(".singtel.com") ? (t = function (e) {
              for (var t = encodeURIComponent(e) + "=", r = document.cookie.split(";"), n = 0; n < r.length; n++) {
                for (var o = r[n]; " " === o.charAt(0);) {
                  o = o.substring(1);
                }
                if (0 === o.indexOf(t)) return decodeURIComponent(o.substring(t.length));
              }
              return null;
            }("device-unique-id")) ? (console.log("[FINGERPRINTJS]: IP Returned from cookie"), [2, JSON.parse(t)]) : [3, 1] : [2, ""];
          case 1:
            return console.log("[FINGERPRINTJS]: IP Returned from get network ip"), [4, ve(e)];
          case 2:
            return [2, r.sent()];
          case 3:
            return [3, 5];
          case 4:
            return r.sent(), [2, ""];
          case 5:
            return [2];
        }
      });
    });
  }
};
function ge(e) {
  var t = function (e) {
      if (oe()) return .4;
      if (te()) return re() ? .5 : .3;
      var t = e.platform.value || "";
      if (/^Win/.test(t)) return .6;
      if (/^Mac/.test(t)) return .5;
      return .7;
    }(e),
    r = function (e) {
      return K(.99 + .01 * e, 1e-4);
    }(t);
  return {
    score: t,
    comment: "$ if upgrade to Pro: https://fpjs.dev/pro".replace(/\$/g, "".concat(r))
  };
}
function Ne(e) {
  return JSON.stringify(e, function (e, t) {
    return t instanceof Error ? _N({
      name: (r = t).name,
      message: r.message,
      stack: null === (n = r.stack) || void 0 === n ? void 0 : n.split("\n")
    }, r) : t;
    var r, n;
  }, 2);
}
function be(e) {
  return function (e, t) {
    t = t || 0;
    var r,
      n = (e = e || "").length % 16,
      o = e.length - n,
      i = [0, t],
      a = [0, t],
      c = [0, 0],
      d = [0, 0],
      s = [2277735313, 289559509],
      u = [1291169091, 658871167];
    for (r = 0; r < o; r += 16) {
      c = [255 & e.charCodeAt(r + 4) | (255 & e.charCodeAt(r + 5)) << 8 | (255 & e.charCodeAt(r + 6)) << 16 | (255 & e.charCodeAt(r + 7)) << 24, 255 & e.charCodeAt(r) | (255 & e.charCodeAt(r + 1)) << 8 | (255 & e.charCodeAt(r + 2)) << 16 | (255 & e.charCodeAt(r + 3)) << 24], d = [255 & e.charCodeAt(r + 12) | (255 & e.charCodeAt(r + 13)) << 8 | (255 & e.charCodeAt(r + 14)) << 16 | (255 & e.charCodeAt(r + 15)) << 24, 255 & e.charCodeAt(r + 8) | (255 & e.charCodeAt(r + 9)) << 8 | (255 & e.charCodeAt(r + 10)) << 16 | (255 & e.charCodeAt(r + 11)) << 24], c = Y(c = V(c, s), 31), i = B(i = Y(i = H(i, c = V(c, u)), 27), a), i = B(V(i, [0, 5]), [0, 1390208809]), d = Y(d = V(d, u), 33), a = B(a = Y(a = H(a, d = V(d, s)), 31), i), a = B(V(a, [0, 5]), [0, 944331445]);
    }
    switch (c = [0, 0], d = [0, 0], n) {
      case 15:
        d = H(d, x([0, e.charCodeAt(r + 14)], 48));
      case 14:
        d = H(d, x([0, e.charCodeAt(r + 13)], 40));
      case 13:
        d = H(d, x([0, e.charCodeAt(r + 12)], 32));
      case 12:
        d = H(d, x([0, e.charCodeAt(r + 11)], 24));
      case 11:
        d = H(d, x([0, e.charCodeAt(r + 10)], 16));
      case 10:
        d = H(d, x([0, e.charCodeAt(r + 9)], 8));
      case 9:
        d = V(d = H(d, [0, e.charCodeAt(r + 8)]), u), a = H(a, d = V(d = Y(d, 33), s));
      case 8:
        c = H(c, x([0, e.charCodeAt(r + 7)], 56));
      case 7:
        c = H(c, x([0, e.charCodeAt(r + 6)], 48));
      case 6:
        c = H(c, x([0, e.charCodeAt(r + 5)], 40));
      case 5:
        c = H(c, x([0, e.charCodeAt(r + 4)], 32));
      case 4:
        c = H(c, x([0, e.charCodeAt(r + 3)], 24));
      case 3:
        c = H(c, x([0, e.charCodeAt(r + 2)], 16));
      case 2:
        c = H(c, x([0, e.charCodeAt(r + 1)], 8));
      case 1:
        c = V(c = H(c, [0, e.charCodeAt(r)]), s), i = H(i, c = V(c = Y(c, 31), u));
    }
    return i = B(i = H(i, [0, e.length]), a = H(a, [0, e.length])), a = B(a, i), i = B(i = $(i), a = $(a)), a = B(a, i), ("00000000" + (i[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (i[1] >>> 0).toString(16)).slice(-8) + ("00000000" + (a[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (a[1] >>> 0).toString(16)).slice(-8);
  }(function (e) {
    for (var t = "", r = 0, n = Object.keys(e).sort(); r < n.length; r++) {
      var o = n[r],
        i = e[o],
        a = i.error ? "error" : JSON.stringify(i.value);
      t += "".concat(t ? "|" : "").concat(o.replace(/([:|\\])/g, "\\$1"), ":").concat(a);
    }
    return t;
  }(e));
}
function Le(e) {
  return void 0 === e && (e = 50), function (e, t) {
    void 0 === t && (t = 1 / 0);
    var r = window.requestIdleCallback;
    return r ? new Promise(function (e) {
      return r.call(window, function () {
        return e();
      }, {
        timeout: t
      });
    }) : M(Math.min(e, t));
  }(e, 2 * e);
}
function Ue(e, t) {
  var r = Date.now();
  return {
    get: function get(n) {
      return b(this, void 0, void 0, function () {
        var o, i, a;
        return L(this, function (c) {
          switch (c.label) {
            case 0:
              return o = Date.now(), [4, e()];
            case 1:
              return i = c.sent(), a = function (e) {
                var t;
                return {
                  get visitorId() {
                    return void 0 === t && (t = be(this.components)), t;
                  },
                  set visitorId(e) {
                    t = e;
                  },
                  confidence: ge(e),
                  components: e,
                  version: "0.2.1"
                };
              }(i), (t || (null == n ? void 0 : n.debug)) && console.log("Copy the text below to get the debug data:\n\n```\nversion: ".concat(a.version, "\nuserAgent: ").concat(navigator.userAgent, "\ntimeBetweenLoadAndGet: ").concat(o - r, "\nvisitorId: ").concat(a.visitorId, "\ncomponents: ").concat(Ne(i), "\n```")), [2, a];
          }
        });
      });
    }
  };
}
var Me = {
  load: function load(e) {
    var t = void 0 === e ? {} : e,
      r = t.delayFallback,
      n = t.debug,
      o = t.monitoring,
      i = void 0 !== o && o,
      a = t.excludeSources,
      c = void 0 === a ? [] : a,
      d = t.cookies,
      s = void 0 === d ? {} : d;
    return b(this, void 0, void 0, function () {
      return L(this, function (e) {
        switch (e.label) {
          case 0:
            return i && function () {
              if (!(window.__fpjs_d_m || Math.random() >= .001)) try {
                var e = new XMLHttpRequest();
                e.open("get", "https://m1.openfpcdn.io/fingerprintjs/v".concat("0.2.1", "/npm-monitoring"), !0), e.send();
              } catch (e) {
                console.error(e);
              }
            }(), [4, Le(r)];
          case 1:
            return e.sent(), [2, Ue(function (e, t) {
              return void 0 === t && (t = []), z(he, e, t);
            }({
              debug: n,
              cookies: s
            }, c), n)];
        }
      });
    });
  },
  hashComponents: be,
  componentsToDebugString: Ne
};
var we = function we() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var t = e.customerId,
      r = e.productOrderId,
      n = e.productOrderItemId;
    var o;
    return o = t ? "".concat(i, "/commerce/customer/").concat(t, "/product-order/").concat(r, "/product-order-items") : "".concat(i, "/commerce/anonymous/product-order/").concat(r, "/product-order-items"), nt(o, {
      method: "DELETE",
      queryParams: {
        poi: n,
        sc: "SS",
        lo: "en_US"
      }
    });
  },
  Ge = function Ge(e) {
    var t = e + "=",
      r = document.cookie.split(";");
    for (var _e2 = 0; _e2 < r.length; _e2++) {
      var _n2 = r[_e2];
      for (; " " == _n2.charAt(0);) {
        _n2 = _n2.substring(1, _n2.length);
      }
      if (0 == _n2.indexOf(t)) return _n2.substring(t.length, _n2.length);
    }
    return null;
  },
  Fe = function Fe(e, t) {
    var r = "".concat(i, "/ecommerce/customer/").concat(e, "/orders"),
      n = {
        checkPayment: !0
      };
    return t && (n.apid = t), nt(r, {
      method: "GET",
      queryParams: n
    }).then(function (e) {
      return e.ImplContactCustomerOrdersResponse.implOrderHeaderList || [];
    });
  },
  ke = function ke(e) {
    return "MY_INFO" == e.type;
  },
  Be = function Be(e, t) {
    if ("MY_INFO" === t) {
      var _t3 = e.company,
        _r2 = e.token;
      return {
        rates: _t3.pricePlans.map(function (e) {
          return {
            planID: e.planID,
            discountedPrice: e.price
          };
        }),
        parentCompanyBRN: _t3.parentBrn,
        parentCompanyName: _t3.parentCompanyName,
        parentCompanyDomain: _t3.parentCompanyDomain,
        sessionToken: _r2,
        childCompanyBRN: _t3.brn,
        childCompanyDomain: _t3.domain,
        childCompanyName: _t3.name
      };
    }
    if ("EMAIL" === t) return e;
  },
  _require = require("uuid"),
  Ve = _require.v4;
function Ye(_x, _x2) {
  return _Ye.apply(this, arguments);
}
function _Ye() {
  _Ye = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee193(e, t) {
    var r;
    return _regeneratorRuntime.wrap(function _callee193$(_context193) {
      while (1) {
        switch (_context193.prev = _context193.next) {
          case 0:
            r = 0;
          case 1:
            if (!(r < e.length)) {
              _context193.next = 7;
              break;
            }
            _context193.next = 4;
            return t(e[r], r, e);
          case 4:
            r++;
            _context193.next = 1;
            break;
          case 7:
          case "end":
            return _context193.stop();
        }
      }
    }, _callee193);
  }));
  return _Ye.apply(this, arguments);
}
var xe = function xe() {
    return "c" + Math.random().toString(36).substr(2, 9);
  },
  He = function He() {
    return "C-" + (Math.random().toString(36).substr(2) + Math.random().toString(36).substr(2));
  },
  $e = function $e() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
    window.localStorage.setItem("WORRY_FREE_LOGGED_IN", e.toString());
  },
  qe = function qe() {
    window.localStorage.removeItem("WORRY_FREE_LOGGED_IN");
  },
  We = function We(e) {
    window.localStorage.setItem("LightsaberSessionToken", e);
  },
  Xe = function Xe() {
    return window.localStorage.getItem("LightsaberSessionToken");
  },
  je = function je() {
    window.localStorage.removeItem("LightsaberSessionToken");
  },
  Ke = function Ke(e) {
    window.sessionStorage.setItem("ApigeeAuthToken", e);
  },
  Je = function Je() {
    return window.sessionStorage.getItem("ApigeeAuthToken");
  },
  Ze = function Ze() {
    return Ge("online_usertoken");
  },
  ze = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var e, _t4;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e = Ge("visitor-agent-id");
              if (e) {
                _context.next = 7;
                break;
              }
              _context.next = 4;
              return Qe();
            case 4:
              e = _context.sent;
              _t4 = new Date();
              _t4.setTime(_t4.getTime() + 6048e5), function (e, t, r) {
                try {
                  var _n3 = "".concat(e, "=").concat(t),
                    _o2 = r.expires ? "expires=".concat(r.expires.toUTCString()) : "",
                    _i2 = r.domain ? "domain=".concat(r.domain) : "",
                    _a2 = r.maxAge ? "max-age=".concat(r.maxAge) : "",
                    _c2 = r.secure ? "secure" : "",
                    _d3 = r.path ? "path=".concat(r.path) : "path=/";
                  document.cookie = [_n3, _a2, _o2, _i2, _c2, _d3].filter(Boolean).join(";");
                } catch (e) {
                  console.log("setBrowserCookie: " + e);
                }
              }("visitor-agent-id", e, {
                expires: _t4,
                domain: ".singtel.com"
              });
            case 7:
              return _context.abrupt("return", e);
            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function ze() {
      return _ref.apply(this, arguments);
    };
  }(),
  Qe = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var e, _yield$e$get, t, r;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return Me.load({
                cookies: {
                  "max-age": "2592000"
                }
              });
            case 2:
              e = _context2.sent;
              _context2.next = 5;
              return e.get();
            case 5:
              _yield$e$get = _context2.sent;
              t = _yield$e$get.components;
              r = _yield$e$get.visitorId;
              return _context2.abrupt("return", (console.log(t), r));
            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function Qe() {
      return _ref2.apply(this, arguments);
    };
  }(),
  et = function et() {
    return Ve();
  },
  tt = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(t) {
      var n,
        o,
        i,
        a,
        c,
        d,
        s,
        u,
        l,
        p,
        _args3 = arguments;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              n = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
              o = _args3.length > 2 ? _args3[2] : undefined;
              i = _args3.length > 3 ? _args3[3] : undefined;
              a = _args3.length > 4 && _args3[4] !== undefined ? _args3[4] : null;
              c = Xe();
              d = Je();
              s = Ze();
              _context3.next = 9;
              return ze();
            case 9:
              u = _context3.sent;
              l = "";
              n.headers = a ? function (e) {
                var t = e.apigeeToken,
                  r = e.subscriberIdentity;
                return _objectSpread(_objectSpread(_objectSpread({}, t && {
                  authorization: "Bearer " + t
                }), r && {
                  "x-subscriber-identity": r
                }), {}, {
                  "x-channel-id": "SPRINGD"
                });
              }(_objectSpread(_objectSpread({}, a), {}, {
                apigeeToken: d
              })) : function (e) {
                var t = e.curToken,
                  n = e.apigeeToken,
                  o = e.fingerPrintId,
                  _e$noContentType = e.noContentType,
                  i = _e$noContentType === void 0 ? !1 : _e$noContentType,
                  a = e.accessToken,
                  c = e.isRevokeCall,
                  d = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
                    "x-client-id": "SPRINGD",
                    "x-channel-id": "SPRINGD",
                    "x-correlation-id": et()
                  }, o && {
                    "x-agent-id": o
                  }), t && "null" !== t && {
                    "uxf-token": t
                  }), n && {
                    authorization: "Bearer " + n
                  }), a && (c ? {
                    token: a
                  } : {
                    "user-authorization": a
                  })), r && {
                    "x-target-url": window.location.href
                  });
                return i ? _objectSpread({}, d) : _objectSpread(_objectSpread({}, d), {}, {
                  "Content-Type": "application/json"
                });
              }({
                curToken: c,
                apigeeToken: d,
                fingerPrintId: u,
                noContentType: o,
                accessToken: s,
                isRevokeCall: i
              }), n.referrer = window.location.href, n.referrerPolicy = "strict-origin-when-cross-origin";
              p = new AbortController();
              return _context3.abrupt("return", (window.detoxAbortController = p, n.signal = p.signal, n.queryParams && (t += (-1 === t.indexOf("?") ? "?" : "&") + function (e) {
                var t = encodeURIComponent,
                  r = function r(e, _r3) {
                    return t(e) + "=" + t(_r3);
                  };
                return Object.keys(e).map(function (t) {
                  var n = e[t];
                  return Array.isArray(n) ? n.map(function (e) {
                    return r(t, e);
                  }).join("&") : r(t, n);
                }).join("&");
              }(n.queryParams), delete n.queryParams), window.mockEnabled && "function" == typeof window.fetchMock ? window.fetchMock(t, n, e) : fetch(t, n).then(function (e) {
                if (!e.ok) return e.text().then(function (t) {
                  var r = new Error(e.statusText);
                  throw r.response = e, r.text = t, r;
                });
                var t = e.headers;
                return l = t.get("uxfauthorization"), l && We(l), e;
              }).then(function (e) {
                return e.json();
              }).then(function (e) {
                return 0 === Object.keys(e).length ? e : _objectSpread(_objectSpread({}, e), {}, {
                  sessionToken: l
                });
              }).catch(function (e) {
                if ("AbortError" !== e.name) throw e;
              })));
            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return function tt(_x3) {
      return _ref3.apply(this, arguments);
    };
  }(),
  rt = function rt(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return tt(e, t, !0);
  },
  nt = function nt(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
    var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    return tt(e, t, !1, r, n);
  },
  ot = function ot(e) {
    return "SU" === e.status || "SUSPENDED" === e.status;
  },
  it = function it(e) {
    return e.find(function (e) {
      return e.productID && "2089835" === e.productSpecContainmentID;
    });
  },
  at = function at(e) {
    return e.find(function (e) {
      return e.productID && "11822" === e.productSpecContainmentID;
    });
  },
  ct = function ct(e) {
    return e.find(function (e) {
      return e.productID && "11762" === e.productSpecContainmentID;
    });
  },
  dt = function dt(e) {
    if (e.services) return e.services.find(function (e) {
      return "CIS" === e.catalogItemName;
    });
  },
  st = function st(e) {
    return e.find(function (e) {
      return e.isPendingPayment;
    });
  },
  ut = function ut(e) {
    if (e) return e.find(function (e) {
      return e.captionId && -1 !== e.captionId.indexOf("SU-");
    });
  },
  lt = function lt(e, t) {
    return t.map(function (t) {
      var r = t.implOrderActionHeaderList.find(function (t) {
        return t.assignedProductId === e;
      });
      return {
        isPendingPayment: t.isPendingPayment,
        orderId: t.orderId,
        orderStatus: null == r ? void 0 : r.orderStatus,
        orderActionId: null == r ? void 0 : r.orderActionId
      };
    }).filter(function (e) {
      return "NE" === e.orderStatus && !e.isPendingPayment;
    });
  },
  pt = function pt(e, t) {
    return e.map(function (e) {
      var t;
      var r = 1 === (null === (t = e.implOrderActionHeaderList) || void 0 === t ? void 0 : t.length) ? e.implOrderActionHeaderList[0] : {};
      return {
        isPendingPayment: e.isPendingPayment,
        orderId: e.orderId,
        orderStatus: null == r ? void 0 : r.orderStatus,
        orderActionId: null == r ? void 0 : r.orderActionId
      };
    }).filter(function (e) {
      return "NE" === e.orderStatus && !e.isPendingPayment && e.orderId !== t;
    });
  },
  It = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(e, t) {
      var r, n;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (e) {
                _context5.next = 2;
                break;
              }
              return _context5.abrupt("return");
            case 2:
              _context5.next = 4;
              return Fe(e);
            case 4:
              r = _context5.sent;
              n = pt(r, t);
              _context5.next = 8;
              return Ye(n, /*#__PURE__*/function () {
                var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(t) {
                  return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          _context4.next = 2;
                          return we({
                            customerId: e,
                            productOrderId: t.orderId,
                            productOrderItemId: t.orderActionId
                          });
                        case 2:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4);
                }));
                return function (_x6) {
                  return _ref5.apply(this, arguments);
                };
              }());
            case 8:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));
    return function It(_x4, _x5) {
      return _ref4.apply(this, arguments);
    };
  }(),
  mt = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(e, t, r) {
      var n;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              n = lt(r, e);
              _context7.next = 3;
              return Ye(n, /*#__PURE__*/function () {
                var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(e) {
                  return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                      switch (_context6.prev = _context6.next) {
                        case 0:
                          _context6.next = 2;
                          return we({
                            customerId: t,
                            productOrderId: e.orderId,
                            productOrderItemId: e.orderActionId
                          });
                        case 2:
                        case "end":
                          return _context6.stop();
                      }
                    }
                  }, _callee6);
                }));
                return function (_x10) {
                  return _ref7.apply(this, arguments);
                };
              }());
            case 3:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));
    return function mt(_x7, _x8, _x9) {
      return _ref6.apply(this, arguments);
    };
  }(),
  Et = function Et(e, t, r) {
    return e.reduce(function (e, n) {
      var o = t instanceof Function ? t(n) : n[t] || n[r],
        i = e.find(function (e) {
          return e && e.key === o;
        });
      return i ? i.values.push(n) : e.push({
        key: o,
        values: [n]
      }), e;
    }, []);
  },
  Rt = function Rt(e, t) {
    return Object.keys(t).every(function (r) {
      return e[r] === t[r];
    });
  },
  St = function St(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    if (!r.length) return e;
    var n = _toConsumableArray(e);
    return [].concat(_toConsumableArray(r.map(function (e) {
      var r = n.findIndex(function (r) {
          return r[t] === e;
        }),
        o = n[r];
      return o && n.splice(r, 1), o;
    }).filter(Boolean)), _toConsumableArray(n));
  },
  _t = function _t(e) {
    return u.includes(e);
  };
var Ot = Object.freeze({
  __proto__: null,
  asyncForEach: Ye,
  temporaryID: xe,
  generateTemporaryId: He,
  authorizationTokenStorageKey: "LightsaberSessionToken",
  worryFreeLoggedIn: "WORRY_FREE_LOGGED_IN",
  setWorryFreeStatus: $e,
  isWorryFreeLoggedIn: function isWorryFreeLoggedIn() {
    return "true" === window.localStorage.getItem("WORRY_FREE_LOGGED_IN");
  },
  clearWorryFreeStatus: qe,
  setToken: We,
  getToken: Xe,
  deleteToken: je,
  setAuthToken: Ke,
  getAuthToken: Je,
  getUiamAccessToken: Ze,
  getAgentIdFromCookie: ze,
  getFingerPrintId: Qe,
  getUIAMUUID: et,
  mcssFetchNoContentType: rt,
  mcssFetch: nt,
  isMobileService: function isMobileService(e) {
    if (!e || !e.offeringName) return !1;
    var t = e.offeringName.toUpperCase();
    return "WS" === e.lob && -1 === t.indexOf("BROADBAND");
  },
  isServiceSuspended: ot,
  isEligibleForRecontract: function isEligibleForRecontract(e) {
    return !ot(e);
  },
  getSilverComponent: it,
  getStaffComponent: at,
  getCisComponent: ct,
  getCisService: dt,
  hasPendingPaymentOrder: st,
  hasFutureDatedSuspension: ut,
  getOpenOrdersForService: lt,
  getOpenOrdersForNewFlow: pt,
  deleteOpenOrderForNewFlow: It,
  deleteOpenOrders: mt,
  groupByArray: Et,
  mappingObject: Rt,
  arrayObjBySequence: St,
  isFreebieContainmentId: _t,
  isCisSessionWithMyInfo: ke,
  getCompanyInfo: Be,
  getCisSessionType: function getCisSessionType(e) {
    return "myinfo" == e.source ? "MY_INFO" : "EMAIL";
  }
});
var Ct = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(e) {
      var t, r, n, o, a, c, d;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              t = e.cleanWorryFree;
              r = i + "/onepass/headers";
              n = {
                queryParams: {
                  cleanWorryFree: !!t
                }
              };
              _context8.next = 5;
              return nt(r, n);
            case 5:
              o = _context8.sent;
              a = o.ImplLoginHeaderResOutput;
              c = o.sessionToken;
              d = a.headersMap;
              return _context8.abrupt("return", _objectSpread(_objectSpread({}, d), {}, {
                sessionToken: c
              }));
            case 10:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));
    return function Ct(_x11) {
      return _ref8.apply(this, arguments);
    };
  }(),
  ft = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(e) {
      var t, r, n, o, a, c, d;
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              t = e.cleanWorryFree;
              r = _objectWithoutProperties(e, _excluded);
              n = i + "/worryfree/otp/send";
              o = {
                method: "POST",
                queryParams: {
                  cleanWorryFree: Boolean(t)
                },
                body: JSON.stringify({
                  ImplWorryFreeOTPInput: r
                }),
                credentials: "include"
              };
              _context9.next = 6;
              return nt(n, o);
            case 6:
              a = _context9.sent;
              c = a.ImplWorryFreeOTPOutput;
              d = a.sessionToken;
              return _context9.abrupt("return", _objectSpread(_objectSpread({}, c), {}, {
                sessionToken: d
              }));
            case 10:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));
    return function ft(_x12) {
      return _ref9.apply(this, arguments);
    };
  }(),
  yt = /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(e) {
      var t, r, n, o, a;
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              t = i + "/worryfree/otp/verify";
              r = {
                method: "POST",
                body: JSON.stringify({
                  ImplWorryFreeOTPInput: e
                }),
                credentials: "include"
              };
              _context10.next = 4;
              return nt(t, r);
            case 4:
              n = _context10.sent;
              o = n.ImplWorryFreeOTPOutput;
              a = n.sessionToken;
              return _context10.abrupt("return", _objectSpread(_objectSpread({}, o), {}, {
                sessionToken: a
              }));
            case 8:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));
    return function yt(_x13) {
      return _ref10.apply(this, arguments);
    };
  }();
var Tt = {
  SEARCH_NUMBERS_LIMIT: 12,
  WORRYFREE_ACCOUNT_VERIFY_URL: "/worryfree/billingAccount/save/sendotp"
};
var At = function At() {
    return nt(i + "/worryfree", {
      method: "DELETE"
    });
  },
  Dt = function Dt(e) {
    var t = i + "/user/information";
    return (null == e ? void 0 : e.updateCache) && (t += "?infovar=A7xY3bQ9zK"), nt(t).then(function (e) {
      var _ref11 = e || {},
        t = _ref11.ImplUserInformationResponse,
        r = _ref11.sessionToken;
      if (!t) return e;
      var n = t.anonymouUser,
        o = _objectWithoutProperties(t, _excluded2),
        i = _objectSpread(_objectSpread({}, o), {}, {
          sessionToken: r
        });
      return i.anonymousUser = n, i;
    });
  },
  Pt = function Pt(e) {
    return nt("".concat(i, "/ecommerce/customer/").concat(e, "/products"), {
      queryParams: {
        sc: "SS",
        lo: "en_US"
      }
    }).then(function (e) {
      return e.Products.products;
    });
  },
  vt = /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(e) {
      var t, r, n;
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              t = e.customerId, r = e.productId, n = "".concat(i, "/ecommerce/customer/").concat(t, "/product/").concat(r);
              _context11.next = 3;
              return nt(n, {
                queryParams: {
                  allParams: !0,
                  sc: "SS",
                  lo: "en_US"
                }
              });
            case 3:
              return _context11.abrupt("return", _context11.sent.Product);
            case 4:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));
    return function vt(_x14) {
      return _ref12.apply(this, arguments);
    };
  }(),
  ht = function ht(e) {
    var t = i + "/cce/validateSessionToken",
      r = {
        method: "POST",
        queryParams: {
          sc: "SS",
          lo: "en_US"
        },
        body: JSON.stringify({
          ImplValidateSessionTokenInput: {
            sessionToken: e
          }
        })
      };
    return nt(t, r).then(function (e) {
      var t = e.ImplValidateSessionTokenOutput;
      return _objectSpread({}, t);
    });
  },
  gt = function gt() {
    return {
      type: "RESET_PRODUCT"
    };
  },
  Nt = function Nt() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return e.find(function (e) {
      return "SIM" === e.catalogItemName || "8027872" === e.catalogItemID;
    });
  },
  bt = function bt(e) {
    var t = e.parameters.find(function (e) {
        return "SIM Type" === e.name && e.valueName === c || "Stock Code" === e.name && "381187630N" === e.valueName;
      }),
      r = e.parameters.find(function (e) {
        return "Master SIM Indicator" === e.name && "Yes" === e.valueName;
      });
    return {
      is5GSimService: Boolean(t),
      isMultiSimService: Boolean(r)
    };
  };
var Lt = Object.freeze({
  __proto__: null,
  setSelectedProduct: function setSelectedProduct(e) {
    return {
      type: "SET_SELECTED_PRODUCT",
      payload: e
    };
  },
  resetProduct: gt,
  getSimService: Nt,
  getSimIndicator: bt
});
var Ut = function Ut() {
    return {
      type: "RESET_USER"
    };
  },
  Mt = function Mt(e) {
    return {
      type: "SET_USER_INFORMATION",
      value: e
    };
  },
  wt = function wt() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
    return {
      type: "SET_USER_LOADING",
      value: e
    };
  },
  Gt = function Gt(e) {
    return {
      type: "SET_USER_ERROR",
      value: e
    };
  },
  Ft = function Ft(e) {
    return {
      type: "SET_USER_PRODUCTS",
      value: e
    };
  },
  kt = function kt(e) {
    return {
      type: "SET_CIS_LOADING",
      value: e
    };
  },
  Bt = function Bt(e) {
    return {
      type: "SET_CIS_ERROR",
      value: e
    };
  };
function Vt() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return /*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(t) {
      var _r4;
      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              t(wt(!0));
              _context12.prev = 1;
              _context12.next = 4;
              return Dt(e);
            case 4:
              _r4 = _context12.sent;
              t(Mt(_r4)), t(wt(!1));
              _context12.next = 11;
              break;
            case 8:
              _context12.prev = 8;
              _context12.t0 = _context12["catch"](1);
              t(Gt(_context12.t0));
            case 11:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, null, [[1, 8]]);
    }));
    return function (_x15) {
      return _ref13.apply(this, arguments);
    };
  }();
}
function Yt(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return /*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(r) {
      var n, o;
      return _regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              n = e.map( /*#__PURE__*/function () {
                var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(e) {
                  var _r5;
                  return _regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) {
                      switch (_context14.prev = _context14.next) {
                        case 0:
                          _context14.prev = 0;
                          _context14.next = 3;
                          return Pt(e);
                        case 3:
                          _r5 = _context14.sent;
                          return _context14.abrupt("return", _r5 ? function (e, r) {
                            var n = t.reduce(function (e, t) {
                              return t ? e.filter(t) : e;
                            }, r).map(function (e) {
                              return e.id;
                            }).map( /*#__PURE__*/function () {
                              var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(t) {
                                var n, o, i, a;
                                return _regeneratorRuntime.wrap(function _callee13$(_context13) {
                                  while (1) {
                                    switch (_context13.prev = _context13.next) {
                                      case 0:
                                        n = r.find(function (e) {
                                          return e.id === t;
                                        });
                                        _context13.next = 3;
                                        return vt({
                                          customerId: e,
                                          productId: t
                                        });
                                      case 3:
                                        o = _context13.sent;
                                        i = Nt(null == o ? void 0 : o.services);
                                        a = {};
                                        return _context13.abrupt("return", (i && (a = bt(i)), _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, n), o), a), {}, {
                                          customerId: e
                                        })));
                                      case 7:
                                      case "end":
                                        return _context13.stop();
                                    }
                                  }
                                }, _callee13);
                              }));
                              return function (_x18) {
                                return _ref16.apply(this, arguments);
                              };
                            }());
                            return Promise.all(n);
                          }(e, _r5) : []);
                        case 7:
                          _context14.prev = 7;
                          _context14.t0 = _context14["catch"](0);
                          if (!(_context14.t0.response && 403 === _context14.t0.response.status)) {
                            _context14.next = 11;
                            break;
                          }
                          return _context14.abrupt("return", []);
                        case 11:
                        case "end":
                          return _context14.stop();
                      }
                    }
                  }, _callee14, null, [[0, 7]]);
                }));
                return function (_x17) {
                  return _ref15.apply(this, arguments);
                };
              }());
              r({
                type: Sr.USER.USER_PRODUCT_LOADING
              });
              _context15.next = 4;
              return Promise.all(n).then(function (e) {
                return e.reduce(function (e, t) {
                  return e.concat(t);
                }, []);
              });
            case 4:
              o = _context15.sent;
              r(Ft(o));
            case 6:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15);
    }));
    return function (_x16) {
      return _ref14.apply(this, arguments);
    };
  }();
}
var xt = Object.freeze({
  __proto__: null,
  resetUser: Ut,
  setUserLoading: wt,
  setUserError: Gt,
  setSelectedService: function setSelectedService(e) {
    return {
      type: "SET_SELECTED_SERVICE",
      value: e
    };
  },
  setUserState: function setUserState(e) {
    return {
      type: "SET_USER",
      value: e
    };
  },
  getUserInformation: Vt,
  getUserProducts: Yt,
  getUserInfoAndProducts: function getUserInfoAndProducts(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      getMainLinesOnly: !1,
      shouldFetchMainLines: !1
    };
    return /*#__PURE__*/function () {
      var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(r) {
        var _t$getMainLinesOnly, n, _t$shouldFetchMainLin, o, a, c, _e3, _a$clientContext, d, s, u, l, _e4, _t5, _r6;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _t$getMainLinesOnly = t.getMainLinesOnly, n = _t$getMainLinesOnly === void 0 ? !1 : _t$getMainLinesOnly, _t$shouldFetchMainLin = t.shouldFetchMainLines, o = _t$shouldFetchMainLin === void 0 ? !1 : _t$shouldFetchMainLin;
                c = function c(e) {
                  return r({
                    type: "GA_TRACKING_USER_PRODUCTS_ERRORS",
                    payload: {
                      label: e
                    }
                  }), r(Gt());
                };
                r(wt());
                _context16.prev = 3;
                _context16.next = 6;
                return Dt();
              case 6:
                a = _context16.sent;
                _context16.next = 12;
                break;
              case 9:
                _context16.prev = 9;
                _context16.t0 = _context16["catch"](3);
                return _context16.abrupt("return", _context16.t0.response && 400 === _context16.t0.response.status ? r(Mt({
                  anonymousUser: !0
                })) : (r(Mt({
                  clientContext: {
                    customers: []
                  }
                })), r(Ft([]))));
              case 12:
                if (!(a && a.anonymousUser)) {
                  _context16.next = 14;
                  break;
                }
                return _context16.abrupt("return", r(Mt(a)));
              case 14:
                if (!(0 === Object.keys(a.userDetails).length)) {
                  _context16.next = 25;
                  break;
                }
                _context16.prev = 15;
                _context16.next = 18;
                return Ct({
                  cleanWorryFree: !1
                });
              case 18:
                _e3 = _context16.sent;
                a.userDetails = {
                  custId: _e3.HTTP_CUST_ID,
                  custIdType: _e3.HTTP_CUST_ID_TYPE
                };
                _context16.next = 25;
                break;
              case 22:
                _context16.prev = 22;
                _context16.t1 = _context16["catch"](15);
                return _context16.abrupt("return", c("Error from apiOnePassHeaders"));
              case 25:
                r(Mt(a));
                _a$clientContext = a.clientContext, d = _a$clientContext.customers, s = _a$clientContext.contact, u = d.map(function (e) {
                  return e.customerId;
                }).filter(function (e, t, r) {
                  return r.indexOf(e) === t;
                });
                l = [e];
                if (!(o || n)) {
                  _context16.next = 34;
                  break;
                }
                _context16.next = 31;
                return function (e) {
                  var t = e.contactId,
                    _e$isMBB = e.isMBB,
                    r = _e$isMBB === void 0 ? !1 : _e$isMBB;
                  return nt("".concat(i, "/contact-person/").concat(t, "/group-list"), {
                    method: "GET",
                    queryParams: {
                      isMBB: r,
                      sc: "SS",
                      lo: "en_US"
                    }
                  }).then(function (e) {
                    return e.ImplGetGroupListOutput.implCustomerGroupIdsList;
                  });
                }({
                  contactId: s.contactId
                });
              case 31:
                _e4 = _context16.sent;
                _t5 = function _t5(e) {
                  return (e || []).map(function (e) {
                    return e.implGroupId;
                  }).reduce(function (e, t) {
                    return [].concat(_toConsumableArray(e), _toConsumableArray(t));
                  }, []).reduce(function (e, t) {
                    return _objectSpread(_objectSpread({}, e), {}, _defineProperty({}, t.mainLineMSISDN, _objectSpread({}, t)));
                  }, {});
                };
                if (r({
                  type: "SET_USER_MAIN_LINES",
                  value: _t5(_e4)
                }), n) {
                  _r6 = function _r6(r) {
                    return Boolean(_t5(_e4)[r.serviceId]);
                  };
                  l = [].concat(_toConsumableArray(l), [_r6]);
                }
              case 34:
                _context16.prev = 34;
                _context16.next = 37;
                return r(Yt(u, l));
              case 37:
                _context16.next = 42;
                break;
              case 39:
                _context16.prev = 39;
                _context16.t2 = _context16["catch"](34);
                return _context16.abrupt("return", c("Error from getUserProducts"));
              case 42:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, null, [[3, 9], [15, 22], [34, 39]]);
      }));
      return function (_x19) {
        return _ref17.apply(this, arguments);
      };
    }();
  },
  getUserMainProducts: function getUserMainProducts(_ref18) {
    var e = _ref18.customerId;
    return /*#__PURE__*/function () {
      var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(t) {
        var _r7;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                t({
                  type: "FETCH_USER_MAIN_PRODUCTS_LOADING"
                });
                _context17.prev = 1;
                _context17.next = 4;
                return Pt(e);
              case 4:
                _r7 = _context17.sent;
                t({
                  type: "FETCH_USER_MAIN_PRODUCTS_SUCCESS",
                  value: _r7
                });
                _context17.next = 11;
                break;
              case 8:
                _context17.prev = 8;
                _context17.t0 = _context17["catch"](1);
                t({
                  type: "FETCH_USER_MAIN_PRODUCTS_ERROR"
                });
              case 11:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, null, [[1, 8]]);
      }));
      return function (_x20) {
        return _ref19.apply(this, arguments);
      };
    }();
  },
  validateCISToken: function validateCISToken(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "EMAIL";
    return /*#__PURE__*/function () {
      var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(r) {
        var _n4, _n5, _o3, _t6, a, _c3, _e5, _t7, _d4;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.prev = 0;
                r(kt(!0));
                _n4 = null;
                if (!("MY_INFO" == t)) {
                  _context18.next = 9;
                  break;
                }
                _context18.next = 6;
                return function (e) {
                  var t = i + "/cce/cisOrstaff/validateSessionToken",
                    r = {
                      method: "POST",
                      queryParams: {
                        sc: "SS",
                        lo: "en_US"
                      },
                      body: JSON.stringify({
                        ImplValidateSessionTokenInput: {
                          sessionToken: e,
                          isCIS: !0
                        }
                      })
                    };
                  return nt(t, r).then(function (e) {
                    var t = e.ImplValidateTokenResponse;
                    return _objectSpread({}, t);
                  });
                }(e);
              case 6:
                _context18.t0 = _context18.sent;
                _context18.next = 12;
                break;
              case 9:
                _context18.next = 11;
                return ht(e);
              case 11:
                _context18.t0 = _context18.sent;
              case 12:
                _n4 = _context18.t0;
                _n5 = _n4, _o3 = _n5.errorCode;
                if (!_o3) {
                  _context18.next = 18;
                  break;
                }
                r(kt(!1));
                _t6 = "CIS_" + _o3;
                return _context18.abrupt("return", (r({
                  type: "GA_TRACKING_CIS_ERRORS",
                  payload: {
                    errorCode: _o3,
                    token: e
                  }
                }), r(Bt(_t6))));
              case 18:
                a = _n4, _c3 = null;
                if (ke(_n4)) {
                  _e5 = _n4, _t7 = _e5.token;
                  a = Be(_e5, "MY_INFO"), _c3 = {
                    $myInfo: {
                      accessToken: _t7
                    }
                  };
                } else "true" === _n4.resultStatus && (a = _n4, _c3 = null);
                _d4 = _objectSpread(_objectSpread({}, a), _c3);
                r({
                  type: "SET_CIS_INFORMATION",
                  value: _d4
                });
                _context18.next = 27;
                break;
              case 24:
                _context18.prev = 24;
                _context18.t1 = _context18["catch"](0);
                r(kt(!1)), r(Bt("CIS_GENERIC_ERROR")), r({
                  type: "GA_TRACKING_CIS_GENERIC_ERRORS",
                  payload: {
                    token: e
                  }
                });
              case 27:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, null, [[0, 24]]);
      }));
      return function (_x21) {
        return _ref20.apply(this, arguments);
      };
    }();
  }
});
var Ht = "RESET_AUTH",
  $t = "RESET_WORRY_FREE",
  qt = "SET_WORRY_FREE_STATUS",
  Wt = "RESET_WORRY_FREE_STATUS",
  Xt = "SET_AUTH_STATUS",
  jt = "SET_WORRY_FREE_DETAILS",
  Kt = "SET_UXF_AUTH_TOKEN",
  Jt = "SET_WORRY_FREE_LOADING",
  Zt = "WORRY_FREE_ACCOUNT_VERIFIED",
  zt = "OTP_SENT",
  Qt = "OTP_RESEND_SUCCESS",
  er = "OTP_MISMATCH_ERROR",
  tr = "OTP_EXCEED_LIMIT_ERROR",
  rr = "OTP_VERIFIED",
  nr = "OTP_VERIFY_ERROR",
  or = "OTP_TIMEOUT_ERROR",
  ir = "OTP_GENERIC_ERROR",
  ar = "ADDITIONAL_VERIFY_ERROR",
  cr = "NEW_NEW_CUSTOMER",
  dr = "NEW_CUSTOMER_TO_MOBILE",
  sr = "WORRY_FREE_FA_CHECK",
  ur = "WORRY_FREE_OTP",
  lr = "LOGGED_IN",
  pr = "CIS_GET_MYINFO_LOADING",
  Ir = "CIS_GET_MYINFO_SUCCESS",
  mr = "CIS_GET_MYINFO_ERROR_STATUS",
  Er = "CIS_MISMATCH_ERROR",
  Rr = "CIS_GET_MYINFO_ERROR",
  Sr = {
    USER: {
      USER_PRODUCT_LOADING: "USER_PRODUCT_LOADING",
      USER_PRODUCT_FAILED: "USER_PRODUCT_FAILED"
    },
    CHECKOUT_ACTIONS: {
      UPDATE_CUSTOMER_SUCCESS: "UPDATE_CUSTOMER_SUCCESS",
      CHECK_EXIST_ACCOUNT_SUCCESS: "CHECK_EXIST_ACCOUNT_SUCCESS",
      CHECK_IDENTITY_SUCCESS: "CHECK_IDENTITY_SUCCESS",
      CREATE_BILLING_ADDRESS_LOADING: "CREATE_BILLING_ADDRESS_LOADING",
      CREATE_BILLING_ADDRESS_SUCCESS: "CREATE_BILLING_ADDRESS_SUCCESS",
      CREATE_BILLING_ADDRESS_FAILED: "CREATE_BILLING_ADDRESS_FAILED",
      UPDATE_BILLING_ADDRESS_LOADING: "UPDATE_BILLING_ADDRESS_LOADING",
      UPDATE_BILLING_ADDRESS_SUCCESS: "UPDATE_BILLING_ADDRESS_SUCCESS",
      UPDATE_BILLING_ADDRESS_FAILED: "UPDATE_BILLING_ADDRESS_FAILED",
      RETRIEVE_CONTACT_DETAIL_LOADING: "RETRIEVE_CONTACT_DETAIL_LOADING",
      RETRIEVE_CONTACT_DETAIL_ERROR: "RETRIEVE_CONTACT_DETAIL_ERROR",
      RETRIEVE_CONTACT_DETAIL_SUCCESS: "RETRIEVE_CONTACT_DETAIL_SUCCESS"
    },
    UPDATE_ORDER_PRODUCT: {
      UPDATE_ORDER_PRODUCT_LOADING: "UPDATE_ORDER_PRODUCT_LOADING",
      UPDATE_ORDER_PRODUCT_SUCCESS: "UPDATE_ORDER_PRODUCT_SUCCESS",
      UPDATE_ORDER_PRODUCT_ERROR: "UPDATE_ORDER_PRODUCT_ERROR"
    },
    ORDER_SUMMARY: {
      FETCH_ORDER_SUMMARY_LOADING: "FETCH_ORDER_SUMMARY_LOADING",
      FETCH_ORDER_SUMMARY_SUCCESS: "FETCH_ORDER_SUMMARY_SUCCESS",
      FETCH_ORDER_SUMMARY_ERROR: "FETCH_ORDER_SUMMARY_ERROR",
      REQUEST_PAYMENT_LOADING: "REQUEST_PAYMENT_LOADING",
      REQUEST_PAYMENT_SUCCESS: "REQUEST_PAYMENT_SUCCESS",
      REQUEST_PAYMENT_FAILED: "REQUEST_PAYMENT_FAILED",
      VERIFY_PAYMENT_LOADING: "VERIFY_PAYMENT_LOADING",
      VERIFY_PAYMENT_SUCCESS: "VERIFY_PAYMENT_SUCCESS",
      VERIFY_PAYMENT_FAILED: "VERIFY_PAYMENT_FAILED",
      SET_PAYMENT_STATUS: "SET_PAYMENT_STATUS",
      CREATE_PROBLEM_LOADING: "CREATE_PROBLEM_LOADING",
      CREATE_PROBLEM_SUCCESS: "CREATE_PROBLEM_SUCCESS",
      CREATE_PROBLEM_FAILED: "CREATE_PROBLEM_FAILED",
      DISTRIBUTE_PROMO_CODE_LOADING: "DISTRIBUTE_PROMO_CODE_LOADING",
      DISTRIBUTE_PROMO_CODE_SUCCESS: "DISTRIBUTE_PROMO_CODE_SUCCESS",
      DISTRIBUTE_PROMO_CODE_FAILURE: "DISTRIBUTE_PROMO_CODE_FAILURE",
      GET_BILLING_REF_LOADING: "GET_BILLING_REF_LOADING",
      GET_BILLING_REF_SUCCESS: "GET_BILLING_REF_SUCCESS",
      GET_BILLING_REF_FAILED: "GET_BILLING_REF_FAILED",
      GET_PAYMENT_INTENT_LOADING: "GET_PAYMENT_INTENT_LOADING",
      GET_PAYMENT_INTENT_SUCCESS: "GET_PAYMENT_INTENT_SUCCESS",
      GET_PAYMENT_INTENT_FAILED: "GET_PAYMENT_INTENT_FAILED",
      GET_CONTRACT_LOADING: "GET_CONTRACT_LOADING",
      GET_CONTRACT_SUCCESS: "GET_CONTRACT_SUCCESS",
      GET_CONTRACT_FAILED: "GET_CONTRACT_FAILED",
      CUSTOMER_CONTACT_UPDATE_LOADING: "CUSTOMER_CONTACT_UPDATE_LOADING",
      CUSTOMER_CONTACT_UPDATE_SUCCESS: "CUSTOMER_CONTACT_UPDATE_SUCCESS",
      CUSTOMER_CONTACT_UPDATE_FAILURE: "CUSTOMER_CONTACT_UPDATE_FAILURE"
    },
    RRP_ORDER_SUMMARY: {
      RRP_ORDER_SUMMARY_LOADING: "RRP_ORDER_SUMMARY_LOADING",
      RRP_ORDER_SUMMARY_SUCCESS: "RRP_ORDER_SUMMARY_SUCCESS",
      RRP_ORDER_SUMMARY_ERROR: "RRP_ORDER_SUMMARY_ERROR",
      RRP_PROMO_CODE_LOADING: "RRP_PROMO_CODE_LOADING",
      RRP_PROMO_CODE_SUCCESS: "RRP_PROMO_CODE_SUCCESS",
      RRP_PROMO_CODE_ERROR: "RRP_PROMO_CODE_ERROR",
      RRP_PAYMENT_REQUEST_LOADING: "RRP_PAYMENT_REQUEST_LOADING",
      RRP_PAYMENT_REQUEST_SUCCESS: "RRP_PAYMENT_REQUEST_SUCCESS",
      RRP_PAYMENT_REQUEST_ERROR: "RRP_PAYMENT_REQUEST_ERROR"
    },
    AUTH: {
      GET_ONEPASS_HEADER_SUCCESS: "GET_ONEPASS_HEADER_SUCCESS",
      GET_ONEPASS_HEADER_FAILED: "GET_ONEPASS_HEADER_FAILED",
      GET_ONEPASS_HEADER_LOADING: "GET_ONEPASS_HEADER_LOADING"
    },
    PAYMENT: {
      CASH_ON_DELIVERY_LOADING: "CASH_ON_DELIVERY_LOADING",
      CASH_ON_DELIVERY_SUCCESS: "CASH_ON_DELIVERY_SUCCESS",
      CASH_ON_DELIVERY_ERROR: "CASH_ON_DELIVERY_ERROR"
    },
    THIRD_PARTY: {
      UPDATE_INDICATOR_ERROR: "UPDATE_INDICATOR_ERROR"
    },
    IPHONE: {
      VALIDATE_GET_SKU_LOADING: "IPHONE_VALIDATE_GET_SKU_LOADING",
      VALIDATE_GET_SKU_SUCCESS: "IPHONE_VALIDATE_GET_SKU_SUCCESS",
      VALIDATE_GET_SKU_FAILED: "IPHONE_VALIDATE_GET_SKU_FAILED",
      VALIDATE_OTP_LOADING: "IPHONE_VALIDATE_OTP_LOADING",
      VALIDATE_OTP_SUCCESS: "IPHONE_VALIDATE_OTP_SUCCESS",
      VALIDATE_OTP_FAILED: "IPHONE_VALIDATE_OTP_FAILED"
    },
    UIAM: {
      GET_UIAM_STATE_LOADING: "GET_UIAM_STATE_LOADING",
      GET_UIAM_STATE_ERROR: "GET_UIAM_STATE_ERROR",
      GET_UIAM_STATE_ID_SUCCESS: "GET_UIAM_STATE_ID_SUCCESS",
      SET_UIAM_TARGET_URL_LOADING: "SET_UIAM_TARGET_URL_LOADING",
      SET_UIAM_TARGET_URL_ERROR: "SET_UIAM_TARGET_URL_ERROR",
      SET_UIAM_TARGET_URL_SUCCESS: "SET_UIAM_TARGET_URL_SUCCESS",
      APP_UUID: "APP_UU_ID"
    },
    ORDER: {
      UPDATE_PRODUCT_ORDER: "UPDATE_PRODUCT_ORDER"
    },
    ORDER_UNDER_PROCESSING: "ORDER_UNDER_PROCESSING",
    RRP: {
      REGISTER_CUSTOMER_LOADING: "REGISTER_CUSTOMER_LOADING",
      REGISTER_CUSTOMER_SUCCESS: "REGISTER_CUSTOMER_SUCCESS",
      REGISTER_CUSTOMER_ERROR: "REGISTER_CUSTOMER_ERROR",
      SEND_OTP_LOADING: "SEND_OTP_LOADING",
      SEND_OTP_SUCCESS: "SEND_OTP_SUCCESS",
      SEND_OTP_ERROR: "SEND_OTP_ERROR",
      RESEND_OTP_LOADING: "RESEND_OTP_LOADING",
      RESEND_OTP_SUCCESS: "RESEND_OTP_SUCCESS",
      RESEND_OTP_ERROR: "RESEND_OTP_ERROR"
    },
    RRP_CART: {
      RRP_ADD_MASTER_ORDER_LOADING: "RRP_ADD_MASTER_ORDER_LOADING",
      RRP_ADD_MASTER_ORDER_SUCCESS: "RRP_ADD_MASTER_ORDER_SUCCESS",
      RRP_ADD_MASTER_ORDER_ERROR: "RRP_ADD_MASTER_ORDER_ERROR",
      RRP_REMOVE_MASTER_ORDER_LOADING: "RRP_REMOVE_MASTER_ORDER_LOADING",
      RRP_REMOVE_MASTER_ORDER_SUCCESS: "RRP_REMOVE_MASTER_ORDER_SUCCESS",
      RRP_REMOVE_MASTER_ORDER_ERROR: "RRP_REMOVE_MASTER_ORDER_ERROR",
      RRP_SHOPPING_CART_LOADING: "RRP_SHOPPING_CART_LOADING",
      RRP_SHOPPING_CART_SUCCESS: "RRP_SHOPPING_CART_SUCCESS",
      RRP_SHOPPING_CART_ERROR: "RRP_SHOPPING_CART_ERROR",
      RRP_CANCEL_MASTER_ORDER_SUCCESS: "RRP_CANCEL_MASTER_ORDER_SUCCESS",
      RRP_CANCEL_MASTER_ORDER_LOADING: "RRP_CANCEL_MASTER_ORDER_LOADING",
      RRP_CANCEL_MASTER_ORDER_ERROR: "RRP_CANCEL_MASTER_ORDER_ERROR",
      RRP_EXTEND_SESSION_LOADING: "RRP_EXTEND_SESSION_LOADING",
      RRP_EXTEND_SESSION_SUCCESS: "RRP_EXTEND_SESSION_SUCCESS",
      RRP_EXTEND_SESSION_ERROR: "RRP_EXTEND_SESSION_ERROR",
      RRP_CANCEL_ORDER_SUCCESS: "RRP_CANCEL_ORDER_SUCCESS",
      RRP_CANCEL_ORDER_LOADING: "RRP_CANCEL_ORDER_LOADING",
      RRP_CANCEL_ORDER_ERROR: "RRP_CANCEL_ORDER_ERROR",
      CREATE_ORDER_SUCCESS: "RRP_CREATE_ORDER_SUCCESS",
      CREATE_ORDER_LOADING: "RRP_CREATE_ORDER_LOADING",
      CREATE_ORDER_FAIL: "RRP_CREATE_ORDER_FAILED",
      RESET_STATE: "RRP_RESET_STATE",
      RETRIEVE_RRP_IPP_DESCRIPTION_LOADING: "RETRIEVE_RRP_IPP_DESCRIPTION_LOADING",
      RETRIEVE_RRP_IPP_DESCRIPTION_SUCCESS: "RETRIEVE_RRP_IPP_DESCRIPTION_SUCCESS",
      RETRIEVE_RRP_IPP_DESCRIPTION_FAIL: "RETRIEVE_RRP_IPP_DESCRIPTION_FAILED",
      RRP_CREATE_IPP_ORDER_LOADING: "RRP_CREATE_IPP_ORDER_LOADING",
      RRP_CREATE_IPP_ORDER_SUCCESS: "RRP_CREATE_IPP_ORDER_SUCCESS",
      DELETE_IPP_ORDER_LOADING: "DELETE_IPP_ORDER_LOADING",
      DELETE_IPP_ORDER_SUCCESS: "DELETE_IPP_ORDER_SUCCESS",
      DELETE_IPP_ORDER_FAILED: "DELETE_IPP_ORDER_FAILED",
      RRP_CREATE_IPP_ORDER_FAIL: "RRP_CREATE_IPP_ORDER_FAILED",
      RRP_CREATE_IPP_ORDER_FAIL_HAS_PENDING_PAYMENT: "RRP_CREATE_IPP_ORDER_FAIL_HAS_PENDING_PAYMENT",
      RRP_SET_TEMP_IPP_CART_ITEM: "RRP_SET_TEMP_IPP_CART_ITEM",
      RRP_SET_PAYMENT_TERM: "RRP_SET_PAYMENT_TERM",
      RRP_CLEAR_ORDER: "RRP_CLEAR_ORDER",
      RRP_IPP_NOT_ELIGIBLE: "RRP_IPP_NOT_ELIGIBLE"
    },
    CUSTOMER_MY_INFO: {
      RETRIEVE_MY_INFO_URL_LOADING: "RETRIEVE_MY_INFO_URL_LOADING",
      RETRIEVE_MY_INFO_URL_SUCCESS: "RETRIEVE_MY_INFO_URL_SUCCESS",
      RETRIEVE_MY_INFO_URL_FAILURE: "RETRIEVE_MY_INFO_URL_FAILURE",
      GET_CUSTOMER_MY_INFO_LOADING: "GET_CUSTOMER_MY_INFO_LOADING",
      GET_CUSTOMER_MY_INFO_SUCCESS: "GET_CUSTOMER_MY_INFO_SUCCESS",
      GET_CUSTOMER_MY_INFO_FAILURE: "GET_CUSTOMER_MY_INFO_FAILURE"
    }
  },
  _r = /*#__PURE__*/function () {
    var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(e, t) {
      var r, n, o, i;
      return _regeneratorRuntime.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              _context19.prev = 0;
              if (!(null == e || null === (r = e.data) || void 0 === r ? void 0 : r.json)) {
                _context19.next = 12;
                break;
              }
              _context19.t0 = _objectSpread;
              _context19.t1 = _objectSpread;
              _context19.t2 = {};
              _context19.next = 7;
              return null == e || null === (o = e.data) || void 0 === o || null === (i = o.clone()) || void 0 === i ? void 0 : i.json();
            case 7:
              _context19.t3 = _context19.sent;
              _context19.t4 = (0, _context19.t1)(_context19.t2, _context19.t3);
              _context19.t5 = {};
              _context19.t6 = {
                status: e.data.status
              };
              return _context19.abrupt("return", (0, _context19.t0)(_context19.t4, _context19.t5, _context19.t6));
            case 12:
              if (!(null == e ? void 0 : e.text)) {
                _context19.next = 14;
                break;
              }
              return _context19.abrupt("return", _objectSpread(_objectSpread({}, JSON.parse(e.text)), {}, {
                status: null === (n = e.response) || void 0 === n ? void 0 : n.status
              }));
            case 14:
              _context19.next = 19;
              break;
            case 16:
              _context19.prev = 16;
              _context19.t7 = _context19["catch"](0);
              t && t(_context19.t7);
            case 19:
            case "end":
              return _context19.stop();
          }
        }
      }, _callee19, null, [[0, 16]]);
    }));
    return function _r(_x22, _x23) {
      return _ref21.apply(this, arguments);
    };
  }(),
  Or = function Or(e) {
    return e || "11952";
  },
  Cr = {
    ONLINE_PAYMENT_TYPES: ["CC"],
    TOMO_FAILED: "TomoFailed",
    RESPONSE_CODE: {
      ORDER_UNDER_PROCESSING: "ERR_ORDER_UNDER_PROCESSING"
    },
    DOC_TYPES: {
      NRIC: "National Registration ID Card (NRIC)"
    },
    AGE_FOR_SILVER_COMPONENT: 60,
    AGE_FOR_IPP: 21,
    RRP_IPP_NOT_ELIGIBLE_CODE: {
      BLACKLISTED: "1",
      UNDER_AGE: "2"
    }
  },
  fr = {
    OTP_VERIFICATION_BLOCKED: "OTP_VERIFICATION_BLOCKED",
    INVALID_OTP: "INVALID_OTP",
    OTP_LIMIT_REACHED: "OTP_LIMIT_REACHED",
    EXPIRED_OTP: "EXPIRED_OTP",
    OTP_API_DOWN: "OTP_API_DOWN"
  },
  yr = "blocked-otp-verification",
  Tr = "expired-otp",
  Ar = function Ar() {
    return {
      type: "RESET_AUTH"
    };
  },
  Dr = function Dr() {
    return {
      type: "RESET_WORRY_FREE"
    };
  },
  Pr = function Pr() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
    return {
      type: "SET_WORRY_FREE_LOADING",
      payload: e
    };
  },
  vr = function vr(e) {
    return {
      type: "SET_WORRY_FREE_STATUS",
      payload: e
    };
  },
  hr = function hr(e) {
    return {
      type: "SET_AUTH_STATUS",
      payload: e
    };
  },
  gr = function gr(e) {
    return {
      type: "SET_WORRY_FREE_DETAILS",
      payload: e
    };
  },
  Nr = function Nr(e) {
    return {
      type: "SET_UXF_AUTH_TOKEN",
      payload: e
    };
  },
  br = function br(e) {
    return {
      type: "CIS_GET_MYINFO_SUCCESS",
      payload: e
    };
  },
  Lr = function Lr() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
    return {
      type: "CIS_GET_MYINFO_LOADING",
      payload: e
    };
  },
  Ur = function Ur(e) {
    return {
      type: "CIS_GET_MYINFO_ERROR_STATUS",
      payload: e
    };
  },
  Mr = function Mr() {
    return /*#__PURE__*/function () {
      var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(e) {
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.prev = 0;
                e(Pr());
                _context20.next = 4;
                return At();
              case 4:
                e(Pr(!1));
                qe();
                _context20.next = 10;
                break;
              case 8:
                _context20.prev = 8;
                _context20.t0 = _context20["catch"](0);
              case 10:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, null, [[0, 8]]);
      }));
      return function (_x24) {
        return _ref22.apply(this, arguments);
      };
    }();
  };
var wr = Object.freeze({
  __proto__: null,
  resetAuth: Ar,
  resetWorryFree: Dr,
  setWorryFreeLoading: Pr,
  setWorryFreeStatus: vr,
  resetWorryFreeStatus: function resetWorryFreeStatus(e) {
    return {
      type: "RESET_WORRY_FREE_STATUS",
      payload: e
    };
  },
  setAuthStatus: hr,
  setWorryFreeDetails: gr,
  setAuthToken: Nr,
  setMyInfoDetails: br,
  setMyInfoLoading: Lr,
  setMyInfoError: Ur,
  deleteWorryFree: Mr,
  getAuthToken: function getAuthToken(e) {
    var t = e.cleanWorryFree,
      _e$cleanWorryFreeOneP = e.cleanWorryFreeOnePassHeader,
      r = _e$cleanWorryFreeOneP === void 0 ? !0 : _e$cleanWorryFreeOneP;
    return /*#__PURE__*/function () {
      var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(e) {
        var n;
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.t0 = t;
                if (!_context21.t0) {
                  _context21.next = 5;
                  break;
                }
                _context21.next = 4;
                return e(Mr());
              case 4:
                je();
              case 5:
                e({
                  type: "RESET_WORRY_FREE"
                });
                _context21.next = 8;
                return Ct({
                  cleanWorryFree: r
                });
              case 8:
                n = _context21.sent;
                return _context21.abrupt("return", e(Nr(n.sessionToken)));
              case 10:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21);
      }));
      return function (_x25) {
        return _ref23.apply(this, arguments);
      };
    }();
  },
  getUserInfoWithCleanWorryFree: function getUserInfoWithCleanWorryFree(_ref24) {
    var _ref24$cleanWorryFree = _ref24.cleanWorryFree,
      e = _ref24$cleanWorryFree === void 0 ? !1 : _ref24$cleanWorryFree;
    return /*#__PURE__*/function () {
      var _ref25 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(t) {
        var r;
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.prev = 0;
                t(wt());
                _context22.next = 4;
                return At();
              case 4:
                _context22.next = 6;
                return Ct({
                  cleanWorryFree: e
                });
              case 6:
                r = _context22.sent;
                t(Nr(r.sessionToken)), t(Vt());
                _context22.next = 13;
                break;
              case 10:
                _context22.prev = 10;
                _context22.t0 = _context22["catch"](0);
                t(Gt());
              case 13:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, null, [[0, 10]]);
      }));
      return function (_x26) {
        return _ref25.apply(this, arguments);
      };
    }();
  },
  sendOtp: function sendOtp(e) {
    return /*#__PURE__*/function () {
      var _ref26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(t) {
        var r, n, o, i, a, c, d, _e$checkBasedOnSendOt, s, _e6, _e7, _s2, _r8, _n6;
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                r = e.acceptorIndentType, n = e.acceptorIndentValue, o = e.cleanWorryFree, i = e.mobileNumber, a = e.type, c = e.indentType, d = e.indentValue, _e$checkBasedOnSendOt = e.checkBasedOnSendOtpStatus, s = _e$checkBasedOnSendOt === void 0 ? !1 : _e$checkBasedOnSendOt;
                t(Pr());
                _context23.prev = 2;
                _context23.next = 5;
                return ft({
                  acceptorIndentType: r,
                  acceptorIndentValue: n,
                  cleanWorryFree: o,
                  mobileNumber: i,
                  indentType: c,
                  indentValue: d,
                  type: a,
                  lob: "MOB",
                  faCheckMandatory: !1
                });
              case 5:
                _e6 = _context23.sent;
                if (!_e6.otpSend) {
                  _context23.next = 9;
                  break;
                }
                _e7 = Date.now(), _s2 = o ? "OTP_SENT" : "OTP_RESEND_SUCCESS";
                return _context23.abrupt("return", (t(gr({
                  acceptorIndentType: r,
                  acceptorIndentValue: n,
                  mobileNumber: i,
                  indentType: c,
                  indentValue: d,
                  type: a,
                  otpStartTime: _e7
                })), o && t(hr("WORRY_FREE_OTP")), t(vr(_s2))));
              case 9:
                return _context23.abrupt("return", s || _e6.newCustomer ? t(vr("NEW_NEW_CUSTOMER")) : _e6.facheckRequired ? t(vr("WORRY_FREE_FA_CHECK")) : t(vr("OTP_MISMATCH_ERROR")));
              case 12:
                _context23.prev = 12;
                _context23.t0 = _context23["catch"](2);
                _context23.next = 16;
                return _r(_context23.t0);
              case 16:
                _r8 = _context23.sent;
                _n6 = "";
                return _context23.abrupt("return", (_n6 = _r8 && 400 === _r8.status ? "OTP_EXCEED_LIMIT_ERROR" : "OTP_GENERIC_ERROR", t(vr(_n6))));
              case 19:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, null, [[2, 12]]);
      }));
      return function (_x27) {
        return _ref26.apply(this, arguments);
      };
    }();
  },
  verifyOtp: function verifyOtp(e) {
    return /*#__PURE__*/function () {
      var _ref27 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(t) {
        var r, n, o, i, a, c, d, _e8, _s3, _r9, _r10;
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                r = e.acceptorIndentType, n = e.acceptorIndentValue, o = e.otpCode, i = e.mobileNumber, a = e.indentType, c = e.indentValue, d = e.type;
                t(Pr());
                _context24.prev = 2;
                _context24.next = 5;
                return yt({
                  acceptorIndentType: r,
                  acceptorIndentValue: n,
                  mobileNumber: i,
                  indentType: a,
                  indentValue: c,
                  type: d,
                  lob: "MOB",
                  otp: o
                });
              case 5:
                _e8 = _context24.sent;
                _s3 = _e8.otpVerified;
                if (!_s3) {
                  _context24.next = 16;
                  break;
                }
                _context24.t0 = "GOMO" !== d && "PREPAID" !== d;
                if (!_context24.t0) {
                  _context24.next = 12;
                  break;
                }
                _context24.next = 12;
                return t(Vt());
              case 12:
                _r9 = _objectSpread(_objectSpread({}, _e8), {}, {
                  lob: "MOB",
                  otp: o
                });
                t(gr(_r9)), t(vr("OTP_VERIFIED")), t(hr("LOGGED_IN")), $e(!0);
                _context24.next = 17;
                break;
              case 16:
                _e8.facheckRequired && !_e8.faverified ? t(vr("ADDITIONAL_VERIFY_ERROR")) : t(vr("OTP_VERIFY_ERROR"));
              case 17:
                _context24.next = 35;
                break;
              case 19:
                _context24.prev = 19;
                _context24.t1 = _context24["catch"](2);
                _r10 = "";
                _context24.t3 = function (e) {
                  var t;
                  var r = null == e || null === (t = e.ErrorInfo) || void 0 === t ? void 0 : t.backendErrorInfo;
                  if (!r) return null;
                  var n = /\[(.*?)\]/.exec(r);
                  return n && n.length > 1 ? n[1] : null;
                };
                _context24.next = 25;
                return _r(_context24.t1);
              case 25:
                _context24.t4 = _context24.sent;
                _context24.t2 = (0, _context24.t3)(_context24.t4);
                _context24.next = _context24.t2 === yr ? 29 : _context24.t2 === Tr ? 31 : 33;
                break;
              case 29:
                _r10 = "OTP_EXCEED_LIMIT_ERROR";
                return _context24.abrupt("break", 34);
              case 31:
                _r10 = "OTP_TIMEOUT_ERROR";
                return _context24.abrupt("break", 34);
              case 33:
                _r10 = "OTP_GENERIC_ERROR";
              case 34:
                t(vr(_r10));
              case 35:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, null, [[2, 19]]);
      }));
      return function (_x28) {
        return _ref27.apply(this, arguments);
      };
    }();
  },
  additionalVerify: function additionalVerify(e) {
    return /*#__PURE__*/function () {
      var _ref28 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(t) {
        var r, n, o, a, c, d, s, _e9, _o4, _r11, _r12;
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                r = e.acceptorIndentType, n = e.acceptorIndentValue, o = e.lob, a = e.mobileNumber, c = e.indentType, d = e.indentValue, s = e.billingAccountNumber;
                t(Pr());
                _context26.prev = 2;
                _context26.next = 5;
                return function () {
                  var _ref29 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(e) {
                    var t, r, n, o, a;
                    return _regeneratorRuntime.wrap(function _callee25$(_context25) {
                      while (1) {
                        switch (_context25.prev = _context25.next) {
                          case 0:
                            t = "".concat(i).concat(Tt.WORRYFREE_ACCOUNT_VERIFY_URL);
                            r = {
                              method: "POST",
                              body: JSON.stringify({
                                ImplWorryFreeOTPInput: e
                              })
                            };
                            _context25.next = 4;
                            return nt(t, r);
                          case 4:
                            n = _context25.sent;
                            o = n.ImplWorryFreeOTPOutput;
                            a = n.sessionToken;
                            return _context25.abrupt("return", _objectSpread(_objectSpread({}, o), {}, {
                              sessionToken: a
                            }));
                          case 8:
                          case "end":
                            return _context25.stop();
                        }
                      }
                    }, _callee25);
                  }));
                  return function (_x30) {
                    return _ref29.apply(this, arguments);
                  };
                }()({
                  acceptorIndentType: r,
                  acceptorIndentValue: n,
                  mobileNumber: a,
                  indentType: c,
                  indentValue: d,
                  billingAccountNumber: s,
                  lob: "MOB"
                });
              case 5:
                _e9 = _context26.sent;
                _o4 = _e9.accountVerified;
                if (_o4) {
                  _r11 = _objectSpread(_objectSpread({}, _e9), {}, {
                    lob: "MOB"
                  });
                  t(gr(_r11));
                }
                t(vr("WORRY_FREE_ACCOUNT_VERIFIED"));
                _context26.next = 15;
                break;
              case 11:
                _context26.prev = 11;
                _context26.t0 = _context26["catch"](2);
                _r12 = _context26.t0.response && 401 === _context26.t0.response.status;
                t(vr(_r12 ? "OTP_TIMEOUT_ERROR" : "OTP_GENERIC_ERROR"));
              case 15:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, null, [[2, 11]]);
      }));
      return function (_x29) {
        return _ref28.apply(this, arguments);
      };
    }();
  },
  getCISMyInfo: function getCISMyInfo(e) {
    return /*#__PURE__*/function () {
      var _ref30 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(t) {
        var r, _e$isCIS, n, _e10, _r13, _n7;
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                r = e.sessionToken, _e$isCIS = e.isCIS, n = _e$isCIS === void 0 ? !0 : _e$isCIS;
                t(Lr());
                _context27.prev = 2;
                _context27.next = 5;
                return function (e) {
                  var t = e.sessionToken,
                    r = e.isCIS;
                  return nt(i + "/cce/cis/myinfo", {
                    method: "POST",
                    queryParams: {
                      sc: "SS",
                      lo: "en_US"
                    },
                    body: JSON.stringify({
                      ImplValidateSessionTokenInput: {
                        sessionToken: t,
                        isCIS: r
                      }
                    })
                  }).then(function (e) {
                    return e.ImplMyInfoOutput;
                  });
                }({
                  sessionToken: r,
                  isCIS: n
                });
              case 5:
                _e10 = _context27.sent;
                t(Lr(!1)), t(br(_e10));
                _context27.next = 17;
                break;
              case 9:
                _context27.prev = 9;
                _context27.t0 = _context27["catch"](2);
                t(Lr(!1));
                _context27.next = 14;
                return _r(_context27.t0);
              case 14:
                _r13 = _context27.sent;
                _n7 = "";
                _n7 = 500 === (null == _r13 ? void 0 : _r13.status) ? "CIS_MISMATCH_ERROR" : "CIS_GET_MYINFO_ERROR", t(Ur(_n7));
              case 17:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, null, [[2, 9]]);
      }));
      return function (_x31) {
        return _ref30.apply(this, arguments);
      };
    }();
  },
  getOnePassHeaders: function getOnePassHeaders() {
    return /*#__PURE__*/function () {
      var _ref31 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(e) {
        var _t8;
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                _context28.prev = 0;
                e({
                  type: Sr.AUTH.GET_ONEPASS_HEADER_LOADING
                });
                _context28.next = 4;
                return Ct({});
              case 4:
                _t8 = _context28.sent;
                return _context28.abrupt("return", e({
                  type: Sr.AUTH.GET_ONEPASS_HEADER_SUCCESS,
                  payload: _t8
                }));
              case 8:
                _context28.prev = 8;
                _context28.t0 = _context28["catch"](0);
                e({
                  type: Sr.AUTH.GET_ONEPASS_HEADER_FAILED
                });
              case 11:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, null, [[0, 8]]);
      }));
      return function (_x32) {
        return _ref31.apply(this, arguments);
      };
    }();
  }
});
var Gr = Object.freeze({
  __proto__: null,
  getApigeeAuthToken: function getApigeeAuthToken(t) {
    return /*#__PURE__*/function () {
      var _ref32 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(r) {
        var n;
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                r({
                  type: "GET_APIGEE_TOKEN_LOADING"
                });
                _context29.prev = 1;
                _context29.next = 4;
                return function () {
                  var t = e + "/api/sg/v1/oauth/token",
                    r = process.env.GATSBY_APIGEE_BASIC_OAUTH || "",
                    n = {
                      method: "POST",
                      headers: _objectSpread({
                        "Content-Type": "application/x-www-form-urlencoded",
                        "x-client-id": "SPRINGD"
                      }, r ? {
                        authorization: "Basic " + r
                      } : {}),
                      body: "grant_type=client_credentials"
                    };
                  return fetch(t, n).then(function (e) {
                    if (200 !== e.status) throw {
                      message: {}
                    };
                    return e.json();
                  }).then(function (e) {
                    if (e && e.access_token) return e;
                    throw {
                      message: {}
                    };
                  }).catch(function (e) {
                    console.log("-----apigee error", e);
                  });
                }();
              case 4:
                n = _context29.sent;
                (null == n ? void 0 : n.access_token) ? (Ke(null == n ? void 0 : n.access_token), r({
                  type: "GET_APIGEE_TOKEN_SUCCESS",
                  payload: n
                }), t && t()) : r({
                  type: "GET_APIGEE_TOKEN_FAILURE"
                });
                _context29.next = 11;
                break;
              case 8:
                _context29.prev = 8;
                _context29.t0 = _context29["catch"](1);
                r({
                  type: "GET_APIGEE_TOKEN_FAILURE"
                });
              case 11:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, null, [[1, 8]]);
      }));
      return function (_x33) {
        return _ref32.apply(this, arguments);
      };
    }();
  }
});
function Fr(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var r = [],
      n = !0,
      o = !1,
      i = void 0;
    try {
      for (var a, c = e[Symbol.iterator](); !(n = (a = c.next()).done) && (r.push(a.value), !t || r.length !== t); n = !0) {
        ;
      }
    } catch (e) {
      o = !0, i = e;
    } finally {
      try {
        n || null == c.return || c.return();
      } finally {
        if (o) throw i;
      }
    }
    return r;
  }(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }();
}
function kr(e, t) {
  var r = e.split("#")[0],
    n = e.split("#")[1],
    o = Object.assign(function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : window.location.search,
        t = /[?&]/.test(e) ? e.slice(e.indexOf("?") + 1).split("&") : [];
      return t.filter(function (e) {
        return e;
      }).reduce(function (e, t) {
        var r = Fr(t.split("="), 2),
          n = r[0],
          o = r[1];
        return e[n] = o && decodeURIComponent(o) || "", e;
      }, {});
    }(r), t),
    i = Object.keys(o).map(function (e) {
      return [e, o[e]].map(encodeURIComponent).join("=");
    }).join("&"),
    a = n ? "#".concat(n) : "";
  return [r.split("?")[0], i].join("?") + a;
}
var Br = function Br(e) {
    return {
      type: "LOAD_CATALOG_BANNER_REQUEST",
      payload: {
        subscriberIdentifier: e
      }
    };
  },
  Vr = function Vr(e, t) {
    return {
      type: "LOAD_CATALOG_BANNER_SUCCESS",
      payload: {
        subscriberIdentifier: e,
        data: t
      }
    };
  },
  Yr = function Yr(e, t) {
    return {
      type: "LOAD_CATALOG_BANNER_ERROR",
      payload: {
        subscriberIdentifier: e,
        error: t
      }
    };
  };
var xr = Object.freeze({
  __proto__: null,
  loadCatalogBannerRequest: Br,
  loadCatalogBannerSuccess: Vr,
  loadCatalogBannerError: Yr,
  getCatalogBanner: function getCatalogBanner(t) {
    return /*#__PURE__*/function () {
      var _ref33 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(r) {
        var n;
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                r(Br(t));
                _context30.prev = 1;
                _context30.next = 4;
                return function (t) {
                  var r = kr(e + "/api/sg/v1/catalog/banner", {
                    sourceId: "CCDE"
                  });
                  return nt(r, {
                    method: "GET"
                  }, !1, {
                    subscriberIdentity: t
                  }).then(function (e) {
                    return e;
                  });
                }(t);
              case 4:
                n = _context30.sent;
                r(Vr(t, n));
                _context30.next = 11;
                break;
              case 8:
                _context30.prev = 8;
                _context30.t0 = _context30["catch"](1);
                r(Yr(t, _context30.t0));
              case 11:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, null, [[1, 8]]);
      }));
      return function (_x34) {
        return _ref33.apply(this, arguments);
      };
    }();
  }
});
var Hr = function Hr() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var t = e.productOrderId,
      r = e.productOrderItemId,
      n = e.productId,
      _e$numberOfResources = e.numberOfResources,
      o = _e$numberOfResources === void 0 ? Tt.SEARCH_NUMBERS_LIMIT : _e$numberOfResources,
      _e$type = e.type,
      a = _e$type === void 0 ? "WIRELESS" : _e$type,
      _e$oaType = e.oaType,
      c = _e$oaType === void 0 ? "" : _e$oaType,
      _e$isOrderConfirm = e.isOrderConfirm,
      d = _e$isOrderConfirm === void 0 ? !1 : _e$isOrderConfirm,
      s = "".concat(i, "/sdp/manageResource/order/").concat(t, "/order-item/").concat(r, "/product-in-order/").concat(n, "/searchNumber");
    var u = {
      sc: "SS",
      lo: "en_US"
    };
    return c && (u = _objectSpread(_objectSpread({}, u), {}, {
      oaType: c
    })), d && (u = _objectSpread(_objectSpread({}, u), {}, {
      isOrderConfirm: !0
    })), nt(s, {
      method: "POST",
      queryParams: u,
      body: JSON.stringify({
        ImplSearchAviableInput: {
          type: a,
          numberOfResources: o,
          mobileBBRequired: !1
        }
      })
    });
  },
  $r = function $r() {
    return {
      type: "SET_SEARCH_NUMBERS_LOADING",
      value: !0
    };
  },
  qr = function qr(e, t) {
    return {
      type: "SET_SEARCH_NUMBERS_SUCCESS",
      value: {
        numbers: e,
        signature: t
      }
    };
  },
  Wr = function Wr() {
    return {
      type: "SET_SEARCH_NUMBERS_ERROR"
    };
  };
var Xr = Object.freeze({
  __proto__: null,
  resetSearchNumbers: function resetSearchNumbers() {
    return {
      type: "RESET_SEARCH_NUMBERS"
    };
  },
  setSearchNumbersLoading: $r,
  setSearchNumbersSuccessful: qr,
  setSearchNumbersError: Wr,
  searchNumbers: function searchNumbers() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var t = e.productOrderId,
      r = e.productOrderItemId,
      n = e.productId;
    return /*#__PURE__*/function () {
      var _ref34 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(e) {
        var o, _i3;
        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                e({
                  type: "SET_SEARCH_NUMBERS_LOADING",
                  value: !0
                });
                _context31.prev = 1;
                _context31.next = 4;
                return Hr({
                  productOrderId: t,
                  productOrderItemId: r,
                  productId: n
                });
              case 4:
                o = _context31.sent;
                _i3 = o.ImplSearchAviableOutput;
                e(qr(_i3.reservedNumbers, _i3.signature));
                _context31.next = 12;
                break;
              case 9:
                _context31.prev = 9;
                _context31.t0 = _context31["catch"](1);
                e({
                  type: "SET_SEARCH_NUMBERS_ERROR"
                });
              case 12:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, null, [[1, 9]]);
      }));
      return function (_x35) {
        return _ref34.apply(this, arguments);
      };
    }();
  }
});
var jr = function jr(e, t, r) {
  var n,
    o = e instanceof Error ? e : new Error(e);
  if ("object" == typeof t ? r = t : null != t && (o.code = t), r) for (n in r) {
    o[n] = r[n];
  }
  return o;
};
"undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self && self;
function Kr(e, t) {
  return e(t = {
    exports: {}
  }, t.exports), t.exports;
}
function Jr(e, t) {
  "boolean" == typeof t && (t = {
    forever: t
  }), this._timeouts = e, this._options = t || {}, this._fn = null, this._errors = [], this._attempts = 1, this._operationTimeout = null, this._operationTimeoutCb = null, this._timeout = null, this._options.forever && (this._cachedTimeouts = this._timeouts.slice(0));
}
var Zr = Jr;
Jr.prototype.stop = function () {
  this._timeout && clearTimeout(this._timeout), this._timeouts = [], this._cachedTimeouts = null;
}, Jr.prototype.retry = function (e) {
  if (this._timeout && clearTimeout(this._timeout), !e) return !1;
  this._errors.push(e);
  var t = this._timeouts.shift();
  if (void 0 === t) {
    if (!this._cachedTimeouts) return !1;
    this._errors.splice(this._errors.length - 1, this._errors.length), this._timeouts = this._cachedTimeouts.slice(0), t = this._timeouts.shift();
  }
  var r = this,
    n = setTimeout(function () {
      r._attempts++, r._operationTimeoutCb && (r._timeout = setTimeout(function () {
        r._operationTimeoutCb(r._attempts);
      }, r._operationTimeout), this._options.unref && r._timeout.unref()), r._fn(r._attempts);
    }, t);
  return this._options.unref && n.unref(), !0;
}, Jr.prototype.attempt = function (e, t) {
  this._fn = e, t && (t.timeout && (this._operationTimeout = t.timeout), t.cb && (this._operationTimeoutCb = t.cb));
  var r = this;
  this._operationTimeoutCb && (this._timeout = setTimeout(function () {
    r._operationTimeoutCb();
  }, r._operationTimeout)), this._fn(this._attempts);
}, Jr.prototype.try = function (e) {
  console.log("Using RetryOperation.try() is deprecated"), this.attempt(e);
}, Jr.prototype.start = function (e) {
  console.log("Using RetryOperation.start() is deprecated"), this.attempt(e);
}, Jr.prototype.start = Jr.prototype.try, Jr.prototype.errors = function () {
  return this._errors;
}, Jr.prototype.attempts = function () {
  return this._attempts;
}, Jr.prototype.mainError = function () {
  if (0 === this._errors.length) return null;
  for (var e = {}, t = null, r = 0, n = 0; n < this._errors.length; n++) {
    var o = this._errors[n],
      i = o.message,
      a = (e[i] || 0) + 1;
    e[i] = a, a >= r && (t = o, r = a);
  }
  return t;
};
var zr = Kr(function (e, t) {
    t.operation = function (e) {
      var r = t.timeouts(e);
      return new Zr(r, {
        forever: e && e.forever,
        unref: e && e.unref
      });
    }, t.timeouts = function (e) {
      if (e instanceof Array) return [].concat(e);
      var t = {
        retries: 10,
        factor: 2,
        minTimeout: 1e3,
        maxTimeout: 1 / 0,
        randomize: !1
      };
      for (var r in e) {
        t[r] = e[r];
      }
      if (t.minTimeout > t.maxTimeout) throw new Error("minTimeout is greater than maxTimeout");
      for (var n = [], o = 0; o < t.retries; o++) {
        n.push(this.createTimeout(o, t));
      }
      return e && e.forever && !n.length && n.push(this.createTimeout(o, t)), n.sort(function (e, t) {
        return e - t;
      }), n;
    }, t.createTimeout = function (e, t) {
      var r = t.randomize ? Math.random() + 1 : 1,
        n = Math.round(r * t.minTimeout * Math.pow(t.factor, e));
      return n = Math.min(n, t.maxTimeout);
    }, t.wrap = function (e, r, n) {
      if (r instanceof Array && (n = r, r = null), !n) for (var o in n = [], e) {
        "function" == typeof e[o] && n.push(o);
      }
      for (var i = 0; i < n.length; i++) {
        var a = n[i],
          c = e[a];
        e[a] = function () {
          var n = t.operation(r),
            o = Array.prototype.slice.call(arguments),
            i = o.pop();
          o.push(function (e) {
            n.retry(e) || (e && (arguments[0] = n.mainError()), i.apply(this, arguments));
          }), n.attempt(function () {
            c.apply(e, o);
          });
        }, e[a].options = r;
      }
    };
  }),
  Qr = (zr.operation, zr.timeouts, zr.createTimeout, zr.wrap, zr),
  en = Object.prototype.hasOwnProperty;
function tn(e) {
  return e && "EPROMISERETRY" === e.code && en.call(e, "retried");
}
var rn = function rn(e, t) {
  var r, n;
  return "object" == typeof e && "function" == typeof t && (r = t, t = e, e = r), n = Qr.operation(t), new Promise(function (t, r) {
    n.attempt(function (o) {
      Promise.resolve().then(function () {
        return e(function (e) {
          throw tn(e) && (e = e.retried), jr("Retrying", "EPROMISERETRY", {
            retried: e
          });
        }, o);
      }).then(t, function (e) {
        tn(e) && (e = e.retried, n.retry(e || new Error())) || r(e);
      });
    });
  });
};
var nn = function nn(e) {
    var t = e.customerId,
      r = e.productOrderItemId,
      n = e.payload,
      _e$rpNeeded = e.rpNeeded,
      o = _e$rpNeeded === void 0 ? !0 : _e$rpNeeded,
      a = e.isOrderConfirm;
    var c;
    return c = t ? "".concat(i, "/commerce/customer/").concat(t, "/product-order-item/").concat(r, "/product-configuration") : "".concat(i, "/commerce/anonymous/product-order-item/").concat(r, "/product-configuration"), nt(c, {
      method: "PUT",
      queryParams: _objectSpread(_objectSpread({}, o && {
        rp: !1,
        rpc: !1
      }), {}, {
        locale: "en_US",
        sc: "SS",
        lo: "en_US"
      }, a && {
        isOrderConfirm: !0
      }),
      body: JSON.stringify(n)
    }).then(function (e) {
      return e.UpdateProductInOrderConfigurationResponse;
    });
  },
  on = function on(e) {
    var t = e.isAnonymous,
      r = e.contactId,
      n = e.customerId,
      o = e.productOrderItemId,
      a = e.productOrderReferenceNumber;
    return nt("".concat(i, "/ecommerce/shoppingcart/customer/").concat(n, "/order/").concat(a, "/add-customer-contact"), {
      method: "POST",
      queryParams: {
        sc: "SS",
        lo: "en_US",
        isAnonymous: t
      },
      body: JSON.stringify({
        ImplAddCustomerContactRestInput: {
          orderAction: [{
            orderActionId: o,
            contactId: r,
            userOnBehalf: "Online"
          }]
        }
      })
    });
  },
  an = function an(e) {
    var t = e.contactId,
      r = e.customerId,
      n = e.serviceId,
      o = e.subscriptionId,
      c = e.planRelId,
      d = e.basePriceSchemaId,
      s = e.planId,
      _e$newContainedProduc = e.newContainedProducts,
      u = _e$newContainedProduc === void 0 ? [] : _e$newContainedProduc,
      _e$newSimpleProducts = e.newSimpleProducts,
      l = _e$newSimpleProducts === void 0 ? [] : _e$newSimpleProducts,
      _e$removedContainedPr = e.removedContainedProducts,
      p = _e$removedContainedPr === void 0 ? [] : _e$removedContainedPr,
      _e$changedContainedPr = e.changedContainedProducts,
      I = _e$changedContainedPr === void 0 ? [] : _e$changedContainedPr,
      m = e.orderActionReason,
      E = e.orderActionType,
      R = e.newCustomerId;
    return nt("".concat(i, "/commerce/contact-person/").concat(t, "/customer/").concat(r, "/product/").concat(n, "/submit-product-configuration"), {
      method: "PUT",
      queryParams: {
        enableHardCancellation: !0,
        sc: "SS",
        lo: "en_US"
      },
      body: JSON.stringify({
        ImplSubmitProductConfigurationRestInput: {
          subscriberId: o,
          updateProductConfigurationRequest: {
            runCompatibilityRules: !1,
            activityForConfiguration: null,
            addDefaultChildItemsImplicitly: !0,
            returnConfigurationData: {
              catalogDataInd: !0,
              crossProductsDiscountsDataInd: !0,
              previousQuotedRecurringPricesInd: !1,
              productConfigurationInd: !0,
              quotedPricesInd: !1,
              quotedProrationInd: !1,
              quotedTaxInd: !1,
              summaryInd: !1,
              topLevelProductData: !0
            },
            replaceProductOfferingConfiguration: [{
              productForReplacement: [{
                newProductOfferingProductSpecID: c,
                productID: n,
                newBasicPriceScehmaID: d,
                orderActionReasonX8: m,
                orderActionTypeX8: E,
                vendorCodeX8: "T0001",
                dealerCodeX8: a,
                productChanges: {
                  removedSimpleProducts: [],
                  changedContainedProducts: I,
                  suspendedContainedProducts: [],
                  changedSimpleProducts: [],
                  newAssignedBillingOffers: [],
                  newContainedProducts: u,
                  newSimpleProducts: l,
                  removedAssignedBillingOffers: [],
                  resumedContainedProducts: [],
                  removedContainedProducts: p
                }
              }],
              newProductOfferingID: s,
              newCustomerIDX8: R
            }],
            productChanges: []
          }
        }
      })
    }).then(function (e) {
      return e.ImplSubmitProductConfigurationRestOutput;
    });
  },
  cn = function cn(e, t) {
    var r = "".concat(i, "/ecommerce/customer/").concat(e, "/retrieve-billing-offers"),
      n = {
        method: "POST",
        queryParams: {
          sc: "SS",
          lo: "en_US"
        },
        body: JSON.stringify({
          ImplRetrieveBillingOffersInOrderInput: {
            assignedProductID: [t]
          }
        })
      };
    return nt(r, n).then(function (e) {
      return e.ImplRetrieveBillingOffersInOrderOutput;
    });
  },
  dn = function dn() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var t = e.productOrderId,
      r = e.productOrderItemId,
      n = e.productId,
      o = e.resourceNumber,
      _e$numbersToBeRelease = e.numbersToBeReleased,
      a = _e$numbersToBeRelease === void 0 ? [] : _e$numbersToBeRelease,
      c = e.signature,
      _e$relaxCompatibility = e.relaxCompatibilityRules,
      d = _e$relaxCompatibility === void 0 ? !1 : _e$relaxCompatibility,
      s = e.returnFullResponse,
      u = "".concat(i, "/ecommerce/order/").concat(t, "/order-item-id/").concat(r, "/product-in-order/").concat(n, "/reserve-resource"),
      l = {
        relaxCompatibilityRules: d,
        setFirstLoad: !0,
        sc: "SS",
        lo: "en_US"
      };
    return s && (l.returnFullResponse = s), nt(u, {
      method: "PUT",
      queryParams: l,
      body: JSON.stringify({
        ImplReserveResourceNumberRequest: {
          resourceNumber: o,
          resourceType: "WIRELESS",
          numbersToBeReleased: a,
          signature: c
        }
      })
    }).then(function (e) {
      return e.ImplReserveAndUpdateResourceResponse;
    });
  },
  sn = function sn(e) {
    var t = e.productOrderItemId,
      r = e.customerId,
      n = e.payload;
    var o;
    var a = {
      rp: !1,
      rpc: !1,
      sc: "SS",
      lo: "en_US"
    };
    return r ? o = "".concat(i, "/commerce/customer/").concat(r, "/product-order-item/").concat(t, "/retireve-product-configuration-options") : (a.locale = "en_US", o = "".concat(i, "/commerce/anonymous/product-order-item/").concat(t, "/retrieve-product-configuration-options")), nt(o, {
      method: "POST",
      queryParams: a,
      body: JSON.stringify(n)
    }).then(function (e) {
      return e.RetrieveProductInOrderConfigurationResponse;
    });
  },
  un = function un(_ref35) {
    var e = _ref35.promoString,
      _ref35$activityCoupon = _ref35.activityCouponConfig,
      t = _ref35$activityCoupon === void 0 ? null : _ref35$activityCoupon;
    var r = i + "/ordering/getpromos",
      n = {
        ImplPromoDisplayRequest: {
          activityForConfiguration: t ? "QuoteSDAllPromo+++promoCode+++EMPTY####@@SEGMENT=PUBLIC@@VAS=EMPTY@@COUPON=" + e : "QuoteSDAllPromo+++promoCode+++EMPTY" + e
        }
      },
      o = {
        method: "POST",
        queryParams: {
          sc: "SS",
          lo: "en_US"
        },
        body: JSON.stringify(n)
      };
    return nt(r, o).then(function (e) {
      return e.ImplPromoDisplayResponse.implPromoDisplayItemList;
    });
  },
  ln = function ln(e) {
    return e < 0 ? 0 : e;
  };
var pn = function pn(e, t) {
    return (parseFloat((100 * e).toFixed(2)) + parseFloat((100 * t).toFixed(2))) / 100;
  },
  In = function In(e, t) {
    return (parseFloat((100 * e).toFixed(2)) - parseFloat((100 * t).toFixed(2))) / 100;
  };
function mn(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function En(e, t, r) {
  return t && mn(e.prototype, t), r && mn(e, r), e;
}
function Rn() {
  return (Rn = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }
    return e;
  }).apply(this, arguments);
}
function Sn(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
}
function _n(e) {
  return !(!e || "function" != typeof e.hasOwnProperty || !(e.hasOwnProperty("__ownerID") || e._map && e._map.hasOwnProperty("__ownerID")));
}
function On(e, t, r) {
  return Object.keys(e).reduce(function (t, n) {
    var o = "" + n;
    return t.has(o) ? t.set(o, r(t.get(o), e[o])) : t;
  }, t);
}
var Cn = function () {
    function e(e, t, r) {
      if (void 0 === t && (t = {}), void 0 === r && (r = {}), !e || "string" != typeof e) throw new Error("Expected a string key for Entity, but found " + e + ".");
      var n = r,
        o = n.idAttribute,
        i = void 0 === o ? "id" : o,
        a = n.mergeStrategy,
        c = void 0 === a ? function (e, t) {
          return Rn({}, e, t);
        } : a,
        d = n.processStrategy,
        s = void 0 === d ? function (e) {
          return Rn({}, e);
        } : d;
      this._key = e, this._getId = "function" == typeof i ? i : function (e) {
        return function (t) {
          return _n(t) ? t.get(e) : t[e];
        };
      }(i), this._idAttribute = i, this._mergeStrategy = c, this._processStrategy = s, this.define(t);
    }
    var t = e.prototype;
    return t.define = function (e) {
      this.schema = Object.keys(e).reduce(function (t, r) {
        var n,
          o = e[r];
        return Rn({}, t, ((n = {})[r] = o, n));
      }, this.schema || {});
    }, t.getId = function (e, t, r) {
      return this._getId(e, t, r);
    }, t.merge = function (e, t) {
      return this._mergeStrategy(e, t);
    }, t.normalize = function (e, t, r, n, o, i) {
      var a = this,
        c = this.getId(e, t, r),
        d = this.key;
      if (d in i || (i[d] = {}), c in i[d] || (i[d][c] = []), i[d][c].some(function (t) {
        return t === e;
      })) return c;
      i[d][c].push(e);
      var s = this._processStrategy(e, t, r);
      return Object.keys(this.schema).forEach(function (t) {
        if (s.hasOwnProperty(t) && "object" == typeof s[t]) {
          var r = a.schema[t],
            c = "function" == typeof r ? r(e) : r;
          s[t] = n(s[t], s, t, c, o, i);
        }
      }), o(this, s, e, t, r), c;
    }, t.denormalize = function (e, t) {
      var r = this;
      return _n(e) ? On(this.schema, e, t) : (Object.keys(this.schema).forEach(function (n) {
        if (e.hasOwnProperty(n)) {
          var o = r.schema[n];
          e[n] = t(e[n], o);
        }
      }), e);
    }, En(e, [{
      key: "key",
      get: function get() {
        return this._key;
      }
    }, {
      key: "idAttribute",
      get: function get() {
        return this._idAttribute;
      }
    }]), e;
  }(),
  fn = function () {
    function e(e, t) {
      t && (this._schemaAttribute = "string" == typeof t ? function (e) {
        return e[t];
      } : t), this.define(e);
    }
    var t = e.prototype;
    return t.define = function (e) {
      this.schema = e;
    }, t.getSchemaAttribute = function (e, t, r) {
      return !this.isSingleSchema && this._schemaAttribute(e, t, r);
    }, t.inferSchema = function (e, t, r) {
      if (this.isSingleSchema) return this.schema;
      var n = this.getSchemaAttribute(e, t, r);
      return this.schema[n];
    }, t.normalizeValue = function (e, t, r, n, o, i) {
      var a = this.inferSchema(e, t, r);
      if (!a) return e;
      var c = n(e, t, r, a, o, i);
      return this.isSingleSchema || null == c ? c : {
        id: c,
        schema: this.getSchemaAttribute(e, t, r)
      };
    }, t.denormalizeValue = function (e, t) {
      var r = _n(e) ? e.get("schema") : e.schema;
      return this.isSingleSchema || r ? t((this.isSingleSchema ? void 0 : _n(e) ? e.get("id") : e.id) || e, this.isSingleSchema ? this.schema : this.schema[r]) : e;
    }, En(e, [{
      key: "isSingleSchema",
      get: function get() {
        return !this._schemaAttribute;
      }
    }]), e;
  }(),
  yn = function (e) {
    function t(t, r) {
      if (!r) throw new Error('Expected option "schemaAttribute" not found on UnionSchema.');
      return e.call(this, t, r) || this;
    }
    Sn(t, e);
    var r = t.prototype;
    return r.normalize = function (e, t, r, n, o, i) {
      return this.normalizeValue(e, t, r, n, o, i);
    }, r.denormalize = function (e, t) {
      return this.denormalizeValue(e, t);
    }, t;
  }(fn),
  Tn = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    Sn(t, e);
    var r = t.prototype;
    return r.normalize = function (e, t, r, n, o, i) {
      var a = this;
      return Object.keys(e).reduce(function (t, r, c) {
        var d,
          s = e[r];
        return null != s ? Rn({}, t, ((d = {})[r] = a.normalizeValue(s, e, r, n, o, i), d)) : t;
      }, {});
    }, r.denormalize = function (e, t) {
      var r = this;
      return Object.keys(e).reduce(function (n, o) {
        var i,
          a = e[o];
        return Rn({}, n, ((i = {})[o] = r.denormalizeValue(a, t), i));
      }, {});
    }, t;
  }(fn),
  An = function An(e) {
    return Array.isArray(e) ? e : Object.keys(e).map(function (t) {
      return e[t];
    });
  },
  Dn = function Dn(e, t, r, n, o, i, a) {
    return e = function (e) {
      if (Array.isArray(e) && e.length > 1) throw new Error("Expected schema definition to be a single schema, but found " + e.length + ".");
      return e[0];
    }(e), An(t).map(function (t, c) {
      return o(t, r, n, e, i, a);
    });
  },
  Pn = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    Sn(t, e);
    var r = t.prototype;
    return r.normalize = function (e, t, r, n, o, i) {
      var a = this;
      return An(e).map(function (e, c) {
        return a.normalizeValue(e, t, r, n, o, i);
      }).filter(function (e) {
        return null != e;
      });
    }, r.denormalize = function (e, t) {
      var r = this;
      return e && e.map ? e.map(function (e) {
        return r.denormalizeValue(e, t);
      }) : e;
    }, t;
  }(fn),
  vn = function vn(e, t, r, n, o, i, a) {
    var c = Rn({}, t);
    return Object.keys(e).forEach(function (r) {
      var n = e[r],
        d = "function" == typeof n ? n(t) : n,
        s = o(t[r], t, r, d, i, a);
      null == s ? delete c[r] : c[r] = s;
    }), c;
  },
  hn = function hn(e, t, r) {
    if (_n(t)) return On(e, t, r);
    var n = Rn({}, t);
    return Object.keys(e).forEach(function (t) {
      null != n[t] && (n[t] = r(n[t], e[t]));
    }), n;
  },
  gn = function e(t, r, n, o, i, a) {
    return "object" == typeof t && t ? "object" != typeof o || o.normalize && "function" == typeof o.normalize ? o.normalize(t, r, n, e, i, a) : (Array.isArray(o) ? Dn : vn)(o, t, r, n, e, i, a) : t;
  },
  Nn = {
    Array: Pn,
    Entity: Cn,
    Object: function () {
      function e(e) {
        this.define(e);
      }
      var t = e.prototype;
      return t.define = function (e) {
        this.schema = Object.keys(e).reduce(function (t, r) {
          var n,
            o = e[r];
          return Rn({}, t, ((n = {})[r] = o, n));
        }, this.schema || {});
      }, t.normalize = function () {
        for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) {
          t[r] = arguments[r];
        }
        return vn.apply(void 0, [this.schema].concat(t));
      }, t.denormalize = function () {
        for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) {
          t[r] = arguments[r];
        }
        return hn.apply(void 0, [this.schema].concat(t));
      }, e;
    }(),
    Union: yn,
    Values: Tn
  },
  bn = Kr(function (e, t) {
    e.exports = function () {
      var e = "millisecond",
        t = "second",
        r = "minute",
        n = "hour",
        o = "day",
        i = "week",
        a = "month",
        c = "quarter",
        d = "year",
        s = /^(\d{4})-?(\d{1,2})-?(\d{0,2})[^0-9]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?.?(\d{1,3})?$/,
        u = /\[([^\]]+)]|Y{2,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,
        l = function l(e, t, r) {
          var n = String(e);
          return !n || n.length >= t ? e : "" + Array(t + 1 - n.length).join(r) + e;
        },
        p = {
          s: l,
          z: function z(e) {
            var t = -e.utcOffset(),
              r = Math.abs(t),
              n = Math.floor(r / 60),
              o = r % 60;
            return (t <= 0 ? "+" : "-") + l(n, 2, "0") + ":" + l(o, 2, "0");
          },
          m: function m(e, t) {
            var r = 12 * (t.year() - e.year()) + (t.month() - e.month()),
              n = e.clone().add(r, a),
              o = t - n < 0,
              i = e.clone().add(r + (o ? -1 : 1), a);
            return Number(-(r + (t - n) / (o ? n - i : i - n)) || 0);
          },
          a: function a(e) {
            return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
          },
          p: function p(s) {
            return {
              M: a,
              y: d,
              w: i,
              d: o,
              D: "date",
              h: n,
              m: r,
              s: t,
              ms: e,
              Q: c
            }[s] || String(s || "").toLowerCase().replace(/s$/, "");
          },
          u: function u(e) {
            return void 0 === e;
          }
        },
        I = {
          name: "en",
          weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
          months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_")
        },
        m = "en",
        E = {};
      E[m] = I;
      var R = function R(e) {
          return e instanceof C;
        },
        S = function S(e, t, r) {
          var n;
          if (!e) return m;
          if ("string" == typeof e) E[e] && (n = e), t && (E[e] = t, n = e);else {
            var o = e.name;
            E[o] = e, n = o;
          }
          return !r && n && (m = n), n || !r && m;
        },
        _ = function _(e, t) {
          if (R(e)) return e.clone();
          var r = "object" == typeof t ? t : {};
          return r.date = e, r.args = arguments, new C(r);
        },
        O = p;
      O.l = S, O.i = R, O.w = function (e, t) {
        return _(e, {
          locale: t.$L,
          utc: t.$u,
          $offset: t.$offset
        });
      };
      var C = function () {
        function l(e) {
          this.$L = this.$L || S(e.locale, null, !0), this.parse(e);
        }
        var p = l.prototype;
        return p.parse = function (e) {
          this.$d = function (e) {
            var t = e.date,
              r = e.utc;
            if (null === t) return new Date(NaN);
            if (O.u(t)) return new Date();
            if (t instanceof Date) return new Date(t);
            if ("string" == typeof t && !/Z$/i.test(t)) {
              var n = t.match(s);
              if (n) return r ? new Date(Date.UTC(n[1], n[2] - 1, n[3] || 1, n[4] || 0, n[5] || 0, n[6] || 0, n[7] || 0)) : new Date(n[1], n[2] - 1, n[3] || 1, n[4] || 0, n[5] || 0, n[6] || 0, n[7] || 0);
            }
            return new Date(t);
          }(e), this.init();
        }, p.init = function () {
          var e = this.$d;
          this.$y = e.getFullYear(), this.$M = e.getMonth(), this.$D = e.getDate(), this.$W = e.getDay(), this.$H = e.getHours(), this.$m = e.getMinutes(), this.$s = e.getSeconds(), this.$ms = e.getMilliseconds();
        }, p.$utils = function () {
          return O;
        }, p.isValid = function () {
          return !("Invalid Date" === this.$d.toString());
        }, p.isSame = function (e, t) {
          var r = _(e);
          return this.startOf(t) <= r && r <= this.endOf(t);
        }, p.isAfter = function (e, t) {
          return _(e) < this.startOf(t);
        }, p.isBefore = function (e, t) {
          return this.endOf(t) < _(e);
        }, p.$g = function (e, t, r) {
          return O.u(e) ? this[t] : this.set(r, e);
        }, p.year = function (e) {
          return this.$g(e, "$y", d);
        }, p.month = function (e) {
          return this.$g(e, "$M", a);
        }, p.day = function (e) {
          return this.$g(e, "$W", o);
        }, p.date = function (e) {
          return this.$g(e, "$D", "date");
        }, p.hour = function (e) {
          return this.$g(e, "$H", n);
        }, p.minute = function (e) {
          return this.$g(e, "$m", r);
        }, p.second = function (e) {
          return this.$g(e, "$s", t);
        }, p.millisecond = function (t) {
          return this.$g(t, "$ms", e);
        }, p.unix = function () {
          return Math.floor(this.valueOf() / 1e3);
        }, p.valueOf = function () {
          return this.$d.getTime();
        }, p.startOf = function (e, c) {
          var s = this,
            u = !!O.u(c) || c,
            l = O.p(e),
            p = function p(e, t) {
              var r = O.w(s.$u ? Date.UTC(s.$y, t, e) : new Date(s.$y, t, e), s);
              return u ? r : r.endOf(o);
            },
            I = function I(e, t) {
              return O.w(s.toDate()[e].apply(s.toDate("s"), (u ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(t)), s);
            },
            m = this.$W,
            E = this.$M,
            R = this.$D,
            S = "set" + (this.$u ? "UTC" : "");
          switch (l) {
            case d:
              return u ? p(1, 0) : p(31, 11);
            case a:
              return u ? p(1, E) : p(0, E + 1);
            case i:
              var _ = this.$locale().weekStart || 0,
                C = (m < _ ? m + 7 : m) - _;
              return p(u ? R - C : R + (6 - C), E);
            case o:
            case "date":
              return I(S + "Hours", 0);
            case n:
              return I(S + "Minutes", 1);
            case r:
              return I(S + "Seconds", 2);
            case t:
              return I(S + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, p.endOf = function (e) {
          return this.startOf(e, !1);
        }, p.$set = function (i, c) {
          var s,
            u = O.p(i),
            l = "set" + (this.$u ? "UTC" : ""),
            p = (s = {}, s.day = l + "Date", s.date = l + "Date", s[a] = l + "Month", s[d] = l + "FullYear", s[n] = l + "Hours", s[r] = l + "Minutes", s[t] = l + "Seconds", s[e] = l + "Milliseconds", s)[u],
            I = u === o ? this.$D + (c - this.$W) : c;
          if (u === a || u === d) {
            var m = this.clone().set("date", 1);
            m.$d[p](I), m.init(), this.$d = m.set("date", Math.min(this.$D, m.daysInMonth())).toDate();
          } else p && this.$d[p](I);
          return this.init(), this;
        }, p.set = function (e, t) {
          return this.clone().$set(e, t);
        }, p.get = function (e) {
          return this[O.p(e)]();
        }, p.add = function (e, c) {
          var s,
            u = this;
          e = Number(e);
          var l = O.p(c),
            p = function p(t) {
              var r = _(u);
              return O.w(r.date(r.date() + Math.round(t * e)), u);
            };
          if (l === a) return this.set(a, this.$M + e);
          if (l === d) return this.set(d, this.$y + e);
          if (l === o) return p(1);
          if (l === i) return p(7);
          var I = (s = {}, s[r] = 6e4, s[n] = 36e5, s[t] = 1e3, s)[l] || 1,
            m = this.$d.getTime() + e * I;
          return O.w(m, this);
        }, p.subtract = function (e, t) {
          return this.add(-1 * e, t);
        }, p.format = function (e) {
          var t = this;
          if (!this.isValid()) return "Invalid Date";
          var r = e || "YYYY-MM-DDTHH:mm:ssZ",
            n = O.z(this),
            o = this.$locale(),
            i = this.$H,
            a = this.$m,
            c = this.$M,
            d = o.weekdays,
            s = o.months,
            l = function l(e, n, o, i) {
              return e && (e[n] || e(t, r)) || o[n].substr(0, i);
            },
            p = function p(e) {
              return O.s(i % 12 || 12, e, "0");
            },
            I = o.meridiem || function (e, t, r) {
              var n = e < 12 ? "AM" : "PM";
              return r ? n.toLowerCase() : n;
            },
            m = {
              YY: String(this.$y).slice(-2),
              YYYY: this.$y,
              M: c + 1,
              MM: O.s(c + 1, 2, "0"),
              MMM: l(o.monthsShort, c, s, 3),
              MMMM: l(s, c),
              D: this.$D,
              DD: O.s(this.$D, 2, "0"),
              d: String(this.$W),
              dd: l(o.weekdaysMin, this.$W, d, 2),
              ddd: l(o.weekdaysShort, this.$W, d, 3),
              dddd: d[this.$W],
              H: String(i),
              HH: O.s(i, 2, "0"),
              h: p(1),
              hh: p(2),
              a: I(i, a, !0),
              A: I(i, a, !1),
              m: String(a),
              mm: O.s(a, 2, "0"),
              s: String(this.$s),
              ss: O.s(this.$s, 2, "0"),
              SSS: O.s(this.$ms, 3, "0"),
              Z: n
            };
          return r.replace(u, function (e, t) {
            return t || m[e] || n.replace(":", "");
          });
        }, p.utcOffset = function () {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, p.diff = function (e, o, s) {
          var u,
            l = O.p(o),
            p = _(e),
            I = 6e4 * (p.utcOffset() - this.utcOffset()),
            m = this - p,
            E = O.m(this, p);
          return E = (u = {}, u[d] = E / 12, u[a] = E, u[c] = E / 3, u[i] = (m - I) / 6048e5, u.day = (m - I) / 864e5, u[n] = m / 36e5, u[r] = m / 6e4, u[t] = m / 1e3, u)[l] || m, s ? E : O.a(E);
        }, p.daysInMonth = function () {
          return this.endOf(a).$D;
        }, p.$locale = function () {
          return E[this.$L];
        }, p.locale = function (e, t) {
          if (!e) return this.$L;
          var r = this.clone(),
            n = S(e, t, !0);
          return n && (r.$L = n), r;
        }, p.clone = function () {
          return O.w(this.$d, this);
        }, p.toDate = function () {
          return new Date(this.valueOf());
        }, p.toJSON = function () {
          return this.isValid() ? this.toISOString() : null;
        }, p.toISOString = function () {
          return this.$d.toISOString();
        }, p.toString = function () {
          return this.$d.toUTCString();
        }, l;
      }();
      return _.prototype = C.prototype, _.extend = function (e, t) {
        return e(t, C, _), _;
      }, _.locale = S, _.isDayjs = R, _.unix = function (e) {
        return _(1e3 * e);
      }, _.en = E[m], _.Ls = E, _;
    }();
  }),
  Ln = {
    BUSINESS_TYPES: {
      DEVICE: "DEVICE"
    },
    ACTION_TYPES: {
      CH: "CH",
      AD: "AD",
      RM: "RM"
    },
    INCLUDED_BY_DEFAULT: "INCLUDED_BY_DEFAULT",
    EARLY_REPAYMENT_FEE: "Early Repayment Fee",
    DEVICE_REPAYMENT_EARLY_CI: "Device Repayment Charges Early CI",
    DEVICE_REPAYMENT_FOR_RRP_DEVICES: "Singtel Device Repayment Plan for RRP Device",
    DEVICE_REPAYMENT_FOR_IPP_DEVICES: "Singtel Instalment Payment Plan Mobile",
    DEVICE_PENALTY_OFFER: "Device Penalty Offer",
    DOWNGRADE_PENALTY: "Downgrade Penalty",
    PRICE_PLAN_CONVERSION_CHARGE: "Price Plan Conversion Charge (CIS)",
    SERVICE_CONTRACT_PENALTY: "Service Contract Penalty",
    MOBILE_BOARDBAND_DATA_PLAN_500MB_IDENTIFIER: "Mobile Broadband Data (500MB) Identifier",
    FREE_MOBILE_BROADBAND_DATA_PLAN: "FREE Mobile Broadband Data Plan",
    DISCOUNT_STOCK_CODE_CHARGES: "Discount Stock Code Charges"
  },
  Un = Kr(function (e, t) {
    e.exports = function (e, t) {
      t.prototype.isSameOrBefore = function (e, t) {
        return this.isSame(e, t) || this.isBefore(e, t);
      };
    };
  }),
  Mn = Kr(function (e, t) {
    e.exports = function (e, t, r) {
      t.prototype.isToday = function () {
        var e = r();
        return this.format("YYYY-MM-DD") === e.format("YYYY-MM-DD");
      };
    };
  });
bn.extend(Un), bn.extend(Mn);
var wn = function wn(e) {
    var t = new Nn.Entity("displayableBillingOffers", {}, {
        idAttribute: function idAttribute(e) {
          return e.productSpecPricing.childPricingSchema.id;
        },
        mergeStrategy: function mergeStrategy(e, t) {
          if (e.selected && t.selected) {
            return "AD" === t.action ? t : e;
          }
          return e.selected ? e : t.selected ? t : _objectSpread(_objectSpread({}, e), t);
        },
        processStrategy: function processStrategy(e, t) {
          return _objectSpread(_objectSpread({}, e), {}, {
            parent: t.productSpecContainmentID,
            parentDisplayableItemProductId: t.productID
          });
        }
      }),
      r = new Nn.Entity("displayableItems", {}, {
        idAttribute: "productSpecContainmentID"
      });
    return r.define({
      displayableBillingOffers: [t],
      displayableItems: [r]
    }), function (e, t) {
      if (!e || "object" != typeof e) throw new Error('Unexpected input given to normalize. Expected type to be "object", found "' + (null === e ? "null" : typeof e) + '".');
      var r = {},
        n = function (e) {
          return function (t, r, n, o, i) {
            var a = t.key,
              c = t.getId(n, o, i);
            a in e || (e[a] = {});
            var d = e[a][c];
            e[a][c] = d ? t.merge(d, r) : r;
          };
        }(r);
      return {
        entities: r,
        result: gn(e, e, null, t, n, {})
      };
    }(e, [r]);
  },
  Gn = function Gn(e) {
    if (e.allowedActions) {
      var _t9 = e.allowedActions.find(function (e) {
        return "RM" === e.type;
      });
      return Boolean(null == _t9 ? void 0 : _t9.allowed);
    }
    return !1;
  },
  Fn = function Fn(e) {
    var t = e.billingOfferID,
      r = "AD" === e.action;
    return t && (!r || !Gn(e));
  },
  kn = function kn(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (e) return e.filter(function (e) {
      return e.displayInformation.enabled;
    }).map(function (e) {
      var _e$productSpecCharact = e.productSpecCharacteristic,
        r = _e$productSpecCharact.ID,
        n = _e$productSpecCharact.defaultValue;
      return {
        characteristicID: r,
        value: t[r] || (null == e ? void 0 : e.value) || (null == n ? void 0 : n.value) || null
      };
    });
  },
  Bn = function Bn(e) {
    var t = [],
      r = [];
    return e.forEach(function (e) {
      e.values.some(function (e) {
        return e.selected;
      }) ? t.push(e) : r.push(e);
    }), [].concat(t, r);
  },
  Vn = function Vn(e) {
    return "14438091" === e;
  },
  Yn = function Yn(e) {
    return "11982" === e;
  },
  xn = function xn(_ref36) {
    var e = _ref36.allPretickAddons,
      t = _ref36.transactionType,
      r = _ref36.customerType,
      n = _ref36.selectedProduct,
      o = _ref36.planId,
      i = _ref36.existingSelectedAddons;
    return e.filter(function (e) {
      var t = !(e.nonCompatibleVasList || []).some(function (e) {
        return i.includes(e);
      });
      return e.segment.includes(r) && e.planIds.includes(o) && t;
    }).filter(function (e) {
      var t = e.phoneList,
        r = e.phoneSpecific;
      return r ? r && n ? null == t ? void 0 : t.includes(n) : void 0 : e;
    }).filter(function (e) {
      var r = e.transactionBoIds,
        n = e.transactionSpsIds,
        o = e.transactionSpecific;
      if (!o) return e;
      var i = t.toLowerCase(),
        a = r[i + "BoIds"],
        c = n[i + "SpsIds"];
      return o && (a.length || c.length) ? e : void 0;
    }).map(function (e) {
      var r = e.transactionBoIds,
        n = e.transactionSpsIds,
        o = e.transactionSpecific;
      if (o && t) {
        var _o5 = t.toLowerCase(),
          _i4 = r[_o5 + "BoIds"],
          a = n[_o5 + "SpsIds"];
        return e.boIds = _i4 || [], e.spsIds = a || [], e;
      }
      return e;
    });
  },
  Hn = function Hn(e, t) {
    return e.productTitle.replace(/ /g, "").toUpperCase().includes(t);
  },
  $n = function $n(e, t) {
    return e && e.find(function (e) {
      return e.selected && Hn({
        productTitle: e.name || ""
      }, t) && (!e.action || "AD" !== e.action);
    });
  },
  qn = function qn(_ref37) {
    var e = _ref37.addon,
      t = _ref37.mobileContentItems;
    return Hn(e, D.APPLEMUSIC) ? $n(t, D.APPLEMUSIC) : !!Hn(e, D.SPOTIFY) && $n(t, D.SPOTIFY);
  },
  Wn = function Wn(_ref38) {
    var e = _ref38.aemAtomicAddons,
      t = _ref38.mobileContentItems;
    var r = [];
    return e.map(function (e) {
      var n = (null == e ? void 0 : e.simpleProductSpecID) || e.productSpecContainmentID,
        o = t && t.find(function (e) {
          return e.simpleProductSpecID === n;
        });
      if (!o || o.action && "AD" === o.action) {
        if (qn({
          addon: e,
          mobileContentItems: t
        })) ;else {
          var _t10 = o ? [{
              allowed: !1,
              type: "SU"
            }, {
              allowed: !1,
              type: "RS"
            }, {
              allowed: !1,
              type: "AD"
            }, {
              allowed: !1,
              type: "UP"
            }, {
              allowed: !0,
              type: "RM"
            }] : [{
              allowed: !1,
              type: "SU"
            }, {
              allowed: !1,
              type: "RS"
            }, {
              allowed: !0,
              type: "AD"
            }, {
              allowed: !1,
              type: "UP"
            }, {
              allowed: !1,
              type: "RM"
            }],
            _i5 = _objectSpread(_objectSpread(_objectSpread({}, e), o), {}, {
              productID: null == o ? void 0 : o.productID,
              productSpecContainmentID: (null == o ? void 0 : o.productSpecContainmentID) || n,
              selected: (null == o ? void 0 : o.selected) || !1,
              allowedActions: _t10,
              selectedMatchesMaxQuantity: !1
            });
          r = _objectSpread(_objectSpread({}, r), {}, _defineProperty({}, n, _i5));
        }
      } else ;
    }), r;
  },
  Xn = function Xn(e) {
    var _e$redTag = e.redTag,
      t = _e$redTag === void 0 ? "" : _e$redTag,
      _e$prestigeStatusX = e.prestigeStatusX8,
      r = _e$prestigeStatusX === void 0 ? "" : _e$prestigeStatusX;
    return "Y" === t || "Y" === t && ["P", "VIP", "IPA", "P-VIP", "P-Gold", "D1", "D2", "Null"].includes(r) ? "R" : "N" === t && ["P", "P-VIP"].includes(r) ? "P" : "";
  },
  jn = function jn() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return ["STAFF", "CIS", "PUBLIC"].includes(e.toUpperCase()) ? e.toUpperCase() : "PUBLIC";
  },
  Kn = function Kn() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return ["RECON", "PORT-IN", "PROVIDE"].includes(e.toUpperCase()) ? e.toUpperCase() : "PROVIDE";
  },
  Jn = function Jn(e) {
    var t = !1;
    return e.displayableBillingOffers.forEach(function (e) {
      "AD" === e.action && (e.name.toUpperCase().indexOf("SIM CARD FEE") > -1 || e.name.toUpperCase().indexOf("ESIM FEE") > -1) && (t = !0);
    }), t || "AD" !== e.action || (t = !0), t;
  },
  Zn = function Zn(e) {
    var t = !1;
    if ("AD" !== e.action) t = !0;else if (e.allowedActions) {
      var _r14 = e.allowedActions.find(function (e) {
        return "RM" === e.type;
      });
      _r14 && !_r14.allowed && (t = !0);
    }
    var r, n;
    return t ? null : null === (r = e.productSpecPricing) || void 0 === r || null === (n = r.childPricingSchema) || void 0 === n ? void 0 : n.id;
  },
  zn = function zn(e) {
    var t, r;
    return !!(e.selected && 0 === (null === (t = e.totalOneTimeCalculatedPrice) || void 0 === t ? void 0 : t.finalAmountIncludingTax) || 0 === (null === (r = e.totalRecurringCalculatedPrice) || void 0 === r ? void 0 : r.finalAmountIncludingTax));
  },
  Qn = function Qn(e) {
    var t;
    return !!(e.totalOneTimeCalculatedPrice && ((null === (t = e.totalOneTimeCalculatedPrice) || void 0 === t ? void 0 : t.finalAmountIncludingTax) || 0 === e.totalOneTimeCalculatedPrice.finalAmountIncludingTax) || e.totalRecurringCalculatedPrice && (e.totalRecurringCalculatedPrice.finalAmountIncludingTax || 0 === e.totalRecurringCalculatedPrice.finalAmountIncludingTax));
  },
  eo = function eo(e, t) {
    return ["8363712", "8363682", "10381311", "11337471", "11344731", "11343321", Or(t), "9404693", "9117142", "17987931"].includes(e);
  },
  to = function to(e) {
    return "8363722" === e.productSpecContainmentID && Jn(e);
  },
  ro = function ro(e) {
    return _t(e.productSpecContainmentID) && "AD" === e.action;
  },
  no = function no(e) {
    return ("11822" === e.productSpecContainmentID || "2089835" === e.productSpecContainmentID) && "RM" !== e.action;
  },
  oo = function oo() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var t = arguments.length > 1 ? arguments[1] : undefined;
    var r = [];
    e.forEach(function (e) {
      var n = eo(e.productSpecContainmentID, t),
        o = to(e),
        i = ro(e);
      var a;
      if (!(n || o || i)) if (no(e)) (null === (a = e.displayableBillingOffers) || void 0 === a ? void 0 : a.length) > 0 && e.displayableBillingOffers.forEach(function (e) {
        zn(e) && r.push(Zn(e));
      });else if ("11762" === e.productSpecContainmentID || "CIS" === e.name) {
        var c;
        if ("RM" !== e.action && e.selected) (null === (c = e.displayableBillingOffers) || void 0 === c ? void 0 : c.length) > 0 && e.displayableBillingOffers.forEach(function (e) {
          var t, n;
          e.selected && "8478572" !== (null === (t = e.productSpecPricing) || void 0 === t || null === (n = t.childPricingSchema) || void 0 === n ? void 0 : n.id) && r.push(Zn(e));
        });
      } else if ("9722" === e.productSpecContainmentID && "RM" === e.action) {
        var d;
        (null === (d = e.displayableBillingOffers) || void 0 === d ? void 0 : d.length) > 0 && e.displayableBillingOffers.forEach(function (e) {
          var t;
          "RM" === e.action && (null === (t = e.totalOneTimeCalculatedPrice) || void 0 === t ? void 0 : t.finalAmountIncludingTax) && Zn(e) && r.push(Zn(e));
        });
      } else if ("9732" === e.productSpecContainmentID) {
        var s, u;
        (null === (s = e.displayableBillingOffers) || void 0 === s ? void 0 : s.length) > 0 && e.displayableBillingOffers.forEach(function (e) {
          e.selected && Zn(e) && r.push(Zn(e));
        }), (null === (u = e.displayableItems) || void 0 === u ? void 0 : u.length) > 0 && e.displayableItems.forEach(function (e) {
          var t;
          (null === (t = e.displayableBillingOffers) || void 0 === t ? void 0 : t.length) > 0 && e.displayableBillingOffers.forEach(function (e) {
            var t;
            e.selected && (null === (t = e.productSpecPricing) || void 0 === t ? void 0 : t.childPricingSchema) && Zn(e) && r.push(Zn(e));
          });
        });
      } else if ("12102" === e.productSpecContainmentID || "10026181" === e.productSpecContainmentID) {
        var l, p;
        (null === (l = e.displayableItems) || void 0 === l ? void 0 : l.length) > 0 && e.displayableItems.forEach(function (e) {
          var t, n, o, i;
          ((null === (t = e.totalOneTimeCalculatedPrice) || void 0 === t ? void 0 : t.finalAmountIncludingTax) || (null === (n = e.totalRecurringCalculatedPrice) || void 0 === n ? void 0 : n.finalAmountIncludingTax) || 0 === (null === (o = e.totalRecurringCalculatedPrice) || void 0 === o ? void 0 : o.finalAmountIncludingTax)) && (null === (i = e.displayableBillingOffers) || void 0 === i ? void 0 : i.length) > 0 && e.displayableBillingOffers.forEach(function (e) {
            var t;
            e.selected && (null === (t = e.productSpecPricing) || void 0 === t ? void 0 : t.childPricingSchema) && Zn(e) && r.push(Zn(e));
          });
        }), (null === (p = e.displayableBillingOffers) || void 0 === p ? void 0 : p.length) > 0 && e.displayableBillingOffers.forEach(function (e) {
          e.selected && Zn(e) && r.push(Zn(e));
        });
      } else if ("Apple Care" === e.name) e.displayableBillingOffers.forEach(function (e) {
        var t;
        e.selected && (null == e || null === (t = e.productSpecPricing) || void 0 === t ? void 0 : t.childPricingSchema) && r.push(e.productSpecPricing.childPricingSchema.id);
      });else if ("14438091" === e.productSpecContainmentID && "RM" === e.action) {
        var I;
        (null === (I = e.displayableItems) || void 0 === I ? void 0 : I.length) > 0 && e.displayableItems.forEach(function (e) {
          var t;
          (null === (t = e.displayableBillingOffers) || void 0 === t ? void 0 : t.length) > 0 && e.displayableBillingOffers.forEach(function (e) {
            var t;
            e.selected && (null === (t = e.productSpecPricing) || void 0 === t ? void 0 : t.childPricingSchema) && Zn(e) && r.push(Zn(e));
          });
        });
      } else if (Qn(e)) {
        var m, E;
        (null === (m = e.displayableBillingOffers) || void 0 === m ? void 0 : m.length) > 0 && e.displayableBillingOffers.forEach(function (t) {
          var n, o, i, a;
          var c = !0;
          "18059161" === e.productSpecContainmentID && e.selected && "13674081" === (null === (n = t.productSpecPricing) || void 0 === n || null === (o = n.childPricingSchema) || void 0 === o ? void 0 : o.id) && (c = !1);
          var d = "RM" === t.action && ((null === (i = t.totalOneTimeCalculatedPrice) || void 0 === i ? void 0 : i.finalAmountIncludingTax) || (null === (a = t.totalRecurringCalculatedPrice) || void 0 === a ? void 0 : a.finalAmountIncludingTax));
          c & (t.selected || d) && r.push(Zn(t));
        }), (null === (E = e.displayableItems) || void 0 === E ? void 0 : E.length) > 0 && e.displayableItems.forEach(function (e) {
          var t;
          (null === (t = e.displayableBillingOffers) || void 0 === t ? void 0 : t.length) > 0 && e.displayableBillingOffers.forEach(function (e) {
            var t;
            e.selected && (null === (t = e.productSpecPricing) || void 0 === t ? void 0 : t.childPricingSchema) && Zn(e) && r.push(Zn(e));
          });
        });
      }
    });
    var n = r.filter(Boolean).join(",");
    return n || "";
  };
var io = Object.freeze({
  __proto__: null,
  normalizeBillingOffers: wn,
  getDisplayableCharacteristic: function getDisplayableCharacteristic(e, t) {
    return e.find(function (_ref39) {
      var e = _ref39.productSpecCharacteristicID;
      return e === t;
    });
  },
  canAddBillingOffer: function canAddBillingOffer(e) {
    if (e.allowedActions) {
      var _t11 = e.allowedActions.find(function (e) {
        return "AD" === e.type;
      });
      return Boolean(null == _t11 ? void 0 : _t11.allowed);
    }
    return !1;
  },
  canRemoveBillingOffer: Gn,
  isBillingOfferDisabled: Fn,
  getChangedCharacteristics: kn,
  sortAddonGroupsBySelectedFirst: Bn,
  getAddonFormFields: function getAddonFormFields(e) {
    var t;
    return {
      title: e.productTitle,
      formFields: null == e || null === (t = e.displayableCharacteristics) || void 0 === t ? void 0 : t.filter(function (e) {
        return e.displayInformation.enabled && e.displayInformation.visible;
      })
    };
  },
  sortAddonsByGroup: function sortAddonsByGroup(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var r = Object.keys(e).map(function (t) {
      return e[t];
    });
    var n = Et(r, "groupName", "productTitle");
    return n = St(n, "key", t), n = Bn(n), n.map(function (e) {
      var t = e.values;
      var r = _toConsumableArray(t);
      t.some(function (e) {
        return e.selected;
      }) && (r = t.map(function (e) {
        return _objectSpread(_objectSpread({}, e), {}, {
          disabled: !e.selected
        });
      }));
      var n = t.every(function (e) {
        return e.selectedMatchesMaxQuantity && !1 === e.selected;
      });
      return {
        groupName: e.key,
        productSpecContainmentID: t[0].productSpecContainmentID,
        disabled: n,
        addons: r
      };
    });
  },
  isDataXProductSpec: Vn,
  isMobileInternetFilter: Yn,
  isMBBProductSpec: function isMBBProductSpec(e) {
    var t, r;
    return "8363712" === (null == e ? void 0 : e.productSpecContainmentID) && ("71957955" === (null == e || null === (t = e.productSpecPricing) || void 0 === t || null === (r = t.childPricingSchema) || void 0 === r ? void 0 : r.id) || (null == e ? void 0 : e.name) === Ln.MOBILE_BOARDBAND_DATA_PLAN_500MB_IDENTIFIER || (null == e ? void 0 : e.productTitle) === Ln.FREE_MOBILE_BROADBAND_DATA_PLAN);
  },
  isNewSelectedAddon: function isNewSelectedAddon(e) {
    var t = e.contractDetails;
    var r;
    t && (r = t.find(function (_ref40) {
      var e = _ref40.productSpecCharacteristicID;
      return "8242" === e;
    }));
    var n = r && Number(r.value);
    return bn(n).isToday();
  },
  isAddonInContract: function isAddonInContract(e) {
    var t = e.contractDetails;
    var r, n;
    t && (r = t.find(function (_ref41) {
      var e = _ref41.productSpecCharacteristicID;
      return "8242" === e;
    }), n = t.find(function (_ref42) {
      var e = _ref42.productSpecCharacteristicID;
      return "8252" === e;
    }));
    var o = r && Number(r.value),
      i = n && Number(n.value);
    return bn().isAfter(bn(o)) && bn().isSameOrBefore(bn(i));
  },
  findPretickAddons: xn,
  isAddonGroup: Hn,
  findExistingAtomicByName: $n,
  isAddonExistingAtomic: qn,
  retrieveAvailableAtomics: Wn,
  getSubSegmentValue: Xn,
  getSegmentType: jn,
  getTransactionType: Kn,
  getNewlyAddedSimDetails: Jn,
  checkRemoveLinkState: Zn,
  checkIfOfferSelected: zn,
  getDisplayableItemPriceCheck: Qn,
  getSkipState: eo,
  isSIMSKU: to,
  isFreebieCheckState: ro,
  isStaffOrSilverProduct: no,
  getOrderActionOfferIDs: oo
});
var ao = Ln.ACTION_TYPES,
  co = function co(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "&";
    var r = {};
    if (e.indexOf(t) > -1) {
      r = e.split(t).reduce(function (e, t) {
        var _t$split = t.split("="),
          _t$split2 = _slicedToArray(_t$split, 2),
          r = _t$split2[0],
          n = _t$split2[1];
        return _objectSpread(_objectSpread({}, e), {}, _defineProperty({}, r, n));
      }, {});
    }
    return r;
  },
  so = function so(e) {
    return e.map(function (e) {
      var t, r;
      if (R.includes(null == e || null === (t = e.productSpecPricing) || void 0 === t || null === (r = t.childPricingSchema) || void 0 === r ? void 0 : r.id)) {
        var _t12 = e.totalOneTimeCalculatedPrice,
          _r15 = e.totalRecurringCalculatedPrice,
          n = e.oneTimeCalculatedPrices,
          o = _objectWithoutProperties(e, _excluded3);
        return _objectSpread(_objectSpread({}, o), {}, {
          totalOneTimeCalculatedPrice: _r15,
          totalRecurringCalculatedPrice: _t12,
          recurringCalculatedPrices: n
        });
      }
      return e;
    });
  },
  uo = function uo(e) {
    return e.totalRecurringCalculatedPrice.finalAmountIncludingTax;
  },
  lo = function lo() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var t = e.totalOneTimeCalculatedPrice,
      r = e.totalRecurringCalculatedPrice,
      n = {
        finalAmount: 0,
        finalTaxAmount: 0,
        finalAmountIncludingTax: 0
      };
    return {
      checkoutPrice: (null == t ? void 0 : t.finalAmountIncludingTax) || 0,
      oneTimePrice: (null == n ? void 0 : n.finalAmountIncludingTax) || 0,
      recurringPrice: (null == r ? void 0 : r.finalAmountIncludingTax) || 0
    };
  },
  po = function po() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
    var _e$finalAmount = e.finalAmount,
      r = _e$finalAmount === void 0 ? 0 : _e$finalAmount,
      _e$finalTaxAmount = e.finalTaxAmount,
      n = _e$finalTaxAmount === void 0 ? 0 : _e$finalTaxAmount,
      _e$finalAmountIncludi = e.finalAmountIncludingTax,
      o = _e$finalAmountIncludi === void 0 ? 0 : _e$finalAmountIncludi;
    return t ? {
      finalAmount: r,
      finalTaxAmount: n,
      finalAmountIncludingTax: o
    } : {
      finalAmount: ln(r),
      finalTaxAmount: ln(n),
      finalAmountIncludingTax: ln(o)
    };
  },
  Io = function Io(e, t, r, n) {
    var o, i, a, c;
    return {
      name: (null == e || null === (o = e[0]) || void 0 === o ? void 0 : o.name) || (null == t || null === (i = t.childPricingSchema) || void 0 === i ? void 0 : i.name) || r,
      description: n || (null == e || null === (a = e[0]) || void 0 === a ? void 0 : a.description) || (null == t || null === (c = t.childPricingSchema) || void 0 === c ? void 0 : c.description) || r
    };
  },
  mo = function mo(e) {
    var t = e.name,
      r = e.parentDisplayableItemProductId,
      n = e.parent,
      o = e.removableFromCart,
      i = e.productSpecPricing,
      a = e.oneTimeCalculatedPrices,
      c = e.totalOneTimeCalculatedPrice,
      d = e.billingOfferID,
      s = e.stockCode;
    if (null != (null == c ? void 0 : c.finalAmountIncludingTax) || null != (null == c ? void 0 : c.originalAmount)) return _objectSpread(_objectSpread({}, Io(a, i, t)), {}, {
      price: c.finalAmountIncludingTax,
      totalOneTimeCalculatedPrice: c,
      billingOfferID: d,
      stockCode: s,
      productID: r,
      productSpecContainmentID: n,
      removableFromCart: o,
      productSpecPricing: i
    });
  },
  Eo = function Eo(e) {
    var t;
    var r = e.removableFromCart;
    var n = e.name,
      o = e.parentDisplayableItemProductId,
      i = e.parent,
      a = e.productSpecPricing,
      c = e.recurringCalculatedPrices,
      d = e.totalRecurringCalculatedPrice,
      s = e.simpleProductSpecID,
      u = e.billingOfferID,
      l = e.productSpecPricingID,
      p = e.atomicParentDisplayableItemProductName,
      I = d && d.finalAmountIncludingTax;
    if (void 0 !== I) return "8363712" === i && I > 0 && (null == a ? void 0 : a.includeByDefault) && (null == a ? void 0 : a.includeByDefault) === Ln.INCLUDED_BY_DEFAULT && (r = !1), _objectSpread(_objectSpread({}, Io(c, a, n, p)), {}, {
      includeByDefault: null == a ? void 0 : a.includeByDefault,
      price: d.finalAmountIncludingTax,
      totalRecurringCalculatedPrice: d,
      productID: o,
      productSpecContainmentID: i,
      removableFromCart: r,
      billingOfferID: u,
      productSpecPricingID: l,
      cID: null == a || null === (t = a.childPricingSchema) || void 0 === t ? void 0 : t.id
    }, s && {
      simpleProductSpecID: s
    });
  },
  Ro = function Ro(e) {
    var t = [];
    var r = e.reduce(function (e, t) {
      return e = t.description in e ? _objectSpread(_objectSpread({}, e), {}, _defineProperty({}, t.description, [].concat(_toConsumableArray(e[t.description]), [t]))) : _objectSpread(_objectSpread({}, e), {}, _defineProperty({}, t.description, [t]));
    }, {});
    return Object.keys(r).sort(function (e, t) {
      return e.localeCompare(t);
    }).map(function (e) {
      return r[e].length > 1 ? r[e].sort(function (e, t) {
        return t.price - e.price;
      }) : r[e];
    }).forEach(function (e) {
      t = [].concat(_toConsumableArray(t), _toConsumableArray(e));
    }), t;
  },
  So = function So(e) {
    if (e) {
      var _t13 = new Date(parseInt(e)),
        r = new Date(),
        n = !1;
      _t13 > r && (_t13 = r, r = new Date(e), n = !0);
      var o = r.getFullYear() - _t13.getFullYear(),
        _i6 = r.getMonth() - _t13.getMonth();
      var a = 0;
      return r.getDate() - _t13.getDate() < 0 && (a = -1), (n ? -1 : 1) * (12 * o + _i6 + a);
    }
    return 0;
  },
  _o = function _o(e, t) {
    return e - So(t);
  },
  Oo = function Oo(e) {
    var t = e.find(function (e) {
      var t;
      return (null === (t = e.oneTimeCalculatedPrices) || void 0 === t ? void 0 : t.length) > 1;
    });
    var r = {},
      n = {};
    if (t) {
      var o, i, a, c, d, s, u;
      if ((null == t || null === (o = t.oneTimeCalculatedPrices) || void 0 === o ? void 0 : o.length) > 1) {
        var _e11 = t.oneTimeCalculatedPrices.reduce(function (e, t) {
          return e.finalAmount < t.finalAmount ? e : t;
        }, {});
        _e11 && (r = {
          finalAmount: _e11.finalAmount,
          finalTaxAmount: _e11.finalTaxAmount,
          finalAmountIncludingTax: _e11.finalAmount + _e11.finalTaxAmount
        });
      }
      n.oneTimePrice = {
        finalAmount: (null == t || null === (i = t.totalOneTimeCalculatedPrice) || void 0 === i ? void 0 : i.finalAmount) || 0,
        finalTaxAmount: (null == t || null === (a = t.totalOneTimeCalculatedPrice) || void 0 === a ? void 0 : a.finalTaxAmount) || 0,
        finalAmountIncludingTax: (null == t || null === (c = t.totalOneTimeCalculatedPrice) || void 0 === c ? void 0 : c.finalAmountIncludingTax) || 0
      }, n.checkoutPrice = {
        finalAmount: 0,
        finalTaxAmount: 0,
        finalAmountIncludingTax: 0
      }, n.recurringPrice = {
        finalAmount: (null == t || null === (d = t.totalRecurringCalculatedPrice) || void 0 === d ? void 0 : d.finalAmount) || 0,
        finalTaxAmount: (null == t || null === (s = t.totalRecurringCalculatedPrice) || void 0 === s ? void 0 : s.finalTaxAmount) || 0,
        finalAmountIncludingTax: (null == t || null === (u = t.totalRecurringCalculatedPrice) || void 0 === u ? void 0 : u.finalAmountIncludingTax) || 0
      };
    }
    return {
      ippCharges: r,
      ippTotalCharges: n
    };
  },
  Co = function Co(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    var r = {};
    if (!e) return r;
    var n = e.find(function (e) {
      var r = t ? Ln.ACTION_TYPES.RM : Ln.ACTION_TYPES.AD;
      return e.businessType === Ln.BUSINESS_TYPES.DEVICE && e.action === r;
    });
    if (!n) return r;
    var o = n.displayableBillingOffers.find(function (e) {
        var t = e.productSpecPricing.childPricingSchema;
        return "14253191" === t.id || "26208904" === t.id || t.name === Ln.DEVICE_REPAYMENT_EARLY_CI;
      }),
      i = n.displayableBillingOffers.find(function (e) {
        return "8428912" === e.productSpecPricing.childPricingSchema.id;
      }),
      a = xo(n.displayableCharacteristics),
      c = a.model,
      d = a.brand,
      s = a.sku,
      u = a.monthlyTerm,
      l = a.paymentSolution,
      p = a.startDate;
    var I;
    if ("Instalments" === l) {
      I = _objectSpread({
        numberOfInstalment: u,
        remainingInstalment: u && p ? _o(u, p) : null,
        ippStartDate: p
      }, Oo(n.displayableBillingOffers));
    }
    return r = {
      ippDetails: I,
      repaymentChanges: lo(o),
      deviceCharges: lo(i),
      repaymentChangesBreakdown: po(null == o ? void 0 : o.totalOneTimeCalculatedPrice, !1),
      deviceChargesBreakdown: po(null == i ? void 0 : i.totalOneTimeCalculatedPrice, !1),
      model: c,
      brand: d,
      sku: s,
      name: n.name,
      repaymentChangesBOID: null == o ? void 0 : o.billingOfferID,
      repaymentChangesProductID: null == o ? void 0 : o.productID,
      deviceProductID: n.productID
    }, r;
  },
  fo = function fo(e, t) {
    var r;
    if (!e) return null;
    var n = ((null == e ? void 0 : e.displayableItems) || []).find(function (e) {
      return e.productSpecContainmentID === Or(t);
    });
    return (null == n || null === (r = n.displayableBillingOffers) || void 0 === r ? void 0 : r.length) > 0 ? null == n ? void 0 : n.displayableBillingOffers.find(function (_ref43) {
      var e = _ref43.selected;
      return e;
    }) : null;
  },
  yo = function yo() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var t = e.reduce(function (e, t) {
      if ("4140405" === t.productSpecContainmentID) {
        var r = xo(t.displayableCharacteristics),
          n = r.bibStartDate,
          o = r.bibEndDate,
          _i7 = new Date().getTime();
        Number(n) <= _i7 && _i7 <= Number(o) && e.push(r);
      }
      return e;
    }, []);
    return t.length ? t[0] : null;
  },
  To = function To(e, t) {
    var r = {};
    var n = e.find(function (e) {
      return e.productSpecContainmentID === Or(t);
    });
    if (n) {
      var _e12 = xo(n.displayableCharacteristics);
      r = _objectSpread(_objectSpread({}, _e12), {}, {
        brand: _e12.brand,
        model: _e12.model,
        tradeinPrice: _e12.amount
      });
    }
    return r;
  },
  Ao = function Ao(e) {
    var t;
    var r = e.billingOffers,
      n = e.productOrderItem,
      o = r.find(function (e) {
        return "8363712" === e.parent && uo(e) > 0;
      }),
      i = null == n || null === (t = n.displayableItems) || void 0 === t ? void 0 : t.find(function (_ref44) {
        var e = _ref44.productSpecContainmentID;
        return "8363712" === e;
      }),
      a = i && i.productID;
    return {
      name: n.productName,
      price: uo(o),
      billingOfferID: o.billingOfferID,
      productSpecPricingID: o.productSpecPricingID,
      basePriceSchemaId: o.productSpecPricing.childPricingSchema.id,
      productId: a
    };
  },
  Do = function Do(e) {
    var t = e.origDisplayableItems,
      r = t.find(function (e) {
        return "8363682" === e.productSpecContainmentID;
      });
    if (r) {
      var _e13 = r.displayableBillingOffers.find(function (e) {
        return e.name === Ln.DOWNGRADE_PENALTY && e.penalty;
      });
      if (_e13) return {
        name: _e13.oneTimeCalculatedPrices[0].name,
        totalOneTimeCalculatedPrice: _e13.totalOneTimeCalculatedPrice || 0
      };
    }
    return null;
  },
  Po = function Po(e) {
    var t = e.find(function (e) {
      return "8363682" === e.parent && e.name && e.name.toUpperCase().includes("DELIVERY CHARGE");
    });
    return t && t.oneTimeCalculatedPrices ? {
      name: t.oneTimeCalculatedPrices[0].name,
      description: t.oneTimeCalculatedPrices[0].description,
      billingOfferID: t.billingOfferID,
      totalOneTimeCalculatedPrice: t.totalOneTimeCalculatedPrice || 0,
      productSpecContainmentID: t.parent,
      productID: t.parentDisplayableItemProductId,
      price: t.totalOneTimeCalculatedPrice ? t.totalOneTimeCalculatedPrice.finalAmountIncludingTax : 0,
      removableFromCart: t.removableFromCart,
      stockCode: t.stockCode
    } : null;
  },
  vo = function vo(e) {
    var t = e.origDisplayableItems,
      r = null == t ? void 0 : t.find(function (e) {
        return "8363712" === e.productSpecContainmentID;
      });
    if (r && r.displayableItems) {
      var _e14 = r.displayableItems.find(function (e) {
        return "11782" === e.productSpecContainmentID && e.action === Ln.ACTION_TYPES.RM;
      });
      if (_e14) {
        var _t14 = _e14.displayableBillingOffers.find(function (e) {
          return e.name === Ln.SERVICE_CONTRACT_PENALTY;
        });
        if (_t14 && _t14.action === Ln.ACTION_TYPES.RM) return {
          name: _t14.oneTimeCalculatedPrices[0].name,
          totalOneTimeCalculatedPrice: _t14.totalOneTimeCalculatedPrice
        };
      }
    }
    return {};
  },
  ho = function ho(e) {
    var t = e.technicalVasIds,
      r = e.bo;
    if (t && r) {
      var n, o;
      var _e15 = null == r || null === (n = r.productSpecPricing) || void 0 === n || null === (o = n.childPricingSchema) || void 0 === o ? void 0 : o.id;
      return t.includes(_e15);
    }
    return !1;
  },
  go = function go(e) {
    var t = e.bo,
      r = e.productSpecContainmentID,
      n = e.productID,
      _e$aspireBillingOffer = e.aspireBillingOffers,
      o = _e$aspireBillingOffer === void 0 ? [] : _e$aspireBillingOffer,
      _e$displayableCharact = e.displayableCharacteristics,
      i = _e$displayableCharact === void 0 ? [] : _e$displayableCharact,
      a = e.name,
      c = t.totalOneTimeCalculatedPrice,
      d = t.totalRecurringCalculatedPrice;
    if (t && r && n) {
      var s, u;
      var _e16 = null === (s = t.productSpecPricing) || void 0 === s || null === (u = s.childPricingSchema) || void 0 === u ? void 0 : u.id,
        _p = o.includes(_e16),
        _I = c && c.finalAmountIncludingTax > 0 || d && d.finalAmountIncludingTax > 0,
        _m = Gn(t),
        _E = !_p && _I && _m && !Fn(t),
        _R = xo(i);
      var _S;
      if ("8363722" === r && (_S = _R.simType, _S && t.oneTimeCalculatedPrices && t.oneTimeCalculatedPrices.length > 0)) {
        var l;
        var _e17 = (null === (l = t.oneTimeCalculatedPrices[0]) || void 0 === l ? void 0 : l.description) || "";
        t.oneTimeCalculatedPrices[0].description = "".concat(_S, " ").concat(_e17);
      }
      return _objectSpread(_objectSpread({}, t), {}, {
        parent: r,
        parentDisplayableItemProductId: n,
        stockCode: _R.sku,
        removableFromCart: _E,
        type: _S,
        atomicParentDisplayableItemProductName: a
      });
    }
    return {};
  },
  No = function No(e) {
    var t;
    var r = e.displayableSimpleProductReferences,
      n = e.origDisplayableItems,
      _e$mobileContent = e.mobileContent,
      o = _e$mobileContent === void 0 ? [] : _e$mobileContent,
      _e$technicalVasIds = e.technicalVasIds,
      i = _e$technicalVasIds === void 0 ? [] : _e$technicalVasIds,
      _e$aspireBillingOffer2 = e.aspireBillingOffers,
      a = _e$aspireBillingOffer2 === void 0 ? [] : _e$aspireBillingOffer2;
    var c = [];
    if (r) {
      var d;
      var _e18 = null == r ? void 0 : r.find(function (e) {
        return e.businessType === Ln.BUSINESS_TYPES.DEVICE && e.action === Ln.ACTION_TYPES.RM;
      });
      var _t15 = null == _e18 || null === (d = _e18.displayableBillingOffers) || void 0 === d ? void 0 : d.find(function (e) {
        var t, r, n, o, i;
        return e.action === Ln.ACTION_TYPES.RM && (null == e || null === (t = e.totalOneTimeCalculatedPrice) || void 0 === t ? void 0 : t.finalAmountIncludingTax) > 0 && ("14317891" === (null == e || null === (r = e.productSpecPricing) || void 0 === r || null === (n = r.childPricingSchema) || void 0 === n ? void 0 : n.id) || "19226141" === (null == e || null === (o = e.productSpecPricing) || void 0 === o || null === (i = o.childPricingSchema) || void 0 === i ? void 0 : i.id) || (null == e ? void 0 : e.name) === Ln.DEVICE_REPAYMENT_FOR_RRP_DEVICES || (null == e ? void 0 : e.name) === Ln.EARLY_REPAYMENT_FEE);
      });
      _t15 && (_t15.oneTimeCalculatedPrices[0].description = Ln.EARLY_REPAYMENT_FEE, c.push(_t15));
    }
    var s = n && Do({
      origDisplayableItems: n
    });
    (null == s ? void 0 : s.name) && c.push(s);
    var u = vo({
      origDisplayableItems: n
    });
    (null == u ? void 0 : u.name) && c.push(u);
    var l = function l(_ref45) {
        var _ref45$displayableBil = _ref45.displayableBillingOffers,
          e = _ref45$displayableBil === void 0 ? [] : _ref45$displayableBil,
          t = _ref45.productSpecContainmentID,
          r = _ref45.productID,
          _ref45$displayableIte = _ref45.displayableItems,
          n = _ref45$displayableIte === void 0 ? [] : _ref45$displayableIte,
          _ref45$isOneTimeItem = _ref45.isOneTimeItem,
          o = _ref45$isOneTimeItem === void 0 ? function (e) {
            return !1;
          } : _ref45$isOneTimeItem;
        var d = e.filter(function (e) {
          var t = ho({
            technicalVasIds: i,
            bo: e
          });
          return !o(e) && e.selected && e.totalRecurringCalculatedPrice && (!t && void 0 !== e.totalRecurringCalculatedPrice.finalAmountIncludingTax || e.totalRecurringCalculatedPrice.finalAmountIncludingTax);
        });
        if (d) {
          var _c4;
          var _e19 = d.map(function (e) {
            return go({
              bo: e,
              productSpecContainmentID: t,
              productID: r,
              aspireBillingOffers: a
            });
          });
          (_c4 = c).push.apply(_c4, _toConsumableArray(_e19));
        }
        (null == n ? void 0 : n.length) > 0 && n.forEach(function (e) {
          var n = e.displayableBillingOffers.filter(function (e) {
            var t = ho({
              technicalVasIds: i,
              bo: e
            });
            return e.selected && e.totalRecurringCalculatedPrice && (!t && void 0 !== e.totalRecurringCalculatedPrice.finalAmountIncludingTax || e.totalRecurringCalculatedPrice.finalAmountIncludingTax);
          });
          if (n) {
            var _c5;
            var _e20 = n.map(function (e) {
              return go({
                bo: e,
                productSpecContainmentID: t,
                productID: r,
                aspireBillingOffers: a
              });
            });
            (_c5 = c).push.apply(_c5, _toConsumableArray(_e20));
          }
        });
      },
      p = function p(e) {
        return e && void 0 !== e.finalAmountIncludingTax;
      };
    n && n.forEach(function (e) {
      var t = e.totalOneTimeCalculatedPrice,
        r = e.totalRecurringCalculatedPrice,
        n = e.displayableBillingOffers,
        i = e.displayableItems,
        d = e.productSpecContainmentID,
        s = e.productID,
        u = e.displayableCharacteristics,
        I = e.name,
        m = e.saleable;
      if ("17987931" !== e.productSpecContainmentID) if ("10141011" === d && o) {
        var _c6;
        var _e21 = o[s];
        var _t16 = n || [];
        !n && _e21 && _t16.push(_e21);
        var _r16 = null == _t16 ? void 0 : _t16.map(function (t) {
          if (_e21) {
            t.simpleProductSpecID = _e21.simpleProductSpecID, t.totalRecurringCalculatedPrice = _e21.totalRecurringCalculatedPrice, t.saleable = "saleable" in t ? t.saleable : m;
            var _r17 = t.allowedActions,
              _n8 = t.action,
              _o6 = t.selected,
              _i8 = Gn(t);
            if (_o6 && _n8 === Ln.ACTION_TYPES.AD && !_i8) {
              var _t17 = Gn(_e21);
              _r17.map(function (e) {
                e.type === Ln.ACTION_TYPES.RM && (e.allowed = _t17);
              });
            }
          }
          return go({
            bo: t,
            productSpecContainmentID: d,
            productID: s,
            aspireBillingOffers: a,
            name: I
          });
        });
        _r16 && (_c6 = c).push.apply(_c6, _toConsumableArray(_r16));
      } else if (t && (t.finalAmountIncludingTax || t.originalAmount || void 0 !== t.finalAmountIncludingTax)) {
        var _e22 = function _e22(e) {
            return e.totalOneTimeCalculatedPrice && (e.totalOneTimeCalculatedPrice.finalAmountIncludingTax || e.totalOneTimeCalculatedPrice.originalAmount || void 0 !== e.totalOneTimeCalculatedPrice.finalAmountIncludingTax) || e.totalRecurringCalculatedPrice.finalAmountIncludingTax;
          },
          _t18 = n.filter(function (t) {
            return _e22(t);
          });
        if (_t18) {
          var _c7;
          var _e23 = _t18.map(function (e) {
            return go({
              bo: e,
              productSpecContainmentID: d,
              productID: s,
              aspireBillingOffers: a,
              displayableCharacteristics: u
            });
          }).filter(function (e) {
            return "RM" !== e.action;
          });
          (_c7 = c).push.apply(_c7, _toConsumableArray(_e23));
        }
        p(r) && l({
          displayableBillingOffers: n,
          productSpecContainmentID: d,
          productID: s,
          displayableItems: i,
          isOneTimeItem: _e22
        });
      } else p(r) ? l({
        displayableBillingOffers: n,
        productSpecContainmentID: d,
        productID: s,
        displayableItems: i
      }) : (null == i ? void 0 : i.length) > 0 && i.forEach(function (e) {
        var t = e.displayableBillingOffers.filter(function (e) {
          return e.penalty && e.totalOneTimeCalculatedPrice && e.totalOneTimeCalculatedPrice.finalAmountIncludingTax;
        });
        if (t) {
          var _c8;
          var _e24 = t.map(function (e) {
            return go({
              bo: e,
              productSpecContainmentID: d,
              productID: s,
              aspireBillingOffers: a
            });
          });
          (_c8 = c).push.apply(_c8, _toConsumableArray(_e24));
        }
      });
    });
    var I = null === (t = c) || void 0 === t ? void 0 : t.find(function (e) {
      return e.name === Ln.PRICE_PLAN_CONVERSION_CHARGE;
    });
    if (n && !I) {
      var _e25 = null == n ? void 0 : n.find(function (e) {
        return "8363712" === e.productSpecContainmentID;
      });
      if (_e25) {
        var m;
        var _t19 = null === (m = _e25.displayableBillingOffers) || void 0 === m ? void 0 : m.find(function (e) {
          return e.name === Ln.PRICE_PLAN_CONVERSION_CHARGE;
        });
        _t19 && _t19.action === Ln.ACTION_TYPES.AD && (_t19.oneTimeCalculatedPrices[0].description = Ln.PRICE_PLAN_CONVERSION_CHARGE, c.push(_t19));
      }
    }
    return c = so(c), {
      chargesBillingOffers: c
    };
  },
  bo = function bo(e) {
    var t;
    return e.forEach(function (e) {
      t = t || (e.displayableCharacteristics || []).find(function (e) {
        return "18059091" === e.productSpecCharacteristicID && !!e.value;
      });
    }), t;
  },
  Lo = function Lo(e) {
    var t = [];
    return e.filter(function (e) {
      return "10381311" === e.productSpecContainmentID && e.action === Ln.ACTION_TYPES.AD;
    }).forEach(function (e) {
      var r = e.displayableBillingOffers.find(function (e) {
          return e.name === Ln.DISCOUNT_STOCK_CODE_CHARGES;
        }),
        n = xo(e.displayableCharacteristics);
      n.name && t.push(_objectSpread({
        label: n.name,
        billingOfferID: r && r.billingOfferID,
        stockCode: n.sku,
        productID: e.productID
      }, po(e.totalOneTimeCalculatedPrice)));
    }), {
      promotions: t,
      totalAmount: t.length ? t.reduce(function (e, t) {
        return pn(e, t.finalAmountIncludingTax);
      }, 0) : 0
    };
  },
  Uo = function Uo(e) {
    return {
      name: e.Name,
      idX8: e.VoucherNo,
      description: e.VoucherDescription,
      expiryDate: e.ExpiryDate,
      issueDate: e.IssueDate,
      redemptionDate: e.RedemptionDate,
      type: e.VoucherType,
      productOrderItemId: e.TransactionNumber,
      checkoutPrice: {
        finalAmount: 0,
        finalTaxAmount: 0,
        finalAmountIncludingTax: In(0, e.Amount)
      }
    };
  },
  Mo = function Mo(e) {
    var t = e.filter(function (e) {
      return "9117142" === e.productSpecContainmentID && e.action === ao.AD;
    });
    var r,
      n,
      o,
      i,
      a,
      c,
      d,
      s = [];
    return t.forEach(function (e) {
      e.displayableBillingOffers.forEach(function (e) {
        var t, i;
        if ((null === (t = e.oneTimeCalculatedPrices) || void 0 === t ? void 0 : t.length) > 1) {
          var _t20 = e.oneTimeCalculatedPrices.sort(function (e, t) {
            return Math.abs(e.finalAmount) - Math.abs(t.finalAmount);
          });
          r = _t20[0].finalAmount, n = _t20[1].finalAmount;
        } else 1 == (null === (i = e.oneTimeCalculatedPrices) || void 0 === i ? void 0 : i.length) && (o = e.oneTimeCalculatedPrices[0].finalAmount);
      });
      var t = xo(e.displayableCharacteristics);
      i = t.redemptionType, a = t.monthlyTerm, c = t.startDate, d = t.endDate, t.vouchers && (s = t.vouchers);
    }), {
      lists: s.map(Uo),
      recurringAmount: r,
      remainingAmount: n,
      onetimeAmount: o,
      redemptionType: i,
      splittingMonth: a,
      splittingStartDate: c,
      splittingEndDate: d
    };
  },
  wo = function wo(e) {
    var t = [];
    return t = e.filter(function (e) {
      return _t(e.productSpecContainmentID) && e.action === Ln.ACTION_TYPES.AD;
    }), t.length && (t = t.map(function (e) {
      var t = xo(e.displayableCharacteristics);
      return {
        name: t.name,
        productID: e.productID,
        freebieId: t.equipmentId,
        skuId: t.sku
      };
    })), t;
  },
  Go = function Go(e, t) {
    return "8363712" === e.parent && e.productSpecPricingID === t.productSpecPricingID;
  },
  Fo = function Fo() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return "8472632" === e.productSpecContainmentID;
  },
  ko = function ko(e) {
    return "10141011" === e;
  },
  Bo = function Bo(e, t) {
    return In(e, t);
  },
  Vo = function Vo() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var t = po();
    return e.reduce(function (e, t) {
      return t ? {
        finalAmount: pn(e.finalAmount, t.finalAmount),
        finalTaxAmount: pn(e.finalTaxAmount, t.finalTaxAmount),
        finalAmountIncludingTax: pn(e.finalAmountIncludingTax, t.finalAmountIncludingTax)
      } : e;
    }, t);
  },
  Yo = function Yo(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    var r = {},
      n = e.totalOneTimeCalculatedPrice || {},
      o = e.totalRecurringCalculatedPrice || {};
    return t ? (r.checkoutPrice = {
      finalAmount: n.finalAmount || 0,
      finalTaxAmount: n.finalTaxAmount || 0,
      finalAmountIncludingTax: n.finalAmountIncludingTax || 0
    }, r.oneTimePrice = {
      finalAmount: 0,
      finalTaxAmount: 0,
      finalAmountIncludingTax: 0
    }) : (r.oneTimePrice = {
      finalAmount: n.finalAmount || 0,
      finalTaxAmount: n.finalTaxAmount || 0,
      finalAmountIncludingTax: n.finalAmountIncludingTax || 0
    }, r.checkoutPrice = {
      finalAmount: 0,
      finalTaxAmount: 0,
      finalAmountIncludingTax: 0
    }), r.recurringPrice = {
      finalAmount: o.finalAmount || 0,
      finalTaxAmount: o.finalTaxAmount || 0,
      finalAmountIncludingTax: o.finalAmountIncludingTax || 0
    }, r;
  },
  xo = function xo() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var t = {};
    if (0 === e.length) return t;
    var _iterator = _createForOfIteratorHelper(e),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var r = _step.value;
        switch (r.productSpecCharacteristicID) {
          case "10381191":
          case "8382":
            t.amount = Math.abs(r.value);
            break;
          case "8620482":
          case "10383541":
            t.name = r.value;
            break;
          case "8852":
            t.model = r.value;
            break;
          case "8842":
            t.brand = r.value;
            break;
          case "8832":
          case "8832":
          case "10381181":
            t.sku = r.value;
            break;
          case "8182":
            t.deliveryMethod = r.value;
            break;
          case "8272":
          case "8034942":
          case "2852265":
            t.monthlyTerm = r.value;
            break;
          case "8822":
            t.equipmentId = r.value;
            break;
          case "8022112":
          case "8128572":
          case "2852275":
            t.startDate = r.value;
            break;
          case "4140525":
            t.bibStartDate = r.value;
            break;
          case "8128562":
          case "2852285":
            t.endDate = r.value;
            break;
          case "4140535":
            t.bibEndDate = r.value;
            break;
          case "13897781":
            t.paymentSolution = r.value;
            break;
          case "2852255":
            t.redemptionType = r.value;
            break;
          case "8469052":
            t.ciStatus = r.value;
            break;
          case "8022652":
            t.simType = r.value;
            break;
          case "8302":
            t.imei = r.value;
        }
        if (new RegExp("^8511912_\\d").test(r.productSpecCharacteristicID) && r.value) {
          var _e26 = co(r.value, ",");
          t.vouchers = t.vouchers ? [].concat(_toConsumableArray(t.vouchers), [_e26]) : [_e26];
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return t;
  },
  Ho = function Ho(e) {
    var t = [];
    if (!e) return t;
    var r = e.filter(function (e) {
      return e.selected && "17987931" === e.productSpecContainmentID && e.action === Ln.ACTION_TYPES.AD;
    });
    return r.length && r.forEach(function (e) {
      var r = xo(e.displayableCharacteristics),
        n = r.monthlyTerm,
        o = r.paymentSolution,
        i = r.startDate;
      var a, c;
      if ("Instalments" === o) {
        a = _objectSpread({
          numberOfInstalment: n,
          remainingInstalment: n && i ? _o(n, i) : null,
          ippStartDate: i
        }, Oo(e.displayableBillingOffers));
      }
      if (a) {
        c = Yo({});
        var _t21 = e.displayableBillingOffers.find(function (e) {
          var t;
          return (null === (t = e.oneTimeCalculatedPrices) || void 0 === t ? void 0 : t.length) > 1;
        });
        if (_t21) {
          var _e27 = _t21.oneTimeCalculatedPrices.reduce(function (e, t) {
            return e.finalAmount < t.finalAmount ? e : t;
          }, {});
          c.recurringPrice = _objectSpread(_objectSpread({}, _e27), {}, {
            finalAmountIncludingTax: pn(_e27.finalAmount, _e27.finalTaxAmount)
          });
        }
      } else c = Yo(e, !0);
      var d = _objectSpread(_objectSpread(_objectSpread({
        ippDetails: a
      }, r), c), {}, {
        accessoryId: r.equipmentId,
        skuId: r.sku,
        simpleProductSpecID: e.simpleProductSpecID,
        productID: e.productID,
        productSpecContainmentID: e.productSpecContainmentID,
        parentProductID: e.parentProductID,
        name: e.name,
        parentProductSpecContainmentID: e.parentProductSpecContainmentID
      });
      var s = !0;
      if (e.allowedActions) {
        var _t22 = e.allowedActions.find(function (e) {
          return e.type === Ln.ACTION_TYPES.RM;
        });
        _t22 && !_t22.allowed && (s = !1);
      }
      d.removableFromCart = s, t.push(d);
    }), t;
  },
  $o = function $o(_ref46) {
    var e = _ref46.device,
      t = _ref46.accessories,
      r = _ref46.appleCare,
      n = _ref46.deliveryCharges;
    var o = [];
    return (null == e ? void 0 : e.deviceChargesBreakdown) && o.push(po(e.deviceChargesBreakdown)), (null == e ? void 0 : e.repaymentChangesBreakdown) && o.push(po(e.repaymentChangesBreakdown)), (null == r ? void 0 : r.totalOneTimeCalculatedPrice) && o.push(po(r.totalOneTimeCalculatedPrice)), (null == t ? void 0 : t.length) && t.forEach(function (e) {
      o.push(po(e.checkoutPrice));
    }), (null == n ? void 0 : n.totalOneTimeCalculatedPrice) && o.push(po(n.totalOneTimeCalculatedPrice)), po(Vo(o));
  },
  qo = function qo(e) {
    var t = e.lists,
      r = e.redemptionType,
      n = S.rebate,
      o = S.immediate,
      i = {
        Immediate: r === o ? t : [],
        Rebate: r === n ? t : []
      };
    return function (e) {
      return r ? i[e] : t;
    };
  },
  Wo = function Wo(_ref47) {
    var e = _ref47.productPrice,
      t = _ref47.checkoutPrice,
      r = _ref47.promotions,
      n = _ref47.tradeInBo,
      o = _ref47.vouchers,
      i = _ref47.totalOneTimeCalculatedPrice,
      a = _ref47.device,
      c = _ref47.accessoryPrice,
      d = _ref47.deliveryCharges;
    var s, u, l, p;
    var I = po(),
      m = po(),
      E = po({
        finalAmountIncludingTax: null == i ? void 0 : i.finalAmountIncludingTax
      }),
      R = 0;
    var S = (null == c ? void 0 : c.finalAmountIncludingTax) > 0 || (null == d ? void 0 : d.finalAmountIncludingTax) > 0;
    if (null == r || null === (s = r.promotions) || void 0 === s ? void 0 : s.length) {
      var _n9 = po(Vo(r.promotions));
      _n9.finalAmountIncludingTax < 0 && (e.finalAmountIncludingTax > 0 || S ? (t = Vo([_n9, t]), e = Vo([_n9, e]), S && e.finalAmountIncludingTax < 0 && (R = e.finalAmountIncludingTax)) : m = Vo([_n9, m]));
    }
    if ((null == n ? void 0 : n.totalOneTimeCalculatedPrice) && !(null == n ? void 0 : n.isSopDeviceOneTimeRebate)) {
      var _r18 = po(n.totalOneTimeCalculatedPrice);
      _r18.finalAmountIncludingTax < 0 && (e.finalAmountIncludingTax > 0 ? (t = Vo([_r18, t]), e = Vo([_r18, e])) : m = Vo([_r18, m]));
    }
    if (null == o ? void 0 : o.length) {
      var _r19 = Vo(_toConsumableArray(o.map(function (e) {
        return e.checkoutPrice;
      })));
      _r19.finalAmountIncludingTax < 0 && (t = Vo([_r19, t])), e.finalAmountIncludingTax > 0 && (e = Vo([_r19, e])).finalAmountIncludingTax < 0 && (e = po());
    }
    (null === (u = m) || void 0 === u ? void 0 : u.finalAmountIncludingTax) < 0 && (E = Vo([po({
      finalAmountIncludingTax: -m.finalAmountIncludingTax
    }), po({
      finalAmountIncludingTax: E.finalAmountIncludingTax
    })]));
    var _ = (null == n ? void 0 : n.isSopDeviceOneTimeRebate) && E.finalAmountIncludingTax < 0;
    E.finalAmountIncludingTax > t.finalAmountIncludingTax ? I = t.finalAmountIncludingTax >= 0 ? Vo([po(E), po({
      finalAmountIncludingTax: -t.finalAmountIncludingTax
    })]) : Vo([po(E), po({
      finalAmountIncludingTax: Math.abs(t.finalAmountIncludingTax)
    })]) : _ && (I = Vo([po(E)]));
    var O = (null == a || null === (l = a.ippDetails) || void 0 === l || null === (p = l.ippTotalCharges) || void 0 === p ? void 0 : p.oneTimePrice) || {};
    if ((null == O ? void 0 : O.finalAmountIncludingTax) > 0 && (I = Vo([I, po({
      finalAmountIncludingTax: -(null == O ? void 0 : O.finalAmountIncludingTax)
    })])), e.finalAmountIncludingTax < 0) {
      var _r20 = 0;
      if (R < 0) {
        var _e28 = ((null == c ? void 0 : c.finalAmountIncludingTax) || 0) + ((null == d ? void 0 : d.finalAmountIncludingTax) || 0);
        _r20 = Math.abs(R) > _e28 ? -_e28 : R;
      }
      t = Vo([t, po({
        finalAmountIncludingTax: _r20
      }), po({
        finalAmountIncludingTax: Math.abs(e.finalAmountIncludingTax)
      })]);
    }
    return t.finalAmountIncludingTax < 0 && (t = po()), {
      additionToFirstBill: I,
      payTotal: t
    };
  };
var Xo = Object.freeze({
  __proto__: null,
  deserializeObject: co,
  specialHandlingOnDummyAddons: so,
  createPriceModelForDeviceCharges: lo,
  populatePrice: po,
  getOfferNameAndDesciption: Io,
  mapOfferToOneTimePrice: mo,
  mapOfferRecurringPrice: Eo,
  sortOfferReccuringPrice: Ro,
  getDifferentOfMonth: So,
  getRemainingMonth: _o,
  getIppRepaymentFromOrder: Oo,
  getDeviceFromOrder: Co,
  getTradeInBOfromProductConfiguration: fo,
  getBibFromOrder: yo,
  getTradeInFromOrder: To,
  getPlanFromOrder: Ao,
  getDevicePenalty: function getDevicePenalty(e) {
    var t = e.billingOffers,
      r = e.displayableItems,
      n = r[12012];
    if (n && n.action === Ln.ACTION_TYPES.RM) {
      var _e29 = n.displayableBillingOffers.find(function (e) {
        return t[e] && t[e].name === Ln.DEVICE_PENALTY_OFFER;
      });
      return t[_e29];
    }
    return !1;
  },
  getPlanDowngradePenalty: Do,
  getDeliveryCharges: Po,
  getServiceContractPenalty: vo,
  isTechnicalVas: ho,
  assignParentBo: go,
  getChargesBillingOffers: No,
  getAppliedPromoText: bo,
  getPromotions: Lo,
  mappingVoucherData: Uo,
  getVouchers: Mo,
  getFreebies: wo,
  isPlanBo: Go,
  isDeviceCare: Fo,
  isDiscountStock: function isDiscountStock(e) {
    return "10381311" === e;
  },
  isCallerID: function isCallerID(e) {
    return "9722" === e;
  },
  isAppleCare: function isAppleCare(e) {
    return l.includes(e);
  },
  isDataXEarlyTermination: function isDataXEarlyTermination(e) {
    return "14438101" === e;
  },
  isMobileContent: ko,
  isAccessory: function isAccessory(e) {
    return "17987931" === e;
  },
  calculateSaveAmount: Bo,
  calculateSumPrice: Vo,
  calculateOffsetPrice: function calculateOffsetPrice(_ref48) {
    var e = _ref48.totalDiscountStockPrice,
      t = _ref48.totalDevicePrice,
      r = _ref48.totalRepaymentPrice;
    var n = po();
    return e && (t && t.finalAmountIncludingTax > 0 && (e.finalAmount = pn(e.finalAmount, t.finalAmount), e.finalTaxAmount = pn(e.finalTaxAmount, t.finalTaxAmount), e.finalAmountIncludingTax = pn(e.finalAmountIncludingTax, t.finalAmountIncludingTax), e.finalAmountIncludingTax < 0 ? t = po() : (t.finalAmount = e.finalAmount, t.finalTaxAmount = e.finalTaxAmount, t.finalAmountIncludingTax = e.finalAmountIncludingTax)), r && r.finalAmountIncludingTax > 0 && e.finalAmountIncludingTax < 0 && (e.finalAmount = pn(e.finalAmount, r.finalAmount), e.finalTaxAmount = pn(e.finalTaxAmount, r.finalTaxAmount), e.finalAmountIncludingTax = pn(e.finalAmountIncludingTax, r.finalAmountIncludingTax), e.finalAmountIncludingTax < 0 ? r = po() : (r.finalAmount = e.finalAmount, r.finalTaxAmount = e.finalTaxAmount, r.finalAmountIncludingTax = e.finalAmountIncludingTax)), (null == e ? void 0 : e.finalAmountIncludingTax) < 0 && (n.finalAmount = pn(n.finalAmount, e.finalAmount), n.finalTaxAmount = pn(n.finalTaxAmount, e.finalTaxAmount), n.finalAmountIncludingTax = pn(n.finalAmountIncludingTax, e.finalAmountIncludingTax))), n;
  },
  createCustomePropertiesForItem: Yo,
  getCharacteristic: xo,
  getAccessoriesFromOrder: Ho,
  groupOneTimePrice: $o,
  getVouchersByType: qo,
  getTotalPrices: Wo
});
var jo = function jo(e, t) {
    var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    return r && Object.keys(r).length ? e.find(function (e) {
      return e.productSpecContainmentID === t && Rt(e, r);
    }) : e.find(function (e) {
      return e.productSpecContainmentID === t;
    });
  },
  Ko = function Ko(e) {
    var t = at(e),
      r = ct(e);
    return t && t.selected ? "STAFF" : r && r.selected ? "CIS" : "PUBLIC";
  },
  Jo = function Jo(e) {
    var t = jo(e, "8363682");
    if (t) {
      return xo(t.displayableCharacteristics).ciStatus;
    }
  },
  Zo = function Zo(_ref49) {
    var e = _ref49.displayableItems,
      t = _ref49.productOrderItemType;
    return "CH" === t ? "RECON" : function (e) {
      var t = jo(e, "11812");
      return t && t.selected;
    }(e) ? "PORT-IN" : "PROVIDE";
  },
  zo = function zo(e) {
    var t = jo(e, "10482", {
      action: "AD"
    });
    if (t) {
      var _e30 = t.displayableSimpleProductReferences[0],
        r = _e30.businessType,
        n = _e30.action;
      if ("DEVICE" === r && "AD" === n) {
        var _t23 = _e30.displayableCharacteristics,
          _r21 = _t23.find(function (e) {
            return "8842" === e.productSpecCharacteristicID;
          }),
          _n10 = _t23.find(function (e) {
            return "8852" === e.productSpecCharacteristicID;
          });
        return {
          brand: _r21 && _r21.value,
          model: _r21 && _n10.value
        };
      }
    }
  },
  Qo = function Qo(e) {
    var t = [],
      r = [];
    return "AD" === e.type ? r.push({
      productSpecContainmentID: "17987931",
      temporaryID: xe(),
      simpleProductSpecID: e.productSpecID
    }) : Array.isArray(e.productID) ? t.push.apply(t, _toConsumableArray(e.productID)) : t.push({
      productID: e.productID
    }), {
      UpdateProductInOrderConfigurationRequest: {
        runCompatibilityRules: !0,
        activityForConfiguration: null,
        confirmationMessagesApproved: !0,
        returnRemovedItems: !0,
        configurationLevel: "FULL",
        settingsView: "FULL",
        productChanges: [{
          removedContainedProducts: t,
          changedContainedProducts: [],
          suspendedContainedProducts: [],
          changedSimpleProducts: [],
          newAssignedBillingOffers: [],
          newContainedProducts: [],
          newSimpleProducts: r,
          removedSimpleProducts: [],
          removedAssignedBillingOffers: [],
          resumedContainedProducts: []
        }],
        returnConfigurationData: {
          catalogDataInd: !0,
          crossProductsDiscountsDataInd: !0,
          previousQuotedRecurringPricesInd: !1,
          productConfigurationInd: !0,
          quotedPricesInd: !0,
          quotedProrationInd: !0,
          quotedTaxInd: !0,
          summaryInd: !0
        }
      }
    };
  },
  ei = function ei(e) {
    var t;
    var r = function r(e) {
      return e === o.SINGTEL;
    };
    if (!Array.isArray(e) || r(null === (t = e[0]) || void 0 === t ? void 0 : t.vendor)) return e;
    var n = e.findIndex(function (e) {
      return r(e.vendor);
    });
    if (-1 !== n) {
      var _e$splice = e.splice(n, 1),
        _e$splice2 = _slicedToArray(_e$splice, 1),
        _t24 = _e$splice2[0];
      e.unshift(_t24);
    }
    return e;
  },
  ti = function ti(e) {
    return {
      type: "SAVE_PROMOTION_ORDER_DETAILS",
      value: e
    };
  },
  ri = function ri(e) {
    var t = e.productOffer,
      r = e.brand,
      n = e.model,
      _e$transactionType = e.transactionType,
      o = _e$transactionType === void 0 ? "" : _e$transactionType,
      i = e.ciTier,
      _e$customerType = e.customerType,
      a = _e$customerType === void 0 ? "" : _e$customerType,
      c = e.subSegment,
      _e$addonIds = e.addonIds,
      d = _e$addonIds === void 0 ? [] : _e$addonIds,
      s = e.coupon,
      u = e.sourcePlan,
      l = e.isSimOnlyPlan,
      _e$specialPromoCodeSt = e.specialPromoCodeString,
      p = _e$specialPromoCodeSt === void 0 ? "" : _e$specialPromoCodeSt;
    var I = "",
      m = "",
      E = "";
    I = ["RECON", "PORT-IN", "PROVIDE"].includes(o.toUpperCase()) ? o.toUpperCase() : "PROVIDE", m = ["STAFF", "CIS", "PUBLIC"].includes(a.toUpperCase()) ? a.toUpperCase() : "PUBLIC", "RECON" === I && u && (E = u);
    var R = [{
      key: "OFFERID",
      value: t
    }, {
      key: "@@BRAND",
      value: r
    }, {
      key: "@@MODEL",
      value: n
    }, {
      key: "@@TRANSACTION_TYPE",
      value: I
    }, {
      key: "@@SOURCE_PLAN",
      value: E
    }, {
      key: "@@CI_TIER",
      value: i
    }, {
      key: "@@SEGMENT",
      value: m
    }, {
      key: "@@SUB_SEGMENT",
      value: c
    }, {
      key: "@@VAS",
      value: d.join()
    }, {
      key: "@@COUPON",
      value: s
    }];
    return l && R.push({
      key: "@OFFER_TYPE",
      value: "SIM-ONLY"
    }), p && R.push({
      key: "@@PICKNGO",
      value: p
    }), "####" + R.map(function (e) {
      return e.value ? "".concat(e.key, "=").concat(e.value) : "";
    }).join("");
  },
  ni = function ni(e) {
    var t = e.productOfferId,
      r = e.displayableItems,
      n = e.productOrderItemType,
      o = e.addonIds,
      i = e.specialPromoCode;
    return /*#__PURE__*/function () {
      var _ref50 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(e) {
        var a, c, d, s;
        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                e({
                  type: "FETCH_PROMOTIONS_LOADING"
                });
                a = zo(r), c = {
                  productOffer: t,
                  transactionType: Zo({
                    displayableItems: r,
                    productOrderItemType: n
                  }),
                  ciTier: Jo(r),
                  customerType: Ko(r),
                  brand: a && a.brand,
                  model: a && a.model,
                  addonIds: o,
                  specialPromoCodeString: i
                };
                e(ti(c));
                d = ri(c);
                _context32.prev = 4;
                _context32.next = 7;
                return un({
                  promoString: d
                });
              case 7:
                s = _context32.sent;
                e({
                  type: "FETCH_PROMOTIONS_SUCCESS",
                  value: s
                });
                _context32.next = 14;
                break;
              case 11:
                _context32.prev = 11;
                _context32.t0 = _context32["catch"](4);
                e(function (e) {
                  return {
                    type: "FETCH_PROMOTIONS_ERROR",
                    value: e
                  };
                }());
              case 14:
                return _context32.abrupt("return", Promise.resolve(s));
              case 15:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, null, [[4, 11]]);
      }));
      return function (_x36) {
        return _ref50.apply(this, arguments);
      };
    }();
  };
var oi = Object.freeze({
  __proto__: null,
  setPromoOrderDetails: ti,
  createPromoString: ri,
  getPromoData: ni
});
var ii = function ii(e) {
    var t = e.customerId,
      r = e.productOrderId,
      n = e.payload;
    var o;
    return o = t ? "".concat(i, "/ecommerce/customer/").concat(t, "/order/").concat(r, "/update-order-products") : "".concat(i, "/ecommerce/anonymous/order/").concat(r, "/update-order-products"), nt(o, {
      method: "POST",
      queryParams: {
        rp: !1,
        rpc: !1,
        lo: "en_US",
        sc: "SS"
      },
      body: JSON.stringify(n)
    }).then(function (e) {
      return e.ImplUpdateOrderProductsResponse;
    });
  },
  ai = function ai(e) {
    var t = e.productOffering,
      r = e.productOfferingProductSpecId,
      n = e.newSimpleProducts,
      o = e.newContainedProducts,
      c = e.orderActionReasonX8,
      d = e.customerId,
      s = e.simCardType;
    var u;
    return u = d ? "".concat(i, "/commerce/customer/").concat(d, "/product-offering/").concat(t, "/product-order") : "".concat(i, "/commerce/anonymous/product-offering/").concat(t, "/product-order"), nt(u, {
      method: "POST",
      queryParams: {
        sc: "SS",
        lo: "en_US"
      },
      body: JSON.stringify({
        CreateNewOfferingConfigurationRequest: {
          returnConfiguration: "ALL",
          runCompatibilityRules: !1,
          returnConfigurationData: {
            catalogDataInd: !0,
            crossProductsDiscountsDataInd: !0,
            previousQuotedRecurringPricesInd: !1,
            productConfigurationInd: !1,
            quotedPricesInd: !1,
            quotedProrationInd: !1,
            quotedTaxInd: !1,
            summaryInd: !1
          },
          newProducts: [{
            productOfferingProductSpecID: r,
            temporaryID: xe(),
            vendorCodeX8: "T0001",
            dealerCodeX8: a,
            orderActionReasonX8: c,
            productChanges: {
              changedContainedProducts: [{
                productSpecContainmentID: "8363722",
                temporaryID: xe(),
                changedCharacteristics: [{
                  characteristicID: 10382891,
                  value: "No"
                }, {
                  characteristicID: "8022652",
                  value: s
                }]
              }],
              newSimpleProducts: n,
              newContainedProducts: o
            }
          }]
        }
      })
    }).then(function (e) {
      var t = e.CreateNewOfferingConfigurationResponse,
        r = e.sessionToken,
        n = t.productOrderID,
        o = t.productOrderReferenceNumber,
        i = t.newProductsInNewOfferings;
      return {
        productOrderId: n,
        productOrderReferenceNumber: o,
        productOrderItemId: i[0].productOrderItemID,
        productId: i[0].productID,
        sessionToken: r
      };
    });
  },
  ci = function ci(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    return di({
      dob: e,
      ageToCompare: Cr.AGE_FOR_SILVER_COMPONENT,
      checkDayAndMonth: t
    });
  },
  di = function di(_ref51) {
    var e = _ref51.dob,
      t = _ref51.ageToCompare,
      _ref51$checkDayAndMon = _ref51.checkDayAndMonth,
      r = _ref51$checkDayAndMon === void 0 ? !1 : _ref51$checkDayAndMon;
    if (!e) return !1;
    var n = new Date();
    n.setHours(0, 0, 0, 0);
    var o = new Date(e);
    o.setHours(0, 0, 0, 0);
    var i = n.getFullYear() - o.getFullYear();
    o.setFullYear(n.getFullYear());
    var a = n.getTime() >= o.getTime();
    return i > t || i === t && (a || !r);
  };
var si = Object.freeze({
  __proto__: null,
  isEligibleForSilver: ci,
  compareAge: di
});
var ui = function ui() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return e.filter(function (e) {
      return e.toUpperCase().match(/\/SILVER-CUSTOMER-PLANS$/);
    }).length > 0;
  },
  li = function li(e) {
    var t = e.aemPlans,
      _e$isCisPlanCatalogue = e.isCisPlanCatalogue,
      r = _e$isCisPlanCatalogue === void 0 ? !1 : _e$isCisPlanCatalogue,
      _e$cisPlanRates = e.cisPlanRates,
      n = _e$cisPlanRates === void 0 ? [] : _e$cisPlanRates;
    if (r && n.length > 0) {
      var _e31 = n.map(function (e) {
        return e.planID;
      });
      return t.filter(function (t) {
        return _e31.includes(t.basePriceSchemaId);
      }).map(function (e) {
        var t = n.find(function (t) {
          return t.planID == e.basePriceSchemaId;
        });
        if (t) {
          var _r22 = e.monthlyCharges,
            _n11 = t.discountedPrice;
          return _n11 && _r22 && parseFloat(_n11) < parseFloat(_r22) ? _objectSpread(_objectSpread({}, e), {}, {
            $discountedPrice: _n11
          }) : _n11 && _r22 && parseFloat(_n11) > parseFloat(_r22) ? _objectSpread(_objectSpread({}, e), {}, {
            monthlyCharges: _n11
          }) : _objectSpread({}, e);
        }
      });
    }
    return t;
  };
var pi = {
    isPlanSilverTag: ui,
    retrievePlanList: li
  },
  Ii = Object.freeze({
    __proto__: null,
    isPlanSilverTag: ui,
    retrievePlanList: li,
    default: pi
  });
var mi = function mi(e) {
    var t = e.slotType,
      r = e.hasPrelaunchDevice,
      n = e.cdf,
      o = e.documentRequired,
      a = e.dealer,
      c = e.outlet,
      d = e.ld,
      s = e.payload;
    var u;
    return u = t === v.R ? i + "/rrp/fs-popstation-timeslots" : i + "/fs/selfcollection/timeslots", nt(u, _objectSpread({
      method: s ? "POST" : "GET",
      queryParams: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
        sc: "SS",
        lo: "en_US"
      }, r && {
        hasPrelaunchDevice: r
      }), n && {
        cdf: n
      }), a && {
        dealer: a
      }), o && {
        documentRequired: o
      }), c && {
        outlet: c
      }), d && {
        ld: d
      })
    }, s && {
      body: JSON.stringify(s)
    })).then(function (e) {
      return e.ImplReserveSelfCollectionTimeSlotsResponse ? e.ImplReserveSelfCollectionTimeSlotsResponse : e.ImplSelfCollectionTimeSlotsResponse.implSelfCollectionTimeSlots;
    });
  },
  Ei = function Ei(e) {
    var t = e.postcode;
    return nt("".concat(i, "/ordering/postcode/").concat(t, "/pop-stations"), {
      method: "GET",
      queryParams: {
        sc: "SS",
        lo: "en_US"
      }
    }).then(function (e) {
      return e.ImplRetrievePOPStationsResponse;
    });
  },
  Ri = function Ri(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (!Array.isArray(e) || 0 === e.length) throw new Error("Incorrect SKU format. Please specify a list of SKUs to check for availabilty.");
    var r = e.join("_"),
      n = {
        queryParams: _objectSpread({
          cs: "SS",
          lo: "en_US"
        }, t ? {
          storeIdPickUp: t
        } : {})
      };
    return nt(i + "/sku/".concat(r, "/availability"), n).then(function (e) {
      var t = e.ImplCheckEquipmentAvailablityOutput,
        _ref52 = t || {},
        r = _ref52.itemAvailability;
      return r || {};
    });
  },
  Si = function Si(e) {
    var t = e.itemCode,
      r = e.storeIdPickup;
    return nt(i + "/pos/store-availability", {
      method: "POST",
      queryParams: {
        sc: "SS",
        lo: "en_US"
      },
      body: JSON.stringify({
        ImplStoreAvailabilityRestInput: {
          itemCode: t,
          storeIdPickup: r
        }
      })
    }).then(function (e) {
      return e.ImplStoreAvailabilityRestOutput;
    });
  },
  _i = i + "/pos/reserveOrAllocateEquipment",
  Oi = function Oi(e) {
    var t = e.customerId,
      r = e.productOrderReferenceNumber,
      n = e.payload;
    return nt("".concat(i, "/ordering/customer/").concat(t, "/order/").concat(r, "/update-delivery-address"), {
      method: "PUT",
      queryParams: {
        sc: "SS",
        lo: "en_US"
      },
      body: JSON.stringify({
        ImplUpdateOrderDeliveryAddressRestInput: n
      })
    }).then(function (e) {
      return e.ImplBaseRestOutput;
    });
  },
  Ci = i + "/location/address",
  fi = function fi(e) {
    var t = e.contactId,
      r = e.allocationId,
      _e$allocationStatus = e.allocationStatus,
      n = _e$allocationStatus === void 0 ? "Conf" : _e$allocationStatus,
      o = e.isOrderConfirm,
      a = _objectWithoutProperties(e, _excluded4),
      c = "".concat(i, "/pos/contact-person/").concat(t, "/update-status");
    var d = [];
    return d = Array.isArray(r) ? r.map(function (e) {
      return _objectSpread({
        allocationID: e,
        allocationStatus: n
      }, a);
    }) : [_objectSpread({
      allocationID: r,
      allocationStatus: n
    }, a)], nt(c, {
      method: "PUT",
      queryParams: _objectSpread({
        sc: "SS",
        lo: "en_US"
      }, o && {
        isOrderConfirm: !0
      }),
      body: JSON.stringify({
        ImplUpdateEquipmentStatusRestInput: {
          allocationStatusInfo: d
        }
      })
    }).then(function (e) {
      return e.ImplUpdateEquipmentStatusRestOutput;
    });
  },
  yi = function yi(e) {
    var t = e.contactId,
      r = e.productOrderReferenceNumber;
    return nt("".concat(i, "/ordering/order/").concat(r, "/contact-person/").concat(t, "/retrieve-delivery-details"), {
      method: "GET",
      queryParams: {
        sc: "SS",
        lo: "en_US"
      }
    }).then(function (e) {
      return e.ImplRetrieveOrderDeliveryDetailsRestOutput;
    });
  },
  Ti = function Ti() {
    var _ref53 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      e = _ref53.appointmentOrderId,
      _ref53$slotType = _ref53.slotType,
      t = _ref53$slotType === void 0 ? P.M : _ref53$slotType,
      _ref53$rrpFullPriceSl = _ref53.rrpFullPriceSlotType,
      r = _ref53$rrpFullPriceSl === void 0 ? "" : _ref53$rrpFullPriceSl,
      _ref53$paymentMode = _ref53.paymentMode,
      n = _ref53$paymentMode === void 0 ? "CASH" : _ref53$paymentMode,
      _ref53$dealerCode = _ref53.dealerCode,
      o = _ref53$dealerCode === void 0 ? a : _ref53$dealerCode,
      _ref53$documentRequir = _ref53.documentRequired,
      c = _ref53$documentRequir === void 0 ? !0 : _ref53$documentRequir,
      _ref53$leadDay = _ref53.leadDay,
      d = _ref53$leadDay === void 0 ? 2 : _ref53$leadDay,
      _ref53$hasPrelaunchDe = _ref53.hasPrelaunchDevice,
      s = _ref53$hasPrelaunchDe === void 0 ? !1 : _ref53$hasPrelaunchDe;
    var u,
      l = {
        slotType: P[t] || t,
        paymentMode: n,
        dealerCode: o,
        leadDay: d
      };
    return t === v.R ? (u = i + "/rrp/retrieve-logistic-appointments-slots", l = _objectSpread(_objectSpread({}, l), {}, {
      hasPrelaunchDevice: s,
      slotType: r
    })) : (u = i + "/sdp/manageAppointment/logistic-appointments-slots", l = _objectSpread(_objectSpread({}, l), {}, {
      documentRequired: c,
      hasPrelaunchDevice: s
    })), nt(u, {
      method: "POST",
      queryParams: _objectSpread({
        sc: "SS",
        lo: "en_US"
      }, e ? {
        appointmentOrderId: e
      } : {}),
      body: JSON.stringify({
        ImplLogisticDispatchAvailableAppointmentsSlotsInput: l
      })
    }).then(function (e) {
      return e.ImplLogisticDispatchAvailableAppointmentsSlotsOutput;
    });
  },
  Ai = function Ai(e) {
    var t = e.contactId,
      r = e.dealerCode,
      n = e.endDate,
      o = e.hasPrelaunchDevice,
      a = e.startDate;
    return nt("".concat(i, "/eappointment/contact-person/").concat(t, "/timeslots"), {
      method: "POST",
      queryParams: {
        sc: "SS",
        lo: "en_US"
      },
      body: JSON.stringify({
        ImplEAppointmentTimeSlotsRequest: {
          dealerCode: r,
          endDate: n,
          hasPrelaunchDevice: o,
          startDate: a
        }
      })
    }).then(function (e) {
      return e.ImplEAppointmentTimeSlotsResponse;
    });
  },
  Di = function Di(e) {
    return nt("".concat(i, "/sdp/address/").concat(e), {
      method: "GET",
      queryParams: {
        sc: "SS",
        lo: "en_US"
      }
    }).then(function (e) {
      var t;
      return null == e || null === (t = e.ImplSearchAddressResponse) || void 0 === t ? void 0 : t.geographicAddress;
    });
  },
  Pi = function Pi(e) {
    var t = e.contactId,
      r = e.customerId;
    return nt("".concat(i, "/eappointment/contact-person/").concat(t, "/view"), {
      method: "POST",
      queryParams: {
        sc: "SS",
        lo: "en_US"
      },
      body: JSON.stringify({
        ImplViewAppointmentRequest: {
          apptId: "",
          customerId: r,
          customerIdType: "C",
          source: "eShop"
        }
      })
    }).then(function (e) {
      return e.ImplViewAppointmentResponse;
    });
  },
  vi = function vi(e) {
    var t = e.contactId,
      r = _objectWithoutProperties(e, _excluded5);
    return nt("".concat(i, "/eappointment/contact-person/").concat(t, "/create"), {
      method: "POST",
      queryParams: {
        sc: "SS",
        lo: "en_US"
      },
      body: JSON.stringify({
        ImplCreateAppointmentRequest: _objectSpread(_objectSpread({}, r), {}, {
          customerIdType: "C",
          source: "eShop"
        })
      })
    }).then(function (e) {
      return e.ImplEAppointmentResponse;
    });
  },
  hi = function hi(e) {
    var t = e.contactId,
      r = e.customerId,
      n = e.apptId;
    return nt("".concat(i, "/eappointment/contact-person/").concat(t, "/cancel"), {
      method: "POST",
      queryParams: {
        source: "eShop",
        sc: "SS",
        lo: "en_US"
      },
      body: JSON.stringify({
        ImplCancelAppointmentRequest: {
          apptId: n,
          customerId: t,
          customerIdType: "C",
          source: "eShop"
        }
      })
    }).then(function (e) {
      return e.ImplViewAppointmentResponse;
    });
  },
  gi = function gi(e) {
    return null == e ? void 0 : e.filter(function (_ref54) {
      var e = _ref54.faStatus;
      return 83 !== e && 78 !== e && 88 !== e;
    });
  },
  Ni = process.env.GATSBY_AEM_URL,
  bi = process.env.GATSBY_MCSS_HOST,
  Li = bi + "/api/sg/v1/eshop-service-fulfillment/online-eshop",
  Ui = "true" === process.env.GATSBY_FEATURE_MTPOS_FS_API_MIGRATION,
  Mi = "RRP",
  wi = {
    M: "M",
    RRP: "R",
    N: "N"
  },
  Gi = function Gi(e) {
    var t = e.dealer,
      r = e.outlet,
      n = e.ld;
    return nt(Li + "/fulfilment/selfcollection/timeslots", {
      method: "POST",
      queryParams: {
        sc: "SS",
        lo: "en_US"
      },
      body: JSON.stringify({
        ImplSelfCollectionTimeSlotsRequest: {
          dealer: t,
          outlet: r,
          ld: n
        }
      })
    }).then(function (e) {
      var t, r;
      return null == e || null === (t = e.body) || void 0 === t || null === (r = t.ImplSelfCollectionTimeSlotsResponse) || void 0 === r ? void 0 : r.implSelfCollectionTimeSlots;
    });
  },
  Fi = function Fi(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (!Array.isArray(e) || 0 === e.length) throw new Error("Incorrect SKU format. Please specify a list of SKUs to check for availabilty.");
    var r = t ? {
      storeIdPickUp: t
    } : {};
    return nt(Li + "/mtpos/check-equipment-availability", {
      method: "POST",
      queryParams: {
        sc: "SS",
        lo: "en_US"
      },
      body: JSON.stringify({
        ImplEquipmentAvailabilityInput: _objectSpread(_objectSpread({}, r), {}, {
          itemCodes: e
        })
      })
    }).then(function (e) {
      var _ref55 = (null == e ? void 0 : e.body) || {},
        t = _ref55.ImplCheckEquipmentAvailablityOutput,
        _ref56 = t || {},
        r = _ref56.itemAvailability;
      return r || {};
    });
  },
  ki = function ki(e) {
    var t = e.itemCode,
      r = e.storeIdPickup;
    return nt(Li + "/mtpos/store-availability", {
      method: "POST",
      queryParams: {
        sc: "SS",
        lo: "en_US"
      },
      body: JSON.stringify({
        ImplStoreAvailabilityRestInput: {
          itemCode: t,
          storeIdPickup: r
        }
      })
    }).then(function (e) {
      var t;
      return null == e || null === (t = e.body) || void 0 === t ? void 0 : t.ImplStoreAvailabilityRestOutput;
    });
  },
  Bi = function Bi() {
    var _ref57 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      e = _ref57.appointmentOrderId,
      _ref57$slotType = _ref57.slotType,
      t = _ref57$slotType === void 0 ? wi.M : _ref57$slotType,
      _ref57$rrpFullPriceSl = _ref57.rrpFullPriceSlotType,
      r = _ref57$rrpFullPriceSl === void 0 ? "" : _ref57$rrpFullPriceSl,
      _ref57$paymentMode = _ref57.paymentMode,
      n = _ref57$paymentMode === void 0 ? "CASH" : _ref57$paymentMode,
      _ref57$dealerCode = _ref57.dealerCode,
      o = _ref57$dealerCode === void 0 ? "D2519" : _ref57$dealerCode,
      _ref57$documentRequir = _ref57.documentRequired,
      i = _ref57$documentRequir === void 0 ? !0 : _ref57$documentRequir,
      _ref57$leadDay = _ref57.leadDay,
      a = _ref57$leadDay === void 0 ? 2 : _ref57$leadDay,
      _ref57$hasPrelaunchDe = _ref57.hasPrelaunchDevice,
      c = _ref57$hasPrelaunchDe === void 0 ? !1 : _ref57$hasPrelaunchDe;
    var d = {
      slotType: wi[t] || t,
      paymentMode: n,
      dealerCode: o,
      leadDay: a
    };
    var s = Li + "/fulfilment/logistic-appointments-slots";
    return d = t === Mi ? _objectSpread(_objectSpread({}, d), {}, {
      hasPrelaunchDevice: c,
      slotType: r
    }) : _objectSpread(_objectSpread({}, d), {}, {
      documentRequired: i,
      hasPrelaunchDevice: c
    }), nt(s, {
      method: "POST",
      queryParams: {
        sc: "SS",
        lo: "en_US"
      },
      body: JSON.stringify({
        ImplLogisticDispatchAvailableAppointmentsSlotsInput: _objectSpread({}, d)
      })
    }).then(function (e) {
      var t;
      return null == e || null === (t = e.body) || void 0 === t ? void 0 : t.ImplLogisticDispatchAvailableAppointmentsSlotsOutput;
    });
  },
  Vi = function Vi(e) {
    return /*#__PURE__*/function () {
      var _ref58 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(t) {
        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                _context33.prev = 0;
                t({
                  type: "GET_POPSTATIONS_LOADING"
                });
                _context33.t0 = t;
                _context33.next = 5;
                return Ei({
                  postcode: e
                });
              case 5:
                _context33.t1 = _context33.sent;
                _context33.t2 = {
                  postcode: e
                };
                _context33.t3 = {
                  type: "GET_POPSTATIONS_SUCCESS",
                  payload: _context33.t1,
                  meta: _context33.t2
                };
                return _context33.abrupt("return", (0, _context33.t0)(_context33.t3));
              case 11:
                _context33.prev = 11;
                _context33.t4 = _context33["catch"](0);
                return _context33.abrupt("return", t({
                  type: "GET_POPSTATIONS_FAILED",
                  payload: _context33.t4,
                  error: !0,
                  meta: {
                    postcode: e
                  }
                }));
              case 14:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, null, [[0, 11]]);
      }));
      return function (_x37) {
        return _ref58.apply(this, arguments);
      };
    }();
  },
  Yi = function Yi(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
    return /*#__PURE__*/function () {
      var _ref59 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34(r) {
        return _regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                r({
                  type: "GET_ADDRESS_INFO_LOADING"
                });
                _context34.prev = 1;
                _context34.t0 = r;
                _context34.next = 5;
                return Di(e);
              case 5:
                _context34.t1 = _context34.sent;
                _context34.t2 = {
                  postcode: e,
                  saveNewAddressInfo: t
                };
                _context34.t3 = {
                  type: "GET_ADDRESS_INFO_SUCCESS",
                  payload: _context34.t1,
                  meta: _context34.t2
                };
                return _context34.abrupt("return", (0, _context34.t0)(_context34.t3));
              case 11:
                _context34.prev = 11;
                _context34.t4 = _context34["catch"](1);
                return _context34.abrupt("return", r({
                  type: "GET_ADDRESS_INFO_FAILED",
                  error: _context34.t4,
                  meta: {
                    postcode: e
                  }
                }));
              case 14:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, null, [[1, 11]]);
      }));
      return function (_x38) {
        return _ref59.apply(this, arguments);
      };
    }();
  },
  xi = function xi() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var r = e.filter(function (e) {
      return t.includes(e.itemCode);
    });
    if (t.length !== r.length) return !0;
    for (var _e32 = 0; _e32 < r.length; _e32++) {
      var _t25 = r[_e32];
      if (_t25.availableQty <= 0 || "NA" === _t25.status) return !0;
    }
    return !1;
  },
  Hi = function Hi(e) {
    return /*#__PURE__*/function () {
      var _ref60 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35(t) {
        var r, n, o;
        return _regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                _context35.prev = 0;
                t({
                  type: la.GET_DELIVERY_DETAILS_LOADING
                });
                r = e.productOrderReferenceNumber;
                n = e.contactId;
                _context35.next = 6;
                return yi({
                  contactId: n,
                  productOrderReferenceNumber: r
                });
              case 6:
                o = _context35.sent;
                return _context35.abrupt("return", (o.billingAccountDetails = gi(null == o ? void 0 : o.billingAccountDetails), t({
                  type: la.GET_DELIVERY_DETAILS_SUCCESS,
                  payload: o
                })));
              case 10:
                _context35.prev = 10;
                _context35.t0 = _context35["catch"](0);
                return _context35.abrupt("return", t({
                  type: la.GET_DELIVERY_DETAILS_ERROR,
                  error: _context35.t0
                }));
              case 13:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35, null, [[0, 10]]);
      }));
      return function (_x39) {
        return _ref60.apply(this, arguments);
      };
    }();
  },
  $i = function $i() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var t = h.LOGISTIC[null == e ? void 0 : e.slotType] || h.LOGISTIC.OTHER,
      _e$leadDay = e.leadDay,
      r = _e$leadDay === void 0 ? t : _e$leadDay,
      n = _objectSpread(_objectSpread({}, e), {}, {
        leadDay: r
      });
    return /*#__PURE__*/function () {
      var _ref61 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36(e) {
        var _t26;
        return _regeneratorRuntime.wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                _context36.prev = 0;
                e({
                  type: la.GET_APPOINTMENT_SLOT_LOADING
                });
                if (!Ui) {
                  _context36.next = 8;
                  break;
                }
                _context36.next = 5;
                return Bi(n);
              case 5:
                _context36.t0 = _context36.sent;
                _context36.next = 11;
                break;
              case 8:
                _context36.next = 10;
                return Ti(n);
              case 10:
                _context36.t0 = _context36.sent;
              case 11:
                _t26 = _context36.t0;
                e({
                  type: la.GET_APPOINTMENT_SLOT_SUCCESS,
                  payload: _t26
                });
                _context36.next = 18;
                break;
              case 15:
                _context36.prev = 15;
                _context36.t1 = _context36["catch"](0);
                e({
                  type: la.GET_APPOINTMENT_SLOT_ERROR,
                  error: _context36.t1
                });
              case 18:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee36, null, [[0, 15]]);
      }));
      return function (_x40) {
        return _ref61.apply(this, arguments);
      };
    }();
  },
  qi = function qi(e) {
    return /*#__PURE__*/function () {
      var _ref62 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37(t) {
        return _regeneratorRuntime.wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                _context37.prev = 0;
                t({
                  type: "SET_COLLECT_AT_STORE_TIME_SLOTS_LOADING"
                });
                _context37.t0 = t;
                _context37.next = 5;
                return Ai(e);
              case 5:
                _context37.t1 = _context37.sent;
                _context37.t2 = {
                  type: "SET_COLLECT_AT_STORE_TIME_SLOTS_SUCCESS",
                  payload: _context37.t1
                };
                return _context37.abrupt("return", (0, _context37.t0)(_context37.t2));
              case 10:
                _context37.prev = 10;
                _context37.t3 = _context37["catch"](0);
                return _context37.abrupt("return", t({
                  type: "SET_COLLECT_AT_STORE_TIME_SLOTS_FAILURE",
                  error: _context37.t3
                }));
              case 13:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37, null, [[0, 10]]);
      }));
      return function (_x41) {
        return _ref62.apply(this, arguments);
      };
    }();
  },
  Wi = function Wi(e) {
    var t = h.SELF_COLLECTION[null == e ? void 0 : e.slotType] || h.SELF_COLLECTION.OTHER,
      r = e.slotType,
      _e$dealer = e.dealer,
      n = _e$dealer === void 0 ? a : _e$dealer,
      _e$documentRequired = e.documentRequired,
      o = _e$documentRequired === void 0 ? !1 : _e$documentRequired,
      i = e.outlet,
      _e$leadDays = e.leadDays,
      c = _e$leadDays === void 0 ? t : _e$leadDays,
      _e$hasPrelaunchDevice = e.hasPrelaunchDevice,
      d = _e$hasPrelaunchDevice === void 0 ? !1 : _e$hasPrelaunchDevice,
      s = {
        slotType: r,
        cdf: "",
        dealer: n,
        documentRequired: o,
        outlet: i,
        ld: c,
        hasPrelaunchDevice: d
      };
    return /*#__PURE__*/function () {
      var _ref63 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38(t) {
        return _regeneratorRuntime.wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                _context38.prev = 0;
                t({
                  type: "GET_SELF_COLLECTION_LOADING"
                });
                _context38.t0 = t;
                if (!Ui) {
                  _context38.next = 9;
                  break;
                }
                _context38.next = 6;
                return Gi(s);
              case 6:
                _context38.t1 = _context38.sent;
                _context38.next = 12;
                break;
              case 9:
                _context38.next = 11;
                return mi(s);
              case 11:
                _context38.t1 = _context38.sent;
              case 12:
                _context38.t2 = _context38.t1;
                _context38.t3 = e;
                _context38.t4 = {
                  type: "GET_SELF_COLLECTION_SUCCESS",
                  payload: _context38.t2,
                  meta: _context38.t3
                };
                (0, _context38.t0)(_context38.t4);
                _context38.next = 21;
                break;
              case 18:
                _context38.prev = 18;
                _context38.t5 = _context38["catch"](0);
                t({
                  type: "GET_SELF_COLLECTION_FAILED",
                  payload: _context38.t5,
                  error: !0,
                  meta: e
                });
              case 21:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38, null, [[0, 18]]);
      }));
      return function (_x42) {
        return _ref63.apply(this, arguments);
      };
    }();
  },
  Xi = function Xi(e) {
    var t = e.timeSlotId,
      r = e.serviceId,
      n = e.nric,
      o = {
        ImplReserveSelfCollectionTimeSlotsRequest: {
          mode: "R",
          id: t,
          serviceNo: r,
          custId: n
        }
      };
    return /*#__PURE__*/function () {
      var _ref64 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39(e) {
        var _t27;
        return _regeneratorRuntime.wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                _context39.prev = 0;
                e({
                  type: "RESERVE_SELF_COLLECTION_TIME_SLOT_LOADING"
                });
                _context39.next = 4;
                return mi({
                  payload: o
                });
              case 4:
                _t27 = _context39.sent;
                if (!("False" !== (null == _t27 ? void 0 : _t27.response))) {
                  _context39.next = 7;
                  break;
                }
                return _context39.abrupt("return", (e({
                  type: "RESERVE_SELF_COLLECTION_TIME_SLOT_SUCCESS",
                  payload: _t27
                }), _t27));
              case 7:
                e({
                  type: "RESERVE_SELF_COLLECTION_TIME_SLOT_ERROR",
                  payload: _t27
                });
                _context39.next = 13;
                break;
              case 10:
                _context39.prev = 10;
                _context39.t0 = _context39["catch"](0);
                e({
                  type: "RESERVE_SELF_COLLECTION_TIME_SLOT_ERROR",
                  payload: _context39.t0
                });
              case 13:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee39, null, [[0, 10]]);
      }));
      return function (_x43) {
        return _ref64.apply(this, arguments);
      };
    }();
  },
  ji = function ji(e) {
    var t = _toConsumableArray(e.skuList);
    return t.some(function (e) {
      return e === d["3IN1"] || e === d[c];
    }) || t.push(d[c]), ( /*#__PURE__*/function () {
      var _ref65 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee40(e) {
        var _r23, r;
        return _regeneratorRuntime.wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                e({
                  type: "GET_COLLECT_NOW_LOADING"
                });
                _context40.prev = 1;
                _context40.next = 4;
                return function (e) {
                  var t = e.skuList;
                  return nt(i + "/sdp/lamp/enquireAvailableStock", {
                    method: "POST",
                    queryParams: {
                      sc: "SS",
                      lo: "en_US"
                    },
                    body: JSON.stringify({
                      ImplEnquireAvailableStockRequest: {
                        skuList: t
                      }
                    })
                  }).then(function (e) {
                    return e.ImplEnquireAvailableStockResponse.implPOPStationDetails;
                  });
                }({
                  skuList: t
                });
              case 4:
                _r23 = _context40.sent;
                return _context40.abrupt("return", (e({
                  type: "GET_COLLECT_NOW_SUCCESS",
                  payload: _r23
                }), _r23));
              case 8:
                _context40.prev = 8;
                _context40.t0 = _context40["catch"](1);
                if (!(500 === (null == _context40.t0 || null === (r = _context40.t0.response) || void 0 === r ? void 0 : r.status))) {
                  _context40.next = 12;
                  break;
                }
                return _context40.abrupt("return", (e({
                  type: "GET_COLLECT_NOW_SUCCESS",
                  payload: []
                }), []));
              case 12:
                e({
                  type: "GET_COLLECT_NOW_ERROR",
                  payload: _context40.t0
                });
              case 13:
              case "end":
                return _context40.stop();
            }
          }
        }, _callee40, null, [[1, 8]]);
      }));
      return function (_x44) {
        return _ref65.apply(this, arguments);
      };
    }());
  },
  Ki = function Ki(e) {
    var t = e.skuList;
    return /*#__PURE__*/function () {
      var _ref66 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee41(e) {
        var r;
        return _regeneratorRuntime.wrap(function _callee41$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                e({
                  type: "GET_MTPOS_LOADING"
                });
                _context41.prev = 1;
                if (!Ui) {
                  _context41.next = 8;
                  break;
                }
                _context41.next = 5;
                return Fi(t);
              case 5:
                _context41.t0 = _context41.sent;
                _context41.next = 11;
                break;
              case 8:
                _context41.next = 10;
                return Ri(t);
              case 10:
                _context41.t0 = _context41.sent;
              case 11:
                r = _context41.t0;
                return _context41.abrupt("return", (e({
                  type: "GET_MTPOS_SUCCESS",
                  payload: r
                }), r));
              case 15:
                _context41.prev = 15;
                _context41.t1 = _context41["catch"](1);
                e({
                  type: "GET_MTPOS_ERROR",
                  payload: _context41.t1
                });
              case 18:
              case "end":
                return _context41.stop();
            }
          }
        }, _callee41, null, [[1, 15]]);
      }));
      return function (_x45) {
        return _ref66.apply(this, arguments);
      };
    }();
  },
  Ji = {
    GET_STORE_AVAILABILITY_LOADING: "GET_STORE_AVAILABILITY_LOADING",
    GET_STORE_AVAILABILITY_SUCCESS: "GET_STORE_AVAILABILITY_SUCCESS",
    GET_STORE_AVAILABILITY_ERROR: "GET_STORE_AVAILABILITY_ERROR"
  },
  Zi = function Zi(e) {
    return /*#__PURE__*/function () {
      var _ref67 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee43(t) {
        var r, n, o;
        return _regeneratorRuntime.wrap(function _callee43$(_context43) {
          while (1) {
            switch (_context43.prev = _context43.next) {
              case 0:
                t({
                  type: Ji.GET_STORE_AVAILABILITY_LOADING
                });
                _context43.prev = 1;
                r = e.skus;
                n = e.storeIdPickup;
                _context43.next = 6;
                return Promise.all(r.map( /*#__PURE__*/function () {
                  var _ref68 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee42(e) {
                    var t;
                    return _regeneratorRuntime.wrap(function _callee42$(_context42) {
                      while (1) {
                        switch (_context42.prev = _context42.next) {
                          case 0:
                            t = {
                              itemCode: e,
                              storeIdPickup: n
                            };
                            return _context42.abrupt("return", Ui ? ki(t) : Si(t));
                          case 2:
                          case "end":
                            return _context42.stop();
                        }
                      }
                    }, _callee42);
                  }));
                  return function (_x47) {
                    return _ref68.apply(this, arguments);
                  };
                }()));
              case 6:
                o = _context43.sent;
                return _context43.abrupt("return", (t({
                  type: Ji.GET_STORE_AVAILABILITY_SUCCESS,
                  payload: o
                }), o));
              case 10:
                _context43.prev = 10;
                _context43.t0 = _context43["catch"](1);
                t({
                  type: Ji.GET_STORE_AVAILABILITY_ERROR,
                  payload: _context43.t0
                });
              case 13:
              case "end":
                return _context43.stop();
            }
          }
        }, _callee43, null, [[1, 10]]);
      }));
      return function (_x46) {
        return _ref67.apply(this, arguments);
      };
    }();
  },
  zi = function zi(e) {
    return /*#__PURE__*/function () {
      var _ref69 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee44(t) {
        var r;
        return _regeneratorRuntime.wrap(function _callee44$(_context44) {
          while (1) {
            switch (_context44.prev = _context44.next) {
              case 0:
                t({
                  type: Ji.GET_STORE_AVAILABILITY_LOADING
                });
                _context44.prev = 1;
                if (!Ui) {
                  _context44.next = 8;
                  break;
                }
                _context44.next = 5;
                return ki(e);
              case 5:
                _context44.t0 = _context44.sent;
                _context44.next = 11;
                break;
              case 8:
                _context44.next = 10;
                return Si(e);
              case 10:
                _context44.t0 = _context44.sent;
              case 11:
                r = _context44.t0;
                return _context44.abrupt("return", (t({
                  type: Ji.GET_STORE_AVAILABILITY_SUCCESS,
                  payload: r
                }), r));
              case 15:
                _context44.prev = 15;
                _context44.t1 = _context44["catch"](1);
                t({
                  type: Ji.GET_STORE_AVAILABILITY_ERROR,
                  payload: _context44.t1
                });
              case 18:
              case "end":
                return _context44.stop();
            }
          }
        }, _callee44, null, [[1, 15]]);
      }));
      return function (_x48) {
        return _ref69.apply(this, arguments);
      };
    }();
  },
  Qi = {
    EXTEND_EQUIPMENT_RESERVATION_LOADING: "EXTEND_EQUIPMENT_RESERVATION_LOADING",
    EXTEND_EQUIPMENT_RESERVATION_SUCCESS: "EXTEND_EQUIPMENT_RESERVATION_SUCCESS",
    EXTEND_EQUIPMENT_RESERVATION_ERROR: "EXTEND_EQUIPMENT_RESERVATION_ERROR"
  },
  ea = function ea(e) {
    var t = e.contactId,
      r = e.allocationId,
      _e$sessExpirationMins = e.sessExpirationMins,
      n = _e$sessExpirationMins === void 0 ? 20 : _e$sessExpirationMins,
      _e$newExpirationTime = e.newExpirationTime,
      o = _e$newExpirationTime === void 0 ? bn().add(n, "minute").valueOf() : _e$newExpirationTime,
      _e$allocationStatus2 = e.allocationStatus,
      i = _e$allocationStatus2 === void 0 ? "Extend" : _e$allocationStatus2;
    return /*#__PURE__*/function () {
      var _ref70 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee45(e) {
        var _a3;
        return _regeneratorRuntime.wrap(function _callee45$(_context45) {
          while (1) {
            switch (_context45.prev = _context45.next) {
              case 0:
                _context45.prev = 0;
                e({
                  type: Qi.EXTEND_EQUIPMENT_RESERVATION_LOADING
                });
                _context45.next = 4;
                return fi({
                  contactId: t,
                  allocationId: r,
                  allocationStatus: i,
                  sessExpirationMins: n,
                  newExpirationTime: o
                });
              case 4:
                _a3 = _context45.sent;
                e({
                  type: Qi.EXTEND_EQUIPMENT_RESERVATION_SUCCESS,
                  payload: _a3
                });
                _context45.next = 11;
                break;
              case 8:
                _context45.prev = 8;
                _context45.t0 = _context45["catch"](0);
                e({
                  type: Qi.EXTEND_EQUIPMENT_RESERVATION_ERROR,
                  error: _context45.t0
                });
              case 11:
              case "end":
                return _context45.stop();
            }
          }
        }, _callee45, null, [[0, 8]]);
      }));
      return function (_x49) {
        return _ref70.apply(this, arguments);
      };
    }();
  },
  ta = function ta(e) {
    var t = e.skuList,
      r = e.collectionPointCode,
      _e$collectionPointTyp = e.collectionPointType,
      n = _e$collectionPointTyp === void 0 ? "LOCKER" : _e$collectionPointTyp;
    return /*#__PURE__*/function () {
      var _ref71 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee46(e) {
        var o;
        return _regeneratorRuntime.wrap(function _callee46$(_context46) {
          while (1) {
            switch (_context46.prev = _context46.next) {
              case 0:
                _context46.prev = 0;
                e({
                  type: "RESERVE_SELF_COLLECTION_LOADING"
                });
                _context46.next = 4;
                return function (e) {
                  var t = e.skuList,
                    r = e.collectionPointType,
                    n = e.collectionPointCode,
                    o = e.actionIndicator,
                    a = e.lampTrackingId;
                  return nt(i + "/sdp/lamp/reserve", {
                    method: "POST",
                    queryParams: {
                      sc: "SS",
                      lo: "en_US"
                    },
                    body: JSON.stringify({
                      ImplReservationRequest: {
                        skuList: t,
                        actionIndicator: o,
                        collectionPointType: r,
                        collectionPointCode: n,
                        lampTrackingId: a
                      }
                    })
                  }).then(function (e) {
                    return e.ImplReservationResponse;
                  });
                }({
                  skuList: t,
                  actionIndicator: "R",
                  collectionPointType: n,
                  collectionPointCode: r
                });
              case 4:
                o = _context46.sent;
                return _context46.abrupt("return", (e({
                  type: "RESERVE_SELF_COLLECTION_SUCCESS",
                  payload: o
                }), o));
              case 8:
                _context46.prev = 8;
                _context46.t0 = _context46["catch"](0);
                e({
                  type: "RESERVE_SELF_COLLECTION_ERROR",
                  payload: _context46.t0
                });
              case 11:
              case "end":
                return _context46.stop();
            }
          }
        }, _callee46, null, [[0, 8]]);
      }));
      return function (_x50) {
        return _ref71.apply(this, arguments);
      };
    }();
  },
  ra = function ra(e) {
    return /*#__PURE__*/function () {
      var _ref72 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee47(t) {
        var r;
        return _regeneratorRuntime.wrap(function _callee47$(_context47) {
          while (1) {
            switch (_context47.prev = _context47.next) {
              case 0:
                _context47.prev = 0;
                t({
                  type: "RESERVE_EQUIPMENT_LOADING"
                });
                _context47.next = 4;
                return function (_ref73) {
                  var e = _ref73.selectedStoreId,
                    t = _ref73.customerId,
                    r = _ref73.productOrderId,
                    n = _ref73.items;
                  var o = {
                    ImplReserveOrAllocateEquipmentRestInput: {
                      reservationInfoX9: {
                        itemInfoX9: n.map(function (e) {
                          return {
                            itemCodeX9: e.skuId,
                            qtyX9: e.qty || 1,
                            reservationState: "PEND"
                          };
                        }),
                        orderIDX9: r,
                        customerIDX9: t,
                        channelX9: "O",
                        storeIDOrderX9: a,
                        storeIDPickupX9: e,
                        vipIndX9: !1
                      }
                    }
                  };
                  return nt(_i, {
                    method: "POST",
                    queryParams: {
                      sc: "SS",
                      lo: "en_US"
                    },
                    body: JSON.stringify(o)
                  }).then(function (e) {
                    return e.ImplReserveOrAllocateEquipmentRestOutput;
                  });
                }(e);
              case 4:
                r = _context47.sent;
                return _context47.abrupt("return", (t({
                  type: "RESERVE_EQUIPMENT_SUCCESS",
                  payload: r
                }), r));
              case 8:
                _context47.prev = 8;
                _context47.t0 = _context47["catch"](0);
                t({
                  type: "RESERVE_EQUIPMENT_ERROR",
                  payload: _context47.t0
                });
              case 11:
              case "end":
                return _context47.stop();
            }
          }
        }, _callee47, null, [[0, 8]]);
      }));
      return function (_x51) {
        return _ref72.apply(this, arguments);
      };
    }();
  },
  na = function na(e) {
    return /*#__PURE__*/function () {
      var _ref74 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee48(t) {
        var r, n, o;
        return _regeneratorRuntime.wrap(function _callee48$(_context48) {
          while (1) {
            switch (_context48.prev = _context48.next) {
              case 0:
                _context48.prev = 0;
                t({
                  type: "ALLOCATE_EQUIPMENT_LOADING"
                });
                _context48.next = 4;
                return function (_ref75) {
                  var e = _ref75.productOrderId,
                    t = _ref75.items;
                  var r = {
                    ImplReserveOrAllocateEquipmentRestInput: {
                      allocationInfoX9: {
                        itemInfoX9: t.map(function (e) {
                          return {
                            itemCodeX9: e.skuId,
                            qtyX9: e.qty || 1,
                            reservationState: "PEND"
                          };
                        }),
                        extOrderIDX9: e,
                        channelX9: "O",
                        storeIDOrderX9: 0,
                        cfuX9: "C",
                        vipIndX9: !1
                      }
                    }
                  };
                  return nt(_i, {
                    method: "POST",
                    body: JSON.stringify(r)
                  }).then(function (e) {
                    return e.ImplReserveOrAllocateEquipmentRestOutput;
                  });
                }(e);
              case 4:
                r = _context48.sent;
                n = e.items.reduce(function (e, t) {
                  var r = t.skuId,
                    n = _objectWithoutProperties(t, _excluded6);
                  return r in e || (e[r] = n), e;
                }, {});
                o = [];
                return _context48.abrupt("return", (r.allocationStatusX9.forEach(function (e) {
                  var t;
                  e.type = null === (t = n[e.itemCodeX9]) || void 0 === t ? void 0 : t.type, e.allocationOKX9 || o.push(e);
                }), o.length ? t({
                  type: "ALLOCATE_EQUIPMENT_ERROR",
                  payload: o
                }) : t({
                  type: "ALLOCATE_EQUIPMENT_SUCCESS",
                  payload: r
                }), r));
              case 10:
                _context48.prev = 10;
                _context48.t0 = _context48["catch"](0);
                t({
                  type: "ALLOCATE_EQUIPMENT_ERROR",
                  payload: _context48.t0
                });
              case 13:
              case "end":
                return _context48.stop();
            }
          }
        }, _callee48, null, [[0, 10]]);
      }));
      return function (_x52) {
        return _ref74.apply(this, arguments);
      };
    }();
  },
  oa = function oa(e) {
    var t = e.customerId,
      r = e.productOrderId,
      n = e.productId,
      o = e.productOrderItemId,
      _e$removedContainedPr2 = e.removedContainedProducts,
      i = _e$removedContainedPr2 === void 0 ? [] : _e$removedContainedPr2,
      a = {
        ImplUpdateOrderProductsRequest: {
          returnRemovedItems: !1,
          returnRemovedByReplaceItems: !1,
          settingsViewFilter: "FULL",
          stepsToRetrieve: [],
          stepsToValidate: [],
          attachmentTypes: [],
          runCompatibilityRules: !0,
          activityForConfiguration: "QuoteSDOrderSummary+++promoCode+++EMPTY",
          confirmationMessagesApproved: !1,
          saveIfCompatibilityRulesFailed: !1,
          addDefaultChildItemsImplicitly: !1,
          returnConfigurationData: {
            catalogDataInd: !0,
            crossProductsDiscountsDataInd: !0,
            previousQuotedRecurringPricesInd: !1,
            productConfigurationInd: !0,
            quotedPricesInd: !0,
            quotedProrationInd: !0,
            quotedTaxInd: !0,
            summaryInd: !0
          },
          implUpdateOrderProductConfigurationList: [{
            productOrderItemId: o,
            returnFullUpcResponse: !1,
            productConfigurationChanges: {
              links: [],
              resumedContainedProducts: [],
              changedContainedProducts: [{
                productID: n
              }],
              newContainedProducts: [],
              removedContainedProducts: i,
              suspendedContainedProducts: []
            }
          }]
        }
      };
    return /*#__PURE__*/function () {
      var _ref76 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee49(e) {
        var _n12;
        return _regeneratorRuntime.wrap(function _callee49$(_context49) {
          while (1) {
            switch (_context49.prev = _context49.next) {
              case 0:
                _context49.prev = 0;
                e({
                  type: "UPDATE_ORDER_PRODUCT_LOADING"
                });
                _context49.next = 4;
                return ii({
                  payload: a,
                  customerId: t,
                  productOrderId: r
                });
              case 4:
                _n12 = _context49.sent;
                return _context49.abrupt("return", (e({
                  type: "UPDATE_ORDER_PRODUCT_SUCCESS",
                  payload: _n12
                }), _n12));
              case 8:
                _context49.prev = 8;
                _context49.t0 = _context49["catch"](0);
                e({
                  type: "UPDATE_ORDER_PRODUCT_ERROR",
                  payload: _context49.t0
                });
              case 11:
              case "end":
                return _context49.stop();
            }
          }
        }, _callee49, null, [[0, 8]]);
      }));
      return function (_x53) {
        return _ref76.apply(this, arguments);
      };
    }();
  },
  ia = function ia(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "pop-station";
    return /*#__PURE__*/function () {
      var _ref77 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee50(r) {
        var n, _t28, _t29, o;
        return _regeneratorRuntime.wrap(function _callee50$(_context50) {
          while (1) {
            switch (_context50.prev = _context50.next) {
              case 0:
                _context50.prev = 0;
                _context50.t0 = (r({
                  type: "RETRIEVE_ADDRESS_ID_LOADING"
                }), t);
                _context50.next = _context50.t0 === "courier" ? 4 : 7;
                break;
              case 4:
                _t28 = e;
                n = _objectSpread(_objectSpread({}, e), {}, {
                  buildingClassificationX8: _t28.buildingClassificationX8 || "Commercial/Factory/JTC",
                  country: _t28.country || "SGP",
                  state: _t28.state || "SNG",
                  city: _t28.city || "Singapore"
                });
                return _context50.abrupt("break", 9);
              case 7:
                _t29 = e;
                n = {
                  postalCode: _t29.PostCode,
                  street: _t29.StreetName,
                  streetNumber: _t29.HouseBlockNumber,
                  address2: _t29.HouseBlockNumber,
                  country: _t29.country || "SGP",
                  state: _t29.state || "SNG",
                  city: _t29.city || "Singapore",
                  address3: _t29.BuildingName,
                  buildingClassificationX8: _t29.buildingClassification || "Commercial/Factory/JTC"
                };
              case 9:
                _context50.next = 11;
                return function (e) {
                  var t = {
                    CreateAddressRequest: {
                      address: e
                    }
                  };
                  return nt(Ci, {
                    method: "POST",
                    body: JSON.stringify(t)
                  }).then(function (e) {
                    return e.CreateAddressResponse.address.ID;
                  });
                }(n);
              case 11:
                o = _context50.sent;
                return _context50.abrupt("return", (r({
                  type: "RETRIEVE_ADDRESS_ID_SUCCESS",
                  payload: o
                }), o));
              case 15:
                _context50.prev = 15;
                _context50.t1 = _context50["catch"](0);
                r({
                  type: "RETRIEVE_ADDRESS_ID_ERROR",
                  error: _context50.t1
                });
              case 18:
              case "end":
                return _context50.stop();
            }
          }
        }, _callee50, null, [[0, 15]]);
      }));
      return function (_x54) {
        return _ref77.apply(this, arguments);
      };
    }();
  },
  aa = function aa(e) {
    var t = "";
    return e.HouseBlockNumber && (t = e.HouseBlockNumber + ";"), e.UnitNumber && (t = t.concat(e.UnitNumber, ";")), e.BuildingName && (t = t.concat(e.BuildingName, ";")), e.StreetName && (t = t.concat(e.StreetName, ";")), e.city && (t = t.concat(e.city, ";")), e.PostCode && (t = t.concat(e.PostCode, ";")), t;
  },
  ca = function ca(e) {
    var t = e.userInfo,
      r = e.addressId,
      n = e.selectedTimeSlot,
      o = e.address,
      i = e.productOrderReferenceNumber,
      _e$documentRequired2 = e.documentRequired,
      a = _e$documentRequired2 === void 0 ? !1 : _e$documentRequired2,
      c = e.selectedFulfilmentMode,
      d = e.productOrderItemId,
      _e$orderActionsForDel = e.orderActionsForDelivery,
      s = _e$orderActionsForDel === void 0 ? [] : _e$orderActionsForDel,
      _e$orderActionsForFsS = e.orderActionsForFsSrd,
      u = _e$orderActionsForFsS === void 0 ? [] : _e$orderActionsForFsS,
      _e$isSnailMail = e.isSnailMail,
      l = _e$isSnailMail === void 0 ? !1 : _e$isSnailMail,
      _e$isNewSimAdded = e.isNewSimAdded,
      p = _e$isNewSimAdded === void 0 ? !1 : _e$isNewSimAdded,
      I = e.selectedCollectAtStore,
      m = e.customerId,
      _e$isBackOrder = e.isBackOrder,
      E = _e$isBackOrder === void 0 ? !1 : _e$isBackOrder,
      _e$isPreOrder = e.isPreOrder,
      R = _e$isPreOrder === void 0 ? !1 : _e$isPreOrder,
      _e$isRrpIppOrder = e.isRrpIppOrder,
      S = _e$isRrpIppOrder === void 0 ? !1 : _e$isRrpIppOrder,
      _e$deliveryTimeSlot = e.deliveryTimeSlot,
      _ = _e$deliveryTimeSlot === void 0 ? null : _e$deliveryTimeSlot;
    return /*#__PURE__*/function () {
      var _ref78 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee51(e) {
        var R, O, C, f, y, _e33, _e34, _t30, _e35, _e36, _e37, T, _n13, _o7;
        return _regeneratorRuntime.wrap(function _callee51$(_context51) {
          while (1) {
            switch (_context51.prev = _context51.next) {
              case 0:
                R = m || t.clientContext.customers[0].customerId;
                C = "", f = [], y = {};
                _context51.t0 = (f = [{
                  key: "IS_FSORDER_CONSOLIDATED",
                  value: !1
                }, {
                  key: "IsSSBackOrder",
                  value: E
                }], c);
                _context51.next = _context51.t0 === "collect-now" ? 5 : _context51.t0 === "pop-station" ? 8 : _context51.t0 === "mailbox-delivery" ? 11 : _context51.t0 === "courier" ? 11 : _context51.t0 === "singtel-store" ? 14 : _context51.t0 === "Drop Shipping" ? 17 : 20;
                break;
              case 5:
                _e33 = o;
                C = "Collect Now", O = {
                  slotStartDate: Date.now(),
                  slotEndDate: null,
                  slotCode: "S4",
                  timeDescription: "From ".concat(bn().format("YYYY-MM-DD, h:mm:ss a"), "  Onwards"),
                  slotId: null,
                  popStationCode: _e33.KioskId
                };
                return _context51.abrupt("break", 21);
              case 8:
                _e34 = n, _t30 = Date.parse(_e34.slotDate);
                C = "Courier To Home (PoPStation)", O = {
                  slotStartDate: _t30,
                  slotEndDate: _t30,
                  slotCode: _e34.slotCode,
                  timeDescription: _e34.slotDesc,
                  slotId: _e34.id,
                  popStationCode: _e34.outletCode
                }, S && (y = {
                  collectionAddressType: c,
                  collectionAddress: I.collectionAddress
                });
                return _context51.abrupt("break", 21);
              case 11:
                _e35 = n;
                C = "courier" === c ? "Courier to Home" : "Courier To Home (Snail Mail)", O = {
                  slotStartDate: _e35.slotStartDate,
                  slotEndDate: _e35.slotStartDate,
                  slotCode: _e35.slotCode,
                  timeDescription: _e35.timeDescription
                };
                return _context51.abrupt("break", 21);
              case 14:
                _e36 = n;
                C = "Pick Up from another store", O = {
                  slotId: I.collectATStoreAppt,
                  slotStartDate: _e36.startDateTime,
                  slotEndDate: _e36.endDateTime,
                  slotCode: _e36.siteId,
                  timeDescription: _e36.slotDesc
                }, y = _objectSpread({
                  collectionAddressType: c,
                  appointmentId: I.collectATStoreAppt,
                  collectionAddress: I.collectionAddress
                }, y);
                return _context51.abrupt("break", 21);
              case 17:
                _e37 = n;
                C = c, O = {
                  slotStartDate: _e37.slotStartDate,
                  slotEndDate: _e37.slotStartDate,
                  slotCode: _e37.slotCode,
                  timeDescription: _e37.timeDescription
                };
                return _context51.abrupt("break", 21);
              case 20:
                C = "Not Applicable", y = _objectSpread({
                  addressId: "",
                  collectionAddressType: null,
                  collectionAddress: null
                }, y), O = _;
              case 21:
                _context51.prev = 21;
                e({
                  type: "UPDATE_DELIVERY_LOADING"
                });
                _n13 = _objectSpread({
                  deliveryMethod: C,
                  addressId: r,
                  recipientDocumentType: t.clientContext.contact.indentType,
                  recipientDocumentId: (null === (T = t.userDetails) || void 0 === T ? void 0 : T.custId) || t.clientContext.contact.indentValue,
                  recipientFirstName: t.clientContext.contact.firstName,
                  recipientLastName: t.clientContext.contact.lastName,
                  recipientPhone: t.clientContext.contact.phone,
                  recipientEmail: t.clientContext.contact.email,
                  newSIMList: [{
                    newSimAdded: p,
                    orderAction: d
                  }],
                  documentRequired: a,
                  orderActionsForDelivery: s,
                  orderActionsForFsSrd: u,
                  implKeyPairList: f,
                  transactionType: "NEW_SIGN_UP",
                  shippingInstructions: "shippingInstructions",
                  isSnailMail: l
                }, y);
                O && (_n13.deliveryTimeSlot = O);
                _context51.next = 27;
                return Oi({
                  customerId: R,
                  productOrderReferenceNumber: i,
                  payload: _n13
                });
              case 27:
                _o7 = _context51.sent;
                return _context51.abrupt("return", (null == _o7 ? void 0 : _o7.errorInfo) ? {
                  errorInfo: !0,
                  res: _o7
                } : (e({
                  type: "UPDATE_DELIVERY_SUCCESS",
                  payload: _o7
                }), _o7));
              case 31:
                _context51.prev = 31;
                _context51.t1 = _context51["catch"](21);
                e({
                  type: "UPDATE_DELIVERY_ERROR",
                  payload: _context51.t1
                });
              case 34:
              case "end":
                return _context51.stop();
            }
          }
        }, _callee51, null, [[21, 31]]);
      }));
      return function (_x55) {
        return _ref78.apply(this, arguments);
      };
    }();
  },
  da = function da(e) {
    return /*#__PURE__*/function () {
      var _ref79 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee52(t) {
        var r;
        return _regeneratorRuntime.wrap(function _callee52$(_context52) {
          while (1) {
            switch (_context52.prev = _context52.next) {
              case 0:
                _context52.prev = 0;
                _context52.next = 3;
                return Pi(e);
              case 3:
                r = _context52.sent;
                t({
                  type: la.CONTACT_VIEW_SUCCESS,
                  payload: r
                });
                _context52.next = 10;
                break;
              case 7:
                _context52.prev = 7;
                _context52.t0 = _context52["catch"](0);
                t({
                  type: la.CONTACT_VIEW_FAILURE,
                  error: _context52.t0
                });
              case 10:
              case "end":
                return _context52.stop();
            }
          }
        }, _callee52, null, [[0, 7]]);
      }));
      return function (_x56) {
        return _ref79.apply(this, arguments);
      };
    }();
  },
  sa = function sa(e) {
    return /*#__PURE__*/function () {
      var _ref80 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee53(t) {
        var r;
        return _regeneratorRuntime.wrap(function _callee53$(_context53) {
          while (1) {
            switch (_context53.prev = _context53.next) {
              case 0:
                _context53.prev = 0;
                _context53.next = 3;
                return vi(e);
              case 3:
                r = _context53.sent;
                t({
                  type: la.EAPPOINTMENT_CREATE_SUCCESS,
                  payload: r
                });
                _context53.next = 10;
                break;
              case 7:
                _context53.prev = 7;
                _context53.t0 = _context53["catch"](0);
                t({
                  type: la.EAPPOINTMENT_CREATE_FAILURE,
                  error: _context53.t0
                });
              case 10:
              case "end":
                return _context53.stop();
            }
          }
        }, _callee53, null, [[0, 7]]);
      }));
      return function (_x57) {
        return _ref80.apply(this, arguments);
      };
    }();
  },
  ua = function ua(e) {
    return /*#__PURE__*/function () {
      var _ref81 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee54(t) {
        var r;
        return _regeneratorRuntime.wrap(function _callee54$(_context54) {
          while (1) {
            switch (_context54.prev = _context54.next) {
              case 0:
                _context54.prev = 0;
                _context54.next = 3;
                return hi(e);
              case 3:
                r = _context54.sent;
                t({
                  type: la.EAPPOINTMENT_CANCEL_SUCCESS,
                  payload: r
                });
                _context54.next = 10;
                break;
              case 7:
                _context54.prev = 7;
                _context54.t0 = _context54["catch"](0);
                t({
                  type: la.EAPPOINTMENT_CANCEL_FAILURE,
                  error: _context54.t0
                });
              case 10:
              case "end":
                return _context54.stop();
            }
          }
        }, _callee54, null, [[0, 7]]);
      }));
      return function (_x58) {
        return _ref81.apply(this, arguments);
      };
    }();
  },
  la = {
    GET_DELIVERY_DETAILS_LOADING: "GET_DELIVERY_DETAILS_LOADING",
    GET_DELIVERY_DETAILS_SUCCESS: "GET_DELIVERY_DETAILS_SUCCESS",
    GET_DELIVERY_DETAILS_ERROR: "GET_DELIVERY_DETAILS_ERROR",
    GET_APPOINTMENT_SLOT_LOADING: "GET_LOGISTIC_APPOINTMENTS_SLOTS_LOADING",
    GET_APPOINTMENT_SLOT_SUCCESS: "GET_LOGISTIC_APPOINTMENTS_SLOTS_SUCCESS",
    GET_APPOINTMENT_SLOT_ERROR: "GET_LOGISTIC_APPOINTMENTS_SLOTS_ERROR",
    CONTACT_VIEW_SUCCESS: "CONTACT_VIEW_SUCCESS",
    CONTACT_VIEW_FAILURE: "CONTACT_VIEW_FAILURE",
    EAPPOINTMENT_CREATE_SUCCESS: "EAPPOINTMENT_CREATE_SUCCESS",
    EAPPOINTMENT_CREATE_FAILURE: "EAPPOINTMENT_CREATE_FAILURE",
    EAPPOINTMENT_CANCEL_SUCCESS: "EAPPOINTMENT_CANCEL_SUCCESS",
    EAPPOINTMENT_CANCEL_FAILURE: "EAPPOINTMENT_CANCEL_FAILURE"
  };
var pa = Object.freeze({
  __proto__: null,
  getPopstations: Vi,
  getAddressInfo: Yi,
  checkEquipmentsIsOutOfStock: xi,
  getDeliveryDetails: Hi,
  getLogisticAppointmentsSlots: $i,
  getCollectAtStoreTimeSlots: qi,
  getSelfCollectionTimeSlots: Wi,
  reserveSelfCollectionTimeSlot: Xi,
  getCollectNowStock: ji,
  getMTPOSStock: Ki,
  STORE_AVAILABILITY_ACTIONS: Ji,
  getStoreAvailabilityForMultipleSkus: Zi,
  getStoreAvailability: zi,
  EXTEND_EQUIPMENT_RESERVATION_ACTIONS: Qi,
  extendEquipmentReservation: ea,
  reserveCollectNowStock: ta,
  reserveEquipment: ra,
  allocateEquipment: na,
  updateOrderProduct: oa,
  retrieveAddressId: ia,
  getCollectNowAddress: aa,
  updateDelivery: ca,
  contactView: da,
  eAppointmentCreate: sa,
  eAppointmentCancel: ua,
  DELIVERY_ACTIONS: la
});
var Ia = function Ia(e) {
    var t = e.customerId,
      r = e.productOrderId,
      n = e.productOrderReferenceNumber,
      _e$isRrpIppOrder2 = e.isRrpIppOrder,
      o = _e$isRrpIppOrder2 === void 0 ? !1 : _e$isRrpIppOrder2;
    return nt("".concat(i, "/commerce/customer/").concat(t, "/product-order/").concat(r, "/quote-with-address"), {
      method: "POST",
      queryParams: {
        sc: "SS",
        lo: "en_US"
      },
      body: JSON.stringify({
        RetrieveQuoteRequest: _objectSpread({
          links: [],
          productOrderReferenceNumber: n,
          activityForConfiguration: "QuoteSDAllDiscounts",
          returnQuoteData: {
            links: [],
            quotedItemsInd: !0,
            taxInformationInd: !0,
            configurationItemsInd: !0,
            returnRemovedItems: !0,
            crossProductDiscountsInd: !0
          },
          shouldCheckForGen3UpgradeEligibilityX8: !0
        }, o && {
          rrpOrderDetailsX8: {
            isRRPOrderX8: o
          }
        })
      })
    }).then(function (e) {
      return e.ImplCustomerProductOrderQuoteWithAddressOutput;
    });
  },
  ma = /*#__PURE__*/function () {
    var _ref82 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee55(e) {
      var t, r, n, _e$isRrpIppOrder3, o;
      return _regeneratorRuntime.wrap(function _callee55$(_context55) {
        while (1) {
          switch (_context55.prev = _context55.next) {
            case 0:
              t = e.customerId, r = e.productOrderId, n = e.productOrderReferenceNumber, _e$isRrpIppOrder3 = e.isRrpIppOrder, o = _e$isRrpIppOrder3 === void 0 ? !1 : _e$isRrpIppOrder3;
              return _context55.abrupt("return", nt("".concat(i, "/commerce-quote/").concat(t ? "customer/" + t : "anonymous", "/product-order/").concat(r, "/quote"), {
                method: "POST",
                queryParams: {
                  sc: "SS",
                  lo: "en_US"
                },
                body: JSON.stringify({
                  RetrieveQuoteRequest: _objectSpread({
                    links: [],
                    productOrderReferenceNumber: n,
                    activityForConfiguration: "QuoteSDAllDiscounts",
                    returnQuoteData: {
                      links: [],
                      quotedItemsInd: !0,
                      taxInformationInd: !0,
                      configurationItemsInd: !0,
                      returnRemovedItems: !0,
                      crossProductDiscountsInd: !0
                    }
                  }, o && {
                    rrpOrderDetailsX8: {
                      isRRPOrderX8: o
                    }
                  })
                })
              }).then(function (e) {
                return e.RetrieveQuoteResponse;
              }));
            case 2:
            case "end":
              return _context55.stop();
          }
        }
      }, _callee55);
    }));
    return function ma(_x59) {
      return _ref82.apply(this, arguments);
    };
  }(),
  Ea = function Ea(e) {
    return e.toLowerCase().replace(/\s?\+/g, "-plus").replace(/[^A-Za-z0-9]/g, "-");
  },
  Ra = "PRODUCT_ADD_TO_CART",
  Sa = "ABANDON_CART",
  _a = function _a() {
    return {
      type: "SHOPPING_CART_LOADING"
    };
  },
  Oa = function Oa(e) {
    return {
      type: "SHOPPING_CART_SUCCESS",
      value: e
    };
  },
  Ca = function Ca() {
    return {
      type: "SHOPPING_CART_ERROR"
    };
  },
  fa = function fa() {
    return {
      type: "EMPTY_CART_LOADING"
    };
  },
  ya = function ya(e) {
    return {
      type: "EMPTY_CART_SUCCESS",
      value: e
    };
  },
  Ta = function Ta() {
    return {
      type: "EMPTY_CART_ERROR"
    };
  },
  Aa = function Aa(_ref83) {
    var e = _ref83.info,
      _ref83$technicalVasId = _ref83.technicalVasIds,
      t = _ref83$technicalVasId === void 0 ? [] : _ref83$technicalVasId,
      _ref83$aspireBillingO = _ref83.aspireBillingOffers,
      r = _ref83$aspireBillingO === void 0 ? [] : _ref83$aspireBillingO,
      n = _ref83.vendorName,
      o = _ref83.tradeInProductSpecContainmentId;
    var i, a, s, u;
    var p = {};
    o = Or(o);
    var I = e.totalOneTimeCalculatedPrice,
      m = e.totalRecurringCalculatedPrice;
    p.vendorName = n, p.barId = e.barNumberX8, e.hashedFaIdX8 && (p.hashedFaIdX8 = e.hashedFaIdX8), p.oneTimePrice = I.finalAmountIncludingTax, p.recurringPrice = m.finalAmountIncludingTax, p.checkOutPrice = 0, p.oneTimePriceBreakdown = po(I), p.recurringPriceBreakdown = po(m), p.checkOutPriceBreakdown = po(), p.billingOfferId = e.productOfferings[0].id, p.productName = e.productOfferings[0].name, p.tradeInProductSpecContainmentId = o;
    var E = e.productOfferings[0].productOrderItems[0],
      R = E.displayableItems,
      S = E.displayableSimpleProductReferences,
      _ = E.productSpecificationLevel,
      O = E.lineOfBusiness,
      C = (S || []).filter(function (e) {
        return ko(e.productSpecContainmentID);
      }).reduce(function (e, t) {
        return _objectSpread(_objectSpread({}, e), {}, _defineProperty({}, t.productID, _objectSpread(_objectSpread({}, t), {}, {
          totalRecurringCalculatedPrice: {
            finalAmountIncludingTax: t.displayableCharacteristics.find(function (e) {
              return "10048781" === e.productSpecCharacteristicID;
            }).value
          }
        })));
      }, {}),
      f = Co(S),
      y = Co(S, !0),
      T = function (_ref84) {
        var e = _ref84.displayableItems;
        if (!Array.isArray(e)) return;
        var t = jo(e, "8363682");
        if (t) {
          return xo(t.displayableCharacteristics).deliveryMethod;
        }
      }({
        displayableItems: R
      });
    p.deliveryMethod = T;
    var D = Ho(S);
    (null == D || null === (i = D[0]) || void 0 === i ? void 0 : i.ippDetails) && (p.productOrder = {
      productOrderId: e.productOrderID,
      productOrderReferenceNumber: e.productOrderReferenceNumber,
      productOrderItemId: E.productOrderItemID,
      productId: E.productID,
      type: "RRPIPP"
    }), p.accessories = D;
    var _No = No({
        origDisplayableItems: R,
        displayableSimpleProductReferences: S,
        mobileContent: C,
        technicalVasIds: t,
        aspireBillingOffers: r
      }),
      P = _No.chargesBillingOffers,
      v = !!(h = P) && h.some(function (e) {
        return "8363722" === e.parent && e.selected && (e.name.toUpperCase().includes("SIM CARD FEE") || e.name.toUpperCase().includes("ESIM FEE"));
      });
    var h;
    p.hasSim = v, p.newlyAddedSimDetails = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var t,
        r = !1;
      var n = e.find(function (e) {
        return "8363722" === e.productSpecContainmentID;
      });
      if (n && (r = n.displayableBillingOffers.some(function (e) {
        return e.action === A.Add && (e.name.toUpperCase().indexOf("SIM CARD FEE") > -1 || e.name.toUpperCase().indexOf("ESIM FEE") > -1);
      }), r || n.action !== A.Add || (r = !0)), r) {
        var _e38 = "3IN1, Non-NFC",
          _r24 = xo(n.displayableCharacteristics),
          _o8 = "eSIM5GPost" === _r24.simType ? null : _r24.sku || d[c];
        t = {
          simProductId: n.productID,
          simDetails: {
            simType: _r24.simType || _e38,
            skuId: _o8
          }
        };
      }
      return t;
    }(R);
    var g = Ao({
        billingOffers: P,
        productOrderItem: E
      }),
      N = Po(P),
      b = Lo(R),
      L = bo(R),
      U = wo(R),
      M = Mo(R),
      w = yo(R),
      G = To(R, o),
      F = (null == G ? void 0 : G.imei) && (null == w ? void 0 : w.imei) === G.imei,
      k = P.map(function (e) {
        return mo(e);
      }).filter(Boolean);
    var B = P.filter(function (e) {
      return !Go(e, g);
    }).map(Eo).filter(Boolean);
    B = Ro(B);
    var V = k.find(function (e) {
        return e.productSpecContainmentID === o;
      }),
      Y = "4769425" === (null == V || null === (a = V.productSpecPricing) || void 0 === a || null === (s = a.childPricingSchema) || void 0 === s ? void 0 : s.id);
    V && (V.isSopDeviceOneTimeRebate = Y), w && (p.bib = _objectSpread(_objectSpread({}, w), {}, {
      tradeInBo: F ? V : null
    })), V && !F && (p.tradeInDetails = _objectSpread(_objectSpread({}, G), {}, {
      tradeInBo: V
    }));
    var x = P.find(function (e) {
        return l.includes(e.parent);
      }),
      H = $o({
        device: f
      }),
      $ = $o({
        accessories: D
      }),
      q = $o({
        device: f,
        accessories: D,
        appleCare: x,
        deliveryCharges: N
      }),
      W = _objectSpread({}, q),
      X = _objectSpread({}, q),
      j = _objectSpread({}, H),
      K = qo(M)("Immediate"),
      J = "true" === process.env.GATSBY_FEATURE_MANUAL_PROMO_CALCULATION,
      _Wo = Wo({
        productPrice: H,
        checkoutPrice: q,
        promotions: b,
        tradeInBo: V,
        vouchers: K,
        totalOneTimeCalculatedPrice: I,
        device: f,
        accessoryPrice: J ? $ : void 0,
        deliveryCharges: N && J ? po(N.totalOneTimeCalculatedPrice) : void 0
      }),
      Z = _Wo.additionToFirstBill,
      z = _Wo.payTotal;
    return p.mobile = _objectSpread(_objectSpread({
      plan: g,
      device: f
    }, y && 0 != Object.keys(y).length && {
      existingDevice: y
    }), {}, {
      promotions: b,
      freebies: U,
      vouchers: M.lists,
      deliveryCharges: N,
      offersWithOneTimePrice: k,
      offersWithRecurringPrice: B,
      serviceId: E.productServiceID
    }), p.originUpfrontPriceBreakdown = W, p.originUpfrontPriceCanBeOffset = X, p.originUpfrontPriceCanBeOffsetForTradeIn = j, p.oneTimePriceBreakdown = Z, p.checkOutPriceBreakdown = z, p.productSpecificationLevel = _, p.appliedPromoText = L, p.lineOfBusiness = O, p.voucher = M, p.isIppOrder = Boolean(null == D || null === (u = D[0]) || void 0 === u ? void 0 : u.ippDetails) || Boolean(null == f ? void 0 : f.ippDetails), p;
  },
  Da = function Da(_ref85) {
    var e = _ref85.sku,
      t = _ref85.planName,
      r = _ref85.numberOfIppInstalments,
      n = _ref85.deviceCharges;
    var o;
    var i = (null == t || null === (o = t.toLowerCase()) || void 0 === o ? void 0 : o.indexOf("sim only")) > -1 ? t.split("(")[0] : t,
      a = null == i ? void 0 : i.replace(/[ ]/g, ""),
      c = [e, Ea(a), r].filter(Boolean).join("_");
    return {
      type: Ra,
      payload: {
        productSkuWithPlan: c,
        devicePrice: n,
        devicePriceCurrency: "SGD"
      }
    };
  },
  Pa = function Pa(_ref86) {
    var e = _ref86.contactId,
      t = _ref86.subscriberId,
      r = _ref86.custType,
      n = _ref86.productOrderId,
      o = _ref86.txn,
      i = _ref86.productName,
      a = _ref86.billingOfferId,
      c = _ref86.deviceModel,
      d = _ref86.deviceBrand,
      s = _ref86.deviceSKU,
      u = _ref86.deviceUpfrontAmount,
      l = _ref86.deviceDisplayName,
      p = _ref86.deviceCapacity,
      I = _ref86.deviceColor,
      m = _ref86.deviceImagePath,
      E = _ref86.planMonthlyCharge;
    return {
      type: Sa,
      payload: {
        custContactId: e,
        custSubscriberId: t,
        custType: r,
        orderId: n,
        lob: "Mobile",
        txn: o,
        productName: i,
        billingOfferId: a,
        deviceModel: c,
        deviceBrand: d,
        deviceSKU: s,
        deviceUpfrontAmount: u,
        cartIndicator: "Open",
        deviceDisplayName: l,
        deviceCapacity: p,
        deviceColor: I,
        deviceImagePath: m,
        planMonthlyCharge: E
      }
    };
  };
var va = Object.freeze({
  __proto__: null,
  cartLoading: _a,
  cartSuccess: Oa,
  rrpCartSuccess: function rrpCartSuccess(e) {
    return {
      type: "RRP_SHOPPING_CART_SUCCESS",
      value: e
    };
  },
  cartError: Ca,
  emptyCartLoading: fa,
  emptyCartSuccess: ya,
  emptyCartError: Ta,
  getShoppingCartData: function getShoppingCartData(e) {
    return /*#__PURE__*/function () {
      var _ref87 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee56(t) {
        var r, n, o, i, a, c, d, s, u, l, p, I, m, E, _e$technicalVasIds2, R, _e$aspireBillingOffer3, S, _, O, C, f, y, T, A, D, _e$isRrpIppOrder4, P, v, h, g, N, b, L, U, M, w;
        return _regeneratorRuntime.wrap(function _callee56$(_context56) {
          while (1) {
            switch (_context56.prev = _context56.next) {
              case 0:
                I = e.customerId, m = e.productOrderId, E = e.productOrderReferenceNumber, _e$technicalVasIds2 = e.technicalVasIds, R = _e$technicalVasIds2 === void 0 ? [] : _e$technicalVasIds2, _e$aspireBillingOffer3 = e.aspireBillingOffers, S = _e$aspireBillingOffer3 === void 0 ? [] : _e$aspireBillingOffer3, _ = e.contactId, O = e.subscriberItem, C = e.custType, f = e.txn, y = e.deviceDisplayName, T = e.deviceCapacity, A = e.deviceColor, D = e.deviceImagePath, _e$isRrpIppOrder4 = e.isRrpIppOrder, P = _e$isRrpIppOrder4 === void 0 ? !1 : _e$isRrpIppOrder4, v = e.tradeInProductSpecContainmentId, h = null == O ? void 0 : O.subscriberId;
                t({
                  type: "SHOPPING_CART_LOADING"
                });
                _context56.prev = 2;
                _context56.next = 5;
                return ma({
                  customerId: I,
                  productOrderId: m,
                  productOrderReferenceNumber: E,
                  isRrpIppOrder: P
                });
              case 5:
                g = _context56.sent;
                _context56.next = 11;
                break;
              case 8:
                _context56.prev = 8;
                _context56.t0 = _context56["catch"](2);
                return _context56.abrupt("return", t({
                  type: "SHOPPING_CART_ERROR"
                }));
              case 11:
                N = Aa({
                  info: null === (r = g) || void 0 === r ? void 0 : r.order,
                  technicalVasIds: R,
                  aspireBillingOffers: S,
                  vendorName: null === (n = g) || void 0 === n ? void 0 : n.vendorName,
                  tradeInProductSpecContainmentId: v
                }), b = null == N || null === (o = N.mobile) || void 0 === o || null === (i = o.device) || void 0 === i ? void 0 : i.sku;
                b && t(Da({
                  sku: N.mobile.device.sku,
                  planName: null === (L = N.mobile) || void 0 === L || null === (U = L.plan) || void 0 === U ? void 0 : U.name,
                  numberOfIppInstalments: null === (M = N.mobile.device.ippDetails) || void 0 === M ? void 0 : M.numberOfInstalment,
                  deviceCharges: null === (w = N.mobile.device.deviceChargesBreakdown) || void 0 === w ? void 0 : w.finalAmountIncludingTax
                }));
                return _context56.abrupt("return", (t(Pa({
                  contactId: _,
                  subscriberId: h,
                  custType: C,
                  productOrderId: m,
                  txn: f,
                  productName: N.productName,
                  billingOfferId: N.billingOfferId,
                  deviceModel: null == N || null === (a = N.mobile) || void 0 === a || null === (c = a.device) || void 0 === c ? void 0 : c.model,
                  deviceBrand: null == N || null === (d = N.mobile) || void 0 === d || null === (s = d.device) || void 0 === s ? void 0 : s.brand,
                  deviceSKU: b,
                  deviceUpfrontAmount: b ? "$" + (null == N || null === (u = N.mobile) || void 0 === u || null === (l = u.device) || void 0 === l || null === (p = l.deviceCharges) || void 0 === p ? void 0 : p.checkoutPrice) : "",
                  deviceDisplayName: y,
                  deviceCapacity: T,
                  deviceColor: A,
                  deviceImagePath: D,
                  planMonthlyCharge: "$" + N.recurringPriceBreakdown.finalAmountIncludingTax
                })), t(Oa(N))));
              case 14:
              case "end":
                return _context56.stop();
            }
          }
        }, _callee56, null, [[2, 8]]);
      }));
      return function (_x60) {
        return _ref87.apply(this, arguments);
      };
    }();
  },
  processQuoteInfo: Aa,
  emptyCart: function emptyCart(e) {
    var t = e.customerId,
      r = e.productOrderId,
      n = e.productOrderItemId,
      o = e.skipEmptyCart;
    return /*#__PURE__*/function () {
      var _ref88 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee57(e) {
        return _regeneratorRuntime.wrap(function _callee57$(_context57) {
          while (1) {
            switch (_context57.prev = _context57.next) {
              case 0:
                e({
                  type: "EMPTY_CART_LOADING"
                });
                _context57.prev = 1;
                _context57.next = 4;
                return we({
                  customerId: t,
                  productOrderId: r,
                  productOrderItemId: n
                });
              case 4:
                e(Rc());
                return _context57.abrupt("return", e(ya({
                  skipEmptyCart: o
                })));
              case 8:
                _context57.prev = 8;
                _context57.t0 = _context57["catch"](1);
                return _context57.abrupt("return", e({
                  type: "EMPTY_CART_ERROR"
                }));
              case 11:
              case "end":
                return _context57.stop();
            }
          }
        }, _callee57, null, [[1, 8]]);
      }));
      return function (_x61) {
        return _ref88.apply(this, arguments);
      };
    }();
  },
  trackProductAddToCart: Da,
  trackAbandonCart: Pa
});
var ha = function ha(e, t) {
    return nt("".concat(i, "/sales/onepay/contact-person/").concat(e, "/payment-request"), {
      method: "POST",
      queryParams: {
        sc: "SS",
        lo: "en_US"
      },
      body: JSON.stringify({
        ImplCreatePaymentRequest: _objectSpread({}, t)
      })
    }).then(function (e) {
      return e;
    });
  },
  ga = function ga(e) {
    var t = e.productOrderId,
      r = e.billingAccountId;
    return nt("".concat(i, "/ordering/order/").concat(t, "/billing-arrangement/").concat(r, "/contract"), {
      method: "GET",
      queryParams: {
        sc: "SS",
        lo: "en_US"
      }
    });
  },
  Na = function Na(e) {
    var t = e.orderId,
      r = e.customerId,
      n = e.purchaseToken,
      o = e.referenceId,
      a = e.amount,
      c = e.accountId;
    return nt(i + "/payment/onepay/validate", {
      method: "POST",
      queryParams: _objectSpread(_objectSpread({}, r ? {
        ci: r
      } : {}), {}, {
        oi: t,
        us: !0,
        isOrderConfirm: !0
      }),
      body: JSON.stringify({
        ImplValidateOnePayRequest: {
          implPaymentDetails: {
            implAccountAmountDetails: [{
              amount: a,
              accountId: c
            }],
            paymentMethodType: "onePay"
          },
          purchaseToken: n,
          referenceId: o,
          isSkipArPayment: !0
        }
      })
    }).then(function (e) {
      return e.ImplPaymentConfirmation;
    });
  },
  ba = function ba(e) {
    var t = e.customerId,
      r = e.productOrderReferenceNumber,
      n = e.encodedPromoStr;
    return nt("".concat(i, "/ordering/customer/").concat(t, "/order/").concat(r, "/distribute-promo-code"), {
      method: "POST",
      body: JSON.stringify({
        ImplDistributePromoCodeRestInput: {
          id: r,
          orderId: r,
          promoCriteria: n
        }
      })
    }).then(function (e) {
      return e;
    });
  },
  La = function La(e) {
    var t = e.id,
      r = e.type,
      n = e.baStatuses,
      o = e.barId,
      a = e.isOrderConfirm;
    var c;
    return c = "development" === process.env.NODE_ENV || "test" === process.env.NODE_ENV || a ? i + "/billing/billing-entity" : "".concat(i, "/billing/type/").concat(r, "/id/").concat(t, "/billing-entity"), nt(c, {
      method: "GET",
      queryParams: _objectSpread(_objectSpread(_objectSpread({
        sc: "SS",
        lo: "en_US"
      }, n ? {
        includeBAStatus: n
      } : {}), o ? {
        barId: o
      } : {}), a ? {
        isOrderConfirm: !0
      } : {})
    }).then(function (e) {
      return e.ImplBillingAccountDetailsResponse.billingAccountDetails;
    });
  },
  Ua = function Ua() {
    return {
      type: "FETCH_ORDER_SUMMARY_LOADING"
    };
  },
  Ma = function Ma(e) {
    return {
      type: "FETCH_ORDER_SUMMARY_SUCCESS",
      value: e
    };
  },
  wa = function wa() {
    return {
      type: "FETCH_ORDER_SUMMARY_ERROR"
    };
  },
  Ga = function Ga(e) {
    return /*#__PURE__*/function () {
      var _ref89 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee58(t) {
        var r, n, o;
        return _regeneratorRuntime.wrap(function _callee58$(_context58) {
          while (1) {
            switch (_context58.prev = _context58.next) {
              case 0:
                r = e.customerId, n = e.productOrderId, o = e.productOrderReferenceNumber;
                t({
                  type: "FETCH_ORDER_SUMMARY_LOADING"
                });
                _context58.prev = 2;
                _context58.next = 5;
                return ma({
                  customerId: r,
                  productOrderId: n,
                  productOrderReferenceNumber: o
                });
              case 5:
                _context58.next = 10;
                break;
              case 7:
                _context58.prev = 7;
                _context58.t0 = _context58["catch"](2);
                return _context58.abrupt("return", t({
                  type: "FETCH_ORDER_SUMMARY_ERROR"
                }));
              case 10:
              case "end":
                return _context58.stop();
            }
          }
        }, _callee58, null, [[2, 7]]);
      }));
      return function (_x62) {
        return _ref89.apply(this, arguments);
      };
    }();
  },
  Fa = function Fa(e) {
    return /*#__PURE__*/function () {
      var _ref90 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee59(t) {
        var r, n, o, _e$technicalVasIds3, i, _e$aspireBillingOffer4, a, _e$isRrpIppOrder5, c, d, s, u, _d5, _e39, l, p, _e40, _t31, _r25, _n14, _o9, _i9, _a4, _c9, _d6;
        return _regeneratorRuntime.wrap(function _callee59$(_context59) {
          while (1) {
            switch (_context59.prev = _context59.next) {
              case 0:
                r = e.customerId, n = e.productOrderId, o = e.productOrderReferenceNumber, _e$technicalVasIds3 = e.technicalVasIds, i = _e$technicalVasIds3 === void 0 ? [] : _e$technicalVasIds3, _e$aspireBillingOffer4 = e.aspireBillingOffers, a = _e$aspireBillingOffer4 === void 0 ? [] : _e$aspireBillingOffer4, _e$isRrpIppOrder5 = e.isRrpIppOrder, c = _e$isRrpIppOrder5 === void 0 ? !1 : _e$isRrpIppOrder5;
                t({
                  type: "FETCH_ORDER_SUMMARY_LOADING"
                });
                s = {};
                _context59.prev = 3;
                _context59.next = 6;
                return Ia({
                  customerId: r,
                  productOrderId: n,
                  productOrderReferenceNumber: o,
                  isRrpIppOrder: c
                });
              case 6:
                d = _context59.sent;
                _d5 = d, _e39 = _d5.quoteInfo, l = _d5.deliveryAddress, p = _objectWithoutProperties(_d5, _excluded7);
                if (s = Aa({
                  info: _e39.order,
                  technicalVasIds: i,
                  aspireBillingOffers: a,
                  vendorName: null === (u = d) || void 0 === u ? void 0 : u.dropShippingVendorName
                }), l) {
                  _e40 = l.buildingName, _t31 = l.houseNumber, _r25 = l.blockOrHouseNum, _n14 = l.streetName, _o9 = l.apartment, _i9 = l.unitNumber, _a4 = l.unitNo, _c9 = l.postcode, _d6 = l.postCode;
                  s.deliveryAddress = {
                    buildingName: _e40,
                    streetName: _n14,
                    blockNumber: _t31 || _r25,
                    unitNumber: _o9 || _i9 || _a4,
                    postalCode: _c9 || _d6
                  };
                }
                return _context59.abrupt("return", t(Ma(_objectSpread(_objectSpread({}, s), p))));
              case 12:
                _context59.prev = 12;
                _context59.t0 = _context59["catch"](3);
                return _context59.abrupt("return", t({
                  type: "FETCH_ORDER_SUMMARY_ERROR"
                }));
              case 15:
              case "end":
                return _context59.stop();
            }
          }
        }, _callee59, null, [[3, 12]]);
      }));
      return function (_x63) {
        return _ref90.apply(this, arguments);
      };
    }();
  },
  ka = function ka(e) {
    e({
      type: Sr.ORDER_SUMMARY.VERIFY_PAYMENT_FAILED
    });
  },
  Ba = function Ba(_ref91) {
    var e = _ref91.customerId,
      t = _ref91.productOrderReferenceNumber,
      _ref91$promoCriteria = _ref91.promoCriteria,
      r = _ref91$promoCriteria === void 0 ? "####" : _ref91$promoCriteria,
      n = _ref91.productOrderId;
    return /*#__PURE__*/function () {
      var _ref92 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee60(n) {
        var o, _r26;
        return _regeneratorRuntime.wrap(function _callee60$(_context60) {
          while (1) {
            switch (_context60.prev = _context60.next) {
              case 0:
                o = r.split("####")[1].replace(/\s/g, "+").replace(/@@/g, "&");
                _context60.prev = 1;
                n({
                  type: Sr.ORDER_SUMMARY.DISTRIBUTE_PROMO_CODE_LOADING
                });
                _context60.next = 5;
                return ba({
                  customerId: e,
                  productOrderReferenceNumber: t,
                  encodedPromoStr: o
                });
              case 5:
                _r26 = _context60.sent;
                if (!_r26) {
                  _context60.next = 8;
                  break;
                }
                return _context60.abrupt("return", n({
                  type: Sr.ORDER_SUMMARY.DISTRIBUTE_PROMO_CODE_SUCCESS,
                  value: _r26.ImplDistributePromoCodeRestOutput
                }));
              case 8:
                _context60.next = 13;
                break;
              case 10:
                _context60.prev = 10;
                _context60.t0 = _context60["catch"](1);
                n({
                  type: Sr.ORDER_SUMMARY.DISTRIBUTE_PROMO_CODE_FAILURE
                });
              case 13:
              case "end":
                return _context60.stop();
            }
          }
        }, _callee60, null, [[1, 10]]);
      }));
      return function (_x64) {
        return _ref92.apply(this, arguments);
      };
    }();
  };
var Va = Object.freeze({
  __proto__: null,
  orderSummaryLoading: Ua,
  orderSummarySuccess: Ma,
  orderSummaryError: wa,
  getQuote: Ga,
  getOrderSummaryData: Fa,
  requestPayment: function requestPayment(e, t) {
    return /*#__PURE__*/function () {
      var _ref93 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee61(r) {
        var n, o, a, c, d, s, u, l, p, _t32, _n15, _o10, _t33, I;
        return _regeneratorRuntime.wrap(function _callee61$(_context61) {
          while (1) {
            switch (_context61.prev = _context61.next) {
              case 0:
                n = t.customerId, o = t.billingAccountId, a = t.paymentIntentRequestData, c = t.paymentRequestData, d = t.membershipCode, s = t.membershipId, u = t.isEkyc, l = t.flowType, p = t.planName;
                _context61.prev = 1;
                r({
                  type: Sr.ORDER_SUMMARY.REQUEST_PAYMENT_LOADING
                });
                _context61.t0 = u;
                if (!_context61.t0) {
                  _context61.next = 9;
                  break;
                }
                _context61.next = 7;
                return function (e) {
                  var t = e.orderId;
                  return nt("".concat(i, "/ecommerce/order/").concat(t, "/update-dynamic-attributes/ekyc"), {
                    method: "GET",
                    queryParams: {
                      sc: "SS",
                      lo: "en_US"
                    }
                  }).then(function (e) {
                    return null == e ? void 0 : e.ImplBaseRestOutput;
                  });
                }({
                  orderId: null == c ? void 0 : c.orderId
                });
              case 7:
                _context61.next = 9;
                return function (_ref94) {
                  var e = _ref94.contactId,
                    t = _ref94.flowType,
                    r = _ref94.planName;
                  var n = {
                    title: "eKYC MyInfo Registered/BuyEshop",
                    medium: "Self Service",
                    channel: "Web",
                    notes: "eKYC MyInfo Registered/BuyEshop/".concat(t, "MobileLine/").concat(r),
                    userId: "sa",
                    contactId: e,
                    direction: {
                      value: "1"
                    },
                    endTime: new Date().getTime() + 9999,
                    startTime: new Date().getTime(),
                    topic: [{
                      reason1: "EkycEshopSignUp",
                      reason2: "RefertoNotes",
                      protocol: "BuyEshop",
                      result: "NotApplicable"
                    }]
                  };
                  return nt("".concat(i, "/contact-person/").concat(e, "/interaction"), {
                    method: "POST",
                    queryParams: {
                      sc: "SS",
                      lo: "en_US"
                    },
                    body: JSON.stringify({
                      ImplCreateInteractionInput: n
                    })
                  }).then(function (e) {
                    return e;
                  });
                }({
                  contactId: e,
                  flowType: l,
                  planName: p
                });
              case 9:
                _context61.t1 = d && s;
                if (!_context61.t1) {
                  _context61.next = 13;
                  break;
                }
                _context61.next = 13;
                return r(Za({
                  partnerCode: d,
                  partnerId: s,
                  updateProducts: !0,
                  productOrderId: null == c ? void 0 : c.orderId
                }));
              case 13:
                _context61.next = 15;
                return function (_ref95) {
                  var e = _ref95.customerId,
                    t = _ref95.billingAccountId;
                  return nt("".concat(i, "/payment/onepay/customer/").concat(e, "/billing-arrangement/").concat(t, "/reference"), {
                    method: "POST",
                    queryParams: {
                      flowType: "eshop"
                    },
                    body: JSON.stringify({
                      customerId: e,
                      billingAccountId: t
                    })
                  }).then(function (e) {
                    return e.ImplOnePayReferenceResponse;
                  });
                }({
                  customerId: n,
                  billingAccountId: o
                });
              case 15:
                _t32 = _context61.sent;
                if (!(_t32 && _t32.referenceId)) {
                  _context61.next = 31;
                  break;
                }
                if (!a) {
                  _context61.next = 23;
                  break;
                }
                _context61.next = 20;
                return I = _objectSpread(_objectSpread({}, a), {}, {
                  merchant_reference_number: _t32.referenceId
                }), nt(i + "/onepay/v1/eshop/payment/intent", {
                  method: "POST",
                  queryParams: {
                    sc: "SS",
                    lo: "en_US"
                  },
                  body: JSON.stringify({
                    ImplPaymentServiceIntentRequest: _objectSpread({}, I)
                  })
                }).then(function (e) {
                  var t = e.sessionToken;
                  return t && We(t), {
                    authToken: t,
                    response: e.ImplPaymentServiceIntentResponse
                  };
                });
              case 20:
                _context61.t2 = _context61.sent;
                _context61.next = 24;
                break;
              case 23:
                _context61.t2 = null;
              case 24:
                _n15 = _context61.t2;
                _context61.next = 27;
                return ha(e, _objectSpread(_objectSpread({}, c), {}, {
                  referenceId: _t32.referenceId
                }));
              case 27:
                _o10 = _context61.sent;
                r(_o10 ? {
                  type: Sr.ORDER_SUMMARY.REQUEST_PAYMENT_SUCCESS,
                  value: {
                    paymentIntent: null == _n15 ? void 0 : _n15.response,
                    payment: _o10,
                    refId: _t32.referenceId
                  }
                } : {
                  type: Sr.ORDER_SUMMARY.REQUEST_PAYMENT_FAILED,
                  value: {
                    errorResponse: _o10
                  }
                });
                _context61.next = 32;
                break;
              case 31:
                r({
                  type: Sr.ORDER_SUMMARY.REQUEST_PAYMENT_FAILED
                });
              case 32:
                _context61.next = 40;
                break;
              case 34:
                _context61.prev = 34;
                _context61.t3 = _context61["catch"](1);
                _context61.next = 38;
                return _r(_context61.t3);
              case 38:
                _t33 = _context61.sent;
                r({
                  type: Sr.ORDER_SUMMARY.REQUEST_PAYMENT_FAILED,
                  value: _t33
                });
              case 40:
              case "end":
                return _context61.stop();
            }
          }
        }, _callee61, null, [[1, 34]]);
      }));
      return function (_x65) {
        return _ref93.apply(this, arguments);
      };
    }();
  },
  getContract: function getContract(_ref96) {
    var e = _ref96.productOrderId,
      t = _ref96.billingAccountId;
    return /*#__PURE__*/function () {
      var _ref97 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee62(r) {
        var n, o;
        return _regeneratorRuntime.wrap(function _callee62$(_context62) {
          while (1) {
            switch (_context62.prev = _context62.next) {
              case 0:
                _context62.prev = 0;
                r({
                  type: Sr.ORDER_SUMMARY.GET_CONTRACT_LOADING
                });
                _context62.next = 4;
                return ga({
                  productOrderId: e,
                  billingAccountId: t
                });
              case 4:
                o = _context62.sent;
                r({
                  type: Sr.ORDER_SUMMARY.GET_CONTRACT_SUCCESS,
                  value: null == o || null === (n = o.ImplGenerateAndDisplayContractRestOutput) || void 0 === n ? void 0 : n.contractList
                });
                _context62.next = 11;
                break;
              case 8:
                _context62.prev = 8;
                _context62.t0 = _context62["catch"](0);
                r({
                  type: Sr.ORDER_SUMMARY.GET_CONTRACT_FAILED
                });
              case 11:
              case "end":
                return _context62.stop();
            }
          }
        }, _callee62, null, [[0, 8]]);
      }));
      return function (_x66) {
        return _ref97.apply(this, arguments);
      };
    }();
  },
  createCustomerProblem: function () {
    var _createCustomerProblem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee63(e, _ref98) {
      var t, r, o, n;
      return _regeneratorRuntime.wrap(function _callee63$(_context63) {
        while (1) {
          switch (_context63.prev = _context63.next) {
            case 0:
              t = _ref98.crmParams, r = _ref98.updateRequestParams;
              _context63.prev = 1;
              _context63.next = 4;
              return n = t, nt(i + "/support/customer-problem", {
                method: "POST",
                queryParams: {
                  sc: "SS",
                  lo: "en_US"
                },
                body: JSON.stringify({
                  CreateCustomerProblemRequest: _objectSpread({}, n)
                })
              }).then(function (e) {
                return e && e.CreateCustomerProblemResponse;
              });
            case 4:
              o = _context63.sent;
              (null == o ? void 0 : o.customerProblemId) && ha(e, r);
              _context63.next = 10;
              break;
            case 8:
              _context63.prev = 8;
              _context63.t0 = _context63["catch"](1);
            case 10:
            case "end":
              return _context63.stop();
          }
        }
      }, _callee63, null, [[1, 8]]);
    }));
    function createCustomerProblem(_x67, _x68) {
      return _createCustomerProblem.apply(this, arguments);
    }
    return createCustomerProblem;
  }(),
  verifyPayment: function verifyPayment(_ref99) {
    var e = _ref99.contactId,
      t = _ref99.orderId,
      r = _ref99.customerId,
      n = _ref99.purchaseToken,
      o = _ref99.referenceId,
      i = _ref99.amount,
      a = _ref99.accountId,
      c = _ref99.productOrderId,
      d = _ref99.productOrderReferenceNumber,
      s = _ref99.barId;
    return /*#__PURE__*/function () {
      var _ref100 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee64(e) {
        var u, l, _e41, p, _t34, I;
        return _regeneratorRuntime.wrap(function _callee64$(_context64) {
          while (1) {
            switch (_context64.prev = _context64.next) {
              case 0:
                _context64.prev = 0;
                if (!(e({
                  type: Sr.ORDER_SUMMARY.VERIFY_PAYMENT_LOADING
                }), !a)) {
                  _context64.next = 14;
                  break;
                }
                if (s) {
                  _context64.next = 7;
                  break;
                }
                _context64.next = 5;
                return Ia({
                  customerId: r,
                  productOrderId: c,
                  productOrderReferenceNumber: d
                });
              case 5:
                _e41 = _context64.sent;
                s = null == _e41 || null === (u = _e41.quoteInfo) || void 0 === u || null === (l = u.order) || void 0 === l ? void 0 : l.barNumberX8;
              case 7:
                if (s) {
                  _context64.next = 9;
                  break;
                }
                return _context64.abrupt("return", ka(e));
              case 9:
                _context64.next = 11;
                return La({
                  baStatuses: ["X", "T"],
                  barId: s,
                  isOrderConfirm: !0
                });
              case 11:
                _t34 = _context64.sent;
                if (a = null == _t34 || null === (p = _t34[0]) || void 0 === p ? void 0 : p.faId) {
                  _context64.next = 14;
                  break;
                }
                return _context64.abrupt("return", ka(e));
              case 14:
                _context64.next = 16;
                return Na({
                  orderId: t,
                  customerId: r,
                  purchaseToken: n,
                  referenceId: o,
                  amount: i,
                  accountId: a
                });
              case 16:
                I = _context64.sent;
                return _context64.abrupt("return", e({
                  type: Sr.ORDER_SUMMARY.VERIFY_PAYMENT_SUCCESS,
                  value: I
                }));
              case 20:
                _context64.prev = 20;
                _context64.t0 = _context64["catch"](0);
                ka(e);
              case 23:
              case "end":
                return _context64.stop();
            }
          }
        }, _callee64, null, [[0, 20]]);
      }));
      return function (_x69) {
        return _ref100.apply(this, arguments);
      };
    }();
  },
  getDistributedPromoCode: function getDistributedPromoCode(e, t, r, n) {
    return /*#__PURE__*/function () {
      var _ref101 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee65(o) {
        var i;
        return _regeneratorRuntime.wrap(function _callee65$(_context65) {
          while (1) {
            switch (_context65.prev = _context65.next) {
              case 0:
                i = ri(r);
                _context65.next = 3;
                return o(Ba({
                  customerId: e,
                  productOrderReferenceNumber: t,
                  promoCriteria: i,
                  productOrderId: n
                }));
              case 3:
              case "end":
                return _context65.stop();
            }
          }
        }, _callee65);
      }));
      return function (_x70) {
        return _ref101.apply(this, arguments);
      };
    }();
  },
  distributePromoCode: Ba
});
var Ya = function Ya() {
    return {
      type: "SET_PRODUCT_ORDER_LOADING",
      value: !0
    };
  },
  xa = function xa(e) {
    return {
      type: "SET_PRODUCT_ORDER_SUCCESS",
      value: e
    };
  },
  Ha = function Ha(e) {
    return {
      type: "SET_PRODUCT_ORDER_ERROR",
      value: e
    };
  },
  $a = function $a(e) {
    var t = e.preTickAddons,
      r = e.displayableItems,
      n = e.order,
      o = e.cisDetails,
      i = e.planId,
      a = e.transactionType,
      c = e.selectedProduct,
      d = e.displayableSimpleProductReferences;
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee67() {
      var _e42;
      return _regeneratorRuntime.wrap(function _callee67$(_context67) {
        while (1) {
          switch (_context67.prev = _context67.next) {
            case 0:
              _context67.prev = 0;
              _e42 = {
                productOrderId: n.productOrderId,
                productOrderItemId: n.productOrderItemId,
                customerType: o ? "cis" : "public",
                planId: i,
                preTickAddons: t,
                displayableItems: r,
                transactionType: a,
                selectedProduct: c,
                displayableSimpleProductReferences: d
              };
              _context67.next = 4;
              return function () {
                var _ref103 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee66(e) {
                  var t, r, n, o, i, a, c, d, s, u, l, p, m, E, R, S, _, O, C, f, y, T, A;
                  return _regeneratorRuntime.wrap(function _callee66$(_context66) {
                    while (1) {
                      switch (_context66.prev = _context66.next) {
                        case 0:
                          t = e.productOrderId, r = e.productOrderItemId, n = e.customerType, o = e.planId, i = e.preTickAddons, a = e.displayableItems, c = e.transactionType, d = e.selectedProduct, s = e.displayableSimpleProductReferences, u = wn(a), l = u.entities.displayableBillingOffers, p = s, m = Object.keys(l).filter(function (e) {
                            return l[e].selected;
                          }), E = p && p.filter(function (e) {
                            return "10141011" === e.productSpecContainmentID && e.selected;
                          }).map(function (e) {
                            return e.simpleProductSpecID;
                          }), R = m.concat(E || []), S = xn({
                            allPretickAddons: i,
                            transactionType: c,
                            selectedProduct: d,
                            planId: o,
                            customerType: n,
                            existingSelectedAddons: R
                          }), _ = S.reduce(function (e, t) {
                            return e.concat(t.boIds);
                          }, []).filter(function (e, t, r) {
                            return r.indexOf(e) === t;
                          }).map(function (e) {
                            return l[e];
                          }).filter(function (e) {
                            return !1 === (null == e ? void 0 : e.selected);
                          }), O = S.filter(function (e) {
                            var t;
                            return Boolean(null === (t = e.spsIds) || void 0 === t ? void 0 : t.length);
                          }).map(function (e) {
                            return e.spsIds;
                          }).reduce(function (e, t) {
                            return e.concat(t);
                          }, []).filter(function (e) {
                            return !(E || []).includes(e);
                          });
                          if (!(0 === _.length && 0 === O.length)) {
                            _context66.next = 3;
                            break;
                          }
                          return _context66.abrupt("return", !1);
                        case 3:
                          C = _.reduce(function (e, t) {
                            return e[t.productSpecPricingID] = He(), e;
                          }, {}), f = _.map(function (e) {
                            var t = u.entities.displayableItems[e.parent],
                              r = t.productSpecContainmentID;
                            if (!t.productID || I.includes(r)) return {
                              productSpecContainmentID: t.productSpecContainmentID,
                              temporaryID: C[e.productSpecPricingID],
                              parentProductSpecContainmentID: t.parentProductSpecContainmentID,
                              parentProductID: t.parentProductID
                            };
                          }), y = _.map(function (e) {
                            var t = u.entities.displayableItems[e.parent],
                              r = t.productSpecContainmentID;
                            return !t.productID || I.includes(r) ? {
                              productSpecPricingID: e.productSpecPricingID,
                              parentProductSpecContainmentID: t.productSpecContainmentID,
                              parentTemporaryID: C[e.productSpecPricingID]
                            } : {
                              productSpecPricingID: e.productSpecPricingID,
                              parentProductID: t.productID,
                              parentProductSpecContainmentID: t.productSpecContainmentID
                            };
                          }), T = O && O.map(function (e) {
                            return {
                              temporaryID: He(),
                              productSpecContainmentID: "10141011",
                              simpleProductSpecID: e
                            };
                          }), A = {
                            ImplUpdateOrderProductsRequest: {
                              returnRemovedItems: !1,
                              returnRemovedByReplaceItems: !1,
                              settingsViewFilter: "FULL",
                              stepsToRetrieve: [],
                              stepsToValidate: [],
                              attachmentTypes: [],
                              runCompatibilityRules: !0,
                              activityForConfiguration: "SD Add Comp Stage+++promoCode+++EMPTY",
                              confirmationMessagesApproved: !1,
                              saveIfCompatibilityRulesFailed: !1,
                              addDefaultChildItemsImplicitly: !1,
                              returnConfigurationData: {
                                catalogDataInd: !0,
                                crossProductsDiscountsDataInd: !0,
                                previousQuotedRecurringPricesInd: !1,
                                productConfigurationInd: !0,
                                quotedPricesInd: !1,
                                quotedProrationInd: !1,
                                quotedTaxInd: !1,
                                summaryInd: !0
                              },
                              implUpdateOrderProductConfigurationList: [{
                                productOrderItemId: r,
                                returnFullUpcResponse: !1,
                                productConfigurationChanges: {
                                  links: [],
                                  resumedContainedProducts: [],
                                  changedContainedProducts: [],
                                  newContainedProducts: f.filter(Boolean),
                                  removedContainedProducts: [],
                                  suspendedContainedProducts: [],
                                  newSimpleProducts: T,
                                  newAssignedBillingOffers: y
                                }
                              }]
                            }
                          };
                          _context66.t0 = _objectSpread;
                          _context66.t1 = _objectSpread;
                          _context66.t2 = {};
                          _context66.next = 9;
                          return ii({
                            productOrderId: t,
                            payload: A
                          });
                        case 9:
                          _context66.t3 = _context66.sent;
                          _context66.t4 = (0, _context66.t1)(_context66.t2, _context66.t3);
                          _context66.t5 = {};
                          _context66.t6 = {
                            preTickAddonsBoIds: null == S ? void 0 : S.reduce(function (e, t) {
                              var r;
                              return (null == t || null === (r = t.boIds) || void 0 === r ? void 0 : r.length) ? [].concat(_toConsumableArray(e), _toConsumableArray(t.boIds)) : e;
                            }, O || [])
                          };
                          return _context66.abrupt("return", (0, _context66.t0)(_context66.t4, _context66.t5, _context66.t6));
                        case 14:
                        case "end":
                          return _context66.stop();
                      }
                    }
                  }, _callee66);
                }));
                return function (_x71) {
                  return _ref103.apply(this, arguments);
                };
              }()(_e42);
            case 4:
              return _context67.abrupt("return", _context67.sent);
            case 7:
              _context67.prev = 7;
              _context67.t0 = _context67["catch"](0);
            case 9:
            case "end":
              return _context67.stop();
          }
        }
      }, _callee67, null, [[0, 7]]);
    }));
  },
  qa = function qa(e) {
    return /*#__PURE__*/function () {
      var _ref104 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee68(t) {
        var r, n;
        return _regeneratorRuntime.wrap(function _callee68$(_context68) {
          while (1) {
            switch (_context68.prev = _context68.next) {
              case 0:
                _context68.next = 2;
                return Dt();
              case 2:
                r = _context68.sent;
                if (!(t({
                  type: "SET_USER_INFORMATION",
                  value: r
                }), r.clientContext)) {
                  _context68.next = 6;
                  break;
                }
                n = (null == e ? void 0 : e.customerId) || r.clientContext.customers[0].customerId;
                return _context68.abrupt("return", (r.clientContext.customers.forEach(function (e) {
                  t({
                    type: "CT_TRACKING_SEND_CUSTOMER_ID",
                    payload: {
                      customerId: e.customerId
                    }
                  }), t({
                    type: "DT_TRACKING_IDENTIFY_USER",
                    payload: {
                      customerId: e.customerId
                    }
                  });
                }), n));
              case 6:
                return _context68.abrupt("return", null);
              case 7:
              case "end":
                return _context68.stop();
            }
          }
        }, _callee68);
      }));
      return function (_x72) {
        return _ref104.apply(this, arguments);
      };
    }();
  },
  Wa = function Wa() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    t.forEach(function (t) {
      e.push({
        productSpecContainmentID: "17987931",
        simpleProductSpecID: t.id,
        temporaryID: xe()
      });
    });
  },
  Xa = function Xa(e) {
    return /*#__PURE__*/function () {
      var _ref105 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee69(t) {
        var r, n, o, i, a, c, d, _e$planTags, s, u, _e$accessories, l, p, I, m, _e43, E, R;
        return _regeneratorRuntime.wrap(function _callee69$(_context69) {
          while (1) {
            switch (_context69.prev = _context69.next) {
              case 0:
                r = e.customerId, n = e.simpleProductSpecId, o = e.cisDetails, i = e.planId, a = e.planRelId, c = e.monthlyTerm, d = e.simCardType, _e$planTags = e.planTags, s = _e$planTags === void 0 ? [] : _e$planTags, u = e.contact, _e$accessories = e.accessories, l = _e$accessories === void 0 ? [] : _e$accessories, p = [], I = [];
                if (n) {
                  _e43 = {
                    businessType: "DEVICE",
                    simpleProductSpecID: n,
                    temporaryID: xe()
                  };
                  c && (m = "NEWIPP", _e43.changedCharacteristics = [{
                    characteristicID: "8272",
                    value: c
                  }, {
                    characteristicID: "13897781",
                    value: "Instalments"
                  }]), I.push(_e43), Wa(I, l);
                }
                E = !1;
                if (u && !o) {
                  ja(s, u).productSpecContainmentID && (p.push(ja(s, u)), E = !0);
                }
                o && p.push({
                  changedCharacteristics: [{
                    characteristicID: 8480012,
                    value: o.parentCompanyBRN
                  }, {
                    characteristicID: 8582,
                    value: o.parentCompanyName
                  }, {
                    characteristicID: 8592,
                    value: o.childCompanyName
                  }],
                  productSpecContainmentID: "11762",
                  temporaryID: xe()
                });
                _context69.next = 7;
                return ai({
                  productOffering: i,
                  productOfferingProductSpecId: a,
                  customerId: r,
                  newSimpleProducts: I,
                  newContainedProducts: p,
                  orderActionReasonX8: m,
                  simCardType: d
                });
              case 7:
                R = _context69.sent;
                return _context69.abrupt("return", (R && (R.hasSilverComponent = E), t({
                  type: "CT_TRACKING_SEND_PRODUCT_ORDER_ID",
                  payload: {
                    productOrderId: R.productOrderId
                  }
                }), R));
              case 9:
              case "end":
                return _context69.stop();
            }
          }
        }, _callee69);
      }));
      return function (_x73) {
        return _ref105.apply(this, arguments);
      };
    }();
  },
  ja = function ja(e, t) {
    var r,
      n,
      o = {};
    if ((ui(e) || !1) && t) {
      var _t$dateOfBirth = t.dateOfBirth,
        _e44 = _t$dateOfBirth === void 0 ? null : _t$dateOfBirth,
        _t$indentType = t.indentType,
        _o11 = _t$indentType === void 0 ? null : _t$indentType;
      n = ci(_e44), r = C[_o11];
    }
    return n && "NRIC" === r && (o = {
      productSpecContainmentID: "2089835",
      temporaryID: xe()
    }), o;
  },
  Ka = function Ka(e) {
    return {
      type: "ADD_PROMO_CODE_SUCCESS",
      value: e
    };
  },
  Ja = function Ja(e) {
    return {
      type: "ADD_PROMO_CODE_ERROR",
      value: e
    };
  },
  Za = function Za(_ref106) {
    var e = _ref106.partnerId,
      t = _ref106.partnerCode,
      r = _ref106.productOrderId,
      n = _ref106.promoString,
      o = _ref106.updateProducts,
      a = _ref106.specialPromo;
    return /*#__PURE__*/function () {
      var _ref107 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee70(c) {
        var s, u, l, _e45, d;
        return _regeneratorRuntime.wrap(function _callee70$(_context70) {
          while (1) {
            switch (_context70.prev = _context70.next) {
              case 0:
                _context70.prev = 0;
                _context70.next = 3;
                return function (e) {
                  var t = e.productOrderId,
                    r = e.code,
                    _e$parentLine = e.parentLine,
                    n = _e$parentLine === void 0 ? "" : _e$parentLine,
                    o = e.partnerId,
                    a = e.partnerCode,
                    _e$isCouponApply = e.isCouponApply,
                    c = _e$isCouponApply === void 0 ? !0 : _e$isCouponApply,
                    _e$isEncrypted = e.isEncrypted,
                    d = _e$isEncrypted === void 0 ? !1 : _e$isEncrypted,
                    _e$pickNgoREG = e.pickNgoREG,
                    s = _e$pickNgoREG === void 0 ? "NA" : _e$pickNgoREG,
                    _e$pickNgoSIM = e.pickNgoSIM,
                    u = _e$pickNgoSIM === void 0 ? "NA" : _e$pickNgoSIM,
                    _e$partner = e.partner,
                    l = _e$partner === void 0 ? "NA" : _e$partner,
                    _e$specialPromo = e.specialPromo,
                    p = _e$specialPromo === void 0 ? !1 : _e$specialPromo,
                    I = _objectSpread(_objectSpread({}, !p && {
                      isCouponApply: c,
                      isEncrypted: d
                    }), {}, {
                      sc: "SS",
                      lo: "en_US"
                    }),
                    m = _objectSpread(_objectSpread(_objectSpread({
                      pickNgoREG: s,
                      pickNgoSIM: u,
                      parentLine: n,
                      partner: l
                    }, r && {
                      code: r
                    }), o && {
                      partnerId: o
                    }), a && {
                      partnerCode: a
                    });
                  return nt("".concat(i, "/ecommerce/order/").concat(t, "/pick-go"), {
                    method: "PUT",
                    queryParams: I,
                    body: JSON.stringify({
                      ImplUpdateOrderForPickNGoInput: m
                    })
                  }).then(function (e) {
                    return e;
                  });
                }({
                  productOrderId: r,
                  code: n,
                  partnerId: e,
                  partnerCode: t,
                  specialPromo: a
                });
              case 3:
                s = _context70.sent;
                u = s.ImplBaseRestOutput;
                l = s.ErrorInfo;
                if (!((null == u ? void 0 : u.transactionId) && !o)) {
                  _context70.next = 8;
                  break;
                }
                return _context70.abrupt("return", c(Ka(n)));
              case 8:
                if (!l) {
                  _context70.next = 11;
                  break;
                }
                _e45 = {
                  errorCode: Cr.TOMO_FAILED
                };
                throw c((d = _e45, {
                  type: Sr.THIRD_PARTY.UPDATE_INDICATOR_ERROR,
                  payload: d
                })), _e45;
              case 11:
                return _context70.abrupt("return", s);
              case 14:
                _context70.prev = 14;
                _context70.t0 = _context70["catch"](0);
                if (!o) {
                  _context70.next = 18;
                  break;
                }
                throw _context70.t0;
              case 18:
                return _context70.abrupt("return", c(Ja("SOMETHING_WENT_WRONG")));
              case 19:
              case "end":
                return _context70.stop();
            }
          }
        }, _callee70, null, [[0, 14]]);
      }));
      return function (_x74) {
        return _ref107.apply(this, arguments);
      };
    }();
  },
  za = {
    PENDING_SUBMITTED_ORDER_FORM: "RECONTRACT_ORDER_ALREADY_FOUND",
    "waiting period (from last IPP start date) is required before the next IPP sign up": "IPP_30_DAY_BLOCK",
    "Device can't be upgraded before CI6.": "ELIGIBILITY_NOT_CI_ELIGIBLE",
    "B6.1": "FOREIGNER_NOT_ELIGIBLE",
    "Additional Device can only be taken after 3 months completion": "THREE_MONTHS_NOT_ELIGIBLE"
  },
  Qa = function Qa(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    return "BLOCKING" === e.compatibilityStatus ? e.messages.filter(function (e) {
      return "ERROR" === e.severity;
    }) : t && "INFORMATION" === e.compatibilityStatus ? e.messages.filter(function (e) {
      return "INFORMATION" === e.severity;
    }) : void 0;
  },
  ec = function ec(e, t) {
    var r = "GA_TRACKING_".concat(t, "_BLOCKING_MESSAGES");
    return /*#__PURE__*/function () {
      var _ref108 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee71(t) {
        return _regeneratorRuntime.wrap(function _callee71$(_context71) {
          while (1) {
            switch (_context71.prev = _context71.next) {
              case 0:
                return _context71.abrupt("return", e.forEach(function (e) {
                  return t({
                    type: r,
                    payload: {
                      messageText: e.text
                    }
                  });
                }));
              case 1:
              case "end":
                return _context71.stop();
            }
          }
        }, _callee71);
      }));
      return function (_x75) {
        return _ref108.apply(this, arguments);
      };
    }();
  },
  tc = function tc(e, t) {
    var r = "DL_TRACKING_".concat(t, "_BLOCKING_MESSAGES");
    return /*#__PURE__*/function () {
      var _ref109 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee72(t) {
        return _regeneratorRuntime.wrap(function _callee72$(_context72) {
          while (1) {
            switch (_context72.prev = _context72.next) {
              case 0:
                return _context72.abrupt("return", e.forEach(function (e) {
                  return t({
                    type: r,
                    payload: {
                      messageText: e.text
                    }
                  });
                }));
              case 1:
              case "end":
                return _context72.stop();
            }
          }
        }, _callee72);
      }));
      return function (_x76) {
        return _ref109.apply(this, arguments);
      };
    }();
  },
  rc = "GA_TRACKING_CHANGE_SIM",
  nc = "GA_TRACKING_CHECKOUT_BLOCKING_MESSAGES",
  oc = "Checkout Api Error",
  ic = "Outstanding bill",
  ac = "DL_TRACKING_CHECKOUT_BLOCKING_MESSAGES",
  cc = "Checkout Api Error",
  dc = "Outstanding bill",
  sc = /*#__PURE__*/function () {
    var _ref110 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee73(e) {
      var t, r, n, o, a, _e$setFirstLoad, c, d, s;
      return _regeneratorRuntime.wrap(function _callee73$(_context73) {
        while (1) {
          switch (_context73.prev = _context73.next) {
            case 0:
              t = e.productOrderId;
              r = e.productOrderItemId;
              n = e.productId;
              o = e.msisdn;
              a = e.returnFullResponse;
              _e$setFirstLoad = e.setFirstLoad;
              c = _e$setFirstLoad === void 0 ? !0 : _e$setFirstLoad;
              d = "".concat(i, "/ecommerce/order/").concat(t, "/order-item-id/").concat(r, "/product/").concat(n, "/number-port");
              _context73.next = 10;
              return nt(d, {
                method: "PUT",
                queryParams: _objectSpread(_objectSpread({
                  sc: "SS",
                  lo: "en_US"
                }, a ? {
                  returnFullResponse: a
                } : {}), c ? {
                  setFirstLoad: c
                } : {}),
                body: JSON.stringify({
                  ImplProductConfigurationInput: {
                    msisdn: o
                  }
                })
              });
            case 10:
              s = _context73.sent;
              return _context73.abrupt("return", s.StatusResponse ? {
                statusResponse: s.StatusResponse
              } : s.ImplProductConfigurationOutput);
            case 12:
            case "end":
              return _context73.stop();
          }
        }
      }, _callee73);
    }));
    return function sc(_x77) {
      return _ref110.apply(this, arguments);
    };
  }(),
  uc = "GENERIC_ERROR",
  lc = "PENDING_ORDER",
  pc = "PORT_IN_SUBMITTED_ORDER_FOUND",
  Ic = "PORT_IN_NUMBER_GENERIC_ERROR",
  mc = "GA_TRACKING_PORT_IN_SUCCESS",
  Ec = function Ec(e) {
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee74() {
      var t, r, n, o, _yield$sc, i;
      return _regeneratorRuntime.wrap(function _callee74$(_context74) {
        while (1) {
          switch (_context74.prev = _context74.next) {
            case 0:
              t = e.order;
              r = e.portinNumber;
              n = e.returnFullResponse;
              o = e.setFirstLoad;
              _context74.next = 6;
              return sc({
                productOrderId: t.productOrderId,
                productOrderItemId: t.productOrderItemId,
                productId: t.productId,
                msisdn: r,
                returnFullResponse: n,
                setFirstLoad: o
              });
            case 6:
              _yield$sc = _context74.sent;
              i = _yield$sc.statusResponse;
              return _context74.abrupt("return", i);
            case 9:
            case "end":
              return _context74.stop();
          }
        }
      }, _callee74);
    }));
  },
  Rc = function Rc() {
    return {
      type: "RESET_ORDER"
    };
  },
  Sc = function Sc() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
    return {
      type: "SET_ORDER_LOADING",
      value: e
    };
  },
  _c = function _c(e) {
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee75() {
      var t, r, n, o, i, a, c;
      return _regeneratorRuntime.wrap(function _callee75$(_context75) {
        while (1) {
          switch (_context75.prev = _context75.next) {
            case 0:
              t = e.numbers, r = e.resourceNumber, n = e.signature, o = e.order, i = e.relaxCompatibilityRules, a = e.returnFullResponse, c = t.filter(function (e) {
                return e !== r;
              });
              return _context75.abrupt("return", dn({
                productOrderId: o.productOrderId,
                productOrderItemId: o.productOrderItemId,
                productId: o.productId,
                resourceNumber: r,
                numbersToBeReleased: c,
                signature: n,
                relaxCompatibilityRules: i,
                returnFullResponse: a
              }));
            case 2:
            case "end":
              return _context75.stop();
          }
        }
      }, _callee75);
    }));
  },
  Oc = function Oc(e) {
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee76() {
      var t, r;
      return _regeneratorRuntime.wrap(function _callee76$(_context76) {
        while (1) {
          switch (_context76.prev = _context76.next) {
            case 0:
              t = e.customerId, r = e.productOrderItemId;
              return _context76.abrupt("return", sn({
                customerId: t,
                productOrderItemId: r,
                payload: {
                  RetrieveProductInOrderConfigurationRequest: {
                    activityForConfiguration: "NegotiateProductConfiguration",
                    configurationLevel: "FULL",
                    settingsView: "FULL",
                    loadFirstStep: !1,
                    stepIDs: [],
                    serviceRequiredDate: null,
                    returnConfigurationData: {
                      catalogDataInd: !0,
                      crossProductsDiscountsDataInd: !0,
                      previousQuotedRecurringPricesInd: !1,
                      productConfigurationInd: !1,
                      quotedPricesInd: !0,
                      quotedProrationInd: !1,
                      quotedTaxInd: !1,
                      summaryInd: !1
                    }
                  }
                }
              }));
            case 2:
            case "end":
              return _context76.stop();
          }
        }
      }, _callee76);
    }));
  },
  Cc = function Cc(e) {
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee77() {
      var t, r, n;
      return _regeneratorRuntime.wrap(function _callee77$(_context77) {
        while (1) {
          switch (_context77.prev = _context77.next) {
            case 0:
              t = e.customerId, r = e.productOrderItemId, n = e.changedContainedProducts;
              return _context77.abrupt("return", nn({
                productOrderItemId: r,
                customerId: t,
                payload: {
                  UpdateProductInOrderConfigurationRequest: {
                    runCompatibilityRules: !0,
                    activityForConfiguration: null,
                    confirmationMessagesApproved: !1,
                    returnRemovedItems: !1,
                    configurationLevel: "FULL",
                    settingsView: "FULL",
                    updateEvenIfNotValid: !1,
                    returnConfiguration: "ALL",
                    productChanges: [{
                      removedContainedProducts: [],
                      changedContainedProducts: n,
                      suspendedContainedProducts: [],
                      changedSimpleProducts: [],
                      newAssignedBillingOffers: [],
                      newContainedProducts: [],
                      newSimpleProducts: [],
                      removedAssignedBillingOffers: [],
                      resumedContainedProducts: []
                    }],
                    returnConfigurationData: {
                      catalogDataInd: !0,
                      crossProductsDiscountsDataInd: !0,
                      previousQuotedRecurringPricesInd: !1,
                      productConfigurationInd: !0,
                      quotedPricesInd: !1,
                      quotedProrationInd: !1,
                      quotedTaxInd: !1,
                      summaryInd: !1
                    }
                  }
                }
              }));
            case 2:
            case "end":
              return _context77.stop();
          }
        }
      }, _callee77);
    }));
  };
function fc(e) {
  var t = e.customerId,
    r = e.mainLineGroupId,
    n = e.productOrderItemId,
    o = e.productId;
  return /*#__PURE__*/function () {
    var _ref115 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee78(e) {
      var i;
      return _regeneratorRuntime.wrap(function _callee78$(_context78) {
        while (1) {
          switch (_context78.prev = _context78.next) {
            case 0:
              i = [{
                productSpecContainmentID: parseInt("8363712", 10),
                productID: o,
                changedCharacteristics: [{
                  characteristicID: 8518342,
                  value: r
                }]
              }];
              _context78.prev = 1;
              e({
                type: "UPDATE_MAIN_LINE_NUMBER_LOADING"
              });
              _context78.next = 5;
              return e(Cc({
                customerId: t,
                productOrderItemId: n,
                changedContainedProducts: i
              }));
            case 5:
              e({
                type: "UPDATE_MAIN_LINE_NUMBER_SUCCESS"
              });
              _context78.next = 11;
              break;
            case 8:
              _context78.prev = 8;
              _context78.t0 = _context78["catch"](1);
              throw e({
                type: "UPDATE_MAIN_LINE_NUMBER_ERROR"
              }), _context78.t0;
            case 11:
            case "end":
              return _context78.stop();
          }
        }
      }, _callee78, null, [[1, 8]]);
    }));
    return function (_x78) {
      return _ref115.apply(this, arguments);
    };
  }();
}
function yc(_ref116) {
  var e = _ref116.productOrderItemId,
    t = _ref116.productId,
    _ref116$promoOrderDet = _ref116.promoOrderDetails,
    r = _ref116$promoOrderDet === void 0 ? {} : _ref116$promoOrderDet,
    n = _ref116.selectedAddonIds,
    o = _ref116.customerId,
    _ref116$isSimOnlyPlan = _ref116.isSimOnlyPlan,
    i = _ref116$isSimOnlyPlan === void 0 ? !1 : _ref116$isSimOnlyPlan,
    _ref116$specialPromoC = _ref116.specialPromoCode,
    a = _ref116$specialPromoC === void 0 ? "" : _ref116$specialPromoC;
  return /*#__PURE__*/function () {
    var _ref117 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee79(c) {
      var d, s, _t35, _r27, _n16;
      return _regeneratorRuntime.wrap(function _callee79$(_context79) {
        while (1) {
          switch (_context79.prev = _context79.next) {
            case 0:
              c({
                type: "UPDATE_ORDER_TO_RUN_RULES_LOADING"
              });
              d = ri(_objectSpread(_objectSpread({}, r), {}, {
                addonIds: n,
                isSimOnlyPlan: i,
                specialPromoCodeString: a
              })), s = {
                UpdateProductInOrderConfigurationRequest: {
                  runCompatibilityRules: !0,
                  activityForConfiguration: "SD Add Comp Stage+++promoCode+++EMPTY" + d,
                  confirmationMessagesApproved: !1,
                  returnRemovedItems: !1,
                  configurationLevel: "FULL",
                  settingsView: "FULL",
                  updateEvenIfNotValid: !1,
                  returnConfiguration: "ALL",
                  productChanges: [{
                    removedContainedProducts: [],
                    changedContainedProducts: [{
                      productID: t
                    }],
                    suspendedContainedProducts: [],
                    changedSimpleProducts: [],
                    newAssignedBillingOffers: [],
                    newContainedProducts: [],
                    newSimpleProducts: [],
                    removedAssignedBillingOffers: [],
                    resumedContainedProducts: []
                  }],
                  returnConfigurationData: {
                    catalogDataInd: !0,
                    crossProductsDiscountsDataInd: !0,
                    previousQuotedRecurringPricesInd: !1,
                    productConfigurationInd: !0,
                    quotedPricesInd: !1,
                    quotedProrationInd: !1,
                    quotedTaxInd: !1,
                    summaryInd: !1
                  }
                }
              };
              _context79.prev = 2;
              _context79.next = 5;
              return nn({
                customerId: o,
                productOrderItemId: e,
                payload: s
              });
            case 5:
              _t35 = _context79.sent;
              _r27 = _t35.productConfiguration;
              _n16 = Qa(_r27);
              if (!_n16) {
                _context79.next = 10;
                break;
              }
              throw c(ec(_n16, "ADDONS")), new Error(JSON.stringify(_n16));
            case 10:
              _context79.next = 15;
              break;
            case 12:
              _context79.prev = 12;
              _context79.t0 = _context79["catch"](2);
              throw c({
                type: "UPDATE_ORDER_TO_RUN_RULES_ERROR"
              }), _context79.t0;
            case 15:
              c({
                type: "SET_PROMO_CRITERIA",
                payload: d
              });
              _context79.next = 18;
              return c({
                type: "UPDATE_ORDER_TO_RUN_RULES_SUCCESS"
              });
            case 18:
              return _context79.abrupt("return", _context79.sent);
            case 19:
            case "end":
              return _context79.stop();
          }
        }
      }, _callee79, null, [[2, 12]]);
    }));
    return function (_x79) {
      return _ref117.apply(this, arguments);
    };
  }();
}
var Tc = function Tc(e) {
    if (!(null == e ? void 0 : e.productConfiguration)) return null;
    var t;
    var r = e.productConfiguration.displayableItems,
      n = wn(r).entities.displayableItems[8363722];
    if (n) {
      var _e46 = xo(n.displayableCharacteristics);
      t = null == _e46 ? void 0 : _e46.simType;
    }
    return t;
  },
  Ac = function Ac(_ref118) {
    var e = _ref118.contact,
      t = _ref118.customerId,
      r = _ref118.productOrder,
      _ref118$isAnonymous = _ref118.isAnonymous,
      n = _ref118$isAnonymous === void 0 ? !1 : _ref118$isAnonymous;
    return /*#__PURE__*/function () {
      var _ref119 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee80(o) {
        return _regeneratorRuntime.wrap(function _callee80$(_context80) {
          while (1) {
            switch (_context80.prev = _context80.next) {
              case 0:
                _context80.prev = 0;
                o({
                  type: "ADD_CONTACT_TO_ORDER_LOADING"
                });
                _context80.next = 4;
                return on({
                  customerId: t,
                  contactId: e.contactId,
                  productOrderReferenceNumber: r.productOrderReferenceNumber,
                  productOrderItemId: r.productOrderItemId,
                  isAnonymous: n
                });
              case 4:
                o({
                  type: "CONTACT_ADDED_TO_ORDER"
                });
                _context80.next = 10;
                break;
              case 7:
                _context80.prev = 7;
                _context80.t0 = _context80["catch"](0);
                throw o({
                  type: "ADD_CONTACT_TO_ORDER_ERROR"
                }), _context80.t0;
              case 10:
              case "end":
                return _context80.stop();
            }
          }
        }, _callee80, null, [[0, 7]]);
      }));
      return function (_x80) {
        return _ref119.apply(this, arguments);
      };
    }();
  },
  Dc = /*#__PURE__*/function () {
    var _ref120 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee81(e) {
      var t, r, n;
      return _regeneratorRuntime.wrap(function _callee81$(_context81) {
        while (1) {
          switch (_context81.prev = _context81.next) {
            case 0:
              t = e.productOrderItemId, r = e.removedContainedProducts;
              if (null == r ? void 0 : r.length) {
                _context81.next = 3;
                break;
              }
              return _context81.abrupt("return");
            case 3:
              n = {
                UpdateProductInOrderConfigurationRequest: {
                  runCompatibilityRules: !1,
                  activityForConfiguration: "QuoteSDOrderSummary",
                  confirmationMessagesApproved: !0,
                  returnRemovedItems: !0,
                  configurationLevel: "FULL",
                  settingsView: "FULL",
                  productChanges: [{
                    removedContainedProducts: r,
                    changedContainedProducts: [],
                    suspendedContainedProducts: [],
                    changedSimpleProducts: [],
                    newAssignedBillingOffers: [],
                    newContainedProducts: [],
                    newSimpleProducts: [],
                    removedSimpleProducts: [],
                    removedAssignedBillingOffers: [],
                    resumedContainedProducts: []
                  }],
                  returnConfigurationData: {
                    catalogDataInd: !0,
                    crossProductsDiscountsDataInd: !0,
                    previousQuotedRecurringPricesInd: !1,
                    productConfigurationInd: !0,
                    quotedPricesInd: !0,
                    quotedProrationInd: !0,
                    quotedTaxInd: !0,
                    summaryInd: !0
                  }
                }
              };
              _context81.next = 6;
              return nn({
                productOrderItemId: t,
                payload: n
              });
            case 6:
              return _context81.abrupt("return", _context81.sent);
            case 7:
            case "end":
              return _context81.stop();
          }
        }
      }, _callee81);
    }));
    return function Dc(_x81) {
      return _ref120.apply(this, arguments);
    };
  }();
var Pc = Object.freeze({
  __proto__: null,
  setProductOrderLoading: Ya,
  setProductOrderSuccessful: xa,
  setProductOrderError: Ha,
  addPreTickAddons: $a,
  getCustomerId: qa,
  createProductOrder: Xa,
  addSilverComponentToOrder: ja,
  addPromoCode: function addPromoCode(e) {
    var t = e.productOrderId,
      r = e.promoString,
      _e$promoCheckNeeded = e.promoCheckNeeded,
      n = _e$promoCheckNeeded === void 0 ? !0 : _e$promoCheckNeeded,
      _e$updateProducts = e.updateProducts,
      o = _e$updateProducts === void 0 ? !1 : _e$updateProducts,
      _e$productOrder = e.productOrder,
      i = _e$productOrder === void 0 ? {} : _e$productOrder,
      _e$userInformation = e.userInformation,
      a = _e$userInformation === void 0 ? {} : _e$userInformation,
      c = e.orderSummaryPayload,
      d = e.customerId;
    return /*#__PURE__*/function () {
      var _ref121 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee83(e) {
        var s, _t36, _ref122, _n17, _o12;
        return _regeneratorRuntime.wrap(function _callee83$(_context83) {
          while (1) {
            switch (_context83.prev = _context83.next) {
              case 0:
                e({
                  type: "ADD_PROMO_CODE_LOADING",
                  value: r
                });
                s = {
                  productOrder: i,
                  userInformation: a,
                  orderSummaryPayload: c,
                  customerId: d
                };
                if (!n) {
                  _context83.next = 17;
                  break;
                }
                _context83.prev = 3;
                _context83.next = 6;
                return un({
                  promoString: r,
                  activityCouponConfig: !0
                });
              case 6:
                _t36 = _context83.sent;
                _ref122 = null == _t36 ? void 0 : _t36[0];
                _n17 = _ref122.promoId;
                _o12 = _ref122.isValid;
                if (!(_n17 !== r || !_o12)) {
                  _context83.next = 12;
                  break;
                }
                return _context83.abrupt("return", e(Ja("INVALID_PROMO_CODE")));
              case 12:
                _context83.next = 17;
                break;
              case 14:
                _context83.prev = 14;
                _context83.t0 = _context83["catch"](3);
                return _context83.abrupt("return", e(Ja("SOMETHING_WENT_WRONG")));
              case 17:
                _context83.next = 19;
                return e(Za({
                  productOrderId: t,
                  promoString: r,
                  updateProducts: o
                }));
              case 19:
                _context83.t1 = o;
                if (!_context83.t1) {
                  _context83.next = 23;
                  break;
                }
                _context83.next = 23;
                return e(function (e) {
                  return /*#__PURE__*/function () {
                    var _ref123 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee82(t) {
                      var r, n, _e$orderSummaryPayloa, o, i, a, c, d, _e47, _s4, u;
                      return _regeneratorRuntime.wrap(function _callee82$(_context82) {
                        while (1) {
                          switch (_context82.prev = _context82.next) {
                            case 0:
                              r = e.productOrder, n = e.userInformation, _e$orderSummaryPayloa = e.orderSummaryPayload, o = _e$orderSummaryPayloa === void 0 ? null : _e$orderSummaryPayloa, i = e.customerId;
                              _context82.prev = 1;
                              _e47 = r.productOrderId, _s4 = r.productId, u = r.productOrderItemId;
                              _context82.next = 5;
                              return t(Ga(o));
                            case 5:
                              _context82.next = 7;
                              return t(oa({
                                customerId: i || (null == n || null === (a = n.clientContext) || void 0 === a || null === (c = a.customers) || void 0 === c || null === (d = c[0]) || void 0 === d ? void 0 : d.customerId),
                                productOrderId: _e47,
                                productId: _s4,
                                productOrderItemId: u
                              }));
                            case 7:
                              _context82.next = 9;
                              return t(Ga(o));
                            case 9:
                              _context82.next = 11;
                              return t(Fa(o));
                            case 11:
                              _context82.next = 16;
                              break;
                            case 13:
                              _context82.prev = 13;
                              _context82.t0 = _context82["catch"](1);
                              return _context82.abrupt("return", t(Ja("SOMETHING_WENT_WRONG_UPDATE_PRODUCTS")));
                            case 16:
                            case "end":
                              return _context82.stop();
                          }
                        }
                      }, _callee82, null, [[1, 13]]);
                    }));
                    return function (_x83) {
                      return _ref123.apply(this, arguments);
                    };
                  }();
                }(_objectSpread({}, s)));
              case 23:
                return _context83.abrupt("return", e(Ka(r)));
              case 24:
              case "end":
                return _context83.stop();
            }
          }
        }, _callee83, null, [[3, 14]]);
      }));
      return function (_x82) {
        return _ref121.apply(this, arguments);
      };
    }();
  },
  resetOrder: Rc,
  setOrderLoading: Sc,
  assignNumberToOrderApi: _c,
  assignNumberToOrder: function assignNumberToOrder(e) {
    return /*#__PURE__*/function () {
      var _ref124 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee84(t) {
        return _regeneratorRuntime.wrap(function _callee84$(_context84) {
          while (1) {
            switch (_context84.prev = _context84.next) {
              case 0:
                _context84.prev = 0;
                t(Sc(!0));
                _context84.next = 4;
                return t(_c(e));
              case 4:
                t(Sc(!1));
                _context84.next = 10;
                break;
              case 7:
                _context84.prev = 7;
                _context84.t0 = _context84["catch"](0);
                return _context84.abrupt("return", (t({
                  type: "GA_TRACKING_NEW_NUMBER_ERROR"
                }), t(Ha({
                  type: "newNumber",
                  status: "NGNIS_NUMBER_RESERVED_ERROR"
                }))));
              case 10:
              case "end":
                return _context84.stop();
            }
          }
        }, _callee84, null, [[0, 7]]);
      }));
      return function (_x84) {
        return _ref124.apply(this, arguments);
      };
    }();
  },
  negotiateProductConfiguration: Oc,
  updateProductInConfiguration: Cc,
  createNewNumberOrder: function createNewNumberOrder(e) {
    return /*#__PURE__*/function () {
      var _ref125 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee86(t) {
        var _e$thirdPartyIndicato, r, _e$hasSpecialPromo, n, o, i, a, d, s, u, l, p, I, _e$selectedProduct, m, _e$simCardType, E, R, S, _e$service, _, O, C, _e48, _r28, _n18, f, y, T, _e49, _r29, _n19, _i10, _a5, _e50, _n19$displayableSimpl, _r30, _c10;
        return _regeneratorRuntime.wrap(function _callee86$(_context86) {
          while (1) {
            switch (_context86.prev = _context86.next) {
              case 0:
                _e$thirdPartyIndicato = e.thirdPartyIndicator, r = _e$thirdPartyIndicato === void 0 ? {} : _e$thirdPartyIndicato, _e$hasSpecialPromo = e.hasSpecialPromo, n = _e$hasSpecialPromo === void 0 ? "" : _e$hasSpecialPromo, o = e.planId, i = e.planRelId, a = e.simpleProductSpecId, d = e.numbers, s = e.resourceNumber, u = e.signature, l = e.cisDetails, p = e.preTickAddons, I = e.monthlyTerm, _e$selectedProduct = e.selectedProduct, m = _e$selectedProduct === void 0 ? null : _e$selectedProduct, _e$simCardType = e.simCardType, E = _e$simCardType === void 0 ? c : _e$simCardType, R = e.planTags, S = e.contact, _e$service = e.service, _ = _e$service === void 0 ? null : _e$service, O = e.accessories;
                t({
                  type: "SET_PRODUCT_ORDER_LOADING",
                  value: !0
                });
                _context86.prev = 2;
                _context86.next = 5;
                return t(qa({}));
              case 5:
                C = _context86.sent;
                _context86.next = 11;
                break;
              case 8:
                _context86.prev = 8;
                _context86.t0 = _context86["catch"](2);
                C = null;
              case 11:
                if (!(C && _)) {
                  _context86.next = 27;
                  break;
                }
                _e48 = _.id;
                _context86.prev = 13;
                _context86.next = 16;
                return Fe(C, _e48);
              case 16:
                _r28 = _context86.sent;
                if (!st(_r28)) {
                  _context86.next = 19;
                  break;
                }
                return _context86.abrupt("return", t(Ha({
                  errorMsg: "ELIGIBILITY_HAS_PENDING_PAYMENT_ORDER",
                  serviceId: _e48
                })));
              case 19:
                _n18 = lt(_e48, _r28);
                _context86.next = 22;
                return Ye(_n18, /*#__PURE__*/function () {
                  var _ref126 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee85(e) {
                    return _regeneratorRuntime.wrap(function _callee85$(_context85) {
                      while (1) {
                        switch (_context85.prev = _context85.next) {
                          case 0:
                            _context85.next = 2;
                            return we({
                              customerId: C,
                              productOrderId: e.orderId,
                              productOrderItemId: e.orderActionId
                            });
                          case 2:
                          case "end":
                            return _context85.stop();
                        }
                      }
                    }, _callee85);
                  }));
                  return function (_x86) {
                    return _ref126.apply(this, arguments);
                  };
                }());
              case 22:
                _context86.next = 27;
                break;
              case 24:
                _context86.prev = 24;
                _context86.t1 = _context86["catch"](13);
                return _context86.abrupt("return", t(Ha({
                  errorMsg: "NEW_ORDER_GENERIC_ERROR",
                  serviceId: _e48
                })));
              case 27:
                f = {
                  customerId: C,
                  simpleProductSpecId: a,
                  cisDetails: l,
                  planId: o,
                  planRelId: i,
                  monthlyTerm: I,
                  simCardType: E,
                  planTags: R,
                  contact: S,
                  accessories: O
                };
                _context86.prev = 28;
                _context86.next = 31;
                return t(Xa(f));
              case 31:
                y = _context86.sent;
                _context86.next = 37;
                break;
              case 34:
                _context86.prev = 34;
                _context86.t2 = _context86["catch"](28);
                return _context86.abrupt("return", t(Ha(_context86.t2.response && _context86.t2.response.status)));
              case 37:
                if (!(Object.keys(r).length || n)) {
                  _context86.next = 46;
                  break;
                }
                _context86.prev = 38;
                _context86.next = 41;
                return t(Za(_objectSpread(_objectSpread(_objectSpread({}, r), n && {
                  promoString: n,
                  specialPromo: !0
                }), {}, {
                  productOrderId: y.productOrderId,
                  updateProducts: !0
                })));
              case 41:
                _context86.next = 46;
                break;
              case 43:
                _context86.prev = 43;
                _context86.t3 = _context86["catch"](38);
                return _context86.abrupt("return", t(Ha(_context86.t3.response && _context86.t3.response.status)));
              case 46:
                if (!S) {
                  _context86.next = 54;
                  break;
                }
                _context86.prev = 47;
                _context86.next = 50;
                return t(Ac({
                  contact: S,
                  customerId: C,
                  productOrder: y,
                  isAnonymous: !1
                }));
              case 50:
                _context86.next = 54;
                break;
              case 52:
                _context86.prev = 52;
                _context86.t4 = _context86["catch"](47);
              case 54:
                _context86.prev = 54;
                _context86.next = 57;
                return t(Oc({
                  productOrderItemId: y.productOrderItemId
                }));
              case 57:
                _context86.next = 61;
                break;
              case 59:
                _context86.prev = 59;
                _context86.t5 = _context86["catch"](54);
              case 61:
                _context86.prev = 61;
                _e49 = {
                  numbers: d,
                  resourceNumber: s,
                  signature: u,
                  order: y,
                  relaxCompatibilityRules: !1,
                  returnFullResponse: !0
                };
                _context86.next = 65;
                return t(_c(_e49));
              case 65:
                _r29 = _context86.sent;
                _n19 = _r29.updateOrderResponse.productConfiguration;
                if (!p) {
                  _context86.next = 72;
                  break;
                }
                _e50 = _n19.displayableItems, _n19$displayableSimpl = _n19.displayableSimpleProductReferences, _r30 = _n19$displayableSimpl === void 0 ? [] : _n19$displayableSimpl;
                _context86.next = 71;
                return t($a({
                  preTickAddons: p,
                  displayableItems: _e50,
                  order: y,
                  cisDetails: l,
                  planId: o,
                  transactionType: "ga",
                  selectedProduct: m,
                  displayableSimpleProductReferences: _r30
                }));
              case 71:
                _i10 = _context86.sent;
              case 72:
                t({
                  type: "GA_TRACKING_NEW_NUMBER_SUCCESS"
                }), "BLOCKING" !== (null == _n19 ? void 0 : _n19.compatibilityStatus) && (_a5 = null == _n19 ? void 0 : _n19.serviceID);
                _c10 = {
                  productOrderId: y.productOrderId,
                  productOrderReferenceNumber: y.productOrderReferenceNumber,
                  productOrderItemId: y.productOrderItemId,
                  productId: y.productId,
                  hasSilverComponent: y.hasSilverComponent,
                  reserveResourceNumber: _a5,
                  type: "NEW",
                  preTickAddonsBoIds: (null === (T = _i10) || void 0 === T ? void 0 : T.preTickAddonsBoIds) || []
                };
                return _context86.abrupt("return", t(xa(_c10)));
              case 77:
                _context86.prev = 77;
                _context86.t6 = _context86["catch"](61);
                return _context86.abrupt("return", (t({
                  type: "GA_TRACKING_NEW_NUMBER_ERROR"
                }), t(Ha({
                  type: "newNumber",
                  status: "NGNIS_NUMBER_RESERVED_ERROR"
                }))));
              case 80:
              case "end":
                return _context86.stop();
            }
          }
        }, _callee86, null, [[2, 8], [13, 24], [28, 34], [38, 43], [47, 52], [54, 59], [61, 77]]);
      }));
      return function (_x85) {
        return _ref125.apply(this, arguments);
      };
    }();
  },
  createMobileShareNewNumberOrder: function createMobileShareNewNumberOrder(e) {
    return /*#__PURE__*/function () {
      var _ref127 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee87(t) {
        var r, n, o, i, a, d, s, u, _e$selectedProduct2, l, _e$simCardType2, p, I, m, E, R, S, _, _e51, _i11, _c11, _p2, _I2, _E2, _O, C, _f, y;
        return _regeneratorRuntime.wrap(function _callee87$(_context87) {
          while (1) {
            switch (_context87.prev = _context87.next) {
              case 0:
                r = e.service, n = e.mainLineGroupId, o = e.planId, i = e.planRelId, a = e.numbers, d = e.resourceNumber, s = e.signature, u = e.preTickAddons, _e$selectedProduct2 = e.selectedProduct, l = _e$selectedProduct2 === void 0 ? null : _e$selectedProduct2, _e$simCardType2 = e.simCardType, p = _e$simCardType2 === void 0 ? c : _e$simCardType2, I = e.contact;
                t({
                  type: "SET_PRODUCT_ORDER_LOADING",
                  value: !0
                });
                _context87.prev = 2;
                _context87.next = 5;
                return t(qa(r));
              case 5:
                m = _context87.sent;
                _context87.next = 11;
                break;
              case 8:
                _context87.prev = 8;
                _context87.t0 = _context87["catch"](2);
                m = null;
              case 11:
                E = {
                  customerId: m,
                  planId: o,
                  planRelId: i,
                  simCardType: p
                };
                _context87.prev = 12;
                _context87.next = 15;
                return t(Xa(E));
              case 15:
                R = _context87.sent;
                _context87.next = 21;
                break;
              case 18:
                _context87.prev = 18;
                _context87.t1 = _context87["catch"](12);
                return _context87.abrupt("return", t(Ha(_context87.t1.response && _context87.t1.response.status)));
              case 21:
                if (!I) {
                  _context87.next = 29;
                  break;
                }
                _context87.prev = 22;
                _context87.next = 25;
                return t(Ac({
                  contact: I,
                  customerId: m,
                  productOrder: R,
                  isAnonymous: !1
                }));
              case 25:
                _context87.next = 29;
                break;
              case 27:
                _context87.prev = 27;
                _context87.t2 = _context87["catch"](22);
              case 29:
                _context87.prev = 29;
                _context87.next = 32;
                return t(Oc({
                  customerId: m,
                  productOrderItemId: R.productOrderItemId
                }));
              case 32:
                _context87.next = 36;
                break;
              case 34:
                _context87.prev = 34;
                _context87.t3 = _context87["catch"](29);
              case 36:
                _context87.prev = 36;
                _e51 = {
                  numbers: a,
                  resourceNumber: d,
                  signature: s,
                  order: R,
                  relaxCompatibilityRules: !0,
                  returnFullResponse: !0
                };
                _context87.next = 40;
                return t(_c(_e51));
              case 40:
                _i11 = {
                  customerId: m,
                  productOrderItemId: R.productOrderItemId
                };
                _context87.next = 43;
                return t(Oc(_i11));
              case 43:
                _c11 = _context87.sent;
                _p2 = _c11.productConfiguration.displayableItems;
                _I2 = (null === (S = _c11.productConfiguration) || void 0 === S ? void 0 : S.displayableSimpleProductReferences) || [];
                _context87.t4 = u;
                if (!_context87.t4) {
                  _context87.next = 51;
                  break;
                }
                _context87.next = 50;
                return t($a({
                  preTickAddons: u,
                  displayableItems: _p2,
                  order: R,
                  planId: o,
                  transactionType: "ga",
                  selectedProduct: l,
                  displayableSimpleProductReferences: _I2
                }));
              case 50:
                _E2 = _context87.sent;
              case 51:
                t({
                  type: "GA_TRACKING_MS_NEW_NUMBER_SUCCESS"
                });
                _O = _p2.find(function (_ref128) {
                  var e = _ref128.productSpecContainmentID;
                  return "8363712" === e;
                }), C = _O && _O.productID, _f = {
                  customerId: r.customerId,
                  mainLineGroupId: n,
                  productOrderItemId: R.productOrderItemId,
                  productId: C
                };
                _context87.next = 55;
                return t(fc(_f));
              case 55:
                y = {
                  productOrderId: R.productOrderId,
                  productOrderReferenceNumber: R.productOrderReferenceNumber,
                  productOrderItemId: R.productOrderItemId,
                  productId: R.productId,
                  type: "MS_NEW",
                  preTickAddonsBoIds: (null === (_ = _E2) || void 0 === _ ? void 0 : _.preTickAddonsBoIds) || []
                };
                return _context87.abrupt("return", t(xa(y)));
              case 59:
                _context87.prev = 59;
                _context87.t5 = _context87["catch"](36);
                return _context87.abrupt("return", (t({
                  type: "GA_TRACKING_MS_NEW_NUMBER_ERROR"
                }), t(Ha({
                  type: "newNumber",
                  status: "NGNIS_NUMBER_RESERVED_ERROR"
                }))));
              case 62:
              case "end":
                return _context87.stop();
            }
          }
        }, _callee87, null, [[2, 8], [12, 18], [22, 27], [29, 34], [36, 59]]);
      }));
      return function (_x87) {
        return _ref127.apply(this, arguments);
      };
    }();
  },
  updateMainLineNumber: fc,
  createRecontractOrder: function createRecontractOrder(e) {
    var t = e.selectedPlan,
      r = e.service,
      n = e.contact,
      o = e.cisDetails,
      i = e.simpleProductSpecId,
      a = e.preTickAddons,
      c = e.monthlyTerm,
      _e$selectedProduct3 = e.selectedProduct,
      d = _e$selectedProduct3 === void 0 ? null : _e$selectedProduct3,
      _e$accessories2 = e.accessories,
      s = _e$accessories2 === void 0 ? [] : _e$accessories2,
      _e$specialPromoString = e.specialPromoString,
      u = _e$specialPromoString === void 0 ? "" : _e$specialPromoString,
      l = r.customerId,
      p = r.id,
      I = r.subscriptionId,
      m = t.planId,
      E = t.planRelId,
      R = t.basePriceSchemaId;
    return /*#__PURE__*/function () {
      var _ref129 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee92(e) {
        var S, _, _e52, _e53, _t37, O, f, _e54, y, T, A, D, _t38, P, v, h, g, N, b, L, U, M, w, G, F, k, _n$dateOfBirth, _e55, _n$indentType, _t40, B, V, Y, _t41, _r32, _n20, _t42, _i12;
        return _regeneratorRuntime.wrap(function _callee92$(_context92) {
          while (1) {
            switch (_context92.prev = _context92.next) {
              case 0:
                _ = function _(t, r) {
                  return e({
                    type: "GA_TRACKING_RECONTRACT_ERRORS",
                    payload: {
                      label: r || t
                    }
                  }), e(Ha({
                    errorMsg: t,
                    serviceId: p
                  }));
                };
                e({
                  type: "SET_PRODUCT_ORDER_LOADING",
                  value: !0
                }), e({
                  type: "GA_TRACKING_RECONTRACT_CLICK"
                });
                _context92.prev = 2;
                _context92.next = 5;
                return cn(l, p);
              case 5:
                _e52 = _context92.sent;
                if (!ut(_e52.pendingComponents)) {
                  _context92.next = 8;
                  break;
                }
                return _context92.abrupt("return", _("ELIGIBILITY_HAS_PENDING_ORDER"));
              case 8:
                _context92.next = 13;
                break;
              case 10:
                _context92.prev = 10;
                _context92.t0 = _context92["catch"](2);
                return _context92.abrupt("return", _("RECONTRACT_GENERIC_ERROR", "Error from apiBillingOffers"));
              case 13:
                _context92.prev = 13;
                _context92.next = 16;
                return Fe(l, p);
              case 16:
                _e53 = _context92.sent;
                if (!st(_e53)) {
                  _context92.next = 19;
                  break;
                }
                return _context92.abrupt("return", _("ELIGIBILITY_HAS_PENDING_PAYMENT_ORDER"));
              case 19:
                _t37 = lt(p, _e53);
                _context92.next = 22;
                return Ye(_t37, /*#__PURE__*/function () {
                  var _ref130 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee88(e) {
                    return _regeneratorRuntime.wrap(function _callee88$(_context88) {
                      while (1) {
                        switch (_context88.prev = _context88.next) {
                          case 0:
                            _context88.next = 2;
                            return we({
                              customerId: l,
                              productOrderId: e.orderId,
                              productOrderItemId: e.orderActionId
                            });
                          case 2:
                          case "end":
                            return _context88.stop();
                        }
                      }
                    }, _callee88);
                  }));
                  return function (_x89) {
                    return _ref130.apply(this, arguments);
                  };
                }());
              case 22:
                _context92.next = 34;
                break;
              case 24:
                _context92.prev = 24;
                _context92.t1 = _context92["catch"](13);
                _context92.next = 28;
                return function () {
                  var _ref131 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee89(e) {
                    var t, _r31;
                    return _regeneratorRuntime.wrap(function _callee89$(_context89) {
                      while (1) {
                        switch (_context89.prev = _context89.next) {
                          case 0:
                            _context89.prev = 0;
                            _context89.next = 3;
                            return _r(e);
                          case 3:
                            _r31 = _context89.sent;
                            return _context89.abrupt("return", (null == _r31 || null === (t = _r31.ErrorInfo) || void 0 === t ? void 0 : t.errorCode) === Cr.RESPONSE_CODE.ORDER_UNDER_PROCESSING);
                          case 7:
                            _context89.prev = 7;
                            _context89.t0 = _context89["catch"](0);
                            return _context89.abrupt("return", !1);
                          case 10:
                          case "end":
                            return _context89.stop();
                        }
                      }
                    }, _callee89, null, [[0, 7]]);
                  }));
                  return function (_x90) {
                    return _ref131.apply(this, arguments);
                  };
                }()(_context92.t1);
              case 28:
                if (!_context92.sent) {
                  _context92.next = 32;
                  break;
                }
                _context92.t2 = e({
                  type: Sr.ORDER_UNDER_PROCESSING,
                  value: Cr.RESPONSE_CODE.ORDER_UNDER_PROCESSING
                });
                _context92.next = 33;
                break;
              case 32:
                _context92.t2 = _("RECONTRACT_GENERIC_ERROR", "Error from apiProductOrderDelete");
              case 33:
                return _context92.abrupt("return", _context92.t2);
              case 34:
                O = [], f = [];
                if (o && O.push({
                  changedCharacteristics: [{
                    characteristicID: 8480012,
                    value: o.parentCompanyBRN
                  }, {
                    characteristicID: 8582,
                    value: o.parentCompanyName
                  }, {
                    characteristicID: 8592,
                    value: o.childCompanyName
                  }],
                  productSpecContainmentID: "11762",
                  temporaryID: xe()
                }), i) {
                  O.push({
                    productSpecContainmentID: "10482",
                    temporaryID: xe()
                  });
                  _e54 = {
                    businessType: "DEVICE",
                    simpleProductSpecID: i,
                    temporaryID: xe()
                  };
                  c && (_e54.changedCharacteristics = [{
                    characteristicID: "8272",
                    value: c
                  }, {
                    characteristicID: "13897781",
                    value: "Instalments"
                  }]), f.push(_e54), Wa(f, s);
                }
                y = [], T = dt(r);
                o && T && y.push({
                  productID: T.id
                });
                D = 0;
                _context92.prev = 39;
                _t38 = {
                  factor: 1
                };
                _context92.next = 43;
                return rn( /*#__PURE__*/function () {
                  var _ref132 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee91(t, r) {
                    var o, _t39;
                    return _regeneratorRuntime.wrap(function _callee91$(_context91) {
                      while (1) {
                        switch (_context91.prev = _context91.next) {
                          case 0:
                            D = r;
                            _context91.next = 3;
                            return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee90() {
                              var e;
                              return _regeneratorRuntime.wrap(function _callee90$(_context90) {
                                while (1) {
                                  switch (_context90.prev = _context90.next) {
                                    case 0:
                                      e = "RECON";
                                      Number(c) > 0 && (e = "NEWIPP");
                                      _context90.next = 4;
                                      return an({
                                        contactId: n.contactId,
                                        customerId: l,
                                        serviceId: p,
                                        subscriptionId: I,
                                        planId: m,
                                        planRelId: E,
                                        basePriceSchemaId: R,
                                        newContainedProducts: O,
                                        newSimpleProducts: f,
                                        removedContainedProducts: y,
                                        orderActionReason: e,
                                        orderActionType: "CH"
                                      });
                                    case 4:
                                      return _context90.abrupt("return", _context90.sent);
                                    case 5:
                                    case "end":
                                      return _context90.stop();
                                  }
                                }
                              }, _callee90);
                            }))();
                          case 3:
                            o = _context91.sent;
                            if (!o.errorInfo) {
                              _context91.next = 6;
                              break;
                            }
                            return _context91.abrupt("return", t(o.errorInfo[0]));
                          case 6:
                            if (!u) {
                              _context91.next = 16;
                              break;
                            }
                            _context91.prev = 7;
                            _t39 = o.updateProductConfigurationResponse.productOrderID;
                            _context91.next = 11;
                            return e(Za({
                              promoString: u,
                              specialPromo: !0,
                              productOrderId: _t39,
                              updateProducts: !0
                            }));
                          case 11:
                            _context91.next = 16;
                            break;
                          case 13:
                            _context91.prev = 13;
                            _context91.t0 = _context91["catch"](7);
                            return _context91.abrupt("return", e(Ha(_context91.t0.response && _context91.t0.response.status)));
                          case 16:
                            return _context91.abrupt("return", o);
                          case 17:
                          case "end":
                            return _context91.stop();
                        }
                      }
                    }, _callee91, null, [[7, 13]]);
                  }));
                  return function (_x91, _x92) {
                    return _ref132.apply(this, arguments);
                  };
                }(), _t38);
              case 43:
                A = _context92.sent;
                _context92.next = 49;
                break;
              case 46:
                _context92.prev = 46;
                _context92.t3 = _context92["catch"](39);
                return _context92.abrupt("return", _("RECONTRACT_GENERIC_ERROR", _context92.t3.errorCode || "Error from submitReconOrder"));
              case 49:
                D > 1 && e({
                  type: "GA_TRACKING_RECONTRACT_ERROR_RETRY",
                  payload: {
                    attempts: D
                  }
                });
                P = A.updateProductConfigurationResponse, v = P.productsInReplaceProductOffering[0].products[0], h = v.productID, g = v.productOrderItemID, N = P.productOrderID, b = P.productOrderReferenceNumber, L = v.productConfiguration.displayableItems, U = [], M = at(L), w = ct(L), G = it(L);
                M && U.push({
                  productID: M.productID
                }), !o && w && U.push({
                  productID: w.productID
                });
                F = !1, k = "";
                if (!!(null == t ? void 0 : t.tags) && ui(t.tags) && n) {
                  _n$dateOfBirth = n.dateOfBirth, _e55 = _n$dateOfBirth === void 0 ? null : _n$dateOfBirth, _n$indentType = n.indentType, _t40 = _n$indentType === void 0 ? null : _n$indentType;
                  F = ci(_e55), k = C[_t40];
                }
                B = [];
                !F || "NRIC" !== k || o || G || B.push({
                  productSpecContainmentID: "2089835",
                  temporaryID: xe()
                });
                V = {
                  UpdateProductInOrderConfigurationRequest: {
                    runCompatibilityRules: !0,
                    addDefaultChildItemsImplicitly: !0,
                    activityForConfiguration: "NPCFirstLoad",
                    confirmationMessagesApproved: !1,
                    returnRemovedItems: !1,
                    configurationLevel: "FULL",
                    settingsView: "FULL",
                    updateEvenIfNotValid: !1,
                    returnConfiguration: "ALL",
                    productChanges: [{
                      removedContainedProducts: U,
                      changedContainedProducts: [{
                        productID: h
                      }],
                      suspendedContainedProducts: [],
                      changedSimpleProducts: [],
                      newAssignedBillingOffers: [],
                      newContainedProducts: B,
                      newSimpleProducts: [],
                      removedAssignedBillingOffers: [],
                      resumedContainedProducts: []
                    }],
                    returnConfigurationData: {
                      catalogDataInd: !0,
                      crossProductsDiscountsDataInd: !0,
                      previousQuotedRecurringPricesInd: !1,
                      productConfigurationInd: !0,
                      quotedPricesInd: !1,
                      quotedProrationInd: !1,
                      quotedTaxInd: !1,
                      summaryInd: !1
                    }
                  }
                };
                _context92.prev = 57;
                _context92.next = 60;
                return nn({
                  customerId: l,
                  productOrderItemId: g,
                  payload: V
                });
              case 60:
                _t41 = _context92.sent;
                _r32 = _t41.productConfiguration;
                _n20 = Qa(_r32);
                if (!_n20) {
                  _context92.next = 67;
                  break;
                }
                e(ec(_n20, "RECONTRACT"));
                _t42 = function (e) {
                  var _iterator2 = _createForOfIteratorHelper(e),
                    _step2;
                  try {
                    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                      var _t43 = _step2.value;
                      for (var _i13 = 0, _Object$entries = Object.entries(za); _i13 < _Object$entries.length; _i13++) {
                        var _Object$entries$_i = _slicedToArray(_Object$entries[_i13], 2),
                          _e56 = _Object$entries$_i[0],
                          _r33 = _Object$entries$_i[1];
                        if (-1 !== _t43.text.indexOf(_e56)) return _r33;
                      }
                    }
                  } catch (err) {
                    _iterator2.e(err);
                  } finally {
                    _iterator2.f();
                  }
                  return null;
                }(_n20);
                return _context92.abrupt("return", _t42 ? _(_t42) : _("RECONTRACT_GENERIC_ERROR", "Error from blocking message"));
              case 67:
                _i12 = (null == _r32 ? void 0 : _r32.displayableSimpleProductReferences) || [];
                _context92.t4 = a;
                if (!_context92.t4) {
                  _context92.next = 73;
                  break;
                }
                _context92.next = 72;
                return e($a({
                  preTickAddons: a,
                  displayableItems: _r32.displayableItems,
                  order: {
                    productOrderId: N,
                    productOrderItemId: g
                  },
                  cisDetails: o,
                  planId: m,
                  transactionType: "recon",
                  selectedProduct: d,
                  displayableSimpleProductReferences: _i12
                }));
              case 72:
                Y = _context92.sent;
              case 73:
                _context92.next = 78;
                break;
              case 75:
                _context92.prev = 75;
                _context92.t5 = _context92["catch"](57);
                return _context92.abrupt("return", _("RECONTRACT_GENERIC_ERROR", "Error from apiProductConfiguration"));
              case 78:
                _context92.prev = 78;
                _context92.next = 81;
                return e(Ac({
                  contact: n,
                  customerId: l,
                  productOrder: {
                    productOrderReferenceNumber: b,
                    productOrderItemId: g
                  },
                  isAnonymous: !1
                }));
              case 81:
                _context92.next = 86;
                break;
              case 83:
                _context92.prev = 83;
                _context92.t6 = _context92["catch"](78);
                return _context92.abrupt("return", _("RECONTRACT_GENERIC_ERROR", "Error from apiAddCustomerContact"));
              case 86:
                return _context92.abrupt("return", (e({
                  type: "GA_TRACKING_RECONTRACT_ORDER_IDS",
                  payload: {
                    productOrderReferenceNumber: b
                  }
                }), e(xa({
                  productOrderId: N,
                  productOrderReferenceNumber: b,
                  productOrderItemId: g,
                  productId: h,
                  type: "RECON",
                  service: r,
                  preTickAddonsBoIds: (null === (S = Y) || void 0 === S ? void 0 : S.preTickAddonsBoIds) || []
                }))));
              case 87:
              case "end":
                return _context92.stop();
            }
          }
        }, _callee92, null, [[2, 10], [13, 24], [39, 46], [57, 75], [78, 83]]);
      }));
      return function (_x88) {
        return _ref129.apply(this, arguments);
      };
    }();
  },
  updateOrderToRunRules: yc,
  addSimToOrder: function addSimToOrder(e) {
    var t = e.customerId,
      r = e.productOrderItemId,
      n = e.simProductId,
      _e$simType = e.simType,
      o = _e$simType === void 0 ? c : _e$simType;
    return /*#__PURE__*/function () {
      var _ref134 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee93(e) {
        var i, _a6;
        return _regeneratorRuntime.wrap(function _callee93$(_context93) {
          while (1) {
            switch (_context93.prev = _context93.next) {
              case 0:
                i = {
                  UpdateProductInOrderConfigurationRequest: {
                    runCompatibilityRules: !0,
                    activityForConfiguration: "SD Add Comp Stage",
                    confirmationMessagesApproved: !1,
                    returnRemovedItems: !1,
                    configurationLevel: "FULL",
                    settingsView: "FULL",
                    updateEvenIfNotValid: !1,
                    returnConfiguration: "ALL",
                    productChanges: [{
                      removedContainedProducts: [],
                      changedContainedProducts: [{
                        productID: n,
                        changedCharacteristics: [{
                          characteristicID: 10382891,
                          value: "No"
                        }, {
                          characteristicID: "8858992",
                          value: null
                        }, {
                          characteristicID: "8022652",
                          value: o
                        }, {
                          characteristicID: 132395,
                          value: null
                        }]
                      }],
                      suspendedContainedProducts: [],
                      changedSimpleProducts: [],
                      newAssignedBillingOffers: [],
                      newContainedProducts: [],
                      newSimpleProducts: [],
                      removedSimpleProducts: [],
                      removedAssignedBillingOffers: [],
                      resumedContainedProducts: []
                    }],
                    returnConfigurationData: {
                      catalogDataInd: !0,
                      crossProductsDiscountsDataInd: !1,
                      previousQuotedRecurringPricesInd: !1,
                      productConfigurationInd: !0,
                      quotedPricesInd: !1,
                      quotedProrationInd: !1,
                      quotedTaxInd: !1,
                      summaryInd: !1
                    }
                  }
                };
                o === c && i.UpdateProductInOrderConfigurationRequest.productChanges[0].changedContainedProducts[0].changedCharacteristics.push({
                  characteristicID: "8832",
                  value: "381187630N"
                }), e({
                  type: "ADD_SIM_TO_ORDER_LOADING"
                });
                _context93.prev = 2;
                _context93.next = 5;
                return nn({
                  customerId: t,
                  productOrderItemId: r,
                  payload: i
                });
              case 5:
                _a6 = _context93.sent;
                return _context93.abrupt("return", (e({
                  type: rc
                }), e({
                  type: "SET_ORDER_SIM_CARD_DETAILS",
                  value: {
                    hasSim: !0,
                    productId: n,
                    is5GSim: o === c || void 0,
                    selectedSimType: Tc(_a6)
                  }
                }), e({
                  type: "ADD_SIM_TO_ORDER_SUCCESS"
                })));
              case 9:
                _context93.prev = 9;
                _context93.t0 = _context93["catch"](2);
                throw e({
                  type: "ADD_SIM_TO_ORDER_ERROR"
                }), _context93.t0;
              case 12:
              case "end":
                return _context93.stop();
            }
          }
        }, _callee93, null, [[2, 9]]);
      }));
      return function (_x93) {
        return _ref134.apply(this, arguments);
      };
    }();
  },
  addAccessoriesFromOrder: function addAccessoriesFromOrder(_ref135) {
    var e = _ref135.customerId,
      t = _ref135.productOrderItemId,
      r = _ref135.productSpecId;
    return /*#__PURE__*/function () {
      var _ref136 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee94(n) {
        return _regeneratorRuntime.wrap(function _callee94$(_context94) {
          while (1) {
            switch (_context94.prev = _context94.next) {
              case 0:
                _context94.prev = 0;
                n({
                  type: "ADD_ACCESSORIES_LOADING"
                });
                _context94.next = 4;
                return nn({
                  customerId: e,
                  productOrderItemId: t,
                  payload: Qo({
                    type: "AD",
                    productSpecID: r
                  })
                });
              case 4:
                n({
                  type: "ADD_ACCESSORIES_SUCCESS",
                  value: r
                });
                return _context94.abrupt("return", !0);
              case 8:
                _context94.prev = 8;
                _context94.t0 = _context94["catch"](0);
                return _context94.abrupt("return", (n({
                  type: "ADD_ACCESSORIES_ERROR"
                }), !1));
              case 11:
              case "end":
                return _context94.stop();
            }
          }
        }, _callee94, null, [[0, 8]]);
      }));
      return function (_x94) {
        return _ref136.apply(this, arguments);
      };
    }();
  },
  removeAccessoriesFromOrder: function removeAccessoriesFromOrder(_ref137) {
    var e = _ref137.customerId,
      t = _ref137.productOrderItemId,
      r = _ref137.productId;
    return /*#__PURE__*/function () {
      var _ref138 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee95(n) {
        return _regeneratorRuntime.wrap(function _callee95$(_context95) {
          while (1) {
            switch (_context95.prev = _context95.next) {
              case 0:
                _context95.prev = 0;
                n({
                  type: "REMOVE_ACCESSORIES_LOADING"
                });
                _context95.next = 4;
                return nn({
                  customerId: e,
                  productOrderItemId: t,
                  payload: Qo({
                    type: "RM",
                    productID: r
                  })
                });
              case 4:
                n({
                  type: "REMOVE_ACCESSORIES_SUCCESS"
                });
                return _context95.abrupt("return", !0);
              case 8:
                _context95.prev = 8;
                _context95.t0 = _context95["catch"](0);
                return _context95.abrupt("return", (n({
                  type: "REMOVE_ACCESSORIES_ERROR"
                }), !1));
              case 11:
              case "end":
                return _context95.stop();
            }
          }
        }, _callee95, null, [[0, 8]]);
      }));
      return function (_x95) {
        return _ref138.apply(this, arguments);
      };
    }();
  },
  addCustomerContact: Ac,
  removeContainedProductsFromOrder: Dc,
  handlePortInOrder: function handlePortInOrder(e) {
    var t = e.contactId,
      r = e.serviceNumber,
      n = e.simpleProductSpecId,
      o = e.planId,
      a = e.planRelId,
      c = e.basePriceSchemaId,
      d = e.telcoType,
      s = e.preTickAddons,
      _e$selectedProduct4 = e.selectedProduct,
      u = _e$selectedProduct4 === void 0 ? null : _e$selectedProduct4,
      l = e.simCardType,
      p = e.planTags,
      I = e.contact,
      m = e.cisDetails,
      E = e.accessories;
    return /*#__PURE__*/function () {
      var _ref139 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee101(e) {
        var R, S, _, O, C, f, y, _e57, _e58, _r34, T, A, D, P, v, _e59, h, g, N, b, L, U, M, w, _t44, _r35, _n21;
        return _regeneratorRuntime.wrap(function _callee101$(_context101) {
          while (1) {
            switch (_context101.prev = _context101.next) {
              case 0:
                S = function S(t) {
                  return e(Ha({
                    errorMsg: "PORT_IN_" + t
                  }));
                };
                e({
                  type: "SET_PRODUCT_ORDER_LOADING",
                  value: !0
                });
                _context101.prev = 2;
                _context101.next = 5;
                return function () {
                  var _ref140 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee96(e) {
                    var t, r;
                    return _regeneratorRuntime.wrap(function _callee96$(_context96) {
                      while (1) {
                        switch (_context96.prev = _context96.next) {
                          case 0:
                            t = e.contactId, r = "".concat(i, "/contact-person/").concat(t, "/retrievePrepaidSubscriptions");
                            _context96.next = 3;
                            return nt(r, {
                              method: "GET",
                              queryParams: {
                                sc: "SS",
                                lo: "en_US"
                              }
                            });
                          case 3:
                            return _context96.abrupt("return", _context96.sent.ImplRetrievePrepaidSubsOutput.products);
                          case 4:
                          case "end":
                            return _context96.stop();
                        }
                      }
                    }, _callee96);
                  }));
                  return function (_x97) {
                    return _ref140.apply(this, arguments);
                  };
                }()({
                  contactId: t
                });
              case 5:
                _ = _context101.sent;
                _context101.next = 11;
                break;
              case 8:
                _context101.prev = 8;
                _context101.t0 = _context101["catch"](2);
                return _context101.abrupt("return", S("GENERIC_ERROR"));
              case 11:
                f = _.find(function (e) {
                  return e.serviceId === r;
                });
                _context101.prev = 12;
                _context101.next = 15;
                return vt({
                  customerId: f.customerIdX8,
                  productId: f.id
                });
              case 15:
                O = _context101.sent;
                _context101.next = 21;
                break;
              case 18:
                _context101.prev = 18;
                _context101.t1 = _context101["catch"](12);
                return _context101.abrupt("return", S("GENERIC_ERROR"));
              case 21:
                y = Nt(O.services);
                _context101.prev = 22;
                _context101.next = 25;
                return function () {
                  var _ref141 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee97(e) {
                    var t, r;
                    return _regeneratorRuntime.wrap(function _callee97$(_context97) {
                      while (1) {
                        switch (_context97.prev = _context97.next) {
                          case 0:
                            t = e.contactId, r = "".concat(i, "/contact/").concat(t, "/findCustomer");
                            _context97.next = 3;
                            return nt(r, {
                              method: "GET",
                              queryParams: {
                                sc: "SS",
                                lo: "en_US"
                              }
                            });
                          case 3:
                            return _context97.abrupt("return", _context97.sent.ImplFindCustomerOutput);
                          case 4:
                          case "end":
                            return _context97.stop();
                        }
                      }
                    }, _callee97);
                  }));
                  return function (_x98) {
                    return _ref141.apply(this, arguments);
                  };
                }()({
                  contactId: t
                });
              case 25:
                C = _context101.sent;
                _context101.next = 31;
                break;
              case 28:
                _context101.prev = 28;
                _context101.t2 = _context101["catch"](22);
                return _context101.abrupt("return", S("GENERIC_ERROR"));
              case 31:
                _context101.prev = 31;
                _context101.next = 34;
                return cn(f.customerIdX8, f.id);
              case 34:
                _e57 = _context101.sent;
                if (!ut(_e57.pendingComponents)) {
                  _context101.next = 37;
                  break;
                }
                return _context101.abrupt("return", S("PENDING_ORDER"));
              case 37:
                _context101.next = 42;
                break;
              case 39:
                _context101.prev = 39;
                _context101.t3 = _context101["catch"](31);
                return _context101.abrupt("return", S("GENERIC_ERROR"));
              case 42:
                _context101.prev = 42;
                _context101.next = 45;
                return function (_ref142) {
                  var e = _ref142.contactId,
                    t = _ref142.customerId,
                    r = _ref142.productId;
                  return nt("".concat(i, "/contact/").concat(e, "/customer/").concat(t, "/product/").concat(r, "/orders"), {
                    method: "GET",
                    queryParams: {
                      apid: r,
                      checkPayment: !0,
                      sc: "SS",
                      lo: "en_US"
                    }
                  }).then(function (e) {
                    return e.ImplContactCustomerOrdersResponse.implOrderHeaderList || [];
                  });
                }({
                  contactId: t,
                  customerId: f.customerIdX8,
                  productId: f.id
                });
              case 45:
                _e58 = _context101.sent;
                if (!st(_e58)) {
                  _context101.next = 48;
                  break;
                }
                return _context101.abrupt("return", S("PENDING_ORDER"));
              case 48:
                _r34 = lt(f.id, _e58);
                _context101.next = 51;
                return Ye(_r34, /*#__PURE__*/function () {
                  var _ref143 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee98(e) {
                    return _regeneratorRuntime.wrap(function _callee98$(_context98) {
                      while (1) {
                        switch (_context98.prev = _context98.next) {
                          case 0:
                            _context98.next = 2;
                            return we({
                              customerId: f.customerIdX8,
                              productOrderId: e.orderId,
                              productOrderItemId: e.orderActionId
                            });
                          case 2:
                          case "end":
                            return _context98.stop();
                        }
                      }
                    }, _callee98);
                  }));
                  return function (_x99) {
                    return _ref143.apply(this, arguments);
                  };
                }());
              case 51:
                _context101.next = 56;
                break;
              case 53:
                _context101.prev = 53;
                _context101.t4 = _context101["catch"](42);
                return _context101.abrupt("return", S("GENERIC_ERROR"));
              case 56:
                T = [], A = [], D = [], P = [];
                if (y.id && P.push({
                  productID: y.id,
                  changedCharacteristics: [{
                    characteristicID: 10382891,
                    value: "No"
                  }, {
                    characteristicID: "8858992",
                    value: null
                  }, {
                    characteristicID: "8022652",
                    value: l
                  }, {
                    characteristicID: 132395,
                    value: null
                  }]
                }), I && !m) {
                  ja(p, I).productSpecContainmentID && T.push(ja(p, I));
                }
                n && (T.push({
                  productSpecContainmentID: "10482",
                  temporaryID: xe()
                }), A.push({
                  businessType: "DEVICE",
                  simpleProductSpecID: n,
                  temporaryID: xe()
                }), Wa(A, E));
                _context101.prev = 59;
                _e59 = {
                  factor: 1
                };
                _context101.next = 63;
                return rn( /*#__PURE__*/function () {
                  var _ref144 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee100(e) {
                    var r;
                    return _regeneratorRuntime.wrap(function _callee100$(_context100) {
                      while (1) {
                        switch (_context100.prev = _context100.next) {
                          case 0:
                            _context100.next = 2;
                            return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee99() {
                              return _regeneratorRuntime.wrap(function _callee99$(_context99) {
                                while (1) {
                                  switch (_context99.prev = _context99.next) {
                                    case 0:
                                      _context99.next = 2;
                                      return an({
                                        contactId: t,
                                        customerId: f.customerIdX8,
                                        serviceId: f.id,
                                        subscriptionId: f.subscriptionId,
                                        orderActionReason: "PREPOS",
                                        orderActionType: "CW",
                                        newContainedProducts: T,
                                        newSimpleProducts: A,
                                        removedContainedProducts: D,
                                        changedContainedProducts: P,
                                        planId: o,
                                        planRelId: a,
                                        basePriceSchemaId: c,
                                        newCustomerId: C.customerId
                                      });
                                    case 2:
                                      return _context99.abrupt("return", _context99.sent);
                                    case 3:
                                    case "end":
                                      return _context99.stop();
                                  }
                                }
                              }, _callee99);
                            }))();
                          case 2:
                            r = _context100.sent;
                            return _context100.abrupt("return", r.errorInfo ? e(r.errorInfo[0]) : r);
                          case 4:
                          case "end":
                            return _context100.stop();
                        }
                      }
                    }, _callee100);
                  }));
                  return function (_x100) {
                    return _ref144.apply(this, arguments);
                  };
                }(), _e59);
              case 63:
                v = _context101.sent;
                _context101.next = 69;
                break;
              case 66:
                _context101.prev = 66;
                _context101.t5 = _context101["catch"](59);
                return _context101.abrupt("return", S("GENERIC_ERROR"));
              case 69:
                h = v.updateProductConfigurationResponse, g = h.productsInReplaceProductOffering[0].products[0], N = g.productID, b = g.productOrderItemID, L = h.productOrderID, U = h.productOrderReferenceNumber, M = (g.productConfiguration.displayableItems, {
                  UpdateProductInOrderConfigurationRequest: {
                    runCompatibilityRules: !0,
                    addDefaultChildItemsImplicitly: !0,
                    activityForConfiguration: "NPCFirstLoad",
                    confirmationMessagesApproved: !1,
                    returnRemovedItems: !1,
                    configurationLevel: "FULL",
                    settingsView: "FULL",
                    updateEvenIfNotValid: !1,
                    returnConfiguration: "ALL",
                    productChanges: [{
                      removedContainedProducts: [],
                      changedContainedProducts: [].concat(P, [{
                        productID: N
                      }]),
                      suspendedContainedProducts: [],
                      changedSimpleProducts: [],
                      newAssignedBillingOffers: [],
                      newContainedProducts: [],
                      newSimpleProducts: [],
                      removedAssignedBillingOffers: [],
                      resumedContainedProducts: []
                    }],
                    returnConfigurationData: {
                      catalogDataInd: !0,
                      crossProductsDiscountsDataInd: !0,
                      previousQuotedRecurringPricesInd: !1,
                      productConfigurationInd: !0,
                      quotedPricesInd: !1,
                      quotedProrationInd: !1,
                      quotedTaxInd: !1,
                      summaryInd: !1
                    }
                  }
                });
                _context101.prev = 70;
                _context101.next = 73;
                return nn({
                  customerId: C.customerId,
                  productOrderItemId: b,
                  payload: M
                });
              case 73:
                _t44 = _context101.sent;
                _r35 = _t44.productConfiguration;
                _n21 = Qa(_r35);
                if (!_n21) {
                  _context101.next = 78;
                  break;
                }
                return _context101.abrupt("return", (e(ec(_n21, "ADDONS")), S("GENERIC_ERROR")));
              case 78:
                _context101.t6 = s;
                if (!_context101.t6) {
                  _context101.next = 83;
                  break;
                }
                _context101.next = 82;
                return e($a({
                  preTickAddons: s,
                  displayableItems: _r35.displayableItems,
                  order: {
                    productOrderId: L,
                    productOrderItemId: b
                  },
                  planId: o,
                  transactionType: "portin",
                  selectedProduct: u,
                  displayableSimpleProductReferences: (null == _r35 ? void 0 : _r35.displayableSimpleProductReferences) || []
                }));
              case 82:
                w = _context101.sent;
              case 83:
                _context101.next = 88;
                break;
              case 85:
                _context101.prev = 85;
                _context101.t7 = _context101["catch"](70);
                return _context101.abrupt("return", S("GENERIC_ERROR"));
              case 88:
                return _context101.abrupt("return", e(xa({
                  productOrderId: L,
                  productOrderReferenceNumber: U,
                  productOrderItemId: b,
                  productId: N,
                  type: "PORT-IN",
                  telcoType: d,
                  changeOwnershipRequired: !1,
                  preTickAddonsBoIds: (null === (R = w) || void 0 === R ? void 0 : R.preTickAddonsBoIds) || []
                })));
              case 89:
              case "end":
                return _context101.stop();
            }
          }
        }, _callee101, null, [[2, 8], [12, 18], [22, 28], [31, 39], [42, 53], [59, 66], [70, 85]]);
      }));
      return function (_x96) {
        return _ref139.apply(this, arguments);
      };
    }();
  },
  createPortinOrder: function createPortinOrder(e) {
    return /*#__PURE__*/function () {
      var _ref146 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee102(t) {
        var _e$hasSpecialPromo2, r, n, o, i, a, c, d, s, _e$selectedProduct5, u, l, p, I, m, E, R, S, _, _e60, _r36, _o13, _i14, _e61, _o14, _e61$displayableSimpl, _a7, _s5, _r37;
        return _regeneratorRuntime.wrap(function _callee102$(_context102) {
          while (1) {
            switch (_context102.prev = _context102.next) {
              case 0:
                _e$hasSpecialPromo2 = e.hasSpecialPromo, r = _e$hasSpecialPromo2 === void 0 ? "" : _e$hasSpecialPromo2, n = e.planId, o = e.planRelId, i = e.simpleProductSpecId, a = e.portinNumber, c = e.cisDetails, d = e.preTickAddons, s = e.monthlyTerm, _e$selectedProduct5 = e.selectedProduct, u = _e$selectedProduct5 === void 0 ? null : _e$selectedProduct5, l = e.simCardType, p = e.planTags, I = e.contact, m = e.accessories;
                t({
                  type: "SET_PRODUCT_ORDER_LOADING",
                  value: !0
                });
                _context102.prev = 2;
                _context102.next = 5;
                return t(qa({}));
              case 5:
                E = _context102.sent;
                _context102.next = 11;
                break;
              case 8:
                _context102.prev = 8;
                _context102.t0 = _context102["catch"](2);
                E = null;
              case 11:
                R = {
                  simpleProductSpecId: i,
                  cisDetails: c,
                  planId: n,
                  planRelId: o,
                  customerId: E,
                  monthlyTerm: s,
                  simCardType: l,
                  planTags: p,
                  contact: I,
                  accessories: m
                };
                _context102.prev = 12;
                _context102.next = 15;
                return t(Xa(R));
              case 15:
                S = _context102.sent;
                _context102.next = 21;
                break;
              case 18:
                _context102.prev = 18;
                _context102.t1 = _context102["catch"](12);
                return _context102.abrupt("return", t(Ha(_context102.t1.response.status)));
              case 21:
                if (!I) {
                  _context102.next = 29;
                  break;
                }
                _context102.prev = 22;
                _context102.next = 25;
                return t(Ac({
                  contact: I,
                  customerId: E,
                  productOrder: S,
                  isAnonymous: !1
                }));
              case 25:
                _context102.next = 29;
                break;
              case 27:
                _context102.prev = 27;
                _context102.t2 = _context102["catch"](22);
              case 29:
                if (!r) {
                  _context102.next = 38;
                  break;
                }
                _context102.prev = 30;
                _context102.next = 33;
                return t(Za(_objectSpread(_objectSpread({}, r && {
                  promoString: r,
                  specialPromo: !0
                }), {}, {
                  productOrderId: S.productOrderId,
                  updateProducts: !0
                })));
              case 33:
                _context102.next = 38;
                break;
              case 35:
                _context102.prev = 35;
                _context102.t3 = _context102["catch"](30);
                return _context102.abrupt("return", t(Ha(_context102.t3.response && _context102.t3.response.status)));
              case 38:
                _context102.prev = 38;
                _e60 = {
                  order: S,
                  portinNumber: a,
                  returnFullResponse: !0,
                  setFirstLoad: !0
                };
                _context102.next = 42;
                return t(Ec(_e60));
              case 42:
                _r36 = _context102.sent;
                _context102.t4 = _r36.status;
                _context102.next = _context102.t4 === "Success" ? 46 : _context102.t4 === "SingtelPostpaid" ? 46 : _context102.t4 === "SingtelPrepaid" ? 46 : 47;
                break;
              case 46:
                return _context102.abrupt("break", 48);
              case 47:
                throw new Error("PORT_IN_SUBMITTED_ORDER_FOUND");
              case 48:
                _o13 = T[_r36.status.toUpperCase()];
                if (!(d && _o13 === T.SUCCESS)) {
                  _context102.next = 54;
                  break;
                }
                _e61 = _r36.updateOrderResponse.productConfiguration, _o14 = _e61.displayableItems, _e61$displayableSimpl = _e61.displayableSimpleProductReferences, _a7 = _e61$displayableSimpl === void 0 ? [] : _e61$displayableSimpl;
                _context102.next = 53;
                return t($a({
                  preTickAddons: d,
                  displayableItems: _o14,
                  order: S,
                  cisDetails: c,
                  planId: n,
                  transactionType: "portin",
                  selectedProduct: u,
                  displayableSimpleProductReferences: _a7
                }));
              case 53:
                _i14 = _context102.sent;
              case 54:
                _o13 === T.SUCCESS && t({
                  type: "GA_TRACKING_PORT_IN_SUCCESS"
                });
                _s5 = {
                  productOrderId: S.productOrderId,
                  productOrderReferenceNumber: S.productOrderReferenceNumber,
                  productOrderItemId: S.productOrderItemId,
                  productId: S.productId,
                  type: "PORT-IN",
                  telcoType: _o13,
                  changeOwnershipRequired: !0,
                  preTickAddonsBoIds: (null === (_ = _i14) || void 0 === _ ? void 0 : _.preTickAddonsBoIds) || []
                };
                return _context102.abrupt("return", t(xa(_s5)));
              case 59:
                _context102.prev = 59;
                _context102.t5 = _context102["catch"](38);
                _r37 = {};
                return _context102.abrupt("return", (_r37 = "PORT_IN_SUBMITTED_ORDER_FOUND" === _context102.t5.message ? {
                  type: "portIn",
                  status: "PORT_IN_SUBMITTED_ORDER_FOUND"
                } : {
                  type: "portIn",
                  status: "PORT_IN_NUMBER_GENERIC_ERROR"
                }, t(Ha(_r37))));
              case 63:
              case "end":
                return _context102.stop();
            }
          }
        }, _callee102, null, [[2, 8], [12, 18], [22, 27], [30, 35], [38, 59]]);
      }));
      return function (_x101) {
        return _ref146.apply(this, arguments);
      };
    }();
  }
});
var _Sr$RRP_ORDER_SUMMARY = Sr.RRP_ORDER_SUMMARY,
  vc = _Sr$RRP_ORDER_SUMMARY.RRP_ORDER_SUMMARY_LOADING,
  hc = _Sr$RRP_ORDER_SUMMARY.RRP_ORDER_SUMMARY_SUCCESS,
  gc = _Sr$RRP_ORDER_SUMMARY.RRP_ORDER_SUMMARY_ERROR,
  Nc = _Sr$RRP_ORDER_SUMMARY.RRP_PROMO_CODE_LOADING,
  bc = _Sr$RRP_ORDER_SUMMARY.RRP_PROMO_CODE_SUCCESS,
  Lc = _Sr$RRP_ORDER_SUMMARY.RRP_PROMO_CODE_ERROR,
  Uc = _Sr$RRP_ORDER_SUMMARY.RRP_PAYMENT_REQUEST_LOADING,
  Mc = _Sr$RRP_ORDER_SUMMARY.RRP_PAYMENT_REQUEST_SUCCESS,
  wc = _Sr$RRP_ORDER_SUMMARY.RRP_PAYMENT_REQUEST_ERROR,
  Gc = function Gc() {
    return {
      type: Nc
    };
  },
  Fc = function Fc(e) {
    return {
      type: bc,
      value: e
    };
  },
  kc = function kc(e) {
    return {
      type: Lc,
      value: e
    };
  };
var Bc = Object.freeze({
  __proto__: null,
  rrpAddPromoCode: function rrpAddPromoCode(e) {
    return /*#__PURE__*/function () {
      var _ref147 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee103(t) {
        var r, o, a, _e62, _n22, _JSON$parse, _t45;
        return _regeneratorRuntime.wrap(function _callee103$(_context103) {
          while (1) {
            switch (_context103.prev = _context103.next) {
              case 0:
                t(Gc());
                r = e.promoCode, o = e.masterOrderId, a = e.orderId;
                _context103.prev = 2;
                _context103.next = 5;
                return function (e) {
                  var t = e.promoCode,
                    r = e.masterOrderId,
                    n = e.orderId;
                  return nt("".concat(i, "/rrp/order/rrp-master-order-id/").concat(r, "/rrp-order-id/").concat(n, "/apply-coupon"), {
                    method: "POST",
                    body: JSON.stringify({
                      ImplRRPApplyPromoRequest: {
                        couponCode: t.toUpperCase()
                      }
                    })
                  }).then(function (e) {
                    return e.ImplRRPApplyPromoResponse;
                  });
                }({
                  promoCode: r,
                  masterOrderId: o,
                  orderId: a
                });
              case 5:
                _e62 = _context103.sent;
                if (!((null == _e62 ? void 0 : _e62.result) === n.SUCCESS)) {
                  _context103.next = 8;
                  break;
                }
                return _context103.abrupt("return", (t(Fc({
                  promoCode: r,
                  masterOrderId: o,
                  orderId: a
                })), null == _e62 ? void 0 : _e62.result));
              case 8:
                throw new Error(null == _e62 ? void 0 : _e62.result);
              case 11:
                _context103.prev = 11;
                _context103.t0 = _context103["catch"](2);
                _n22 = {
                  promoCode: r,
                  masterOrderId: o,
                  orderId: a
                };
                if ((null == _context103.t0 ? void 0 : _context103.t0.message) && "string" == typeof _context103.t0.message) _n22.errorCode = _context103.t0.message;else if (_context103.t0.text) {
                  _JSON$parse = JSON.parse(_context103.t0.text), _t45 = _JSON$parse.ErrorInfo;
                  _n22.errorCode = null == _t45 ? void 0 : _t45.errorCode;
                } else _n22.errorCode = "Error from rrpAddPromoCode";
                return _context103.abrupt("return", t(kc(_n22)));
              case 16:
              case "end":
                return _context103.stop();
            }
          }
        }, _callee103, null, [[2, 11]]);
      }));
      return function (_x102) {
        return _ref147.apply(this, arguments);
      };
    }();
  },
  rrpRemovePromoCode: function rrpRemovePromoCode(e) {
    return /*#__PURE__*/function () {
      var _ref148 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee104(t) {
        var r, o, a, _e63, _n23, _JSON$parse2, _t46;
        return _regeneratorRuntime.wrap(function _callee104$(_context104) {
          while (1) {
            switch (_context104.prev = _context104.next) {
              case 0:
                t(Gc());
                r = e.promoCode, o = e.masterOrderId, a = e.orderId;
                _context104.prev = 2;
                _context104.next = 5;
                return function (e) {
                  var t = e.promoCode,
                    r = e.masterOrderId,
                    n = e.orderId;
                  return nt("".concat(i, "/rrp/order/rrp-master-order-id/").concat(r, "/rrp-order-id/").concat(n, "/remove-coupon"), {
                    method: "POST",
                    body: JSON.stringify({
                      ImplRRPApplyPromoRequest: {
                        couponCode: t.toUpperCase()
                      }
                    })
                  }).then(function (e) {
                    return e.ImplRRPApplyPromoResponse;
                  });
                }({
                  promoCode: r,
                  masterOrderId: o,
                  orderId: a
                });
              case 5:
                _e63 = _context104.sent;
                if (!((null == _e63 ? void 0 : _e63.result) === n.SUCCESS)) {
                  _context104.next = 8;
                  break;
                }
                return _context104.abrupt("return", (t(Fc()), null == _e63 ? void 0 : _e63.result));
              case 8:
                throw new Error(null == _e63 ? void 0 : _e63.result);
              case 11:
                _context104.prev = 11;
                _context104.t0 = _context104["catch"](2);
                _n23 = {
                  promoCode: r,
                  masterOrderId: o,
                  orderId: a
                };
                if ((null == _context104.t0 ? void 0 : _context104.t0.message) && "string" == typeof _context104.t0.message) _n23.errorCode = _context104.t0.message;else if (_context104.t0.text) {
                  _JSON$parse2 = JSON.parse(_context104.t0.text), _t46 = _JSON$parse2.ErrorInfo;
                  _n23.errorCode = null == _t46 ? void 0 : _t46.errorCode;
                } else _n23.errorCode = "Error from rrpRemovePromoCode";
                return _context104.abrupt("return", t(kc(_n23)));
              case 16:
              case "end":
                return _context104.stop();
            }
          }
        }, _callee104, null, [[2, 11]]);
      }));
      return function (_x103) {
        return _ref148.apply(this, arguments);
      };
    }();
  },
  getRrpOrderSummaryData: function getRrpOrderSummaryData(e) {
    return /*#__PURE__*/function () {
      var _ref149 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee105(t) {
        var r, n, o, _e64, _a8, _c12, _d7, s, a, _r39;
        return _regeneratorRuntime.wrap(function _callee105$(_context105) {
          while (1) {
            switch (_context105.prev = _context105.next) {
              case 0:
                t({
                  type: vc
                });
                r = e.masterOrderId;
                _context105.prev = 2;
                _context105.next = 5;
                return function (e) {
                  var t = e.masterOrderId;
                  return nt("".concat(i, "/rrp/order/rrp-master-order-id/").concat(t, "/retrieve-order-summary"), {
                    method: "GET",
                    queryParams: {
                      wq: !0,
                      os: !1
                    }
                  }).then(function (e) {
                    return e.ImplRRPRetrieveMasterOrderDetails;
                  });
                }({
                  masterOrderId: r
                });
              case 5:
                _e64 = _context105.sent;
                _c12 = function _c12(e) {
                  var t = [];
                  return e.forEach(function (e) {
                    var r = {};
                    if (r.items = e.orderItems.map(function (e) {
                      return {
                        brand: e.productDetails.brand,
                        color: e.productDetails.color,
                        model: e.productDetails.model,
                        price: e.productDetails.price,
                        title: e.productDetails.title,
                        quantity: e.quantity,
                        sku: e.sku,
                        finalAmount: e.actualPrice,
                        discountAmount: e.discountedPrice
                      };
                    }), e.promotions) for (var _t47 = 0; _t47 < e.promotions.length; _t47++) {
                      var _r38 = e.promotions[_t47];
                      if (_r38.couponCode && e.coupon && _r38.couponCode === e.coupon) {
                        _a8 = {
                          couponCode: _r38.couponCode,
                          orderId: e.orderId
                        };
                        break;
                      }
                    }
                    r.delivery = e.orderDeliveryDetails, r.promotions = e.promotions, r.finalAmount = e.actualPrice, r.originalAmount = e.retailPrice, r.discountAmount = e.discountedPrice, r.vendor = e.vendor, r.orderId = e.orderId, t.push(r);
                  }), t;
                }, _d7 = {}, s = ei(_e64.ImplRRPOrderDetails);
                return _context105.abrupt("return", (_d7.masterOrderId = _e64.masterOrderId, _d7.orders = _c12(s), _d7.finalAmount = _e64.actualPrice, _d7.originalAmount = _e64.retailPrice, _d7.discountAmount = _e64.discountedPrice, _d7.saveAmount = Bo(null == _e64 || null === (n = _e64.retailPrice) || void 0 === n ? void 0 : n.afterTax, null == _e64 || null === (o = _e64.actualPrice) || void 0 === o ? void 0 : o.afterTax), _d7.personalDetails = _e64.customerDetails, _d7.coupon = _a8, t({
                  type: hc,
                  value: _d7
                })));
              case 10:
                _context105.prev = 10;
                _context105.t0 = _context105["catch"](2);
                _r39 = {};
                return _context105.abrupt("return", ((null == _context105.t0 || null === (a = _context105.t0.text) || void 0 === a ? void 0 : a.ErrorInfo) ? _r39.errorCode = _context105.t0.text.ErrorInfo.errorCode : _r39.errorCode = "Error from getRrpOrderSummaryData", t(function (e) {
                  return {
                    type: gc,
                    value: e
                  };
                }(_r39))));
              case 14:
              case "end":
                return _context105.stop();
            }
          }
        }, _callee105, null, [[2, 10]]);
      }));
      return function (_x104) {
        return _ref149.apply(this, arguments);
      };
    }();
  },
  requestPayment: function requestPayment(e) {
    return /*#__PURE__*/function () {
      var _ref150 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee106(t) {
        var r, n, o, _e65, _a9;
        return _regeneratorRuntime.wrap(function _callee106$(_context106) {
          while (1) {
            switch (_context106.prev = _context106.next) {
              case 0:
                t({
                  type: Uc
                });
                r = e.customerInfo, n = e.order;
                o = [];
                _context106.prev = 3;
                _e65 = [];
                n.orders.forEach(function (t) {
                  var r = t.items.map(function (e) {
                    return {
                      sku: e.sku,
                      title: e.title,
                      finalAmount: e.finalAmount
                    };
                  });
                  o.push(t.orderId), _e65 = [].concat(_toConsumableArray(_e65), _toConsumableArray(r));
                });
                _context106.next = 8;
                return function (e) {
                  var t = e.order,
                    r = e.customerInfo,
                    n = e.successUrl,
                    o = e.failureUrl,
                    a = "".concat(i, "/rrp/payment/rrp-master-order-id/").concat(t.masterOrderId, "/onepay/V2/payment/requests"),
                    c = t.masterOrderId,
                    d = t.finalAmount,
                    s = t.orderItems,
                    u = t.orderIds,
                    l = {
                      rrpMasterOrderId: c,
                      msisdn: r.phone,
                      orderIds: u,
                      skuIds: s.map(function (e) {
                        return e.sku;
                      })
                    };
                  return nt(a, {
                    method: "POST",
                    queryParams: {
                      flowType: "rrp",
                      sc: "SS",
                      lo: "en_US"
                    },
                    body: JSON.stringify({
                      ImplRRPOnePayPaymentRequest: {
                        description: "Singtelshop.com purchase for " + c,
                        redirection_mode: "BROWSER",
                        merchant_data: JSON.stringify(l),
                        parameters: [{
                          name: "merchant_data",
                          value: JSON.stringify(l)
                        }],
                        redirect_urls: {
                          success_url: n,
                          failure_url: o
                        },
                        cart_details: {
                          total_amount_inc_gst: d.afterTax,
                          cart_items: s.map(function (e) {
                            return {
                              mobile_number: e.sku,
                              mobile_description: e.title,
                              device_amount: e.finalAmount.afterTax
                            };
                          })
                        },
                        implPaymentServiceIntentRequest: {
                          amount: d.afterTax,
                          currency: "SGD",
                          email: r.email,
                          mobile_number: r.phone,
                          merchant_data: JSON.stringify(l),
                          customer_Info: {
                            cust_name: r.name,
                            mobile_number: r.phone,
                            postal_code: r.postcode,
                            billing_address: r.billingAddress
                          },
                          cart_details: {
                            total_amount_bef_gst: d.beforeTax,
                            gst_amount: d.taxAmount,
                            total_amount_inc_gst: d.afterTax,
                            cart_items: s.map(function (e) {
                              return {
                                order_number: c,
                                device_description: e.title,
                                device_amount: e.finalAmount.afterTax
                              };
                            })
                          }
                        }
                      }
                    })
                  }).then(function (e) {
                    return e.ImplRRPOnePayPaymentResponse;
                  });
                }({
                  order: {
                    masterOrderId: n.masterOrderId,
                    finalAmount: n.finalAmount,
                    orderItems: _e65,
                    orderIds: o
                  },
                  customerInfo: {
                    name: r.name,
                    phone: r.phone,
                    postcode: r.postcode,
                    billingAddress: r.billingAddress,
                    email: r.email
                  },
                  successUrl: process.env.GATSBY_HOST + "/accessories/order-confirmation",
                  failureUrl: process.env.GATSBY_HOST + "/accessories/order-confirmation"
                });
              case 8:
                _a9 = _context106.sent;
                t({
                  type: Mc,
                  value: _a9
                });
                _context106.next = 15;
                break;
              case 12:
                _context106.prev = 12;
                _context106.t0 = _context106["catch"](3);
                return _context106.abrupt("return", t(function (e) {
                  return {
                    type: wc,
                    value: e
                  };
                }()));
              case 15:
              case "end":
                return _context106.stop();
            }
          }
        }, _callee106, null, [[3, 12]]);
      }));
      return function (_x105) {
        return _ref150.apply(this, arguments);
      };
    }();
  }
});
var Vc = Object.freeze({
  __proto__: null,
  setSelectedPlan: function setSelectedPlan(e) {
    return {
      type: "SET_SELECTED_PLAN",
      payload: e
    };
  }
});
var Yc = {
  user: Ut,
  auth: Ar,
  product: gt
};
var xc = Object.freeze({
  __proto__: null,
  resetAll: function resetAll() {
    return {
      type: "RESET_ALL"
    };
  },
  resetByKeys: function resetByKeys(e) {
    return /*#__PURE__*/function () {
      var _ref151 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee107(t) {
        return _regeneratorRuntime.wrap(function _callee107$(_context107) {
          while (1) {
            switch (_context107.prev = _context107.next) {
              case 0:
                e.forEach(function (e) {
                  t(Yc[e]());
                });
              case 1:
              case "end":
                return _context107.stop();
            }
          }
        }, _callee107);
      }));
      return function (_x106) {
        return _ref151.apply(this, arguments);
      };
    }();
  }
});
var Hc = function Hc(e) {
    var t = e.payload,
      r = e.productOrderId,
      _e$customerId = e.customerId,
      n = _e$customerId === void 0 ? "" : _e$customerId;
    var o = "".concat(i, "/ecommerce/anonymous/order/").concat(r, "/update-order-action-attributes");
    return n && (o = "".concat(i, "/ecommerce/customer/").concat(n, "/order/").concat(r, "/update-order-action-attributes")), nt(o, {
      method: "POST",
      queryParams: {
        sc: "SS",
        lo: "en_US"
      },
      body: JSON.stringify(t)
    }).then(function (e) {
      return e.ImplUpdateOrderActionsResponse;
    });
  },
  $c = {
    STORE_SELECTED_ACCESSORIES: "STORE_SELECTED_ACCESSORIES",
    CLEAR_SELECTED_ACCESSORIES: "CLEAR_SELECTED_ACCESSORIES",
    REMOVE_ACCESSORY: "REMOVE_ACCESSORY"
  },
  qc = function qc(e) {
    return {
      type: $c.REMOVE_ACCESSORY,
      value: e
    };
  };
var Wc = Object.freeze({
  __proto__: null,
  ACCESSORY_ACTIONS: $c,
  storeSelectedAccessories: function storeSelectedAccessories(e) {
    return {
      type: $c.STORE_SELECTED_ACCESSORIES,
      value: e
    };
  },
  clearSelectedAccessories: function clearSelectedAccessories() {
    return {
      type: $c.CLEAR_SELECTED_ACCESSORIES
    };
  },
  removeAccessory: qc
});
var Xc = function Xc() {
    return {
      type: ad.ADDONS_FETCH_ERROR
    };
  },
  jc = function jc(e) {
    return {
      type: ad.ADDON_ADD_LOADING,
      value: e
    };
  },
  Kc = function Kc(e) {
    return {
      type: ad.ADDON_ADD_SUCCESS,
      value: e
    };
  },
  Jc = function Jc(e) {
    return {
      type: ad.ADDON_ADD_ERROR,
      value: e
    };
  },
  Zc = function Zc(e) {
    var t = e.addon,
      r = e.changedCharacteristic,
      n = xe();
    var o, i;
    var a = t.productSpecContainmentID,
      c = t.productSpecPricingID;
    return o = {
      productSpecPricingID: c,
      parentProductSpecContainmentID: a,
      parentTemporaryID: n
    }, i = {
      productSpecContainmentID: a,
      temporaryID: n,
      parentProductSpecContainmentID: t.parentProductSpecContainmentID,
      parentProductID: t.parentProductID,
      changedCharacteristics: kn(t.displayableCharacteristics, r)
    }, {
      newAssignedBillingOffers: o,
      newContainedProducts: i,
      newSimpleProducts: void 0
    };
  },
  zc = function zc(e) {
    var t = [];
    return t.push({
      productID: e.parentDisplayableItemProductId ? e.parentDisplayableItemProductId : e.productID
    }), t;
  },
  Qc = function Qc(e) {
    var t = e.addon,
      r = e.changedCharacteristic,
      n = xe();
    var o, i, a;
    var c = t.productID,
      d = t.productSpecContainmentID,
      s = t.productSpecPricingID;
    return t.atomic ? a = {
      temporaryID: n,
      productSpecContainmentID: "10141011",
      simpleProductSpecID: t.productSpecContainmentID
    } : !c || I.includes(d) ? (o = {
      productSpecPricingID: s,
      parentProductSpecContainmentID: d,
      parentTemporaryID: n
    }, i = {
      productSpecContainmentID: d,
      temporaryID: n,
      parentProductSpecContainmentID: t.parentProductSpecContainmentID,
      parentProductID: t.parentProductID,
      changedCharacteristics: kn(t.displayableCharacteristics, r)
    }) : o = {
      productSpecPricingID: s,
      parentProductSpecContainmentID: d,
      parentProductID: c
    }, {
      newAssignedBillingOffers: o,
      newContainedProducts: i,
      newSimpleProducts: a
    };
  },
  ed = function ed(e) {
    var t = e.removedAddon,
      r = t.productSpecContainmentID,
      n = [],
      o = [];
    return m.includes(r) ? n.push({
      productID: t.parentDisplayableItemProductId ? t.parentDisplayableItemProductId : t.productID
    }) : E.includes(r) ? 1 === t.grandParentSpecCount ? n.push({
      productID: t.parentProductID
    }) : n.push({
      productID: t.productID
    }) : t.billingOfferID && o.push({
      billingOfferID: t.billingOfferID,
      productSpecPricingID: t.productSpecPricingID
    }), {
      removedAssignedBillingOffers: o,
      removedContainedProducts: n
    };
  },
  td = function td(e) {
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee108() {
      var t, r;
      return _regeneratorRuntime.wrap(function _callee108$(_context108) {
        while (1) {
          switch (_context108.prev = _context108.next) {
            case 0:
              t = e.customerId, r = e.productOrderItemId;
              return _context108.abrupt("return", sn({
                customerId: t,
                productOrderItemId: r,
                payload: {
                  RetrieveProductInOrderConfigurationRequest: {
                    activityForConfiguration: "SD Add Comp Stage",
                    configurationLevel: "FULL",
                    settingsView: "FULL",
                    loadFirstStep: !1,
                    stepIDs: [],
                    serviceRequiredDate: null,
                    returnConfigurationData: {
                      catalogDataInd: !0,
                      crossProductsDiscountsDataInd: !0,
                      previousQuotedRecurringPricesInd: !1,
                      productConfigurationInd: !0,
                      quotedPricesInd: !0,
                      quotedProrationInd: !0,
                      quotedTaxInd: !0,
                      summaryInd: !0
                    }
                  }
                }
              }));
            case 2:
            case "end":
              return _context108.stop();
          }
        }
      }, _callee108);
    }));
  };
function rd(_ref153) {
  var e = _ref153.displayableItem,
    t = _ref153.occurrencesInDisplayableItems,
    r = _ref153.billingOffers;
  var n = e.displayableBillingOffers,
    o = e.productSpecContainment,
    i = o.maximumQuantity;
  if (o) {
    if (Fo(e)) {
      return e.selected && (!e.action || "AD" !== e.action) && t >= i;
    }
    if (Yn(e.productSpecContainmentID)) {
      return n.map(function (e) {
        return r[e];
      }).filter(function (e) {
        return e.selected;
      }).length >= i;
    }
  }
  return !1;
}
var nd = function nd(_ref154) {
    var e = _ref154.productConfig,
      t = _ref154.productOrderItemId,
      r = _ref154.orderActionsPayload,
      _ref154$selectedAddon = _ref154.selectedAddons,
      n = _ref154$selectedAddon === void 0 ? [] : _ref154$selectedAddon,
      o = _ref154.tradeInProductSpecContainmentId,
      i = _ref154.specialPromoCode;
    var _r$indentType = r.indentType,
      a = _r$indentType === void 0 ? "" : _r$indentType,
      _r$indentValue = r.indentValue,
      c = _r$indentValue === void 0 ? "" : _r$indentValue,
      _r$selectedAddonsPayl = r.selectedAddonsPayload,
      d = _r$selectedAddonsPayl === void 0 ? !0 : _r$selectedAddonsPayl,
      _ref155 = e || {},
      s = _ref155.productConfiguration,
      u = _ref155.productOrderItemType,
      _ref156 = s || {},
      l = _ref156.displayableItems,
      p = _ref156.rootProductOfferingID,
      I = zo(l),
      m = Zo({
        displayableItems: l,
        productOrderItemType: u
      }),
      E = Jo(l),
      R = Ko(l),
      S = {
        name: "OFFERID",
        value: p
      },
      _ = {
        name: "TRANSACTION_TYPE",
        value: Kn(m)
      },
      O = {
        name: "CI_TIER",
        value: E
      },
      C = {
        name: "SEGMENT",
        value: jn(R)
      },
      f = {
        name: "VAS",
        value: d ? n.join(",") : oo(l, o)
      };
    return {
      ImplUpdateOrderDetailRequest: {
        orderActionData: [{
          orderActionId: t,
          orderActionType: u,
          attributes: [_objectSpread({}, S), _objectSpread({}, {
            name: "BRAND",
            value: I ? I.brand : ""
          }), _objectSpread({}, {
            name: "MODEL",
            value: I ? (I.model + "").replaceAll("_", " ") : ""
          }), _objectSpread({}, _), _objectSpread({}, O), _objectSpread({}, C), _objectSpread({}, {
            name: "SUB_SEGMENT",
            value: Xn(r)
          }), _objectSpread({}, f), _objectSpread({}, {
            name: "TARGETED",
            value: c
          }), _objectSpread({}, {
            name: "Document_Type",
            value: a
          }), _objectSpread({}, i && {
            name: "PICKNGO",
            value: i
          })].filter(function (e) {
            return e && e.value;
          })
        }]
      }
    };
  },
  od = function od(e) {
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee109() {
      var t, r, n, o, i, a, c, d;
      return _regeneratorRuntime.wrap(function _callee109$(_context109) {
        while (1) {
          switch (_context109.prev = _context109.next) {
            case 0:
              t = e.customerId, r = e.res, n = e.productOrderId, o = e.productOrderItemId, i = e.orderActionsPayload, a = e.selectedAddons, c = e.tradeInProductSpecContainmentId, d = e.specialPromoCode;
              return _context109.abrupt("return", Hc({
                customerId: t,
                productOrderId: n,
                payload: nd({
                  productConfig: r,
                  orderActionsPayload: i,
                  productOrderItemId: o,
                  selectedAddons: a,
                  tradeInProductSpecContainmentId: c,
                  specialPromoCode: d
                })
              }));
            case 2:
            case "end":
              return _context109.stop();
          }
        }
      }, _callee109);
    }));
  };
var id = function id(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  return function (r) {
    var n = {
        isError: !1,
        messages: []
      },
      o = Qa(e);
    return o && (n.isError = !0, r(ec(o, t)), o.forEach(function (e) {
      "ERROR" === e.severity && -1 == n.messages.indexOf(e.text) && n.messages.push(e.text);
    })), n;
  };
};
var ad = {
  ADDON_SIM_ONLY_ADD_LOADING: "ADDON_SIM_ONLY_ADD_LOADING",
  ADDON_SIM_ONLY_ADD_SUCCESS: "ADDON_SIM_ONLY_ADD_SUCCESS",
  ADDONS_FETCH_LOADING: "ADDONS_FETCH_LOADING",
  ADDONS_FETCH_SUCCESS: "ADDONS_FETCH_SUCCESS",
  ADDONS_FETCH_ERROR: "ADDONS_FETCH_ERROR",
  ADDON_ADD_LOADING: "ADDON_ADD_LOADING",
  ADDON_ADD_SUCCESS: "ADDON_ADD_SUCCESS",
  ADDON_ADD_ERROR: "ADDON_ADD_ERROR",
  ADDON_REMOVE_LOADING: "ADDON_REMOVE_LOADING",
  ADDON_REMOVE_SUCCESS: "ADDON_REMOVE_SUCCESS",
  ADDON_REMOVE_ERROR: "ADDON_REMOVE_ERROR",
  ADDON_UPGRADE_LOADING: "ADDON_UPGRADE_LOADING",
  ADDON_UPGRADE_SUCCESS: "ADDON_UPGRADE_SUCCESS",
  ADDON_UPGRADE_ERROR: "ADDON_UPGRADE_ERROR",
  SET_ORDER_SIM_CARD_DETAILS: "SET_ORDER_SIM_CARD_DETAILS",
  UPDATE_ORDER_ACTION_SUCCESS: "UPDATE_ORDER_ACTION_SUCCESS",
  ADDON_REMOVE_ADD_LOADING: "ADDON_REMOVE_ADD_LOADING",
  ADDON_REMOVE_ADD_SUCCESS: "ADDON_REMOVE_ADD_SUCCESS",
  ADDON_REMOVE_ADD_ERROR: "ADDON_REMOVE_ADD_ERROR"
};
var cd = Object.freeze({
  __proto__: null,
  processAppleCareAddons: function processAppleCareAddons(_ref158) {
    var e = _ref158.devices,
      t = _ref158.addons;
    var r = {};
    return t.map(function (_ref159) {
      var t = _ref159.phoneList,
        n = _ref159.productSpecContainmentID,
        o = _ref159.productTitle;
      e.map(function (_ref160) {
        var e = _ref160.groupId,
          i = _ref160.variants;
        i.map(function (_ref161) {
          var i = _ref161.productId;
          if (t.includes(e)) return Object.assign(r, _defineProperty({}, i, {
            id: n,
            name: o
          }));
        });
      });
    }), r;
  },
  getNewAddonBillingContainedProducts: Zc,
  getRemovedAddonBillingContainedProducts: zc,
  getNewAddonBillingOffers: Qc,
  getRemovedAddonBillingOffers: ed,
  retrieveProductConfiguration: td,
  addSimOnlyAddons: function addSimOnlyAddons(e) {
    var t = e.customerId,
      r = e.addonIdsToAdd,
      n = e.addonIdsToRemove,
      o = e.productOrderId,
      i = e.productOrderItemId,
      a = e.preTickAddons,
      c = e.planId,
      d = e.cisDetails;
    return /*#__PURE__*/function () {
      var _ref162 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee110(e) {
        var s, u, l, p, m, E, R, S, _, O, C, f;
        return _regeneratorRuntime.wrap(function _callee110$(_context110) {
          while (1) {
            switch (_context110.prev = _context110.next) {
              case 0:
                e({
                  type: ad.ADDON_SIM_ONLY_ADD_LOADING
                });
                _context110.next = 3;
                return e(td({
                  customerId: t,
                  productOrderItemId: i
                }));
              case 3:
                u = _context110.sent.productConfiguration.displayableItems;
                l = wn(u).entities;
                p = l.displayableBillingOffers;
                m = r.map(function (e) {
                  return _objectSpread(_objectSpread(_objectSpread({}, p[e]), l.displayableItems[p[e].parent]), {}, {
                    selected: p[e].selected
                  });
                }).filter(function (e) {
                  return !e.selected;
                });
                E = n.map(function (e) {
                  return p[e];
                }).filter(function (e) {
                  return !r.includes(e.productSpecPricingID);
                });
                R = m.reduce(function (e, t) {
                  return e[t.productSpecPricingID] = xe(), e;
                }, {});
                S = m.map(function (e) {
                  return {
                    productSpecContainmentID: e.productSpecContainmentID,
                    temporaryID: R[e.productSpecPricingID],
                    parentProductSpecContainmentID: e.parentProductSpecContainmentID,
                    parentProductID: e.parentProductID
                  };
                });
                _ = {
                  UpdateProductInOrderConfigurationRequest: {
                    runCompatibilityRules: !1,
                    addDefaultChildItemsImplicitly: !0,
                    activityForConfiguration: "NPCFirstLoad",
                    confirmationMessagesApproved: !1,
                    returnRemovedItems: !1,
                    configurationLevel: "FULL",
                    settingsView: "FULL",
                    updateEvenIfNotValid: !1,
                    returnConfiguration: "ALL",
                    productChanges: [{
                      removedContainedProducts: [],
                      changedContainedProducts: [],
                      suspendedContainedProducts: [],
                      changedSimpleProducts: [],
                      newAssignedBillingOffers: m.map(function (e) {
                        return I.includes(e.productSpecContainmentID) ? {
                          productSpecPricingID: e.productSpecPricingID,
                          parentProductSpecContainmentID: e.productSpecContainmentID,
                          parentTemporaryID: R[e.productSpecPricingID]
                        } : {
                          productSpecPricingID: e.productSpecPricingID,
                          parentProductID: e.productID,
                          parentProductSpecContainmentID: e.productSpecContainmentID
                        };
                      }),
                      newContainedProducts: S,
                      newSimpleProducts: [],
                      removedAssignedBillingOffers: E.filter(function (e) {
                        return e.billingOfferID;
                      }).map(function (e) {
                        return {
                          billingOfferID: e.billingOfferID,
                          productSpecPricingID: e.productSpecPricingID
                        };
                      }),
                      resumedContainedProducts: []
                    }],
                    returnConfigurationData: {
                      catalogDataInd: !0,
                      crossProductsDiscountsDataInd: !1,
                      previousQuotedRecurringPricesInd: !1,
                      productConfigurationInd: !1,
                      quotedPricesInd: !1,
                      quotedProrationInd: !1,
                      quotedTaxInd: !1,
                      summaryInd: !1
                    }
                  }
                };
                _context110.next = 13;
                return nn({
                  customerId: t,
                  productOrderItemId: i,
                  payload: _
                });
              case 13:
                O = _context110.sent;
                u = O.productConfiguration.displayableItems, l = wn(u).entities, p = l.displayableBillingOffers;
                C = (null === (s = O.productConfiguration) || void 0 === s ? void 0 : s.displayableSimpleProductReferences) || [], f = Object.keys(p).filter(function (e) {
                  return p[e].selected;
                });
                _context110.t0 = a;
                if (!_context110.t0) {
                  _context110.next = 20;
                  break;
                }
                _context110.next = 20;
                return e($a({
                  preTickAddons: a,
                  displayableItems: u,
                  order: {
                    productOrderId: o,
                    productOrderItemId: i
                  },
                  cisDetails: d,
                  planId: c,
                  displayableSimpleProductReferences: C
                }));
              case 20:
                _context110.next = 22;
                return e(function (e) {
                  return {
                    type: ad.ADDON_SIM_ONLY_ADD_SUCCESS,
                    payload: e
                  };
                }({
                  selectedAddons: f
                }));
              case 22:
                return _context110.abrupt("return", _context110.sent);
              case 23:
              case "end":
                return _context110.stop();
            }
          }
        }, _callee110);
      }));
      return function (_x107) {
        return _ref162.apply(this, arguments);
      };
    }();
  },
  getSelectedMatchesMaxQuantity: rd,
  updateOrderActionAttributes: od,
  getAddonsFromOrder: function getAddonsFromOrder(e) {
    var t = e.productOrderItemId,
      r = e.aemAddonsList,
      n = e.customerId,
      o = e.productOrderId,
      i = e.orderActionsPayload,
      _e$bundleAddonsIds = e.bundleAddonsIds,
      a = _e$bundleAddonsIds === void 0 ? [] : _e$bundleAddonsIds,
      _e$containmentIds = e.containmentIds,
      c = _e$containmentIds === void 0 ? [] : _e$containmentIds,
      d = e.specialPromoCode,
      _e$pretickAddonBoIds = e.pretickAddonBoIds,
      s = _e$pretickAddonBoIds === void 0 ? [] : _e$pretickAddonBoIds,
      _e$manuallyAddedAddon = e.manuallyAddedAddons,
      u = _e$manuallyAddedAddon === void 0 ? [] : _e$manuallyAddedAddon;
    return /*#__PURE__*/function () {
      var _ref163 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee111(e) {
        var l, p, I, m, E, S, _, O, _r40, C, f, y, T, A, D, P, _t48, _r41, v, h, g, N, b, L, U, M, w, _e66;
        return _regeneratorRuntime.wrap(function _callee111$(_context111) {
          while (1) {
            switch (_context111.prev = _context111.next) {
              case 0:
                e({
                  type: ad.ADDONS_FETCH_LOADING
                });
                _context111.prev = 1;
                _context111.next = 4;
                return e(td({
                  customerId: n,
                  productOrderItemId: t
                }));
              case 4:
                l = _context111.sent;
                _context111.next = 10;
                break;
              case 7:
                _context111.prev = 7;
                _context111.t0 = _context111["catch"](1);
                return _context111.abrupt("return", e(Xc()));
              case 10:
                p = l.productConfiguration.displayableItems, I = wn(p), m = I.entities.displayableBillingOffers, E = Object.keys(m).filter(function (e) {
                  return m[e].selected;
                }), S = c.reduce(function (e, t) {
                  var r = p.find(function (e) {
                    var r, n;
                    return (null === (r = e.productSpecContainment) || void 0 === r || null === (n = r.containedProduct) || void 0 === n ? void 0 : n.id) === t;
                  });
                  return r && (e[t] = {
                    productSpecContainmentID: r.productSpecContainmentID
                  }), e;
                }, {}), _ = a.reduce(function (e, t) {
                  return m[t] && m[t].selected && (e[t] = m[t]), e;
                }, {});
                if (!i) {
                  _context111.next = 22;
                  break;
                }
                _context111.prev = 12;
                _context111.next = 15;
                return e(od({
                  customerId: n,
                  res: l,
                  productOrderId: o,
                  productOrderItemId: t,
                  orderActionsPayload: i,
                  selectedAddons: E,
                  tradeInProductSpecContainmentId: null === (O = S[i.tradeInProductId]) || void 0 === O ? void 0 : O.productSpecContainmentID,
                  specialPromoCode: d
                }));
              case 15:
                _r40 = _context111.sent;
                e((C = _objectSpread(_objectSpread({}, _r40), {}, {
                  productOrderItemId: t
                }), {
                  type: ad.UPDATE_ORDER_ACTION_SUCCESS,
                  value: C
                }));
                _context111.next = 22;
                break;
              case 19:
                _context111.prev = 19;
                _context111.t1 = _context111["catch"](12);
                return _context111.abrupt("return", e(Xc()));
              case 22:
                _context111.next = 24;
                return e(ni({
                  productOfferId: l.productConfiguration.rootProductOfferingID,
                  displayableItems: l.productConfiguration.displayableItems,
                  productOrderItemType: l.productOrderItemType,
                  addonIds: r.map(function (e) {
                    return e.productSpecContainmentID;
                  }),
                  specialPromoCode: d
                }));
              case 24:
                f = _context111.sent;
                y = l.productConfiguration.displayableSimpleProductReferences;
                T = I.entities.displayableItems;
                A = T[9742];
                D = [];
                A && (D = A.displayableBillingOffers.map(function (e) {
                  return m[e];
                }).filter(function (e) {
                  return e.selected && e.name && e.name.includes("5G Service");
                }));
                P = T[8363722];
                if (P) {
                  _t48 = P.displayableBillingOffers.map(function (e) {
                    return m[e];
                  }).some(function (e) {
                    return e.selected && ("SIM Card Fee" === e.name || "" + e.name.toUpperCase() == "ESIM FEE");
                  }), _r41 = xo(P.displayableCharacteristics);
                  e({
                    type: ad.SET_ORDER_SIM_CARD_DETAILS,
                    value: {
                      hasSim: _t48,
                      productId: P.productID,
                      is5GSim: "381187630N" === _r41.sku || "eSIM5GPost" === (null == _r41 ? void 0 : _r41.simType),
                      selectedSimType: null == _r41 ? void 0 : _r41.simType
                    }
                  });
                }
                v = function v(e) {
                  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                  var r;
                  return !u.includes(e) && (null === (r = m[e]) || void 0 === r ? void 0 : r.selected) && !s.includes(e) && !t.includes(e);
                }, h = r.map(function (e) {
                  return e.productSpecContainmentID;
                }), g = E && E.reduce(function (e, t) {
                  var n = m[t],
                    o = T[n.parent],
                    i = r.find(function (e) {
                      return e.productSpecContainmentID === t;
                    }),
                    a = o.productSpecContainmentID,
                    c = o.displayableCharacteristics,
                    d = o.productID,
                    s = o.displayableItems;
                  if (Vn(a)) {
                    var _r42;
                    if (n.selected && o) {
                      _r42 = T[s].displayableCharacteristics;
                    }
                    return _objectSpread(_objectSpread({}, e), {}, _defineProperty({}, t, _objectSpread(_objectSpread(_objectSpread({}, i), n), {}, {
                      productSpecContainmentID: a,
                      contractDetails: _r42,
                      productID: d
                    })));
                  }
                  return _objectSpread({}, e);
                }, {}), N = p.filter(Fo).length;
                b = Object.keys(m).filter(function (e) {
                  return h.includes(e);
                }).reduce(function (e, t) {
                  var n = r.find(function (e) {
                      return e.productSpecContainmentID === t;
                    }),
                    o = f && f.find(function (e) {
                      return e.promoId === t;
                    }),
                    i = m[t],
                    a = I.entities.displayableItems,
                    c = a[i.parent],
                    d = a[8363682].productID,
                    s = rd({
                      displayableItem: c,
                      occurrencesInDisplayableItems: N,
                      billingOffers: m
                    }),
                    u = c.parentProductID,
                    l = c.parentProductSpecContainmentID,
                    p = c.productID,
                    E = c.productSpecContainmentID,
                    S = c.displayableItems;
                  var _ = c.displayableCharacteristics;
                  var O;
                  R.includes(n.productSpecContainmentID) && (_ = null === (O = _) || void 0 === O ? void 0 : O.map(function (e) {
                    return {
                      displayInformation: _objectSpread(_objectSpread({}, e.displayInformation), {}, {
                        enabled: !1
                      })
                    };
                  }));
                  var C = [];
                  if (Vn(E) && i.selected && S) {
                    C = a[S].displayableCharacteristics;
                  }
                  var y = v(t);
                  return e[t] = _objectSpread(_objectSpread(_objectSpread({}, n), m[t]), {}, {
                    productID: p,
                    displayableCharacteristics: _,
                    mainProductId: d,
                    parentProductID: u,
                    parentProductSpecContainmentID: l,
                    productSpecContainmentID: E,
                    promoDescription: o && o.promoDescription,
                    selectedMatchesMaxQuantity: s,
                    contractDetails: C,
                    isNotRemovable: y,
                    boId: t
                  }), e;
                }, {});
                L = y ? y.filter(function (e) {
                  return ko(e.productSpecContainmentID) && e.selected;
                }) : [], U = L.reduce(function (e, t) {
                  var r, n, o, i;
                  return s.includes(t.simpleProductSpecID) ? [].concat(_toConsumableArray(e), [null === (r = t.displayableBillingOffers) || void 0 === r || null === (n = r[0]) || void 0 === n || null === (o = n.productSpecPricing) || void 0 === o || null === (i = o.childPricingSchema) || void 0 === i ? void 0 : i.id]) : e;
                }, []).filter(function (e) {
                  return Boolean(e);
                }), M = (null == E ? void 0 : E.filter(function (e) {
                  return v(e, U);
                })) || [], w = r && r.filter(function (e) {
                  return e.atomic;
                });
                if (w) {
                  _e66 = Wn({
                    aemAtomicAddons: w,
                    mobileContentItems: L
                  });
                  b = _objectSpread(_objectSpread({}, b), _e66);
                }
                return _context111.abrupt("return", e(function (e) {
                  return {
                    type: ad.ADDONS_FETCH_SUCCESS,
                    value: e
                  };
                }({
                  availableAddons: b,
                  selectedAddons: E,
                  atomicAddons: L,
                  selectedAddonsBo: g,
                  addons5G: D,
                  bundleAddonsData: _,
                  containmentIdData: S,
                  unRemovableAddons: M
                })));
              case 37:
              case "end":
                return _context111.stop();
            }
          }
        }, _callee111, null, [[1, 7], [12, 19]]);
      }));
      return function (_x108) {
        return _ref163.apply(this, arguments);
      };
    }();
  },
  validateProductConfiguration: id,
  removeAndAddAddonFromOrder: function removeAndAddAddonFromOrder(e) {
    var _e$addonToRemove = e.addonToRemove,
      t = _e$addonToRemove === void 0 ? {} : _e$addonToRemove,
      _e$addonToAdd = e.addonToAdd,
      r = _e$addonToAdd === void 0 ? {} : _e$addonToAdd,
      n = e.productOrderItemId,
      o = e.changedCharacteristic,
      i = e.appleCareEmail,
      _e$addWithBillingOffe = e.addWithBillingOffer,
      a = _e$addWithBillingOffe === void 0 ? !1 : _e$addWithBillingOffe,
      _e$removeWithBillingO = e.removeWithBillingOffer,
      c = _e$removeWithBillingO === void 0 ? !1 : _e$removeWithBillingO;
    var d = Zc({
      addon: r,
      changedCharacteristic: o
    });
    a && (d = Qc({
      addon: r,
      changedCharacteristic: o
    }));
    var _d8 = d,
      s = _d8.newAssignedBillingOffers,
      u = _d8.newSimpleProducts;
    var _d9 = d,
      I = _d9.newContainedProducts;
    if (l.includes(r.productSpecContainmentID)) {
      var _e67 = I.changedCharacteristics.find(function (e) {
        return p.includes(e.characteristicID);
      });
      I = _objectSpread(_objectSpread({}, I), {}, {
        changedCharacteristics: [{
          characteristicID: _e67.characteristicID,
          value: i
        }]
      });
    }
    var m = t.productSpecContainmentID,
      E = t.simpleProductSpecID;
    var R = [],
      S = zc(t);
    if (c) {
      var _ed = ed({
          removedAddon: t
        }),
        _e68 = _ed.removedAssignedBillingOffers,
        _r43 = _ed.removedContainedProducts;
      R = _e68, S = _r43;
    }
    return /*#__PURE__*/function () {
      var _ref164 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee112(e) {
        var t, _r44, _o15, r;
        return _regeneratorRuntime.wrap(function _callee112$(_context112) {
          while (1) {
            switch (_context112.prev = _context112.next) {
              case 0:
                e({
                  type: ad.ADDON_REMOVE_ADD_LOADING
                });
                t = {
                  UpdateProductInOrderConfigurationRequest: {
                    runCompatibilityRules: !0,
                    activityForConfiguration: "SD Add Comp Stage",
                    confirmationMessagesApproved: !1,
                    returnRemovedItems: !1,
                    configurationLevel: "FULL",
                    settingsView: "FULL",
                    updateEvenIfNotValid: !1,
                    returnConfiguration: "ALL",
                    productChanges: [{
                      removedContainedProducts: S,
                      changedContainedProducts: [],
                      suspendedContainedProducts: [],
                      changedSimpleProducts: [],
                      newAssignedBillingOffers: s ? [s] : [],
                      newContainedProducts: I ? [I] : [],
                      newSimpleProducts: u ? [u] : [],
                      removedSimpleProducts: [],
                      removedAssignedBillingOffers: R,
                      resumedContainedProducts: []
                    }],
                    returnConfigurationData: {
                      catalogDataInd: !0,
                      crossProductsDiscountsDataInd: !1,
                      previousQuotedRecurringPricesInd: !1,
                      productConfigurationInd: !0,
                      quotedPricesInd: !1,
                      quotedProrationInd: !1,
                      quotedTaxInd: !1,
                      summaryInd: !1
                    }
                  }
                };
                _context112.prev = 2;
                _context112.next = 5;
                return nn({
                  productOrderItemId: n,
                  payload: t
                });
              case 5:
                _r44 = _context112.sent;
                _o15 = e(id(_r44.productConfiguration, "ADD_REMOVE_ADDON"));
                if (!_o15.isError) {
                  _context112.next = 9;
                  break;
                }
                throw _o15.messages;
              case 9:
                "17987931" === m && e(qc(E));
                _context112.next = 15;
                break;
              case 12:
                _context112.prev = 12;
                _context112.t0 = _context112["catch"](2);
                return _context112.abrupt("return", e((r = _context112.t0, {
                  type: ad.ADDON_REMOVE_ADD_ERROR,
                  value: r
                })));
              case 15:
                return _context112.abrupt("return", e({
                  type: ad.ADDON_REMOVE_ADD_SUCCESS
                }));
              case 16:
              case "end":
                return _context112.stop();
            }
          }
        }, _callee112, null, [[2, 12]]);
      }));
      return function (_x109) {
        return _ref164.apply(this, arguments);
      };
    }();
  },
  addAddonToOrder: function addAddonToOrder(e) {
    var t = e.addon,
      r = e.productOrderItemId,
      n = e.appleCareEmail,
      o = e.changedCharacteristic;
    return /*#__PURE__*/function () {
      var _ref165 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee113(e) {
        var i, a, c, d, s, _e69, u, _t49, _n24;
        return _regeneratorRuntime.wrap(function _callee113$(_context113) {
          while (1) {
            switch (_context113.prev = _context113.next) {
              case 0:
                e(jc());
                i = Qc({
                  addon: t,
                  changedCharacteristic: o
                }), a = i.newAssignedBillingOffers, c = i.newSimpleProducts;
                d = i.newContainedProducts;
                s = [];
                if ("11982" === t.productSpecContainmentID && s.push({
                  productID: t.mainProductId,
                  changedCharacteristics: [{
                    characteristicID: "12373511",
                    value: "Yes"
                  }]
                }), l.includes(t.productSpecContainmentID)) {
                  _e69 = d.changedCharacteristics.find(function (e) {
                    return p.includes(e.characteristicID);
                  });
                  d = _objectSpread(_objectSpread({}, d), {}, {
                    changedCharacteristics: [{
                      characteristicID: _e69.characteristicID,
                      value: n
                    }]
                  });
                }
                u = {
                  UpdateProductInOrderConfigurationRequest: {
                    runCompatibilityRules: !0,
                    activityForConfiguration: "SD Add Comp Stage",
                    confirmationMessagesApproved: !1,
                    returnRemovedItems: !1,
                    configurationLevel: "FULL",
                    settingsView: "FULL",
                    updateEvenIfNotValid: !1,
                    returnConfiguration: "ALL",
                    productChanges: [{
                      removedContainedProducts: [],
                      changedContainedProducts: s,
                      suspendedContainedProducts: [],
                      changedSimpleProducts: [],
                      newAssignedBillingOffers: a ? [a] : [],
                      newContainedProducts: d ? [d] : [],
                      newSimpleProducts: c ? [c] : [],
                      removedSimpleProducts: [],
                      removedAssignedBillingOffers: [],
                      resumedContainedProducts: []
                    }],
                    returnConfigurationData: {
                      catalogDataInd: !0,
                      crossProductsDiscountsDataInd: !1,
                      previousQuotedRecurringPricesInd: !1,
                      productConfigurationInd: !0,
                      quotedPricesInd: !1,
                      quotedProrationInd: !1,
                      quotedTaxInd: !1,
                      summaryInd: !1
                    }
                  }
                };
                _context113.prev = 6;
                _context113.next = 9;
                return nn({
                  productOrderItemId: r,
                  payload: u
                });
              case 9:
                _t49 = _context113.sent;
                _n24 = e(id(_t49.productConfiguration, "ADD_ADDON"));
                if (!_n24.isError) {
                  _context113.next = 13;
                  break;
                }
                throw _n24.messages;
              case 13:
                _context113.next = 18;
                break;
              case 15:
                _context113.prev = 15;
                _context113.t0 = _context113["catch"](6);
                return _context113.abrupt("return", e(Jc(_context113.t0)));
              case 18:
                return _context113.abrupt("return", e(Kc(t.boId)));
              case 19:
              case "end":
                return _context113.stop();
            }
          }
        }, _callee113, null, [[6, 15]]);
      }));
      return function (_x110) {
        return _ref165.apply(this, arguments);
      };
    }();
  },
  addTradeInToOrder: function addTradeInToOrder(e) {
    var t = e.productOrderItemId,
      r = e.brand,
      n = e.model,
      o = e.tradeInRulesData,
      i = e.isAddBib,
      a = e.imei,
      c = e.addDefaultChildItemsImplicitly,
      d = e.tradeInProductSpecContainmentId;
    return /*#__PURE__*/function () {
      var _ref166 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee114(e) {
        var s, u, _r45, l, p, _n25, _i15, _r46, _o$promoOrderDetails, _n26, _a10, _c13;
        return _regeneratorRuntime.wrap(function _callee114$(_context114) {
          while (1) {
            switch (_context114.prev = _context114.next) {
              case 0:
                e(jc({
                  isAddBib: i
                }));
                s = {
                  productSpecContainmentID: Or(d),
                  temporaryID: xe(),
                  changedCharacteristics: [{
                    characteristicID: 8035352,
                    value: "Available"
                  }, {
                    characteristicID: 13142,
                    value: "Available"
                  }, {
                    characteristicID: 13162,
                    value: "Available"
                  }, {
                    characteristicID: 13182,
                    value: "Available"
                  }, {
                    characteristicID: 13152,
                    value: "Available"
                  }, {
                    characteristicID: 13132,
                    value: "Available"
                  }, {
                    characteristicID: "8852",
                    value: n
                  }, {
                    characteristicID: "8842",
                    value: r
                  }],
                  parentProductSpecContainmentID: "8363682"
                };
                a && s.changedCharacteristics.push({
                  characteristicID: "8302",
                  value: a
                });
                u = {
                  UpdateProductInOrderConfigurationRequest: {
                    runCompatibilityRules: !0,
                    activityForConfiguration: "SD Add Comp Stage",
                    confirmationMessagesApproved: !1,
                    returnRemovedItems: !1,
                    configurationLevel: "FULL",
                    settingsView: "FULL",
                    updateEvenIfNotValid: !1,
                    addDefaultChildItemsImplicitly: c,
                    returnConfiguration: "ALL",
                    productChanges: [{
                      removedContainedProducts: [],
                      changedContainedProducts: [],
                      suspendedContainedProducts: [],
                      changedSimpleProducts: [],
                      newAssignedBillingOffers: [],
                      newContainedProducts: [s],
                      newSimpleProducts: [],
                      removedSimpleProducts: [],
                      removedAssignedBillingOffers: [],
                      resumedContainedProducts: []
                    }],
                    returnConfigurationData: {
                      catalogDataInd: !0,
                      crossProductsDiscountsDataInd: !1,
                      previousQuotedRecurringPricesInd: !1,
                      productConfigurationInd: !0,
                      quotedPricesInd: !1,
                      quotedProrationInd: !1,
                      quotedTaxInd: !1,
                      summaryInd: !1
                    }
                  }
                };
                _context114.prev = 4;
                _context114.next = 7;
                return nn({
                  productOrderItemId: t,
                  payload: u
                });
              case 7:
                _r45 = _context114.sent;
                if (!o) {
                  _context114.next = 14;
                  break;
                }
                _n25 = fo(null == _r45 ? void 0 : _r45.productConfiguration, d), _i15 = null == _n25 || null === (l = _n25.productSpecPricing) || void 0 === l || null === (p = l.childPricingSchema) || void 0 === p ? void 0 : p.id;
                if (!_i15) {
                  _context114.next = 14;
                  break;
                }
                _r46 = o.productId, _o$promoOrderDetails = o.promoOrderDetails, _n26 = _o$promoOrderDetails === void 0 ? {} : _o$promoOrderDetails, _a10 = o.selectedAddonIds, _c13 = o.customerId;
                _context114.next = 14;
                return e(yc({
                  productOrderItemId: t,
                  productId: _r46,
                  promoOrderDetails: _n26,
                  selectedAddonIds: [].concat(_toConsumableArray(_a10), [_i15]),
                  customerId: _c13
                }));
              case 14:
                _context114.next = 19;
                break;
              case 16:
                _context114.prev = 16;
                _context114.t0 = _context114["catch"](4);
                return _context114.abrupt("return", e(Jc({
                  isAddBib: i
                })));
              case 19:
                return _context114.abrupt("return", e(Kc({
                  isAddBib: i
                })));
              case 20:
              case "end":
                return _context114.stop();
            }
          }
        }, _callee114, null, [[4, 16]]);
      }));
      return function (_x111) {
        return _ref166.apply(this, arguments);
      };
    }();
  },
  removeAddonFromOrder: function removeAddonFromOrder(e) {
    var _e$addon = e.addon,
      t = _e$addon === void 0 ? {} : _e$addon,
      r = e.productOrderItemId,
      _e$promoOrderDetails = e.promoOrderDetails,
      n = _e$promoOrderDetails === void 0 ? {} : _e$promoOrderDetails,
      o = e.selectedAddonIds,
      _e$withPromoString = e.withPromoString,
      i = _e$withPromoString === void 0 ? !1 : _e$withPromoString,
      _e$runUpdateOrderRule = e.runUpdateOrderRulesData,
      a = _e$runUpdateOrderRule === void 0 ? null : _e$runUpdateOrderRule,
      _e$removeWithBillingP = e.removeWithBillingProduct,
      c = _e$removeWithBillingP === void 0 ? !1 : _e$removeWithBillingP,
      _e$isRemoveBib = e.isRemoveBib,
      d = _e$isRemoveBib === void 0 ? !1 : _e$isRemoveBib,
      s = t.productSpecContainmentID,
      u = t.simpleProductSpecID;
    return /*#__PURE__*/function () {
      var _ref167 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee115(e) {
        var _ed2, l, p, I, m, E, _t50, _t51, _a$promoOrderDetails, _n28, _o16, _i16, _n27, R, S;
        return _regeneratorRuntime.wrap(function _callee115$(_context115) {
          while (1) {
            switch (_context115.prev = _context115.next) {
              case 0:
                e({
                  type: ad.ADDON_REMOVE_LOADING
                });
                _ed2 = ed({
                  removedAddon: t
                }), l = _ed2.removedAssignedBillingOffers, p = _ed2.removedContainedProducts;
                c && (p = zc(t), l = []);
                I = [];
                "11982" === t.productSpecContainmentID && I.push({
                  productID: t.mainProductId,
                  changedCharacteristics: [{
                    characteristicID: "12373511",
                    value: "No"
                  }]
                });
                m = "SD Add Comp Stage";
                if (o && i) {
                  m = "SD Add Comp Stage+++promoCode+++EMPTY" + ri(_objectSpread(_objectSpread({}, n), {}, {
                    addonIds: o
                  }));
                }
                E = {
                  UpdateProductInOrderConfigurationRequest: {
                    runCompatibilityRules: !0,
                    activityForConfiguration: m,
                    confirmationMessagesApproved: !1,
                    returnRemovedItems: !1,
                    configurationLevel: "FULL",
                    settingsView: "FULL",
                    updateEvenIfNotValid: !1,
                    returnConfiguration: "ALL",
                    productChanges: [{
                      removedContainedProducts: p,
                      changedContainedProducts: I,
                      suspendedContainedProducts: [],
                      changedSimpleProducts: [],
                      newAssignedBillingOffers: [],
                      newContainedProducts: [],
                      newSimpleProducts: [],
                      removedSimpleProducts: [],
                      removedAssignedBillingOffers: l,
                      resumedContainedProducts: []
                    }],
                    returnConfigurationData: i ? {
                      catalogDataInd: !0,
                      crossProductsDiscountsDataInd: !0,
                      previousQuotedRecurringPricesInd: !1,
                      productConfigurationInd: !0,
                      quotedPricesInd: !0,
                      quotedProrationInd: !0,
                      quotedTaxInd: !0,
                      summaryInd: !0
                    } : {
                      catalogDataInd: !0,
                      crossProductsDiscountsDataInd: !1,
                      previousQuotedRecurringPricesInd: !1,
                      productConfigurationInd: !0,
                      quotedPricesInd: !1,
                      quotedProrationInd: !1,
                      quotedTaxInd: !1,
                      summaryInd: !1
                    }
                  }
                };
                _context115.prev = 8;
                _context115.next = 11;
                return nn({
                  productOrderItemId: r,
                  payload: E
                });
              case 11:
                _t50 = _context115.sent;
                if (!a) {
                  _context115.next = 16;
                  break;
                }
                _t51 = a.productId, _a$promoOrderDetails = a.promoOrderDetails, _n28 = _a$promoOrderDetails === void 0 ? {} : _a$promoOrderDetails, _o16 = a.selectedAddonIds, _i16 = a.customerId;
                _context115.next = 16;
                return e(yc({
                  productOrderItemId: r,
                  productId: _t51,
                  promoOrderDetails: _n28,
                  selectedAddonIds: _o16,
                  customerId: _i16
                }));
              case 16:
                _n27 = e(id(_t50.productConfiguration, "REMOVE_ADDON"));
                if (!_n27.isError) {
                  _context115.next = 19;
                  break;
                }
                throw _n27.messages;
              case 19:
                "17987931" === s && e(qc(u));
                _context115.next = 25;
                break;
              case 22:
                _context115.prev = 22;
                _context115.t0 = _context115["catch"](8);
                return _context115.abrupt("return", e((R = _context115.t0, {
                  type: ad.ADDON_REMOVE_ERROR,
                  value: R
                })));
              case 25:
                return _context115.abrupt("return", e((S = {
                  isRemoveBib: d
                }, {
                  type: ad.ADDON_REMOVE_SUCCESS,
                  value: S
                })));
              case 26:
              case "end":
                return _context115.stop();
            }
          }
        }, _callee115, null, [[8, 22]]);
      }));
      return function (_x112) {
        return _ref167.apply(this, arguments);
      };
    }();
  },
  upgradeAddonToOrder: function upgradeAddonToOrder(e) {
    var t = e.addon,
      r = e.productOrderItemId,
      n = e.removedAddon,
      o = e.customerId;
    return /*#__PURE__*/function () {
      var _ref168 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee116(e) {
        var _ed3, i, a, _Qc, c, d, s, _t52, _n29, u;
        return _regeneratorRuntime.wrap(function _callee116$(_context116) {
          while (1) {
            switch (_context116.prev = _context116.next) {
              case 0:
                e({
                  type: ad.ADDON_UPGRADE_LOADING
                });
                _ed3 = ed({
                  removedAddon: n
                }), i = _ed3.removedAssignedBillingOffers, a = _ed3.removedContainedProducts, _Qc = Qc({
                  addon: t
                }), c = _Qc.newAssignedBillingOffers, d = _Qc.newContainedProducts, s = {
                  UpdateProductInOrderConfigurationRequest: {
                    runCompatibilityRules: !0,
                    activityForConfiguration: "SD Add Comp Stage",
                    confirmationMessagesApproved: !1,
                    returnRemovedItems: !1,
                    configurationLevel: "FULL",
                    settingsView: "FULL",
                    updateEvenIfNotValid: !1,
                    returnConfiguration: "ALL",
                    productChanges: [{
                      removedContainedProducts: a,
                      changedContainedProducts: [],
                      suspendedContainedProducts: [],
                      changedSimpleProducts: [],
                      newAssignedBillingOffers: [c],
                      newContainedProducts: [d],
                      newSimpleProducts: [],
                      removedSimpleProducts: [],
                      removedAssignedBillingOffers: i,
                      resumedContainedProducts: []
                    }],
                    returnConfigurationData: {
                      catalogDataInd: !0,
                      crossProductsDiscountsDataInd: !1,
                      previousQuotedRecurringPricesInd: !1,
                      productConfigurationInd: !0,
                      quotedPricesInd: !1,
                      quotedProrationInd: !1,
                      quotedTaxInd: !1,
                      summaryInd: !1
                    }
                  }
                };
                _context116.prev = 2;
                _context116.next = 5;
                return nn({
                  customerId: o,
                  productOrderItemId: r,
                  payload: s
                });
              case 5:
                _t52 = _context116.sent;
                _n29 = e(id(_t52.productConfiguration, "UPGRADE_ADDON"));
                if (!_n29.isError) {
                  _context116.next = 9;
                  break;
                }
                throw _n29.messages;
              case 9:
                _context116.next = 14;
                break;
              case 11:
                _context116.prev = 11;
                _context116.t0 = _context116["catch"](2);
                return _context116.abrupt("return", e((u = _context116.t0, {
                  type: ad.ADDON_UPGRADE_ERROR,
                  value: u
                })));
              case 14:
                return _context116.abrupt("return", e({
                  type: ad.ADDON_UPGRADE_SUCCESS
                }));
              case 15:
              case "end":
                return _context116.stop();
            }
          }
        }, _callee116, null, [[2, 11]]);
      }));
      return function (_x113) {
        return _ref168.apply(this, arguments);
      };
    }();
  },
  actionType: ad
});
var dd = function dd(e) {
    var t = e.rrpMasterOrderId;
    return nt("".concat(i, "/rrp/order/rrp-master-order-id/").concat(t, "/retrieve-order-details"), {
      method: "GET",
      queryParams: {
        wq: !0,
        os: !1
      }
    }).then(function (e) {
      return e.ImplRRPRetrieveMasterOrderDetails;
    });
  },
  sd = function sd(e) {
    var t = e.orderItemDetails,
      r = e.rrpMasterOrderId;
    return nt("".concat(i, "/rrp/order/rrp-master-order-id/").concat(r, "/add-order-items"), {
      method: "PUT",
      body: JSON.stringify({
        ImplRRPAddOrderItemRequest: {
          orderItemDetails: t
        }
      })
    }).then(function (e) {
      return e.ImplRRPAddOrderItemResponse;
    });
  },
  ud = function ud(e) {
    var t = e.rrpMasterOrderId,
      r = e.orderId,
      _e$orderItemDetails = e.orderItemDetails,
      n = _e$orderItemDetails === void 0 ? [] : _e$orderItemDetails;
    return nt("".concat(i, "/rrp/order/rrp-master-order-id/").concat(t, "/rrp-order-id/").concat(r, "/remove-order-items"), {
      method: "POST",
      body: JSON.stringify({
        ImplRRPRemoveOrderItemRequest: {
          orderItemDetails: n
        }
      })
    }).then(function (e) {
      return e.ImplRRPRemoveOrderItemResponse;
    });
  },
  ld = function ld(e) {
    var t = e.rrpMasterOrderId;
    return nt("".concat(i, "/rrp/order/rrp-master-order-id/").concat(t, "/cancel-master-order"), {
      method: "GET"
    }).then(function (e) {
      return e.ImpRRPCancelOrderResponse;
    });
  },
  pd = function pd(e) {
    var t = e.contactId;
    return nt("".concat(i, "/premium-products/contact-person/").concat(t, "/validate-eligibility"), {
      method: "GET",
      queryParams: {
        sc: "SS",
        lo: "en_US"
      }
    }).then(function (e) {
      return e.ImplValidatePremiumProductsSignupOutput;
    });
  },
  Id = function Id(e) {
    var t = e.contactId;
    return nt("".concat(i, "/customer-management/contact-person/").concat(t), {
      method: "GET",
      queryParams: {
        sc: "SS",
        lo: "en_US",
        isOrderConfirm: !0
      }
    }).then(function (e) {
      var t;
      return null === (t = e.ImplContactPersonOutput) || void 0 === t ? void 0 : t.implContactPerson;
    });
  },
  md = Sr.RRP_CART,
  Ed = function Ed() {
    return {
      type: md.RRP_SHOPPING_CART_LOADING
    };
  },
  Rd = function Rd() {
    return {
      type: md.RRP_ADD_MASTER_ORDER_LOADING
    };
  },
  Sd = function Sd() {
    return {
      type: md.RRP_REMOVE_MASTER_ORDER_LOADING
    };
  },
  _d = function _d() {
    return {
      type: md.RRP_CANCEL_MASTER_ORDER_LOADING
    };
  },
  Od = function Od(e) {
    return {
      type: md.RRP_SHOPPING_CART_SUCCESS,
      value: e
    };
  },
  Cd = function Cd() {
    return {
      type: md.RRP_SHOPPING_CART_ERROR
    };
  },
  fd = function fd(e) {
    return {
      type: md.RRP_ADD_MASTER_ORDER_SUCCESS,
      value: e
    };
  },
  yd = function yd() {
    return {
      type: md.RRP_ADD_MASTER_ORDER_ERROR
    };
  },
  Td = function Td(e) {
    return {
      type: md.RRP_REMOVE_MASTER_ORDER_SUCCESS,
      value: e
    };
  },
  Ad = function Ad() {
    return {
      type: md.RRP_REMOVE_MASTER_ORDER_ERROR
    };
  },
  Dd = function Dd(e) {
    return {
      type: md.RRP_CANCEL_MASTER_ORDER_SUCCESS,
      value: {
        addItemAfterCancel: e
      }
    };
  },
  Pd = function Pd() {
    return {
      type: md.RRP_CANCEL_MASTER_ORDER_ERROR
    };
  },
  vd = function vd() {
    return {
      type: md.RRP_EXTEND_SESSION_LOADING
    };
  },
  hd = function hd() {
    return {
      type: md.RRP_EXTEND_SESSION_SUCCESS
    };
  },
  gd = function gd() {
    return {
      type: md.RRP_EXTEND_SESSION_ERROR
    };
  },
  Nd = function Nd() {
    return {
      type: md.RRP_CANCEL_ORDER_LOADING
    };
  },
  bd = function bd() {
    return {
      type: md.RRP_CANCEL_ORDER_SUCCESS
    };
  },
  Ld = function Ld() {
    return {
      type: md.RRP_CANCEL_ORDER_ERROR
    };
  },
  Ud = function Ud(e) {
    return {
      type: Sr.RRP_CART.RRP_IPP_NOT_ELIGIBLE,
      value: e
    };
  },
  Md = function Md(e) {
    return /*#__PURE__*/function () {
      var _ref169 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee117(t) {
        var r, n, o, _e70;
        return _regeneratorRuntime.wrap(function _callee117$(_context117) {
          while (1) {
            switch (_context117.prev = _context117.next) {
              case 0:
                r = e.rrpMasterOrderId;
                t(Ed());
                _context117.prev = 2;
                _context117.next = 5;
                return dd({
                  rrpMasterOrderId: r
                });
              case 5:
                _e70 = _context117.sent;
                return _context117.abrupt("return", t(Od(_objectSpread(_objectSpread({}, _e70), {}, {
                  ImplRRPOrderDetails: ei(_e70.ImplRRPOrderDetails),
                  saveAmount: Bo(null == _e70 || null === (n = _e70.retailPrice) || void 0 === n ? void 0 : n.afterTax, null == _e70 || null === (o = _e70.actualPrice) || void 0 === o ? void 0 : o.afterTax)
                }))));
              case 9:
                _context117.prev = 9;
                _context117.t0 = _context117["catch"](2);
                return _context117.abrupt("return", t(Cd()));
              case 12:
              case "end":
                return _context117.stop();
            }
          }
        }, _callee117, null, [[2, 9]]);
      }));
      return function (_x114) {
        return _ref169.apply(this, arguments);
      };
    }();
  },
  wd = function wd(e) {
    return /*#__PURE__*/function () {
      var _ref170 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee118(t) {
        var r, o, _e71;
        return _regeneratorRuntime.wrap(function _callee118$(_context118) {
          while (1) {
            switch (_context118.prev = _context118.next) {
              case 0:
                r = e.rrpMasterOrderId, o = e.rrpOrderId;
                t(Nd());
                _context118.prev = 2;
                _context118.next = 5;
                return function (e) {
                  var t = e.rrpMasterOrderId,
                    r = e.rrpOrderId;
                  return nt("".concat(i, "/rrp/order/rrp-master-order-id/").concat(t, "/rrp-order-id/").concat(r, "/cancel-order"), {
                    method: "GET"
                  }).then(function (e) {
                    return e.ImpRRPCancelOrderResponse;
                  });
                }({
                  rrpMasterOrderId: r,
                  rrpOrderId: o
                });
              case 5:
                _e71 = _context118.sent;
                if (!((null == _e71 ? void 0 : _e71.result) !== n.SUCCESS)) {
                  _context118.next = 8;
                  break;
                }
                throw new Error(null == _e71 ? void 0 : _e71.result);
              case 8:
                t(bd());
                _context118.next = 14;
                break;
              case 11:
                _context118.prev = 11;
                _context118.t0 = _context118["catch"](2);
                return _context118.abrupt("return", t(Ld()));
              case 14:
              case "end":
                return _context118.stop();
            }
          }
        }, _callee118, null, [[2, 11]]);
      }));
      return function (_x115) {
        return _ref170.apply(this, arguments);
      };
    }();
  };
var Gd = Object.freeze({
  __proto__: null,
  rrpCartLoading: Ed,
  rrpAddMasterOrderLoading: Rd,
  rrpRemoveMasterOrderLoading: Sd,
  rrpCancelMasterOrderLoading: _d,
  rrpCartSuccess: Od,
  rrpCartError: Cd,
  rrpAddMasterOrderSuccess: fd,
  rrpAddMasterOrderError: yd,
  rrpRemoveMasterOrderSuccess: Td,
  rrpRemoveMasterOrderError: Ad,
  rrpCancelMasterOrderSuccess: Dd,
  rrpCancelMasterOrderError: Pd,
  rrpExtendSessionLoading: vd,
  rrpExtendSessionSuccess: hd,
  rrpExtendSessionError: gd,
  rrpCancelOrderLoading: Nd,
  rrpCancelOrderSuccess: bd,
  rrpCancelOrderError: Ld,
  retrieveRrpMasterOrderDetails: Md,
  rrpAddMasterOrderItems: function rrpAddMasterOrderItems(e) {
    return /*#__PURE__*/function () {
      var _ref171 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee119(t) {
        var r, n, o, _e$shouldFetchOrderDe, i, _e72;
        return _regeneratorRuntime.wrap(function _callee119$(_context119) {
          while (1) {
            switch (_context119.prev = _context119.next) {
              case 0:
                r = e.rrpMasterOrderId, n = e.orderItemDetails, o = e.shouldGoToCart, _e$shouldFetchOrderDe = e.shouldFetchOrderDetailsFromApi, i = _e$shouldFetchOrderDe === void 0 ? !0 : _e$shouldFetchOrderDe;
                t(Rd());
                _context119.prev = 2;
                _context119.next = 5;
                return sd({
                  rrpMasterOrderId: r,
                  orderItemDetails: n
                });
              case 5:
                _e72 = _context119.sent;
                t(fd(_objectSpread(_objectSpread({}, _e72), {}, {
                  shouldGoToCart: o
                })));
                _context119.next = 12;
                break;
              case 9:
                _context119.prev = 9;
                _context119.t0 = _context119["catch"](2);
                return _context119.abrupt("return", t(yd()));
              case 12:
                if (!i) {
                  _context119.next = 21;
                  break;
                }
                _context119.prev = 13;
                _context119.next = 16;
                return t(Md({
                  rrpMasterOrderId: r
                }));
              case 16:
                _context119.next = 21;
                break;
              case 18:
                _context119.prev = 18;
                _context119.t1 = _context119["catch"](13);
                return _context119.abrupt("return", t(Ad()));
              case 21:
              case "end":
                return _context119.stop();
            }
          }
        }, _callee119, null, [[2, 9], [13, 18]]);
      }));
      return function (_x116) {
        return _ref171.apply(this, arguments);
      };
    }();
  },
  rrpRemoveMasterOrderItems: function rrpRemoveMasterOrderItems(e) {
    return /*#__PURE__*/function () {
      var _ref172 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee120(t) {
        var r, n, o, _e$cancelOrder, i, _e73;
        return _regeneratorRuntime.wrap(function _callee120$(_context120) {
          while (1) {
            switch (_context120.prev = _context120.next) {
              case 0:
                r = e.rrpMasterOrderId, n = e.orderItemDetails, o = e.orderId, _e$cancelOrder = e.cancelOrder, i = _e$cancelOrder === void 0 ? !1 : _e$cancelOrder;
                if (!i) {
                  _context120.next = 6;
                  break;
                }
                _context120.next = 4;
                return t(wd({
                  rrpMasterOrderId: r,
                  rrpOrderId: o
                }));
              case 4:
                _context120.next = 17;
                break;
              case 6:
                t(Sd());
                _context120.prev = 7;
                _context120.next = 10;
                return ud({
                  rrpMasterOrderId: r,
                  orderId: o,
                  orderItemDetails: n
                });
              case 10:
                _e73 = _context120.sent;
                t(Td(_e73));
                _context120.next = 17;
                break;
              case 14:
                _context120.prev = 14;
                _context120.t0 = _context120["catch"](7);
                return _context120.abrupt("return", t(Ad()));
              case 17:
                _context120.prev = 17;
                _context120.next = 20;
                return t(Md({
                  rrpMasterOrderId: r
                }));
              case 20:
                _context120.next = 25;
                break;
              case 22:
                _context120.prev = 22;
                _context120.t1 = _context120["catch"](17);
                return _context120.abrupt("return", t(Ad()));
              case 25:
              case "end":
                return _context120.stop();
            }
          }
        }, _callee120, null, [[7, 14], [17, 22]]);
      }));
      return function (_x117) {
        return _ref172.apply(this, arguments);
      };
    }();
  },
  rrpCancelOrder: wd,
  rrpCancelMasterOrderItems: function rrpCancelMasterOrderItems(e) {
    return /*#__PURE__*/function () {
      var _ref173 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee121(t) {
        var r, o, _e74;
        return _regeneratorRuntime.wrap(function _callee121$(_context121) {
          while (1) {
            switch (_context121.prev = _context121.next) {
              case 0:
                r = e.rrpMasterOrderId, o = e.addItemAfterCancel;
                t(_d());
                _context121.prev = 2;
                _context121.next = 5;
                return ld({
                  rrpMasterOrderId: r
                });
              case 5:
                _e74 = _context121.sent;
                if (!((null == _e74 ? void 0 : _e74.result) === n.SUCCESS)) {
                  _context121.next = 8;
                  break;
                }
                return _context121.abrupt("return", (t(Dd(o)), _e74));
              case 8:
                throw new Error(null == _e74 ? void 0 : _e74.result);
              case 11:
                _context121.prev = 11;
                _context121.t0 = _context121["catch"](2);
                return _context121.abrupt("return", t(Pd()));
              case 14:
              case "end":
                return _context121.stop();
            }
          }
        }, _callee121, null, [[2, 11]]);
      }));
      return function (_x118) {
        return _ref173.apply(this, arguments);
      };
    }();
  },
  deleteRRPIppOrder: function deleteRRPIppOrder(e) {
    return /*#__PURE__*/function () {
      var _ref174 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee122(t) {
        return _regeneratorRuntime.wrap(function _callee122$(_context122) {
          while (1) {
            switch (_context122.prev = _context122.next) {
              case 0:
                _context122.prev = 0;
                t({
                  type: Sr.RRP_CART.DELETE_IPP_ORDER_LOADING
                });
                _context122.next = 4;
                return we(e);
              case 4:
                t({
                  type: Sr.RRP_CART.DELETE_IPP_ORDER_SUCCESS,
                  value: {
                    addItemAfterCancel: e.addItemAfterCancel,
                    shouldGoToCart: e.shouldGoToCart
                  }
                });
                _context122.next = 10;
                break;
              case 7:
                _context122.prev = 7;
                _context122.t0 = _context122["catch"](0);
                t({
                  type: Sr.RRP_CART.DELETE_IPP_ORDER_FAILED
                });
              case 10:
              case "end":
                return _context122.stop();
            }
          }
        }, _callee122, null, [[0, 7]]);
      }));
      return function (_x119) {
        return _ref174.apply(this, arguments);
      };
    }();
  },
  rrpExtendSession: function rrpExtendSession(e) {
    return /*#__PURE__*/function () {
      var _ref175 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee123(t) {
        var r, _e75;
        return _regeneratorRuntime.wrap(function _callee123$(_context123) {
          while (1) {
            switch (_context123.prev = _context123.next) {
              case 0:
                r = e.rrpMasterOrderId;
                t(vd());
                _context123.prev = 2;
                _context123.next = 5;
                return function (e) {
                  var t = e.masterOrderId;
                  return nt("".concat(i, "/rrp/order/rrp-master-order-id/").concat(t, "/extend-session"), {
                    method: "GET"
                  }).then(function (e) {
                    return e.ImplRRPExtendSessionResponse;
                  });
                }({
                  masterOrderId: r
                });
              case 5:
                _e75 = _context123.sent;
                if (!(null == _e75 ? void 0 : _e75.sessionExtended)) {
                  _context123.next = 8;
                  break;
                }
                return _context123.abrupt("return", t(hd()));
              case 8:
                throw new Error();
              case 11:
                _context123.prev = 11;
                _context123.t0 = _context123["catch"](2);
                return _context123.abrupt("return", t(gd()));
              case 14:
              case "end":
                return _context123.stop();
            }
          }
        }, _callee123, null, [[2, 11]]);
      }));
      return function (_x120) {
        return _ref175.apply(this, arguments);
      };
    }();
  },
  rrpCreateMasterOrder: function rrpCreateMasterOrder(e, t, r) {
    return /*#__PURE__*/function () {
      var _ref176 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee124(n) {
        var _a11, o;
        return _regeneratorRuntime.wrap(function _callee124$(_context124) {
          while (1) {
            switch (_context124.prev = _context124.next) {
              case 0:
                _context124.prev = 0;
                n({
                  type: Sr.RRP_CART.CREATE_ORDER_LOADING
                });
                _context124.t0 = r;
                if (!_context124.t0) {
                  _context124.next = 8;
                  break;
                }
                _context124.next = 6;
                return At();
              case 6:
                _context124.next = 8;
                return Ct({
                  cleanWorryFree: !0
                });
              case 8:
                _context124.next = 10;
                return o = e, nt(i + "/rrp/order/create-order", {
                  method: "PUT",
                  body: JSON.stringify({
                    ImplRRPCreateOrderRequest: {
                      orderItemDetails: o
                    }
                  })
                }).then(function (e) {
                  return e.ImplRRPAddMasterOrderResponse;
                });
              case 10:
                _a11 = _context124.sent;
                if (!(null == _a11 ? void 0 : _a11.masterOrderId)) {
                  _context124.next = 13;
                  break;
                }
                return _context124.abrupt("return", (n({
                  type: Sr.RRP_CART.CREATE_ORDER_SUCCESS,
                  data: _objectSpread(_objectSpread({}, _a11), {}, {
                    shouldGoToCart: t
                  })
                }), _a11));
              case 13:
                n({
                  type: Sr.RRP_CART.CREATE_ORDER_FAIL
                });
                _context124.next = 19;
                break;
              case 16:
                _context124.prev = 16;
                _context124.t1 = _context124["catch"](0);
                n({
                  type: Sr.RRP_CART.CREATE_ORDER_FAIL
                });
              case 19:
              case "end":
                return _context124.stop();
            }
          }
        }, _callee124, null, [[0, 16]]);
      }));
      return function (_x121) {
        return _ref176.apply(this, arguments);
      };
    }();
  },
  retrieveRRPIPPSubscriptions: function retrieveRRPIPPSubscriptions(e, t) {
    return /*#__PURE__*/function () {
      var _ref177 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee125(r) {
        var n, o, _a12, _c14;
        return _regeneratorRuntime.wrap(function _callee125$(_context125) {
          while (1) {
            switch (_context125.prev = _context125.next) {
              case 0:
                _context125.prev = 0;
                r({
                  type: Sr.RRP_CART.RETRIEVE_RRP_IPP_DESCRIPTION_LOADING
                });
                _context125.next = 4;
                return Id({
                  contactId: e
                });
              case 4:
                _a12 = _context125.sent;
                if (!("X" !== (null == _a12 ? void 0 : _a12.blacklistReason))) {
                  _context125.next = 7;
                  break;
                }
                return _context125.abrupt("return", r(Ud(Cr.RRP_IPP_NOT_ELIGIBLE_CODE.BLACKLISTED)));
              case 7:
                if (!((null == t ? void 0 : t.dob) && !di({
                  dob: t.dob,
                  ageToCompare: Cr.AGE_FOR_IPP,
                  checkDayAndMonth: !0
                }))) {
                  _context125.next = 9;
                  break;
                }
                return _context125.abrupt("return", r(Ud(Cr.RRP_IPP_NOT_ELIGIBLE_CODE.UNDER_AGE)));
              case 9:
                _context125.t0 = "0" !== (null == _a12 ? void 0 : _a12.currentCreditRating);
                if (!_context125.t0) {
                  _context125.next = 14;
                  break;
                }
                _context125.next = 13;
                return pd({
                  contactId: e
                });
              case 13:
                o = _context125.sent;
              case 14:
                if (!(o && !(null === (n = o) || void 0 === n ? void 0 : n.success))) {
                  _context125.next = 16;
                  break;
                }
                return _context125.abrupt("return", r(Ud()));
              case 16:
                _context125.next = 18;
                return function (e) {
                  return nt("".concat(i, "/rrp/ipp/plan/eligibility/contact-person/").concat(e), {
                    method: "GET"
                  }).then(function (e) {
                    return e.RetrieveIPPSubscriptionInfoResponse;
                  });
                }(e);
              case 18:
                _c14 = _context125.sent;
                if (!("000" !== _c14.errorCode)) {
                  _context125.next = 21;
                  break;
                }
                return _context125.abrupt("return", r(Ud()));
              case 21:
                if (!(null == _c14 ? void 0 : _c14.subscriptionIPPDetails)) {
                  _context125.next = 23;
                  break;
                }
                return _context125.abrupt("return", (r({
                  type: Sr.RRP_CART.RETRIEVE_RRP_IPP_DESCRIPTION_SUCCESS,
                  data: _c14
                }), _c14));
              case 23:
                r(Ud());
                _context125.next = 29;
                break;
              case 26:
                _context125.prev = 26;
                _context125.t1 = _context125["catch"](0);
                r({
                  type: Sr.RRP_CART.RETRIEVE_RRP_IPP_DESCRIPTION_FAIL
                });
              case 29:
              case "end":
                return _context125.stop();
            }
          }
        }, _callee125, null, [[0, 26]]);
      }));
      return function (_x122) {
        return _ref177.apply(this, arguments);
      };
    }();
  },
  createRRPIPPOrder: function createRRPIPPOrder(e) {
    return /*#__PURE__*/function () {
      var _ref178 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee126(t) {
        var r, n, o, _a13, _c15, _d10;
        return _regeneratorRuntime.wrap(function _callee126$(_context126) {
          while (1) {
            switch (_context126.prev = _context126.next) {
              case 0:
                r = e.customerId, n = e.serviceId, o = e.createdIppOrderData;
                _context126.prev = 1;
                t({
                  type: Sr.RRP_CART.RRP_CREATE_IPP_ORDER_LOADING
                });
                _context126.t0 = o;
                if (!_context126.t0) {
                  _context126.next = 7;
                  break;
                }
                _context126.next = 7;
                return we(o);
              case 7:
                _context126.next = 9;
                return cn(r, n);
              case 9:
                _a13 = _context126.sent;
                ut(null == _a13 ? void 0 : _a13.pendingComponents) && t({
                  type: Sr.RRP_CART.RRP_CREATE_IPP_ORDER_FAIL
                });
                _context126.next = 13;
                return Fe(r, n);
              case 13:
                _c15 = _context126.sent;
                if (!st(_c15)) {
                  _context126.next = 16;
                  break;
                }
                return _context126.abrupt("return", t({
                  type: md.RRP_CREATE_IPP_ORDER_FAIL_HAS_PENDING_PAYMENT
                }));
              case 16:
                _context126.t1 = null == _c15 ? void 0 : _c15.length;
                if (!_context126.t1) {
                  _context126.next = 20;
                  break;
                }
                _context126.next = 20;
                return mt(_c15, r, n);
              case 20:
                _context126.next = 22;
                return function (e) {
                  var t = e.contactId,
                    r = e.customerId,
                    n = e.assignedProductID,
                    o = e.sku,
                    a = e.numberOfInstalments,
                    c = e.simpleProductSpecID;
                  return nt("".concat(i, "/rrp/ipp/contact-person/").concat(t, "/customer/").concat(r, "/product/").concat(n, "/product-order"), {
                    method: "POST",
                    body: JSON.stringify({
                      ImplRRPIppOrderConfigurationRequest: {
                        spsId: c,
                        sku: o,
                        numberOfInstalments: a
                      }
                    })
                  }).then(function (e) {
                    return null == e ? void 0 : e.ImplRRPIppOrderConfigurationResponse;
                  });
                }(e);
              case 22:
                _d10 = _context126.sent;
                _d10.ippOrderId ? t({
                  type: Sr.RRP_CART.RRP_CREATE_IPP_ORDER_SUCCESS,
                  data: _objectSpread({
                    customerId: r
                  }, _d10)
                }) : t({
                  type: Sr.RRP_CART.RRP_CREATE_IPP_ORDER_FAIL
                });
                _context126.next = 29;
                break;
              case 26:
                _context126.prev = 26;
                _context126.t2 = _context126["catch"](1);
                t({
                  type: Sr.RRP_CART.RRP_CREATE_IPP_ORDER_FAIL
                });
              case 29:
              case "end":
                return _context126.stop();
            }
          }
        }, _callee126, null, [[1, 26]]);
      }));
      return function (_x123) {
        return _ref178.apply(this, arguments);
      };
    }();
  }
});
var Fd = Object.freeze({
  __proto__: null,
  validateGetSKU: function validateGetSKU(e) {
    return /*#__PURE__*/function () {
      var _ref179 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee127(t) {
        var r;
        return _regeneratorRuntime.wrap(function _callee127$(_context127) {
          while (1) {
            switch (_context127.prev = _context127.next) {
              case 0:
                _context127.prev = 0;
                t({
                  type: Sr.IPHONE.VALIDATE_GET_SKU_LOADING
                });
                _context127.next = 4;
                return function (e) {
                  var t = e.campaignId,
                    r = e.token,
                    n = e.emailId,
                    o = e.nric;
                  return nt(i + "/cce/validate-get-sku", {
                    method: "POST",
                    queryParams: {
                      token: r,
                      campaignId: t,
                      emailId: n,
                      sc: "SS",
                      lo: "en_US"
                    },
                    body: JSON.stringify({
                      ImplValidateAndGetSKUByCustIdAndTokenRequest: {
                        nric: o
                      }
                    })
                  }).then(function (e) {
                    return null == e ? void 0 : e.ImplValidateAndGetSKUByCustIdAndTokenResponse;
                  });
                }(e);
              case 4:
                r = _context127.sent;
                t({
                  type: Sr.IPHONE.VALIDATE_GET_SKU_SUCCESS,
                  data: r
                });
                _context127.next = 11;
                break;
              case 8:
                _context127.prev = 8;
                _context127.t0 = _context127["catch"](0);
                t({
                  type: Sr.IPHONE.VALIDATE_GET_SKU_FAILED
                });
              case 11:
              case "end":
                return _context127.stop();
            }
          }
        }, _callee127, null, [[0, 8]]);
      }));
      return function (_x124) {
        return _ref179.apply(this, arguments);
      };
    }();
  },
  validateOTP: function validateOTP(e) {
    return /*#__PURE__*/function () {
      var _ref180 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee128(t) {
        var r;
        return _regeneratorRuntime.wrap(function _callee128$(_context128) {
          while (1) {
            switch (_context128.prev = _context128.next) {
              case 0:
                _context128.prev = 0;
                t({
                  type: Sr.IPHONE.VALIDATE_OTP_LOADING
                });
                _context128.next = 4;
                return function (e) {
                  var t = e.emailId,
                    r = e.otpCode;
                  return nt(i + "/cce/validate-otp", {
                    method: "GET",
                    queryParams: {
                      otpCode: r,
                      emailId: t,
                      sc: "SS",
                      lo: "en_US"
                    }
                  }).then(function (e) {
                    return null == e ? void 0 : e.ImplValidateSessionTokenOutput;
                  });
                }(e);
              case 4:
                r = _context128.sent;
                t({
                  type: Sr.IPHONE.VALIDATE_OTP_SUCCESS,
                  data: r
                });
                _context128.next = 11;
                break;
              case 8:
                _context128.prev = 8;
                _context128.t0 = _context128["catch"](0);
                t({
                  type: Sr.IPHONE.VALIDATE_GET_SKU_FAILED
                });
              case 11:
              case "end":
                return _context128.stop();
            }
          }
        }, _callee128, null, [[0, 8]]);
      }));
      return function (_x125) {
        return _ref180.apply(this, arguments);
      };
    }();
  }
});
var kd = function kd(e) {
    var t = e.productOrderId,
      r = e.isBlockOrder;
    return nt("".concat(i, "/ecommerce/order/").concat(t, "/recalculate-block-flag"), {
      method: "POST",
      queryParams: {
        sc: "SS",
        lo: "en_US"
      },
      body: JSON.stringify({
        ImplRecalculateBlockFlagRequest: {
          orderId: t,
          isBlockOrder: r
        }
      })
    }).then(function (e) {
      return e.ImplRecalculateBlockFlagResponse;
    });
  },
  Bd = function Bd(e) {
    var t = e.customerId,
      r = e.productOrderId,
      n = e.productOrderItemId,
      o = e.productId,
      a = e.productChanges;
    return nt("".concat(i, "/commerce/customer/").concat(t, "/product-order-id/").concat(r, "/validate-product-configurations"), {
      method: "POST",
      queryParams: {
        sc: "SS",
        lo: "en_US"
      },
      body: JSON.stringify({
        ValidateMultiProductsConfigurationRequest: {
          addDefaultChildItemsImplicitly: !0,
          activityForConfiguration: "SDRulesForCheckout+++promoCode+++EMPTY",
          returnRemovedItems: !1,
          settingsView: "FULL",
          productOrderItems: [{
            productChanges: a,
            productOrderItemID: n,
            productID: o
          }],
          retrieveComponentPricing: !1,
          retrieveSchemaPricing: !1,
          performSave: !0,
          returnConfigurationData: {
            catalogDataInd: !0,
            crossProductsDiscountsDataInd: !0,
            previousQuotedRecurringPricesInd: !1,
            productConfigurationInd: !0,
            quotedPricesInd: !0,
            quotedProrationInd: !1,
            quotedTaxInd: !1,
            summaryInd: !0
          }
        }
      })
    }).then(function (e) {
      return e.ValidateMultiProductConfigurationsResponse;
    });
  },
  Vd = function Vd(e) {
    var t = e.contactId;
    return nt("".concat(i, "/customer-management/contact-person/").concat(t), {
      method: "GET",
      queryParams: {
        sc: "SS",
        lo: "en_US"
      }
    }).then(function (e) {
      return e.ImplContactPersonOutput;
    });
  },
  Yd = {
    Device: "Device",
    Accessory: "Accessory",
    Freebie: "Freebie"
  },
  xd = function xd(e) {
    var t = e.contactId,
      r = e.customerId,
      _e$deliveryMethod = e.deliveryMethod,
      n = _e$deliveryMethod === void 0 ? "METH_NON_PAPER" : _e$deliveryMethod,
      o = e.billingAddress,
      a = "".concat(i, "/customer/").concat(r, "/billing-entity?sc=SS&lo=en_US"),
      c = o.unitNo || o.unitNumber || o.apartment;
    return nt(a, {
      method: "POST",
      body: JSON.stringify({
        ImplBillingAccountCreateRequest: {
          deliveryMethod: n,
          nickName: o.nickName || "singtelAccount",
          isEasyMobile: !1,
          contactId: t,
          physicalAddress: {
            floor: o.floor || o.floorNumber,
            room: o.floor || o.floorNumber,
            houseNumber: o.blockOrHouseNum,
            postcode: o.postcode || o.postCode,
            streetName: o.streetName,
            unitNumber: c,
            blockOrHouseAddr: "APT Blk",
            state: o.state,
            apartment: c,
            country: o.country,
            buildingName: o.buildingName
          }
        }
      })
    }).then(function (e) {
      return e.ImplBillingAccountCreateResponse;
    });
  },
  Hd = function Hd(e) {
    var t = e.customerId,
      r = e.productOrderId,
      n = e.productOrderItemId,
      o = e.pcnId;
    return nt("".concat(i, "/commerce/customer/").concat(t, "/product-order/").concat(r, "/pay-channel"), {
      method: "PUT",
      queryParams: {
        sc: "SS",
        lo: "en_US"
      },
      body: JSON.stringify({
        PayChannelProductOrderDetails: {
          productOrderDetails: [{
            paymentCatergory: "POST",
            pcnId: o,
            productOrderItemId: n
          }]
        }
      })
    });
  },
  $d = function $d(e) {
    var t = e.contactId,
      r = e.nric,
      n = e.customerType,
      o = e.intFlowType,
      a = e.billType,
      c = e.deliveryMethod,
      _e$skipNotification = e.skipNotification,
      d = _e$skipNotification === void 0 ? !1 : _e$skipNotification,
      _e$update = e.update,
      s = _e$update === void 0 ? !1 : _e$update;
    var u;
    return u = "development" === process.env.NODE_ENV || "test" === process.env.NODE_ENV ? "".concat(i, "/billing/contact-person/").concat(t, "/opebinfo") : "".concat(i, "/billing/type/").concat(n, "/id/").concat(r, "/contact-person/").concat(t, "/opebinfo"), s ? nt(u, {
      method: "POST",
      queryParams: {
        skipNotification: d,
        intFlowType: o,
        sc: "SS",
        lo: "en_US"
      },
      body: JSON.stringify({
        ImplBillingDataInput: {
          deliveryMethod: c,
          billType: a
        }
      })
    }).then(function (e) {
      return e;
    }) : nt(u, {
      method: "GET",
      queryParams: {
        includeBAStatus: [y.OPEN, y.TENTATIVE],
        sc: "SS",
        lo: "en_US"
      }
    }).then(function (e) {
      return e.ImplBillingAccountDetailsResponse.billingAccountDetails;
    });
  },
  qd = {
    FETCH_BILLING_LOADING: "FETCH_BILLING_LOADING",
    FETCH_BILLING_SUCCESS: "FETCH_BILLING_SUCCESS",
    FETCH_BILLING_ERROR: "FETCH_BILLING_ERROR",
    FETCH_BILLING_PREFERENCE_LOADING: "FETCH_BILLING_PREFERENCE_LOADING",
    FETCH_BILLING_PREFERENCE_SUCCESS: "FETCH_BILLING_PREFERENCE_SUCCESS",
    FETCH_BILLING_PREFERENCE_ERROR: "FETCH_BILLING_PREFERENCE_ERROR"
  },
  Wd = function Wd(e) {
    return /*#__PURE__*/function () {
      var _ref181 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee129(t) {
        var r, n, o, i, _e76, a;
        return _regeneratorRuntime.wrap(function _callee129$(_context129) {
          while (1) {
            switch (_context129.prev = _context129.next) {
              case 0:
                t({
                  type: qd.FETCH_BILLING_PREFERENCE_LOADING
                });
                r = e.contactId, n = e.nric, o = e.indentType, i = C[o];
                _context129.prev = 2;
                _context129.next = 5;
                return $d({
                  contactId: r,
                  nric: n,
                  customerType: i
                });
              case 5:
                _e76 = _context129.sent.find(function (e) {
                  var t = e.billType,
                    r = e.baStatus;
                  if ("E_BILL" !== t && (r === y.OPEN || r === y.TENTATIVE)) return e;
                });
                return _context129.abrupt("return", t((a = !!_e76, {
                  type: qd.FETCH_BILLING_PREFERENCE_SUCCESS,
                  value: a
                })));
              case 9:
                _context129.prev = 9;
                _context129.t0 = _context129["catch"](2);
                return _context129.abrupt("return", t({
                  type: qd.FETCH_BILLING_PREFERENCE_ERROR
                }));
              case 12:
              case "end":
                return _context129.stop();
            }
          }
        }, _callee129, null, [[2, 9]]);
      }));
      return function (_x126) {
        return _ref181.apply(this, arguments);
      };
    }();
  },
  Xd = function Xd(e) {
    return /*#__PURE__*/function () {
      var _ref182 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee130(t) {
        var r, n, o, i, a, c;
        return _regeneratorRuntime.wrap(function _callee130$(_context130) {
          while (1) {
            switch (_context130.prev = _context130.next) {
              case 0:
                t({
                  type: "SET_BILLING_PREFERENCE_LOADING"
                });
                r = e.contactId, n = e.nric, o = e.indentType, i = e.billType, a = C[o], c = f[i] || {};
                _context130.prev = 2;
                _context130.next = 5;
                return $d(_objectSpread({
                  contactId: r,
                  nric: n,
                  customerType: a,
                  update: !0
                }, c));
              case 5:
                return _context130.abrupt("return", t({
                  type: "SET_BILLING_PREFERENCE_SUCCESS"
                }));
              case 8:
                _context130.prev = 8;
                _context130.t0 = _context130["catch"](2);
                return _context130.abrupt("return", t({
                  type: "SET_BILLING_PREFERENCE_ERROR"
                }));
              case 11:
              case "end":
                return _context130.stop();
            }
          }
        }, _callee130, null, [[2, 8]]);
      }));
      return function (_x127) {
        return _ref182.apply(this, arguments);
      };
    }();
  },
  jd = function jd(e) {
    var t = e.productOrderId,
      r = e.contactId;
    return /*#__PURE__*/function () {
      var _ref183 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee131(e) {
        var o, _a14, n;
        return _regeneratorRuntime.wrap(function _callee131$(_context131) {
          while (1) {
            switch (_context131.prev = _context131.next) {
              case 0:
                e({
                  type: qd.FETCH_BILLING_LOADING
                });
                _context131.prev = 1;
                _context131.next = 4;
                return function (e) {
                  var t = e.contactId,
                    r = e.productOrderId;
                  return nt("".concat(i, "/ordering/order/").concat(r, "/contact-person/").concat(t, "/retrieve-billing-details"), {
                    method: "GET",
                    queryParams: {
                      sc: "SS",
                      lo: "en_US"
                    }
                  }).then(function (e) {
                    return e.ImplRetrieveOrderBillingDetailsRestOutput;
                  });
                }({
                  contactId: r,
                  productOrderId: t
                });
              case 4:
                o = _context131.sent;
                _a14 = o.billingAccountDetails;
                return _context131.abrupt("return", (_a14 = _a14.filter(function (_ref184) {
                  var e = _ref184.faStatus;
                  return 83 !== e && 78 !== e;
                }), o.billingAccountDetails = _a14, e((n = {
                  billingDetails: o
                }, {
                  type: qd.FETCH_BILLING_SUCCESS,
                  payload: n
                }))));
              case 9:
                _context131.prev = 9;
                _context131.t0 = _context131["catch"](1);
                return _context131.abrupt("return", e(function (e) {
                  return {
                    type: qd.FETCH_BILLING_ERROR,
                    payload: e
                  };
                }("error in apiBillingDetails - " + _context131.t0.message)));
              case 12:
              case "end":
                return _context131.stop();
            }
          }
        }, _callee131, null, [[1, 9]]);
      }));
      return function (_x128) {
        return _ref183.apply(this, arguments);
      };
    }();
  },
  Kd = function Kd(_ref185) {
    var e = _ref185.contactId,
      t = _ref185.customerId,
      r = _ref185.billingAddress,
      n = _ref185.deliveryMethod,
      o = _ref185.productOrder;
    return /*#__PURE__*/function () {
      var _ref186 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee132(i) {
        var a;
        return _regeneratorRuntime.wrap(function _callee132$(_context132) {
          while (1) {
            switch (_context132.prev = _context132.next) {
              case 0:
                i({
                  type: "SET_BILLING_ACCOUNT_LOADING"
                });
                a = r.billingAccountNumber;
                if (a) {
                  _context132.next = 14;
                  break;
                }
                i({
                  type: "CREATE_BILLING_ACCOUNT_LOADING"
                });
                _context132.prev = 4;
                _context132.next = 7;
                return xd({
                  contactId: e,
                  customerId: t,
                  billingAddress: r,
                  deliveryMethod: n
                });
              case 7:
                a = _context132.sent.billingArangmentId;
                i({
                  type: "CREATE_BILLING_ACCOUNT_SUCCESS"
                });
                _context132.next = 14;
                break;
              case 11:
                _context132.prev = 11;
                _context132.t0 = _context132["catch"](4);
                return _context132.abrupt("return", (i({
                  type: "CREATE_BILLING_ACCOUNT_ERROR"
                }), i({
                  type: "SET_BILLING_ACCOUNT_ERROR"
                })));
              case 14:
                _context132.prev = 14;
                _context132.next = 17;
                return Hd({
                  customerId: t,
                  productOrderId: o.productOrderId,
                  productOrderItemId: o.productOrderItemId,
                  pcnId: a
                });
              case 17:
                return _context132.abrupt("return", i({
                  type: "SET_BILLING_ACCOUNT_SUCCESS"
                }));
              case 20:
                _context132.prev = 20;
                _context132.t1 = _context132["catch"](14);
                return _context132.abrupt("return", i({
                  type: "SET_BILLING_ACCOUNT_ERROR"
                }));
              case 23:
              case "end":
                return _context132.stop();
            }
          }
        }, _callee132, null, [[4, 11], [14, 20]]);
      }));
      return function (_x129) {
        return _ref186.apply(this, arguments);
      };
    }();
  };
var Jd = Object.freeze({
  __proto__: null,
  BILLING_DETAILS: qd,
  isEBillMethod: Wd,
  setBillingPreference: Xd,
  fetchBillingAccountDetails: jd,
  setBillingAccount: Kd
});
var Zd = {
    DOCUMENT_UPLOAD_NEEDED_LOADING: "DOCUMENT_UPLOAD_NEEDED_LOADING",
    DOCUMENT_UPLOAD_NEEDED_SUCCESS: "DOCUMENT_UPLOAD_NEEDED_SUCCESS",
    DOCUMENT_UPLOAD_NEEDED_FAILURE: "DOCUMENT_UPLOAD_NEEDED_FAILURE"
  },
  zd = function zd(e) {
    var t = e.productOrderReferenceNumber,
      r = e.contactId,
      n = e.indentType,
      _e$isHighEndDevice = e.isHighEndDevice,
      o = _e$isHighEndDevice === void 0 ? !1 : _e$isHighEndDevice,
      a = e.selectedOption,
      c = e.implAdditionalUploadDocumentInput,
      d = e.implFlowDetails;
    return /*#__PURE__*/function () {
      var _ref187 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee133(e) {
        var s, _n30, u;
        return _regeneratorRuntime.wrap(function _callee133$(_context133) {
          while (1) {
            switch (_context133.prev = _context133.next) {
              case 0:
                e({
                  type: Zd.DOCUMENT_UPLOAD_NEEDED_LOADING
                });
                s = {
                  ImplIsUploadDocumentNeededResInput: {
                    documentType: O[n],
                    isHighEndDevice: o,
                    selectedOption: a,
                    implFlowDetails: d,
                    implAdditionalUploadDocumentInput: c
                  }
                };
                _context133.prev = 2;
                _context133.next = 5;
                return function (e) {
                  var t = e.contactId,
                    r = e.productOrderReferenceNumber,
                    n = e.implIsUploadDocumentNeededResInput;
                  return nt("".concat(i, "/ecommerce/document/upload/needed/contact-person/").concat(t, "/order/").concat(r, "/v1"), {
                    method: "POST",
                    queryParams: {
                      sc: "SS",
                      lo: "en_US"
                    },
                    body: JSON.stringify(n)
                  }).then(function (e) {
                    return e.ImplIsUploadDocumentNeededResOutput;
                  });
                }({
                  contactId: r,
                  productOrderReferenceNumber: t,
                  implIsUploadDocumentNeededResInput: s
                });
              case 5:
                _n30 = _context133.sent;
                return _context133.abrupt("return", e((u = _n30, {
                  type: Zd.DOCUMENT_UPLOAD_NEEDED_SUCCESS,
                  value: u
                })));
              case 9:
                _context133.prev = 9;
                _context133.t0 = _context133["catch"](2);
                return _context133.abrupt("return", e({
                  type: Zd.DOCUMENT_UPLOAD_NEEDED_FAILURE
                }));
              case 12:
              case "end":
                return _context133.stop();
            }
          }
        }, _callee133, null, [[2, 9]]);
      }));
      return function (_x130) {
        return _ref187.apply(this, arguments);
      };
    }();
  };
var Qd = Object.freeze({
  __proto__: null,
  UPLOAD_DOCUMENTS: Zd,
  isDocumentUploadNeeded: zd
});
var es = function es(e) {
    var t = e.barId,
      r = e.serviceId,
      n = e.billingAccounts,
      o = e.customerId;
    if (t) return !1;
    if (!n) return !0;
    return !function (e, t, r) {
      return r.filter(function (r) {
        return !(!r.subscribers || !r.subscribers.length) && "T" !== r.baStatus && (!t || r.customerId !== t || !!function (e, t) {
          return t.find(function (t) {
            return t.subscriberResourceVal === e;
          });
        }(e, r.subscribers));
      });
    }(r, o, n).length;
  },
  ts = function ts(e) {
    return e.hasSim || e.hasDevices || e.hasAccessories;
  },
  rs = function rs(e) {
    var t = e.billingAccounts,
      r = e.contactId,
      n = e.productOrderReferenceNumber,
      o = e.indentType,
      i = e.cartOrder,
      a = e.barId,
      c = e.customerId,
      d = e.serviceId,
      s = e.nric;
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee134() {
      var e, u, l, p, _t53;
      return _regeneratorRuntime.wrap(function _callee134$(_context134) {
        while (1) {
          switch (_context134.prev = _context134.next) {
            case 0:
              e = !1;
              u = es({
                barId: a,
                customerId: c,
                serviceId: d,
                billingAccounts: t
              });
              _context134.next = 4;
              return Wd({
                contactId: r,
                nric: s,
                indentType: o
              })(function (e) {
                return e && void 0 !== (null == e ? void 0 : e.value);
              });
            case 4:
              l = _context134.sent;
              p = {
                hasSim: null == i ? void 0 : i.hasSim
              };
              if (!(u || ts(p))) {
                _context134.next = 10;
                break;
              }
              e = !0;
              _context134.next = 14;
              break;
            case 10:
              _context134.next = 12;
              return zd({
                contactId: r,
                productOrderReferenceNumber: n,
                indentType: o
              })(function (e) {
                if (e && void 0 !== (null == e ? void 0 : e.value)) return null == e ? void 0 : e.value;
              });
            case 12:
              _t53 = _context134.sent;
              e = null == _t53 ? void 0 : _t53.answer;
            case 14:
              return _context134.abrupt("return", (e || (e = l), e));
            case 15:
            case "end":
              return _context134.stop();
          }
        }
      }, _callee134);
    }));
  },
  ns = function ns(e) {
    var t, r, n, o, i, a, c;
    var d = null == e || null === (t = e.cartOrder) || void 0 === t || null === (r = t.accessories) || void 0 === r ? void 0 : r.map(function (e) {
        return {
          type: Yd.Accessory,
          skuId: null == e ? void 0 : e.skuId
        };
      }),
      s = null == e || null === (n = e.cartOrder) || void 0 === n || null === (o = n.freebies) || void 0 === o ? void 0 : o.map(function (e) {
        return {
          type: Yd.Freebie,
          skuId: e.skuId
        };
      }),
      u = null == e || null === (i = e.order) || void 0 === i || null === (a = i.mobile) || void 0 === a || null === (c = a.device) || void 0 === c ? void 0 : c.sku;
    var l = [];
    u && (l = [{
      type: Yd.Device,
      skuId: u
    }]);
    var p = {
      accessories: d,
      freebies: s,
      devices: l
    };
    return [].concat(_toConsumableArray((null == p ? void 0 : p.accessories) || []), _toConsumableArray((null == p ? void 0 : p.freebies) || []), _toConsumableArray((null == p ? void 0 : p.devices) || []));
  };
var os = Object.freeze({
  __proto__: null,
  isNewBARequired: es,
  isDeliveryRequired: ts,
  isFulFillmentRequired: rs,
  getDevicesList: ns
});
var is = function is(e, t) {
    return nt(i + "/customer-management/caller-by-contact", {
      method: "POST",
      queryParams: {
        sc: "SS",
        lo: "en_US"
      },
      body: JSON.stringify({
        ImplFindCallerByContactInput: {
          implContactDetails: {
            indentValue: e,
            indentType: t
          }
        }
      })
    }).then(function (e) {
      return e.ImplFindCallerByContactOutput;
    });
  },
  as = function as(e) {
    var t = e.contactId,
      r = e.productOrderId,
      n = e.name,
      o = e.idType,
      a = e.nric;
    return nt("".concat(i, "/ecommerce/contact-person/").concat(t, "/order/").concat(r, "/update-characteristics"), {
      method: "POST",
      queryParams: {
        sc: "SS",
        lo: "en_US"
      },
      body: JSON.stringify({
        ImplUpdateOrderActionCharacteristicsRequest: {
          productSpecContainmentId: "11812",
          implUpdateOrderActionCharacteristics: [{
            id: "8482",
            value: n
          }, {
            id: "8502",
            value: o
          }, {
            id: "8492",
            value: a
          }]
        }
      })
    }).then(function (e) {
      return e.ImplUpdateOrderActionCharacteristicsResponse;
    });
  },
  cs = function cs(_ref189) {
    var e = _ref189.selectedPlan,
      t = _ref189.userInformation,
      r = _ref189.productOrder;
    var n;
    var o = null == e ? void 0 : e.tags,
      _ref190 = (null == t || null === (n = t.clientContext) || void 0 === n ? void 0 : n.contact) || {},
      i = _ref190.dateOfBirth,
      a = _ref190.indentType,
      c = ui(o);
    return !(null == r ? void 0 : r.hasSilverComponent) && c && a === Cr.DOC_TYPES.NRIC && ci(i) ? {
      productChanges: {
        newContainedProducts: [{
          productSpecContainmentID: "2089835",
          temporaryID: xe()
        }]
      }
    } : {};
  },
  ds = function ds(e) {
    var _e$isSimOnlyIPP = e.isSimOnlyIPP,
      t = _e$isSimOnlyIPP === void 0 ? !1 : _e$isSimOnlyIPP,
      r = e.userInformation,
      n = e.productOrder,
      o = e.isAnonymous,
      _e$recalculateBlock = e.recalculateBlock,
      i = _e$recalculateBlock === void 0 ? !1 : _e$recalculateBlock,
      _e$portIn = e.portIn,
      a = _e$portIn === void 0 ? !1 : _e$portIn,
      _e$addedToContact = e.addedToContact,
      c = _e$addedToContact === void 0 ? !0 : _e$addedToContact,
      d = e.selectedPlan,
      _e$validateForInfomat = e.validateForInfomationError,
      s = _e$validateForInfomat === void 0 ? !1 : _e$validateForInfomat,
      _e$shouldDeleteOpenOr = e.shouldDeleteOpenOrder,
      u = _e$shouldDeleteOpenOr === void 0 ? !1 : _e$shouldDeleteOpenOr;
    return /*#__PURE__*/function () {
      var _ref191 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee135(e) {
        var t, l, p, _r$clientContext$cont, S, _O2, _C, _f2, I, m, _t54, E, R, _t55, _o17, _t56;
        return _regeneratorRuntime.wrap(function _callee135$(_context135) {
          while (1) {
            switch (_context135.prev = _context135.next) {
              case 0:
                if (!(null == r ? void 0 : r.clientContext)) {
                  _context135.next = 60;
                  break;
                }
                e(Pr());
                _r$clientContext$cont = r.clientContext.contact, S = _r$clientContext$cont.indentType, _O2 = _r$clientContext$cont.indentValue, _C = _r$clientContext$cont.registeredName, _f2 = null == r || null === (t = r.clientContext) || void 0 === t || null === (l = t.customers) || void 0 === l || null === (p = l[0]) || void 0 === p ? void 0 : p.customerId;
                if (!c) {
                  _context135.next = 14;
                  break;
                }
                _context135.prev = 4;
                e({
                  type: "ADD_CONTACT_TO_ORDER_LOADING"
                });
                _context135.next = 8;
                return on({
                  customerId: _f2,
                  contactId: null == r || null === (I = r.clientContext) || void 0 === I || null === (m = I.contact) || void 0 === m ? void 0 : m.contactId,
                  productOrderReferenceNumber: null == n ? void 0 : n.productOrderReferenceNumber,
                  productOrderItemId: null == n ? void 0 : n.productOrderItemId,
                  isAnonymous: o
                });
              case 8:
                e({
                  type: "CONTACT_ADDED_TO_ORDER"
                });
                _context135.next = 14;
                break;
              case 11:
                _context135.prev = 11;
                _context135.t0 = _context135["catch"](4);
                throw e({
                  type: "ADD_CONTACT_TO_ORDER_ERROR"
                }), _context135.t0;
              case 14:
                if (!a) {
                  _context135.next = 24;
                  break;
                }
                _t54 = _[S];
                _context135.prev = 16;
                _context135.next = 19;
                return as({
                  contactId: null == r || null === (E = r.clientContext) || void 0 === E || null === (R = E.contact) || void 0 === R ? void 0 : R.contactId,
                  productOrderId: null == n ? void 0 : n.productOrderId,
                  name: _C,
                  idType: _t54,
                  nric: _O2
                });
              case 19:
                _context135.next = 24;
                break;
              case 21:
                _context135.prev = 21;
                _context135.t1 = _context135["catch"](16);
                return _context135.abrupt("return", e(ms("UPDATE_CHARACTERISTICS_ERROR")));
              case 24:
                _context135.prev = 24;
                _context135.t2 = u;
                if (!_context135.t2) {
                  _context135.next = 29;
                  break;
                }
                _context135.next = 29;
                return It(_f2, null == n ? void 0 : n.productOrderId);
              case 29:
                _context135.next = 34;
                break;
              case 31:
                _context135.prev = 31;
                _context135.t3 = _context135["catch"](24);
                return _context135.abrupt("return", e(Is()));
              case 34:
                if (!i) {
                  _context135.next = 43;
                  break;
                }
                _context135.prev = 35;
                _context135.next = 38;
                return kd({
                  productOrderId: null == n ? void 0 : n.productOrderId,
                  isBlockOrder: !1
                });
              case 38:
                _context135.next = 43;
                break;
              case 40:
                _context135.prev = 40;
                _context135.t4 = _context135["catch"](35);
                return _context135.abrupt("return", e(ms("RECALCULATE_BLOCK_ERROR")));
              case 43:
                _context135.prev = 43;
                _t55 = cs({
                  selectedPlan: d,
                  userInformation: r,
                  productOrder: n
                });
                _context135.next = 47;
                return Bd(_objectSpread({
                  customerId: _f2,
                  productId: null == n ? void 0 : n.productId,
                  productOrderId: null == n ? void 0 : n.productOrderId,
                  productOrderItemId: null == n ? void 0 : n.productOrderItemId
                }, _t55));
              case 47:
                _o17 = _context135.sent;
                if (!(_o17 && _o17.productConfigurations)) {
                  _context135.next = 54;
                  break;
                }
                _t56 = Ts(_o17.productConfigurations, s);
                if (!(null == _t56 ? void 0 : _t56.every(function (_ref192) {
                  var e = _ref192.severity;
                  return "INFORMATION" === e;
                }))) {
                  _context135.next = 52;
                  break;
                }
                return _context135.abrupt("return", (e(Pr(!1)), e(Rs({
                  validateError: _t56,
                  severity: "INFORMATION"
                }))));
              case 52:
                if (!_t56) {
                  _context135.next = 54;
                  break;
                }
                return _context135.abrupt("return", (e(ec(_t56, "CHECKOUT")), e(tc(_t56, "CHECKOUT")), e(Pr(!1)), e(Rs(_t56))));
              case 54:
                (null == _t55 ? void 0 : _t55.productChanges) && e({
                  type: Sr.ORDER.UPDATE_PRODUCT_ORDER,
                  value: {
                    hasSilverComponent: !0
                  }
                }), e(Pr(!1)), e(Rs(null));
                _context135.next = 60;
                break;
              case 57:
                _context135.prev = 57;
                _context135.t5 = _context135["catch"](43);
                return _context135.abrupt("return", (e(Pr(!1)), e(Ss()), e(Os()), e(Is())));
              case 60:
              case "end":
                return _context135.stop();
            }
          }
        }, _callee135, null, [[4, 11], [16, 21], [24, 31], [35, 40], [43, 57]]);
      }));
      return function (_x131) {
        return _ref191.apply(this, arguments);
      };
    }();
  };
var ss = Object.freeze({
  __proto__: null,
  getSilverComponent: cs,
  errorScenarios: ds
});
var us = function us(e) {
    var t = e.contactRoleName,
      r = e.billingAddress,
      n = e.billingArrangementId,
      o = "".concat(i, "/billing/billing-arrangement/").concat(n, "/updateContactForBillingArrangement"),
      a = r.apartment,
      c = r.blockOrHouseNum,
      d = r.buildingName,
      s = r.country,
      u = r.countryCode,
      l = r.floor,
      p = r.postcode,
      I = r.room,
      m = r.state,
      E = r.streetName,
      R = r.unitNumber;
    return nt(o, {
      method: "POST",
      body: JSON.stringify({
        ImplContactRoleBillArrangemntUpdateRequest: {
          contactRoleName: t || "Primary",
          billingArrangementId: n,
          implPhysicalAddress: {
            apartment: a,
            blockOrHouseNum: c,
            buildingName: d,
            country: s,
            countryCode: u,
            floor: l,
            postcode: p,
            room: I,
            state: m,
            streetName: E,
            unitNumber: R
          }
        }
      })
    }).then(function (e) {
      return e.CreateContactRoleIDStruct;
    });
  },
  ls = function ls(e) {
    if (!e) return null;
    var _e$split = e.split("/"),
      _e$split2 = _slicedToArray(_e$split, 3),
      t = _e$split2[0],
      r = _e$split2[1],
      n = _e$split2[2];
    return new Date("".concat(n, "-").concat(r, "-").concat(t)).getTime();
  },
  ps = function ps() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
    return {
      type: "CHECKOUT_LOADING",
      value: e
    };
  },
  Is = function Is(e) {
    return {
      type: "CHECKOUT_ERROR",
      value: e
    };
  },
  ms = function ms(e) {
    return {
      type: "CHECKOUT_ORDER_ERROR",
      value: e
    };
  },
  Es = function Es(e) {
    return {
      type: "CHECKOUT_SUCCESS",
      value: e
    };
  },
  Rs = function Rs(e) {
    return {
      type: "CHECKOUT_ERROR_SCENARIO_CHECK",
      value: e
    };
  },
  Ss = function Ss() {
    return {
      type: nc,
      payload: {
        messageText: oc
      }
    };
  },
  _s = function _s() {
    return {
      type: nc,
      payload: {
        messageText: ic
      }
    };
  },
  Os = function Os() {
    return {
      type: ac,
      payload: {
        messageText: cc
      }
    };
  },
  Cs = function Cs() {
    return {
      type: ac,
      payload: {
        messageText: dc
      }
    };
  },
  fs = function fs(e) {
    var t = e.productOrderId,
      r = e.selectedDevicesSkuIds;
    return /*#__PURE__*/function () {
      var _ref193 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee137(e) {
        return _regeneratorRuntime.wrap(function _callee137$(_context137) {
          while (1) {
            switch (_context137.prev = _context137.next) {
              case 0:
                _context137.next = 2;
                return e(function (e) {
                  var t = e.productOrderId;
                  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee136() {
                    return _regeneratorRuntime.wrap(function _callee136$(_context136) {
                      while (1) {
                        switch (_context136.prev = _context136.next) {
                          case 0:
                            _context136.next = 2;
                            return kd({
                              productOrderId: t,
                              isBlockOrder: !1
                            });
                          case 2:
                            return _context136.abrupt("return", _context136.sent);
                          case 3:
                          case "end":
                            return _context136.stop();
                        }
                      }
                    }, _callee136);
                  }));
                }({
                  productOrderId: t
                }));
              case 2:
              case "end":
                return _context137.stop();
            }
          }
        }, _callee137);
      }));
      return function (_x132) {
        return _ref193.apply(this, arguments);
      };
    }();
  },
  ys = function ys(e) {
    var t = e.customerId,
      r = e.productOrderId,
      n = e.productOrderItemId,
      o = e.productId;
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee138() {
      return _regeneratorRuntime.wrap(function _callee138$(_context138) {
        while (1) {
          switch (_context138.prev = _context138.next) {
            case 0:
              _context138.next = 2;
              return Bd({
                customerId: t,
                productOrderId: r,
                productOrderItemId: n,
                productId: o
              });
            case 2:
              return _context138.abrupt("return", _context138.sent);
            case 3:
            case "end":
              return _context138.stop();
          }
        }
      }, _callee138);
    }));
  },
  Ts = function Ts(e, t) {
    var r;
    return e && e.forEach(function (e) {
      var n = e.productConfiguration,
        o = !r && Qa(n, t);
      o && (r = o);
    }), r;
  },
  As = function As(e) {
    var t = e.id,
      r = e.indentType;
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee139() {
      var e;
      return _regeneratorRuntime.wrap(function _callee139$(_context139) {
        while (1) {
          switch (_context139.prev = _context139.next) {
            case 0:
              e = C[r];
              _context139.next = 3;
              return La({
                id: t,
                type: e
              });
            case 3:
              return _context139.abrupt("return", _context139.sent);
            case 4:
            case "end":
              return _context139.stop();
          }
        }
      }, _callee139);
    }));
  },
  Ds = function Ds(e, t) {
    var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
    var n = {
      error: !1,
      messageText: null
    };
    if (e.error) n = {
      error: !0,
      messageText: "Error from allocateEquipmentForAvailableProducts"
    };else {
      var o = e.allocationStatusX9.find(function (e) {
        return !e.allocationOKX9 && ("Device" === e.type || r);
      });
      o && (null == t ? void 0 : t.available_quantity) <= 0 && (n = {
        error: !0,
        messageText: "".concat(o.statusMSGX9, "; itemCode = ").concat(o.itemCodeX9)
      });
    }
    return n;
  },
  Ps = /*#__PURE__*/function () {
    var _ref198 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee140(_ref197) {
      var e, _ref197$notAvailableS, t, r, n, o, _ref197$itemSkuToOrde, i, a, c, d, s;
      return _regeneratorRuntime.wrap(function _callee140$(_context140) {
        while (1) {
          switch (_context140.prev = _context140.next) {
            case 0:
              e = _ref197.cart, _ref197$notAvailableS = _ref197.notAvailableSkus, t = _ref197$notAvailableS === void 0 ? [] : _ref197$notAvailableS, r = _ref197.simOptions, n = _ref197.dispatch, o = _ref197.productOrderId, _ref197$itemSkuToOrde = _ref197.itemSkuToOrderIdMapping, i = _ref197$itemSkuToOrde === void 0 ? {} : _ref197$itemSkuToOrde;
              c = function (e, t) {
                return ns(e).filter(function (e) {
                  return !(null == t ? void 0 : t.find(function (t) {
                    return t.sku === e.skuId;
                  }));
                });
              }(e, t);
              (null == e ? void 0 : e.newlyAddedSimDetails) && c.push(null == e || null === (d = e.newlyAddedSimDetails) || void 0 === d || null === (s = d.simDetails) || void 0 === s ? void 0 : s.skuId);
              _context140.t0 = (null == c ? void 0 : c.length) > 0;
              if (!_context140.t0) {
                _context140.next = 9;
                break;
              }
              _context140.next = 7;
              return n(na({
                productOrderId: o,
                items: c,
                itemSkuToOrderIdMapping: i
              }));
            case 7:
              a = _context140.sent;
              a || (a = {
                error: !0
              });
            case 9:
              return _context140.abrupt("return", a);
            case 10:
            case "end":
              return _context140.stop();
          }
        }
      }, _callee140);
    }));
    return function Ps(_x133) {
      return _ref198.apply(this, arguments);
    };
  }(),
  vs = function vs(e) {
    return {
      type: "CALLER_BY_CONTACT_SUCCESS",
      payload: e
    };
  },
  hs = /*#__PURE__*/function () {
    var _ref199 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee141(e) {
      var t, r, n;
      return _regeneratorRuntime.wrap(function _callee141$(_context141) {
        while (1) {
          switch (_context141.prev = _context141.next) {
            case 0:
              _context141.next = 2;
              return Vd({
                contactId: e
              });
            case 2:
              n = _context141.sent;
              return _context141.abrupt("return", null == n || null === (t = n.implContactPerson) || void 0 === t || null === (r = t.address) || void 0 === r ? void 0 : r.addressId);
            case 4:
            case "end":
              return _context141.stop();
          }
        }
      }, _callee141);
    }));
    return function hs(_x134) {
      return _ref199.apply(this, arguments);
    };
  }(),
  gs = /*#__PURE__*/function () {
    var _ref201 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee142(_ref200) {
      var e, t, r, n, o, _ref202, i, a;
      return _regeneratorRuntime.wrap(function _callee142$(_context142) {
        while (1) {
          switch (_context142.prev = _context142.next) {
            case 0:
              e = _ref200.customerId, t = _ref200.contactId, r = _ref200.deliveryMethod, n = _ref200.customerInfo;
              _context142.next = 3;
              return xd({
                contactId: t,
                customerId: e,
                billingAddress: n.address,
                deliveryMethod: r
              });
            case 3:
              o = _context142.sent;
              _ref202 = (null == n ? void 0 : n.personIdentificationDetails) || {};
              i = _ref202.type;
              a = _ref202.docNumber;
              _context142.t0 = o;
              _context142.next = 10;
              return is(a, i);
            case 10:
              _context142.t1 = _context142.sent;
              return _context142.abrupt("return", {
                billingAccountRes: _context142.t0,
                contactDataRes: _context142.t1
              });
            case 12:
            case "end":
              return _context142.stop();
          }
        }
      }, _callee142);
    }));
    return function gs(_x135) {
      return _ref201.apply(this, arguments);
    };
  }(),
  Ns = "EKYC_INITIALIZATION_LOADING",
  bs = "EKYC_INITIALIZATION_SUCCESS",
  Ls = "EKYC_INITIALIZATION_FAILURE",
  Us = "EKYC_VERIFICATION_LOADING",
  Ms = "EKYC_VERIFICATION_SUCCESS",
  ws = "EKYC_VERIFICATION_FAILURE",
  Gs = function Gs() {
    var e = bi + "/api/sg/v1/eshop-ekyc/online-eshop/kyc/verify",
      t = {
        method: "POST",
        queryParams: {
          sc: "SS",
          lo: "en_US"
        },
        body: JSON.stringify({}),
        credentials: "include"
      };
    return nt(e, t).then(function (e) {
      var t;
      return null === (t = e.body) || void 0 === t ? void 0 : t.result;
    });
  },
  Fs = function Fs(e) {
    var t = e.eKycRequired,
      r = e.purposeOfVerify,
      n = bi + "/api/sg/v1/eshop-ekyc/online-eshop/kyc/initiate",
      o = {
        method: "POST",
        queryParams: {
          sc: "SS",
          lo: "en_US"
        },
        body: JSON.stringify({
          simComponent: t ? "shop_01" : "shop_02",
          purposeOfVerify: r
        }),
        credentials: "include"
      };
    return nt(n, o).then(function (e) {
      var t;
      return null === (t = e.body) || void 0 === t ? void 0 : t.result;
    });
  },
  ks = function ks(e) {
    return {
      type: "EKYC_VERIFICATION_SUCCESS",
      payload: e
    };
  },
  Bs = function Bs(e) {
    return /*#__PURE__*/function () {
      var _ref203 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee143(t) {
        var r;
        return _regeneratorRuntime.wrap(function _callee143$(_context143) {
          while (1) {
            switch (_context143.prev = _context143.next) {
              case 0:
                t({
                  type: "EKYC_INITIALIZATION_LOADING"
                });
                _context143.prev = 1;
                _context143.next = 4;
                return Fs(e);
              case 4:
                r = _context143.sent;
                t(r ? {
                  type: "EKYC_INITIALIZATION_SUCCESS",
                  payload: r
                } : {
                  type: "EKYC_INITIALIZATION_FAILURE"
                });
                _context143.next = 11;
                break;
              case 8:
                _context143.prev = 8;
                _context143.t0 = _context143["catch"](1);
                t({
                  type: "EKYC_INITIALIZATION_FAILURE"
                });
              case 11:
              case "end":
                return _context143.stop();
            }
          }
        }, _callee143, null, [[1, 8]]);
      }));
      return function (_x136) {
        return _ref203.apply(this, arguments);
      };
    }();
  };
var Vs = Object.freeze({
  __proto__: null,
  initEkycWithEshop: Bs,
  verifyEkycWithEshop: function verifyEkycWithEshop() {
    return /*#__PURE__*/function () {
      var _ref204 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee144(e) {
        var t;
        return _regeneratorRuntime.wrap(function _callee144$(_context144) {
          while (1) {
            switch (_context144.prev = _context144.next) {
              case 0:
                e({
                  type: "EKYC_VERIFICATION_LOADING"
                });
                _context144.prev = 1;
                _context144.next = 4;
                return Gs();
              case 4:
                t = _context144.sent;
                e(t ? ks(t) : {
                  type: "EKYC_VERIFICATION_FAILURE"
                });
                _context144.next = 11;
                break;
              case 8:
                _context144.prev = 8;
                _context144.t0 = _context144["catch"](1);
                e({
                  type: "EKYC_VERIFICATION_FAILURE"
                });
              case 11:
              case "end":
                return _context144.stop();
            }
          }
        }, _callee144, null, [[1, 8]]);
      }));
      return function (_x137) {
        return _ref204.apply(this, arguments);
      };
    }();
  },
  verifyEkycWithMcss: function verifyEkycWithMcss() {
    return /*#__PURE__*/function () {
      var _ref205 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee145(e) {
        var t;
        return _regeneratorRuntime.wrap(function _callee145$(_context145) {
          while (1) {
            switch (_context145.prev = _context145.next) {
              case 0:
                e({
                  type: "EKYC_VERIFICATION_LOADING"
                });
                _context145.prev = 1;
                _context145.next = 4;
                return nt(i + "/user/customer-check", {
                  method: "GET",
                  queryParams: {
                    sc: "SS",
                    lo: "en_US"
                  },
                  credentials: "include"
                }).then(function (e) {
                  return e.ImplUserIdentityCheckRestOutput;
                });
              case 4:
                t = _context145.sent;
                e(t ? ks(t) : {
                  type: "EKYC_VERIFICATION_FAILURE"
                });
                _context145.next = 11;
                break;
              case 8:
                _context145.prev = 8;
                _context145.t0 = _context145["catch"](1);
                e({
                  type: "EKYC_VERIFICATION_FAILURE"
                });
              case 11:
              case "end":
                return _context145.stop();
            }
          }
        }, _callee145, null, [[1, 8]]);
      }));
      return function (_x138) {
        return _ref205.apply(this, arguments);
      };
    }();
  }
});
var Ys = function Ys(e) {
    var t = e.userInfo,
      r = e.productOrderId,
      n = e.productOrderReferenceNumber,
      o = e.customerId,
      _e$technicalVasIds4 = e.technicalVasIds,
      i = _e$technicalVasIds4 === void 0 ? [] : _e$technicalVasIds4,
      _e$aspireBillingOffer5 = e.aspireBillingOffers,
      a = _e$aspireBillingOffer5 === void 0 ? [] : _e$aspireBillingOffer5,
      c = e.selectedDevicesSkuIds,
      d = e.productId,
      _e$isSimOnlyIPP2 = e.isSimOnlyIPP,
      s = _e$isSimOnlyIPP2 === void 0 ? !1 : _e$isSimOnlyIPP2,
      u = e.productOrderItemId,
      l = e.removedContainedProducts,
      p = e.notAvailableSkus,
      I = e.simOptions,
      m = e.cart,
      E = e.itemSkuToOrderIdMapping,
      _e$selectedSimType = e.selectedSimType,
      R = _e$selectedSimType === void 0 ? null : _e$selectedSimType;
    return /*#__PURE__*/function () {
      var _ref206 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee147(e) {
        var S, O, f, y, _n31, _o18, _O$clientContext$cont, _i17, _a15, _l, _T, _A, _D, _t57, _r47, _t58, _t59, _t60, T, _c16;
        return _regeneratorRuntime.wrap(function _callee147$(_context147) {
          while (1) {
            switch (_context147.prev = _context147.next) {
              case 0:
                S = function S(t, r) {
                  return e({
                    type: "GA_TRACKING_CHECKOUT_ERRORS",
                    payload: {
                      label: r || t
                    }
                  }), e(Is({
                    checkoutErrorCode: t
                  }));
                };
                e(ps());
                _context147.prev = 2;
                _context147.next = 5;
                return Dc({
                  productOrderItemId: u,
                  removedContainedProducts: l
                });
              case 5:
                _context147.next = 10;
                break;
              case 7:
                _context147.prev = 7;
                _context147.t0 = _context147["catch"](2);
                return _context147.abrupt("return", (e(Ss()), e(Os()), e(Is())));
              case 10:
                _context147.next = 12;
                return Dt();
              case 12:
                O = _context147.sent;
                if (!(null == O ? void 0 : O.clientContext)) {
                  _context147.next = 77;
                  break;
                }
                _n31 = O.clientContext.customers.map(function (e) {
                  return e.customerId;
                }), _o18 = null === (f = O.clientContext) || void 0 === f || null === (y = f.customers) || void 0 === y ? void 0 : y.find(function (e) {
                  return "Primary" === e.contactRole;
                }), _O$clientContext$cont = O.clientContext.contact, _i17 = _O$clientContext$cont.indentValue, _a15 = _O$clientContext$cont.indentType;
                if (!(_a15 && "NRIC" !== C[_a15] && s)) {
                  _context147.next = 17;
                  break;
                }
                return _context147.abrupt("return", e(Is({
                  checkoutErrorCode: "FOREIGNER_SIGNUP_IPP"
                })));
              case 17:
                _context147.prev = 17;
                _context147.next = 20;
                return e(As({
                  id: _i17,
                  indentType: _a15
                }));
              case 20:
                _l = _context147.sent;
                if (!_l) {
                  _context147.next = 24;
                  break;
                }
                if (!_l.find(function (e) {
                  return e.paInd;
                })) {
                  _context147.next = 24;
                  break;
                }
                return _context147.abrupt("return", (e(_s()), e(Cs()), e(Is({
                  checkoutErrorCode: "OUTSTANDING_BILL"
                }))));
              case 24:
                _context147.next = 29;
                break;
              case 26:
                _context147.prev = 26;
                _context147.t1 = _context147["catch"](17);
                return _context147.abrupt("return", (e(Ss()), e(Os()), e(Is())));
              case 29:
                _T = t.contactId, _A = t.indentValue, _D = t.registeredName;
                _context147.prev = 30;
                _context147.next = 33;
                return e(function (e) {
                  var t = e.contactId,
                    r = e.productOrderId,
                    n = e.name,
                    o = e.indentType,
                    i = e.nric;
                  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee146() {
                    var e;
                    return _regeneratorRuntime.wrap(function _callee146$(_context146) {
                      while (1) {
                        switch (_context146.prev = _context146.next) {
                          case 0:
                            e = _[o];
                            _context146.next = 3;
                            return as({
                              contactId: t,
                              productOrderId: r,
                              name: n,
                              idType: e,
                              nric: i
                            });
                          case 3:
                            return _context146.abrupt("return", _context146.sent);
                          case 4:
                          case "end":
                            return _context146.stop();
                        }
                      }
                    }, _callee146);
                  }));
                }({
                  contactId: _T,
                  productOrderId: r,
                  name: _D,
                  indentType: _a15,
                  nric: _A
                }));
              case 33:
                _context147.next = 38;
                break;
              case 35:
                _context147.prev = 35;
                _context147.t2 = _context147["catch"](30);
                return _context147.abrupt("return", (e(Ss()), e(Os()), e(Is())));
              case 38:
                _context147.prev = 38;
                _context147.next = 41;
                return e(fs({
                  contactIds: _n31,
                  productOrderId: r,
                  selectedDevicesSkuIds: c
                }));
              case 41:
                _context147.next = 46;
                break;
              case 43:
                _context147.prev = 43;
                _context147.t3 = _context147["catch"](38);
                return _context147.abrupt("return", (e(Ss()), e(Os()), e(Is(_context147.t3))));
              case 46:
                _context147.prev = 46;
                _context147.next = 49;
                return e(ys({
                  customerId: (null == _o18 ? void 0 : _o18.customerId) || _n31[0],
                  productOrderId: r,
                  productOrderItemId: u,
                  productId: d
                }));
              case 49:
                _t57 = _context147.sent;
                if (!(_t57 && _t57.productConfigurations)) {
                  _context147.next = 56;
                  break;
                }
                _r47 = Ts(_t57.productConfigurations);
                if (!_r47) {
                  _context147.next = 56;
                  break;
                }
                e(ec(_r47, "CHECKOUT")), e(tc(_r47, "CHECKOUT"));
                _t58 = function (e) {
                  var t = e.messages,
                    r = e.errorCode;
                  return t.find(function (e) {
                    return e.text.includes(r);
                  });
                }({
                  messages: _r47,
                  errorCode: "B7.1"
                });
                return _context147.abrupt("return", e(s && _t58 ? Is({
                  checkoutErrorCode: "CHECKOUT_ERROR_IPP_CREDIT_RATING"
                }) : ms(_r47)));
              case 56:
                _context147.next = 58;
                return xs({
                  cart: m,
                  notAvailableSkus: p,
                  productOrderId: r,
                  dispatch: e,
                  dispatchError: S,
                  simOptions: I,
                  itemSkuToOrderIdMapping: E
                });
              case 58:
                _context147.next = 63;
                break;
              case 60:
                _context147.prev = 60;
                _context147.t4 = _context147["catch"](46);
                return _context147.abrupt("return", (e(Ss()), e(Os()), e(Is())));
              case 63:
                if (!(e(ps(!1)), !R)) {
                  _context147.next = 65;
                  break;
                }
                return _context147.abrupt("return", e(Is()));
              case 65:
                _context147.prev = 65;
                _t59 = {
                  eKycRequired: "noSIM" !== R,
                  purposeOfVerify: "SignUpNewService"
                };
                _context147.next = 69;
                return e(Bs(_t59));
              case 69:
                return _context147.abrupt("return", e(Es({})));
              case 72:
                _context147.prev = 72;
                _context147.t5 = _context147["catch"](65);
                e(Is());
              case 75:
                _context147.next = 90;
                break;
              case 77:
                _context147.prev = 77;
                _context147.next = 80;
                return ma({
                  customerId: o,
                  productOrderId: r,
                  productOrderReferenceNumber: n
                });
              case 80:
                _t60 = _context147.sent;
                _c16 = Aa({
                  info: null === (T = _t60) || void 0 === T ? void 0 : T.order,
                  technicalVasIds: i,
                  aspireBillingOffers: a
                });
                _context147.next = 84;
                return xs({
                  cart: m,
                  notAvailableSkus: p,
                  productOrderId: r,
                  dispatch: e,
                  dispatchError: S,
                  simOptions: I
                });
              case 84:
                return _context147.abrupt("return", e(Es(_c16)));
              case 87:
                _context147.prev = 87;
                _context147.t6 = _context147["catch"](77);
                return _context147.abrupt("return", (e(Ss()), e(Os()), e(Is())));
              case 90:
              case "end":
                return _context147.stop();
            }
          }
        }, _callee147, null, [[2, 7], [17, 26], [30, 35], [38, 43], [46, 60], [65, 72], [77, 87]]);
      }));
      return function (_x139) {
        return _ref206.apply(this, arguments);
      };
    }();
  },
  xs = /*#__PURE__*/function () {
    var _ref209 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee148(_ref208) {
      var e, t, r, n, o, i, a, _t61, _r48;
      return _regeneratorRuntime.wrap(function _callee148$(_context148) {
        while (1) {
          switch (_context148.prev = _context148.next) {
            case 0:
              e = _ref208.cart, t = _ref208.notAvailableSkus, r = _ref208.productOrderId, n = _ref208.dispatch, o = _ref208.simOptions, i = _ref208.dispatchError;
              _context148.next = 3;
              return Ps({
                cart: e,
                notAvailableSkus: t,
                simOptions: o,
                productOrderId: r,
                dispatch: n
              });
            case 3:
              a = _context148.sent;
              if (!a) {
                _context148.next = 8;
                break;
              }
              _t61 = null == e ? void 0 : e.itemCollectionAtStore, _r48 = Ds(a, _t61);
              if (!_r48.error) {
                _context148.next = 8;
                break;
              }
              return _context148.abrupt("return", i("CHECKOUT_ERROR_OUT_OF_STOCK", _r48.messageText));
            case 8:
            case "end":
              return _context148.stop();
          }
        }
      }, _callee148);
    }));
    return function xs(_x140) {
      return _ref209.apply(this, arguments);
    };
  }(),
  Hs = function Hs(e) {
    var t = e.billingAccountId;
    return nt("".concat(i, "/customer/customer-bill-spec/").concat(t, "/pay-channel"), {
      method: "GET",
      queryParams: {
        sc: "SS",
        lo: "en_US"
      }
    });
  },
  $s = function $s(e) {
    var t = e.barId,
      r = e.customerId,
      n = e.productId,
      o = e.productOrderId,
      i = e.productOrderItemId,
      a = e.productOrderReferenceNumber,
      c = e.contact;
    return /*#__PURE__*/function () {
      var _ref210 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee151(e) {
        var d;
        return _regeneratorRuntime.wrap(function _callee151$(_context151) {
          while (1) {
            switch (_context151.prev = _context151.next) {
              case 0:
                _context151.next = 2;
                return Hs({
                  billingAccountId: t
                });
              case 2:
                d = _context151.sent;
                _context151.next = 5;
                return Hd({
                  customerId: r,
                  productOrderId: o,
                  productOrderItemId: i,
                  pcnId: d
                });
              case 5:
                _context151.next = 7;
                return e(function (e) {
                  var t = e.contact,
                    r = e.customerId,
                    n = e.productOrderReferenceNumber;
                  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee149() {
                    var e;
                    return _regeneratorRuntime.wrap(function _callee149$(_context149) {
                      while (1) {
                        switch (_context149.prev = _context149.next) {
                          case 0:
                            e = {
                              deliveryMethod: "Not Applicable",
                              transactionType: "NEW_SIGN_UP",
                              addressId: void 0,
                              recipientDocumentType: t.indentType,
                              recipientDocumentId: t.indentValue,
                              recipientFirstName: t.firstName,
                              recipientLastName: t.lastName,
                              recipientPhone: t.phone,
                              recipientEmail: t.email,
                              shippingInstructions: "shippingInstructions",
                              newSIMList: [],
                              documentRequired: !1,
                              isSnailMail: !1
                            };
                            _context149.next = 3;
                            return Oi({
                              customerId: r,
                              productOrderReferenceNumber: n,
                              payload: e
                            });
                          case 3:
                            return _context149.abrupt("return", _context149.sent);
                          case 4:
                          case "end":
                            return _context149.stop();
                        }
                      }
                    }, _callee149);
                  }));
                }({
                  contact: c,
                  customerId: r,
                  productOrderReferenceNumber: a
                }));
              case 7:
                _context151.next = 9;
                return e(function (e) {
                  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee150() {
                    var t, r, n, o, i;
                    return _regeneratorRuntime.wrap(function _callee150$(_context150) {
                      while (1) {
                        switch (_context150.prev = _context150.next) {
                          case 0:
                            t = e.customerId, r = e.productOrderId, n = e.productOrderItemId, o = e.productId, i = {
                              ImplUpdateOrderProductsRequest: {
                                returnRemovedItems: !1,
                                returnRemovedByReplaceItems: !1,
                                settingsViewFilter: "FULL",
                                stepsToRetrieve: [],
                                stepsToValidate: [],
                                attachmentTypes: [],
                                runCompatibilityRules: !0,
                                activityForConfiguration: "QuoteSDOrderSummary+++promoCode+++EMPTY",
                                confirmationMessagesApproved: !1,
                                saveIfCompatibilityRulesFailed: !1,
                                addDefaultChildItemsImplicitly: !1,
                                returnConfigurationData: {
                                  catalogDataInd: !0,
                                  crossProductsDiscountsDataInd: !0,
                                  previousQuotedRecurringPricesInd: !1,
                                  productConfigurationInd: !0,
                                  quotedPricesInd: !0,
                                  quotedProrationInd: !0,
                                  quotedTaxInd: !0,
                                  summaryInd: !0
                                },
                                implUpdateOrderProductConfigurationList: [{
                                  productOrderItemId: n,
                                  returnFullUpcResponse: !1,
                                  productConfigurationChanges: {
                                    links: [],
                                    resumedContainedProducts: [],
                                    changedContainedProducts: [{
                                      productID: o
                                    }],
                                    newContainedProducts: [],
                                    removedContainedProducts: [],
                                    suspendedContainedProducts: []
                                  }
                                }]
                              }
                            };
                            _context150.next = 3;
                            return ii({
                              customerId: t,
                              productOrderId: r,
                              payload: i
                            });
                          case 3:
                          case "end":
                            return _context150.stop();
                        }
                      }
                    }, _callee150);
                  }));
                }({
                  customerId: r,
                  productOrderId: o,
                  productOrderItemId: i,
                  productId: n
                }));
              case 9:
              case "end":
                return _context151.stop();
            }
          }
        }, _callee151);
      }));
      return function (_x141) {
        return _ref210.apply(this, arguments);
      };
    }();
  },
  qs = function qs(e) {
    var t = e.userInfo,
      r = e.simOptions,
      n = e.productId,
      o = e.productOrderId,
      i = e.productOrderItemId,
      a = e.productOrderReferenceNumber,
      c = e.cart,
      d = e.barId,
      _e$skipFulfillmentChe = e.skipFulfillmentCheck,
      s = _e$skipFulfillmentChe === void 0 ? !1 : _e$skipFulfillmentChe,
      u = e.removedContainedProducts,
      _e$notAvailableSkus = e.notAvailableSkus,
      l = _e$notAvailableSkus === void 0 ? [] : _e$notAvailableSkus,
      _e$itemSkuToOrderIdMa = e.itemSkuToOrderIdMapping,
      p = _e$itemSkuToOrderIdMa === void 0 ? {} : _e$itemSkuToOrderIdMa,
      I = e.selectedSimType;
    return /*#__PURE__*/function () {
      var _ref213 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee152(e) {
        var m, E, R, S, _, O, C, f, y, T, A, D, _t62, _r49, P, v, _t63, _r50, h, g, _t64, _t65;
        return _regeneratorRuntime.wrap(function _callee152$(_context152) {
          while (1) {
            switch (_context152.prev = _context152.next) {
              case 0:
                e(ps());
                _context152.prev = 1;
                _context152.next = 4;
                return Dc({
                  productOrderItemId: i,
                  removedContainedProducts: u
                });
              case 4:
                _context152.next = 9;
                break;
              case 6:
                _context152.prev = 6;
                _context152.t0 = _context152["catch"](1);
                return _context152.abrupt("return", (e(Ss()), e(Os()), e(Is())));
              case 9:
                S = d || (null == c || null === (m = c.order) || void 0 === m ? void 0 : m.barId), _ = null == c ? void 0 : c.order, O = null == c || null === (E = c.order) || void 0 === E || null === (R = E.mobile) || void 0 === R ? void 0 : R.serviceId, C = t.customerId, f = t.contactId, y = t.indentType, T = t.indentValue, A = t.registeredName;
                _context152.prev = 10;
                _context152.next = 13;
                return e(As({
                  id: T,
                  indentType: y
                }));
              case 13:
                D = _context152.sent;
                if (!D) {
                  _context152.next = 17;
                  break;
                }
                if (!D.find(function (e) {
                  return e.paInd;
                })) {
                  _context152.next = 17;
                  break;
                }
                return _context152.abrupt("return", (e(_s()), e(Cs()), e(Is({
                  checkoutErrorCode: "OUTSTANDING_BILL"
                }))));
              case 17:
                _context152.next = 22;
                break;
              case 19:
                _context152.prev = 19;
                _context152.t1 = _context152["catch"](10);
                return _context152.abrupt("return", (e(Ss()), e(Os()), e(Is())));
              case 22:
                _context152.prev = 22;
                _context152.next = 25;
                return e(fs({
                  contactIds: f,
                  productOrderId: o
                }));
              case 25:
                _context152.next = 30;
                break;
              case 27:
                _context152.prev = 27;
                _context152.t2 = _context152["catch"](22);
                return _context152.abrupt("return", (e(Ss()), e(Os()), e(Is())));
              case 30:
                _context152.prev = 30;
                _context152.next = 33;
                return e(ys({
                  customerId: C,
                  productOrderId: o,
                  productOrderItemId: i,
                  productId: n
                }));
              case 33:
                _t62 = _context152.sent;
                if (!(_t62 && _t62.productConfigurations)) {
                  _context152.next = 38;
                  break;
                }
                _r49 = Ts(_t62.productConfigurations);
                if (!_r49) {
                  _context152.next = 38;
                  break;
                }
                return _context152.abrupt("return", (e(ec(_r49, "CHECKOUT")), e(tc(_r49, "CHECKOUT")), e(Is(_r49))));
              case 38:
                _context152.next = 43;
                break;
              case 40:
                _context152.prev = 40;
                _context152.t3 = _context152["catch"](30);
                return _context152.abrupt("return", (e(Ss()), e(Os()), e(Is())));
              case 43:
                _context152.t4 = !!s;
                if (_context152.t4) {
                  _context152.next = 48;
                  break;
                }
                _context152.next = 47;
                return e(rs({
                  billingAccounts: D,
                  contactId: f,
                  productOrderReferenceNumber: a,
                  indentType: y,
                  barId: S,
                  cartOrder: _,
                  customerId: C,
                  serviceId: O,
                  nric: T
                }));
              case 47:
                _context152.t4 = _context152.sent;
              case 48:
                P = _context152.t4;
                _context152.next = 51;
                return Ps({
                  cart: c,
                  notAvailableSkus: l,
                  simOptions: r,
                  productOrderId: o,
                  dispatch: e,
                  itemSkuToOrderIdMapping: p
                });
              case 51:
                v = _context152.sent;
                if (!v) {
                  _context152.next = 56;
                  break;
                }
                _t63 = null == c ? void 0 : c.itemCollectionAtStore, _r50 = Ds(v, _t63);
                if (!_r50.error) {
                  _context152.next = 56;
                  break;
                }
                return _context152.abrupt("return", (h = "CHECKOUT_ERROR_OUT_OF_STOCK", g = _r50.messageText, e({
                  type: "GA_TRACKING_CHECKOUT_ERRORS",
                  payload: {
                    label: g || h
                  }
                }), e(Is({
                  checkoutErrorCode: h
                }))));
              case 56:
                if (!(P || !S)) {
                  _context152.next = 69;
                  break;
                }
                if (I) {
                  _context152.next = 59;
                  break;
                }
                return _context152.abrupt("return", e(Is()));
              case 59:
                _context152.prev = 59;
                _t64 = {
                  eKycRequired: "noSIM" !== I,
                  purposeOfVerify: "RecontractExistingService"
                };
                _context152.next = 63;
                return e(Bs(_t64));
              case 63:
                return _context152.abrupt("return", e(Es({
                  skipOF: !1
                })));
              case 66:
                _context152.prev = 66;
                _context152.t5 = _context152["catch"](59);
                e(Is());
              case 69:
                if (P) {
                  _context152.next = 91;
                  break;
                }
                e(ps(!1));
                _context152.prev = 71;
                _context152.next = 74;
                return e($s({
                  barId: S,
                  contact: t,
                  customerId: C,
                  contactId: f,
                  productId: n,
                  productOrderId: o,
                  productOrderItemId: i,
                  productOrderReferenceNumber: a,
                  nric: T
                }));
              case 74:
                if (I) {
                  _context152.next = 76;
                  break;
                }
                return _context152.abrupt("return", e(Is()));
              case 76:
                _context152.prev = 76;
                _t65 = {
                  eKycRequired: "noSIM" !== I,
                  purposeOfVerify: "RecontractExistingService"
                };
                _context152.next = 80;
                return e(Bs(_t65));
              case 80:
                return _context152.abrupt("return", e(Es({
                  skipOF: !0
                })));
              case 83:
                _context152.prev = 83;
                _context152.t6 = _context152["catch"](76);
                e(Is());
              case 86:
                _context152.next = 91;
                break;
              case 88:
                _context152.prev = 88;
                _context152.t7 = _context152["catch"](71);
                e(Is());
              case 91:
              case "end":
                return _context152.stop();
            }
          }
        }, _callee152, null, [[1, 6], [10, 19], [22, 27], [30, 40], [59, 66], [71, 88], [76, 83]]);
      }));
      return function (_x142) {
        return _ref213.apply(this, arguments);
      };
    }();
  };
var Ws = Object.freeze({
  __proto__: null,
  checkout: function checkout(e) {
    var t = e.type,
      r = _objectWithoutProperties(e, _excluded8);
    return /*#__PURE__*/function () {
      var _ref214 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee154(e) {
        return _regeneratorRuntime.wrap(function _callee154$(_context154) {
          while (1) {
            switch (_context154.prev = _context154.next) {
              case 0:
                if (!("RECON" === t)) {
                  _context154.next = 6;
                  break;
                }
                _context154.next = 3;
                return e(qs(r));
              case 3:
                _context154.t0 = _context154.sent;
                _context154.next = 16;
                break;
              case 6:
                if (!("NEW" === t)) {
                  _context154.next = 12;
                  break;
                }
                _context154.next = 9;
                return e(function (e) {
                  var t = e.productOrderId,
                    r = e.selectedDevicesSkuIds,
                    n = e.productId,
                    o = e.productOrderItemId,
                    _e$isSimOnlyIPP3 = e.isSimOnlyIPP,
                    i = _e$isSimOnlyIPP3 === void 0 ? !1 : _e$isSimOnlyIPP3,
                    _e$isRrpIppOrder6 = e.isRrpIppOrder,
                    a = _e$isRrpIppOrder6 === void 0 ? !1 : _e$isRrpIppOrder6,
                    c = e.removedContainedProducts,
                    d = e.notAvailableSkus,
                    s = e.cart,
                    u = e.simOptions,
                    _e$itemSkuToOrderIdMa2 = e.itemSkuToOrderIdMapping,
                    l = _e$itemSkuToOrderIdMa2 === void 0 ? {} : _e$itemSkuToOrderIdMa2,
                    _e$selectedSimType2 = e.selectedSimType,
                    p = _e$selectedSimType2 === void 0 ? null : _e$selectedSimType2;
                  return /*#__PURE__*/function () {
                    var _ref215 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee153(I) {
                      var m, E, R, S, _t66, _r51, _n32, _e$technicalVasIds5, _o19, _e$aspireBillingOffer6, _i18, _a16, _e77, _t67, _r52, _c17, _, O, f, _ref216, _e78, _c18, _m2, _S2, _y, _e79, _t68, _e80, _r53, _e81, _t69, _e82;
                      return _regeneratorRuntime.wrap(function _callee153$(_context153) {
                        while (1) {
                          switch (_context153.prev = _context153.next) {
                            case 0:
                              E = function E(e, t) {
                                return I({
                                  type: "GA_TRACKING_CHECKOUT_ERRORS",
                                  payload: {
                                    label: t || e
                                  }
                                }), I(Is({
                                  checkoutErrorCode: e
                                }));
                              };
                              I(ps());
                              _context153.prev = 2;
                              _context153.next = 5;
                              return Dc({
                                productOrderItemId: o,
                                removedContainedProducts: c
                              });
                            case 5:
                              _context153.next = 10;
                              break;
                            case 7:
                              _context153.prev = 7;
                              _context153.t0 = _context153["catch"](2);
                              return _context153.abrupt("return", (I(Ss()), I(Os()), I(Is())));
                            case 10:
                              _context153.prev = 10;
                              _context153.next = 13;
                              return Dt();
                            case 13:
                              R = _context153.sent;
                              _context153.next = 18;
                              break;
                            case 16:
                              _context153.prev = 16;
                              _context153.t1 = _context153["catch"](10);
                            case 18:
                              if (null === (m = R) || void 0 === m ? void 0 : m.clientContext) {
                                _context153.next = 38;
                                break;
                              }
                              _t66 = e.customerId, _r51 = e.productOrderId, _n32 = e.productOrderReferenceNumber, _e$technicalVasIds5 = e.technicalVasIds, _o19 = _e$technicalVasIds5 === void 0 ? [] : _e$technicalVasIds5, _e$aspireBillingOffer6 = e.aspireBillingOffers, _i18 = _e$aspireBillingOffer6 === void 0 ? [] : _e$aspireBillingOffer6;
                              _context153.prev = 20;
                              _context153.next = 23;
                              return ma({
                                customerId: _t66,
                                productOrderId: _r51,
                                productOrderReferenceNumber: _n32
                              });
                            case 23:
                              _a16 = _context153.sent;
                              _context153.next = 26;
                              return Ps({
                                cart: s,
                                notAvailableSkus: d,
                                simOptions: u,
                                productOrderId: _r51,
                                dispatch: I,
                                itemSkuToOrderIdMapping: l
                              });
                            case 26:
                              _e77 = _context153.sent;
                              if (!_e77) {
                                _context153.next = 31;
                                break;
                              }
                              _t67 = null == s ? void 0 : s.itemCollectionAtStore, _r52 = Ds(_e77, _t67);
                              if (!_r52.error) {
                                _context153.next = 31;
                                break;
                              }
                              return _context153.abrupt("return", E("CHECKOUT_ERROR_OUT_OF_STOCK", _r52.messageText));
                            case 31:
                              _context153.next = 36;
                              break;
                            case 33:
                              _context153.prev = 33;
                              _context153.t2 = _context153["catch"](20);
                              return _context153.abrupt("return", (I(Ss()), I(Os()), I(Is())));
                            case 36:
                              _c17 = Aa({
                                info: null === (S = _a16) || void 0 === S ? void 0 : S.order,
                                technicalVasIds: _o19,
                                aspireBillingOffers: _i18
                              });
                              return _context153.abrupt("return", (I(ps(!1)), I(Es(_c17))));
                            case 38:
                              _ref216 = (null === (_ = R.clientContext) || void 0 === _ ? void 0 : _.contact) || {}, _e78 = _ref216.indentValue, _c18 = _ref216.indentType, _m2 = _ref216.contactId, _S2 = null === (O = R.clientContext) || void 0 === O || null === (f = O.customers) || void 0 === f ? void 0 : f.find(function (e) {
                                return "Primary" === e.contactRole;
                              });
                              if (!(i && "NRIC" !== C[_c18] && "FEP" !== C[_c18])) {
                                _context153.next = 41;
                                break;
                              }
                              return _context153.abrupt("return", I(Is({
                                checkoutErrorCode: "FOREIGNER_SIGNUP_IPP"
                              })));
                            case 41:
                              if (!a) {
                                _context153.next = 50;
                                break;
                              }
                              _context153.prev = 42;
                              _context153.next = 45;
                              return I(Ac({
                                contact: {
                                  contactId: _m2
                                },
                                customerId: null == _S2 ? void 0 : _S2.customerId,
                                productOrder: {
                                  productOrderItemId: null == s ? void 0 : s.productOrderItemId,
                                  productOrderReferenceNumber: null == s ? void 0 : s.productOrderReferenceNumber
                                },
                                isAnonymous: !1
                              }));
                            case 45:
                              _context153.next = 50;
                              break;
                            case 47:
                              _context153.prev = 47;
                              _context153.t3 = _context153["catch"](42);
                              return _context153.abrupt("return", E("ADD_CUSTOMER_CONTACT_ERROR"));
                            case 50:
                              _context153.prev = 50;
                              _context153.next = 53;
                              return I(As({
                                id: _e78,
                                indentType: _c18
                              }));
                            case 53:
                              _y = _context153.sent;
                              if (!_y) {
                                _context153.next = 57;
                                break;
                              }
                              if (!_y.find(function (e) {
                                return e.paInd;
                              })) {
                                _context153.next = 57;
                                break;
                              }
                              return _context153.abrupt("return", (I(_s()), I(Cs()), I(Is({
                                checkoutErrorCode: "OUTSTANDING_BILL"
                              }))));
                            case 57:
                              _context153.next = 62;
                              break;
                            case 59:
                              _context153.prev = 59;
                              _context153.t4 = _context153["catch"](50);
                              return _context153.abrupt("return", (I(Ss()), I(Os()), I(Is())));
                            case 62:
                              _context153.prev = 62;
                              _context153.t5 = a;
                              if (_context153.t5) {
                                _context153.next = 67;
                                break;
                              }
                              _context153.next = 67;
                              return It(null == _S2 ? void 0 : _S2.customerId, t);
                            case 67:
                              _context153.next = 72;
                              break;
                            case 69:
                              _context153.prev = 69;
                              _context153.t6 = _context153["catch"](62);
                              return _context153.abrupt("return", (I(Ss()), I(Os()), I(Is())));
                            case 72:
                              _context153.prev = 72;
                              _context153.next = 75;
                              return I(fs({
                                contactIds: null == _S2 ? void 0 : _S2.customerId,
                                productOrderId: t,
                                selectedDevicesSkuIds: r
                              }));
                            case 75:
                              _context153.next = 80;
                              break;
                            case 77:
                              _context153.prev = 77;
                              _context153.t7 = _context153["catch"](72);
                              return _context153.abrupt("return", (I(Ss()), I(Os()), I(Is(_context153.t7))));
                            case 80:
                              _context153.prev = 80;
                              _context153.next = 83;
                              return I(ys({
                                customerId: null == _S2 ? void 0 : _S2.customerId,
                                productOrderId: t,
                                productOrderItemId: o,
                                productId: n
                              }));
                            case 83:
                              _e79 = _context153.sent;
                              if (!(_e79 && _e79.productConfigurations)) {
                                _context153.next = 90;
                                break;
                              }
                              _t68 = Ts(_e79.productConfigurations);
                              if (!_t68) {
                                _context153.next = 90;
                                break;
                              }
                              I(ec(_t68, "CHECKOUT")), I(tc(_t68, "CHECKOUT"));
                              _e80 = _t68.find(function (e) {
                                return e.text.includes("B7.1");
                              });
                              return _context153.abrupt("return", I(_e80 && i ? Is({
                                checkoutErrorCode: "CHECKOUT_ERROR_IPP_CREDIT_RATING"
                              }) : ms(_t68)));
                            case 90:
                              _context153.next = 92;
                              return Ps({
                                cart: s,
                                notAvailableSkus: d,
                                simOptions: u,
                                productOrderId: t,
                                dispatch: I,
                                itemSkuToOrderIdMapping: l
                              });
                            case 92:
                              _r53 = _context153.sent;
                              if (!_r53) {
                                _context153.next = 97;
                                break;
                              }
                              _e81 = null == s ? void 0 : s.itemCollectionAtStore, _t69 = Ds(_r53, _e81, a);
                              if (!_t69.error) {
                                _context153.next = 97;
                                break;
                              }
                              return _context153.abrupt("return", E("CHECKOUT_ERROR_OUT_OF_STOCK", _t69.messageText));
                            case 97:
                              _context153.next = 102;
                              break;
                            case 99:
                              _context153.prev = 99;
                              _context153.t8 = _context153["catch"](80);
                              return _context153.abrupt("return", (I(Ss()), I(Os()), I(Is())));
                            case 102:
                              if (p) {
                                _context153.next = 104;
                                break;
                              }
                              return _context153.abrupt("return", I(Is()));
                            case 104:
                              _context153.prev = 104;
                              _e82 = {
                                eKycRequired: "noSIM" !== p,
                                purposeOfVerify: "SignUpNewService"
                              };
                              _context153.next = 108;
                              return I(Bs(_e82));
                            case 108:
                              return _context153.abrupt("return", I(Es({
                                skipOF: !1
                              })));
                            case 111:
                              _context153.prev = 111;
                              _context153.t9 = _context153["catch"](104);
                              I(Is());
                            case 114:
                            case "end":
                              return _context153.stop();
                          }
                        }
                      }, _callee153, null, [[2, 7], [10, 16], [20, 33], [42, 47], [50, 59], [62, 69], [72, 77], [80, 99], [104, 111]]);
                    }));
                    return function (_x144) {
                      return _ref215.apply(this, arguments);
                    };
                  }();
                }(r));
              case 9:
                _context154.t1 = _context154.sent;
                _context154.next = 15;
                break;
              case 12:
                _context154.next = 14;
                return e(Ys(r));
              case 14:
                _context154.t1 = _context154.sent;
              case 15:
                _context154.t0 = _context154.t1;
              case 16:
                return _context154.abrupt("return", _context154.t0);
              case 17:
              case "end":
                return _context154.stop();
            }
          }
        }, _callee154);
      }));
      return function (_x143) {
        return _ref214.apply(this, arguments);
      };
    }();
  },
  createCustomer: function createCustomer(e) {
    return /*#__PURE__*/function () {
      var _ref217 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee155(t) {
        var r, _n33, o, _a17, _c19, _d11, s, u, _l2, _p3, _ref218, _I3, _m3, E, _e83, _t70, _r54, _n34, _o20, _a18, _c20, _d12, _s6, _R2, _yield, S, _2, _yield$gs, _O3, _C2, f, _ref219, _y2, _ref220, _T2, _A2, D, _r55;
        return _regeneratorRuntime.wrap(function _callee155$(_context155) {
          while (1) {
            switch (_context155.prev = _context155.next) {
              case 0:
                _context155.prev = 0;
                _n33 = e.productOrder, o = e.customerInfo, _a17 = e.isSimOnlyIPP, _c19 = e.billingPref, _d11 = e.addedToContact, s = e.portIn, u = e.recalculateBlock, _l2 = e.selectedPlan, _p3 = e.shouldDeleteOpenOrder;
                t(ps());
                _ref218 = o || {}, _I3 = _ref218.contactExists, _m3 = _ref218.contactId, E = _objectWithoutProperties(_ref218, _excluded9);
                if (!_I3) {
                  _context155.next = 8;
                  break;
                }
                _e83 = E.address, _t70 = E.birthDate, _r54 = E.email, _n34 = E.givenName, _o20 = E.nationality, _a18 = E.gender, _c20 = E.phone, _d12 = E.salutation, _s6 = E.selectedOption;
                _context155.next = 8;
                return function (e) {
                  var t = e.contactId,
                    r = e.data,
                    n = "".concat(i, "/customer-management/contact-person/").concat(t),
                    o = {
                      method: "PUT",
                      queryParams: {
                        sc: "SS",
                        lo: "en_US"
                      },
                      body: JSON.stringify({
                        ImplContactPerson: _objectSpread({}, r)
                      })
                    };
                  return nt(n, o).then(function (e) {
                    return e.ImplContactPersonOutput;
                  });
                }({
                  contactId: _m3,
                  data: {
                    address: _e83,
                    birthDate: _t70,
                    emailId: _r54,
                    name: _n34,
                    nationality: _o20,
                    personGender: _a18,
                    phone: _c20,
                    salutation: _d12,
                    selectedOption: _s6
                  }
                });
              case 8:
                _R2 = _I3 && _m3 ? _objectSpread(_objectSpread({}, E), {}, {
                  contactId: _m3
                }) : E;
                _context155.next = 11;
                return function (e) {
                  return nt(i + "/customer-management/create-customer", {
                    method: "POST",
                    queryParams: {
                      sc: "SS",
                      lo: "en_US"
                    },
                    body: JSON.stringify({
                      ImplCreateCustomerInput: _objectSpread({}, e)
                    })
                  }).then(function (e) {
                    return e.ImplCreateCustomerOutput;
                  });
                }(_R2);
              case 11:
                _yield = _context155.sent;
                S = _yield.customerId;
                _2 = _yield.conatctId;
                _context155.next = 16;
                return gs({
                  customerId: S,
                  contactId: _2,
                  customerInfo: E,
                  deliveryMethod: _c19
                });
              case 16:
                _yield$gs = _context155.sent;
                _O3 = _yield$gs.contactDataRes;
                _C2 = _yield$gs.billingAccountRes;
                f = null == _O3 || null === (r = _O3.contactDetails) || void 0 === r ? void 0 : r.dateOfBirth;
                t(vs(_O3));
                _ref219 = o || {}, _y2 = _ref219.givenName, _ref220 = (null == o ? void 0 : o.personIdentificationDetails) || {}, _T2 = _ref220.type, _A2 = _ref220.docNumber;
                _context155.next = 24;
                return t(ds({
                  selectedPlan: _l2,
                  productOrder: _n33,
                  isSimOnlyIPP: _a17,
                  userInformation: {
                    clientContext: {
                      customers: [{
                        customerId: S
                      }],
                      contact: {
                        indentType: _T2,
                        indentValue: _A2,
                        registeredName: _y2,
                        contactId: _2,
                        dateOfBirth: f
                      }
                    }
                  },
                  isAnonymous: !0,
                  addedToContact: !_d11,
                  recalculateBlock: u,
                  portIn: s,
                  shouldDeleteOpenOrder: _p3
                }));
              case 24:
                _context155.next = 26;
                return hs(_2);
              case 26:
                D = _context155.sent;
                t({
                  type: "CREATE_CUSTOMER_SUCCESS",
                  value: {
                    contactId: _2,
                    customerId: S,
                    billingAccountRes: _C2,
                    addressId: D
                  }
                }), t(ps(!1));
                _context155.next = 36;
                break;
              case 30:
                _context155.prev = 30;
                _context155.t0 = _context155["catch"](0);
                _context155.next = 34;
                return _r(_context155.t0);
              case 34:
                _r55 = _context155.sent;
                t(ps(!1)), t(Is(_r55));
              case 36:
              case "end":
                return _context155.stop();
            }
          }
        }, _callee155, null, [[0, 30]]);
      }));
      return function (_x145) {
        return _ref217.apply(this, arguments);
      };
    }();
  },
  resetCreateCustomerStatus: function resetCreateCustomerStatus() {
    return {
      type: "RESET_CREATE_CUSTOMER_STATUS"
    };
  },
  allocateEquipmentForAvailableProducts: Ps,
  updateCustomer: function updateCustomer(_ref221) {
    var e = _ref221.contactId,
      t = _ref221.data,
      r = _ref221.customerId,
      n = _ref221.productOrder,
      o = _ref221.isSimOnlyIPP,
      i = _ref221.addedToContact,
      a = _ref221.customerInfo,
      c = _ref221.portIn,
      d = _ref221.recalculateBlock,
      s = _ref221.selectedPlan,
      u = _ref221.billingPref,
      l = _ref221.retrieveContactData,
      p = _ref221.shouldDeleteOpenOrder;
    return /*#__PURE__*/function () {
      var _ref222 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee156(I) {
        var m, E, _3, _O4, _ref223, _C3, _ref224, _e84, _t71, _r56, R, _t72, _ref225, f, _y3, _T3, _A3, _t73, S;
        return _regeneratorRuntime.wrap(function _callee156$(_context156) {
          while (1) {
            switch (_context156.prev = _context156.next) {
              case 0:
                _context156.prev = 0;
                I(ps());
                _3 = t.address;
                _context156.next = 5;
                return yi({
                  contactId: e,
                  productOrderReferenceNumber: n.productOrderReferenceNumber
                });
              case 5:
                _O4 = _context156.sent;
                _O4.billingAccountDetails = gi(null == _O4 ? void 0 : _O4.billingAccountDetails);
                _ref223 = (null == _O4 || null === (m = _O4.billingAccountDetails) || void 0 === m ? void 0 : m[0]) || {}, _C3 = _ref223.billingAccountNumber;
                if (!_C3) {
                  _context156.next = 18;
                  break;
                }
                _ref224 = a || {};
                _e84 = _ref224.passType;
                _t71 = _ref224.passId;
                _context156.next = 14;
                return is(_t71, _e84);
              case 14:
                _r56 = _context156.sent;
                I(vs(_r56));
                _context156.next = 22;
                break;
              case 18:
                _context156.next = 20;
                return gs({
                  customerId: r,
                  customerInfo: {
                    address: _3,
                    personIdentificationDetails: {
                      type: null == a ? void 0 : a.passType,
                      docNumber: null == a ? void 0 : a.passId
                    }
                  },
                  contactId: e,
                  deliveryMethod: u
                });
              case 20:
                _t72 = _context156.sent;
                _C3 = null == _t72 || null === (R = _t72.billingAccountRes) || void 0 === R ? void 0 : R.billingArangmentId, I(vs(null == _t72 ? void 0 : _t72.contactDataRes));
              case 22:
                _context156.next = 24;
                return us({
                  billingArrangementId: _C3,
                  billingAddress: _3
                });
              case 24:
                _ref225 = a || {}, f = _ref225.passType, _y3 = _ref225.name, _T3 = _ref225.passId;
                _context156.next = 27;
                return I(ds({
                  selectedPlan: s,
                  productOrder: n,
                  isSimOnlyIPP: o,
                  userInformation: {
                    clientContext: {
                      customers: [{
                        customerId: r
                      }],
                      contact: {
                        indentType: f,
                        registeredName: _y3,
                        indentValue: _T3,
                        contactId: e,
                        dateOfBirth: ls(null == l ? void 0 : l.birthDate)
                      }
                    }
                  },
                  isAnonymous: !0,
                  addedToContact: !i,
                  recalculateBlock: d,
                  portIn: c,
                  shouldDeleteOpenOrder: p
                }));
              case 27:
                _context156.next = 29;
                return hs(e);
              case 29:
                _A3 = _context156.sent;
                I((S = {
                  contactId: e,
                  customerId: r,
                  billingAccountRes: {
                    billingArangmentId: _C3
                  },
                  deliveryDetails: _objectSpread(_objectSpread({}, _O4), {}, {
                    billingAccountDetails: (null === (E = _O4.billingAccountDetails) || void 0 === E ? void 0 : E.length) ? _O4.billingAccountDetails : [{
                      billingAccountNumber: _C3
                    }]
                  }),
                  addressId: _A3
                }, {
                  type: Sr.CHECKOUT_ACTIONS.UPDATE_CUSTOMER_SUCCESS,
                  value: S
                })), I(ps(!1));
                _context156.next = 39;
                break;
              case 33:
                _context156.prev = 33;
                _context156.t0 = _context156["catch"](0);
                _context156.next = 37;
                return _r(_context156.t0);
              case 37:
                _t73 = _context156.sent;
                I(ps(!1)), I(Is(_t73));
              case 39:
              case "end":
                return _context156.stop();
            }
          }
        }, _callee156, null, [[0, 33]]);
      }));
      return function (_x146) {
        return _ref222.apply(this, arguments);
      };
    }();
  },
  updateCustomerContact: function updateCustomerContact(e) {
    return /*#__PURE__*/function () {
      var _ref226 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee157(t) {
        var _n35, r;
        return _regeneratorRuntime.wrap(function _callee157$(_context157) {
          while (1) {
            switch (_context157.prev = _context157.next) {
              case 0:
                t({
                  type: Sr.ORDER_SUMMARY.CUSTOMER_CONTACT_UPDATE_LOADING
                });
                _context157.prev = 1;
                _context157.next = 4;
                return function (_ref227) {
                  var e = _ref227.emailId,
                    t = _ref227.phone,
                    r = _ref227.contactId;
                  var n = "".concat(i, "/customer-management/partial/contact-person/").concat(r),
                    o = {
                      method: "PUT",
                      queryParams: {
                        sc: "SS",
                        lo: "en_US"
                      },
                      body: JSON.stringify({
                        ImplContactPerson: {
                          emailId: e,
                          phone: t
                        }
                      })
                    };
                  return nt(n, o).then(function (e) {
                    return e.ImplContactPersonOutput;
                  });
                }(e);
              case 4:
                _n35 = _context157.sent;
                return _context157.abrupt("return", (t((r = _n35, {
                  type: Sr.ORDER_SUMMARY.CUSTOMER_CONTACT_UPDATE_SUCCESS,
                  value: r
                })), _n35));
              case 8:
                _context157.prev = 8;
                _context157.t0 = _context157["catch"](1);
                t({
                  type: Sr.ORDER_SUMMARY.CUSTOMER_CONTACT_UPDATE_FAILURE
                });
              case 11:
              case "end":
                return _context157.stop();
            }
          }
        }, _callee157, null, [[1, 8]]);
      }));
      return function (_x147) {
        return _ref226.apply(this, arguments);
      };
    }();
  },
  getCallerByContact: function getCallerByContact() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return /*#__PURE__*/function () {
      var _ref228 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee158(t) {
        var r, _n36, o;
        return _regeneratorRuntime.wrap(function _callee158$(_context158) {
          while (1) {
            switch (_context158.prev = _context158.next) {
              case 0:
                _context158.prev = 0;
                t(function () {
                  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
                  return {
                    type: "CALLER_BY_CONTACT_LOADING",
                    value: e
                  };
                }());
                r = e.passType;
                _n36 = e.passId;
                _context158.next = 6;
                return is(_n36, r);
              case 6:
                o = _context158.sent;
                t(vs(o));
                _context158.next = 13;
                break;
              case 10:
                _context158.prev = 10;
                _context158.t0 = _context158["catch"](0);
                t({
                  type: "CALLER_BY_CONTACT_ERROR"
                });
              case 13:
              case "end":
                return _context158.stop();
            }
          }
        }, _callee158, null, [[0, 10]]);
      }));
      return function (_x148) {
        return _ref228.apply(this, arguments);
      };
    }();
  },
  checkExistAccount: function checkExistAccount(_ref229) {
    var e = _ref229.accountId,
      t = _ref229.mobileNumber;
    return /*#__PURE__*/function () {
      var _ref230 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee159(r) {
        var o, n;
        return _regeneratorRuntime.wrap(function _callee159$(_context159) {
          while (1) {
            switch (_context159.prev = _context159.next) {
              case 0:
                _context159.prev = 0;
                r(ps());
                _context159.next = 4;
                return function (e) {
                  var t = e.mobileNumber,
                    r = e.accountId;
                  return nt(i + "/sdp/manage-customer-payments/check-exist-account", {
                    method: "POST",
                    body: JSON.stringify({
                      ImplManageCustomerPaymentsRestInput: {
                        mobileNumber: t,
                        accountId: r
                      }
                    })
                  }).then(function (e) {
                    return e.ImplManageCustomerPaymentsRestOutput;
                  });
                }({
                  accountId: e,
                  mobileNumber: t
                });
              case 4:
                o = _context159.sent;
                return _context159.abrupt("return", (r((n = o, {
                  type: Sr.CHECKOUT_ACTIONS.CHECK_EXIST_ACCOUNT_SUCCESS,
                  data: n
                })), r(ps(!1)), o));
              case 8:
                _context159.prev = 8;
                _context159.t0 = _context159["catch"](0);
                r(ps(!1)), r(Is());
              case 11:
              case "end":
                return _context159.stop();
            }
          }
        }, _callee159, null, [[0, 8]]);
      }));
      return function (_x149) {
        return _ref230.apply(this, arguments);
      };
    }();
  },
  checkIdentity: function checkIdentity(_ref231) {
    var e = _ref231.identity,
      t = _ref231.identityType;
    return /*#__PURE__*/function () {
      var _ref232 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee160(r) {
        var o, n;
        return _regeneratorRuntime.wrap(function _callee160$(_context160) {
          while (1) {
            switch (_context160.prev = _context160.next) {
              case 0:
                _context160.prev = 0;
                r(ps());
                _context160.next = 4;
                return function (_ref233) {
                  var e = _ref233.identity,
                    t = _ref233.identityType;
                  return nt(i + "/user/identity-check", {
                    method: "POST",
                    body: JSON.stringify({
                      ImplUserIdentityCheckRestInput: {
                        identity: e,
                        identityType: t
                      }
                    })
                  }).then(function (e) {
                    return e.ImplUserIdentityCheckRestOutput;
                  });
                }({
                  identity: e,
                  identityType: t
                });
              case 4:
                o = _context160.sent;
                return _context160.abrupt("return", (r((n = o, {
                  type: Sr.CHECKOUT_ACTIONS.CHECK_IDENTITY_SUCCESS,
                  data: n
                })), r(ps(!1)), o));
              case 8:
                _context160.prev = 8;
                _context160.t0 = _context160["catch"](0);
                r(ps(!1)), r({
                  type: "CHECKOUT_IDENTITY_ERROR"
                });
              case 11:
              case "end":
                return _context160.stop();
            }
          }
        }, _callee160, null, [[0, 8]]);
      }));
      return function (_x150) {
        return _ref232.apply(this, arguments);
      };
    }();
  },
  createBillingAddressAction: function createBillingAddressAction(_ref234) {
    var e = _ref234.customerId,
      t = _ref234.contactId,
      r = _ref234.deliveryMethod,
      n = _ref234.customerInfo;
    return /*#__PURE__*/function () {
      var _ref235 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee161(o) {
        var _yield$gs2, _i19, _a19, _c21;
        return _regeneratorRuntime.wrap(function _callee161$(_context161) {
          while (1) {
            switch (_context161.prev = _context161.next) {
              case 0:
                _context161.prev = 0;
                o({
                  type: Sr.CHECKOUT_ACTIONS.CREATE_BILLING_ADDRESS_LOADING
                });
                _context161.next = 4;
                return gs({
                  customerInfo: n,
                  customerId: e,
                  contactId: t,
                  deliveryMethod: r
                });
              case 4:
                _yield$gs2 = _context161.sent;
                _i19 = _yield$gs2.billingAccountRes;
                _a19 = _yield$gs2.contactDataRes;
                _c21 = {
                  billingAccountRes: _i19,
                  contactDataRes: _a19
                };
                return _context161.abrupt("return", (o({
                  type: Sr.CHECKOUT_ACTIONS.CREATE_BILLING_ADDRESS_SUCCESS,
                  value: _c21
                }), _c21));
              case 11:
                _context161.prev = 11;
                _context161.t0 = _context161["catch"](0);
                o({
                  type: Sr.CHECKOUT_ACTIONS.CREATE_BILLING_ADDRESS_FAILED
                });
              case 14:
              case "end":
                return _context161.stop();
            }
          }
        }, _callee161, null, [[0, 11]]);
      }));
      return function (_x151) {
        return _ref235.apply(this, arguments);
      };
    }();
  },
  updateBillingAddressActions: function updateBillingAddressActions(_ref236) {
    var e = _ref236.billingArrangementId,
      t = _ref236.contactRoleName,
      r = _ref236.billingAddress,
      n = _ref236.idType,
      o = _ref236.idValue;
    return /*#__PURE__*/function () {
      var _ref237 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee162(i) {
        var _a20;
        return _regeneratorRuntime.wrap(function _callee162$(_context162) {
          while (1) {
            switch (_context162.prev = _context162.next) {
              case 0:
                _context162.prev = 0;
                i({
                  type: Sr.CHECKOUT_ACTIONS.UPDATE_BILLING_ADDRESS_LOADING
                });
                _context162.next = 4;
                return us({
                  billingArrangementId: e,
                  contactRoleName: t,
                  billingAddress: r
                });
              case 4:
                _context162.next = 6;
                return is(o, n);
              case 6:
                _a20 = _context162.sent;
                i({
                  type: Sr.CHECKOUT_ACTIONS.UPDATE_BILLING_ADDRESS_SUCCESS,
                  value: {
                    billingAccountRes: {
                      billingArangmentId: e
                    },
                    contactDataRes: _a20
                  }
                });
                _context162.next = 13;
                break;
              case 10:
                _context162.prev = 10;
                _context162.t0 = _context162["catch"](0);
                i({
                  type: Sr.CHECKOUT_ACTIONS.UPDATE_BILLING_ADDRESS_FAILED
                });
              case 13:
              case "end":
                return _context162.stop();
            }
          }
        }, _callee162, null, [[0, 10]]);
      }));
      return function (_x152) {
        return _ref237.apply(this, arguments);
      };
    }();
  },
  retrieveContactDetails: function retrieveContactDetails(e) {
    return /*#__PURE__*/function () {
      var _ref238 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee163(t) {
        var _n37, r;
        return _regeneratorRuntime.wrap(function _callee163$(_context163) {
          while (1) {
            switch (_context163.prev = _context163.next) {
              case 0:
                _context163.prev = 0;
                t({
                  type: Sr.CHECKOUT_ACTIONS.RETRIEVE_CONTACT_DETAIL_LOADING
                });
                _context163.next = 4;
                return Vd({
                  contactId: e
                });
              case 4:
                _n37 = _context163.sent;
                t((r = _n37, {
                  type: Sr.CHECKOUT_ACTIONS.RETRIEVE_CONTACT_DETAIL_SUCCESS,
                  data: r
                }));
                _context163.next = 11;
                break;
              case 8:
                _context163.prev = 8;
                _context163.t0 = _context163["catch"](0);
                t({
                  type: Sr.CHECKOUT_ACTIONS.RETRIEVE_CONTACT_DETAIL_ERROR
                });
              case 11:
              case "end":
                return _context163.stop();
            }
          }
        }, _callee163, null, [[0, 8]]);
      }));
      return function (_x153) {
        return _ref238.apply(this, arguments);
      };
    }();
  }
});
var Xs = function Xs(e) {
    var t = e.groupStatus,
      r = e.customerId,
      n = e.contactId,
      o = "".concat(i, "/ecommerce/customer/").concat(r, "/contact-person/").concat(n, "/vouchers"),
      a = {
        sc: "SS",
        lo: "en_US"
      };
    return t && (a.groupStatus = t), nt(o, {
      method: "GET",
      queryParams: a
    }).then(function (e) {
      return e.ImplVouchersResponse;
    });
  },
  js = function js(e) {
    var t = e.productOrderReferenceNumber,
      r = e.contactId,
      n = e.customerId,
      o = e.productOrderItemId,
      a = e.voucherIdsToAdd,
      c = e.voucherIdsToRemove,
      d = e.redemptionType,
      s = {
        ImplUpdateOrderWithVoucherRequest: {
          customerId: n,
          implVouchersForOrderActionList: [_objectSpread({
            orderActionId: o,
            orderActionType: "CH",
            redemptionType: d
          }, a ? {
            voucherIdsToAdd: a
          } : {
            voucherIdsToRemove: c
          })],
          isCallProductOrderQuote: !1
        }
      };
    return nt("".concat(i, "/ecommerce/contact-person/").concat(r, "/order/").concat(t, "/voucher-update-order"), {
      method: "POST",
      queryParams: {
        sc: "SS",
        lo: "en_US"
      },
      body: JSON.stringify(s)
    }).then(function (e) {
      return e.ImplUpdateOrderWithVoucherResponse;
    });
  },
  Ks = function Ks() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return {
      type: "GET_VOUCHERS_SUCCESS",
      payload: e
    };
  },
  Js = function Js() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return {
      type: "GET_ALL_VOUCHERS_SUCCESS",
      payload: e
    };
  },
  Zs = function Zs(e) {
    var t = [];
    return e && (t = e.map(function (e) {
      return _objectSpread(_objectSpread({}, e), {}, {
        amountX8: e.amountX8 / 100,
        redemptionDateX8: e.redemptionDateX8,
        serviceNoX8: e.serviceNoX8
      });
    })), t;
  };
var zs = Object.freeze({
  __proto__: null,
  getVoucherSuccess: Ks,
  getAllVoucherSuccess: Js,
  resetReservedVouchers: function resetReservedVouchers(_ref239) {
    var e = _ref239.contactId,
      t = _ref239.customerId,
      _ref239$voucherIds = _ref239.voucherIds,
      r = _ref239$voucherIds === void 0 ? [] : _ref239$voucherIds;
    return /*#__PURE__*/function () {
      var _ref240 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee164(n) {
        var o, _r57;
        return _regeneratorRuntime.wrap(function _callee164$(_context164) {
          while (1) {
            switch (_context164.prev = _context164.next) {
              case 0:
                n({
                  type: "RESET_RESERVED_VOUCHERS_LOADING"
                });
                o = [];
                r.length && (o = r.map(function (e) {
                  return {
                    voucherNoX8: e
                  };
                }));
                _context164.prev = 3;
                if (!(0 === o.length)) {
                  _context164.next = 9;
                  break;
                }
                _context164.next = 7;
                return Xs({
                  contactId: e,
                  customerId: t,
                  groupStatus: "8"
                });
              case 7:
                _r57 = _context164.sent;
                _r57 && _r57.vouchersX8 && (o = _r57.vouchersX8.map(function (e) {
                  return {
                    voucherNoX8: e.idX8
                  };
                }));
              case 9:
                _context164.t0 = o.length;
                if (!_context164.t0) {
                  _context164.next = 13;
                  break;
                }
                _context164.next = 13;
                return function (e) {
                  var t = e.contactId,
                    r = e.voucherList,
                    n = {
                      ImplManageVoucherResInput: {
                        flag: !1,
                        voucherList: r
                      }
                    };
                  return nt("".concat(i, "/sdp/contact-person/").concat(t, "/vouchers/manageVouchers"), {
                    method: "POST",
                    queryParams: {
                      sc: "SS",
                      lo: "en_US"
                    },
                    body: JSON.stringify(n)
                  });
                }({
                  contactId: e,
                  voucherList: o
                });
              case 13:
                return _context164.abrupt("return", n({
                  type: "RESET_RESERVED_VOUCHERS_SUCCESS"
                }));
              case 16:
                _context164.prev = 16;
                _context164.t1 = _context164["catch"](3);
                return _context164.abrupt("return", n({
                  type: "RESET_RESERVED_VOUCHERS_ERROR",
                  error: _context164.t1
                }));
              case 19:
              case "end":
                return _context164.stop();
            }
          }
        }, _callee164, null, [[3, 16]]);
      }));
      return function (_x154) {
        return _ref240.apply(this, arguments);
      };
    }();
  },
  getVoucherData: Zs,
  getAllVouchers: function getAllVouchers(_ref241) {
    var e = _ref241.contactId,
      t = _ref241.customerId;
    return /*#__PURE__*/function () {
      var _ref242 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee165(r) {
        var _yield$Promise$all, _yield$Promise$all2, _n38, o, _i20, _a21, _c22, _d13, n;
        return _regeneratorRuntime.wrap(function _callee165$(_context165) {
          while (1) {
            switch (_context165.prev = _context165.next) {
              case 0:
                r({
                  type: "GET_ALL_VOUCHERS_LOADING"
                });
                _context165.prev = 1;
                _context165.next = 4;
                return Promise.all([Xs({
                  contactId: e,
                  customerId: t
                }), Xs({
                  contactId: e,
                  customerId: t,
                  groupStatus: "8"
                })]);
              case 4:
                _yield$Promise$all = _context165.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
                _n38 = _yield$Promise$all2[0];
                o = _yield$Promise$all2[1];
                _i20 = Zs(_n38.vouchersX8 || []);
                _a21 = o.vouchersX8 || [];
                _c22 = Zs(_a21.map(function (e) {
                  return _objectSpread(_objectSpread({}, e), {}, {
                    redemptionDateX8: !0
                  });
                }));
                _d13 = [].concat(_toConsumableArray(_i20), _toConsumableArray(_c22));
                return _context165.abrupt("return", r(Js(_d13)));
              case 15:
                _context165.prev = 15;
                _context165.t0 = _context165["catch"](1);
                return _context165.abrupt("return", 400 === (null == _context165.t0 || null === (n = _context165.t0.response) || void 0 === n ? void 0 : n.status) ? r(Js()) : r({
                  type: "GET_ALL_VOUCHERS_ERROR",
                  error: _context165.t0
                }));
              case 18:
              case "end":
                return _context165.stop();
            }
          }
        }, _callee165, null, [[1, 15]]);
      }));
      return function (_x155) {
        return _ref242.apply(this, arguments);
      };
    }();
  },
  getVouchers: function getVouchers(e) {
    return /*#__PURE__*/function () {
      var _ref243 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee166(t) {
        var _r58, _n39, r;
        return _regeneratorRuntime.wrap(function _callee166$(_context166) {
          while (1) {
            switch (_context166.prev = _context166.next) {
              case 0:
                t({
                  type: "GET_VOUCHERS_LOADING"
                });
                _context166.prev = 1;
                _context166.next = 4;
                return Xs(e);
              case 4:
                _r58 = _context166.sent;
                _n39 = Zs(_r58.vouchersX8);
                return _context166.abrupt("return", t(Ks(_n39)));
              case 9:
                _context166.prev = 9;
                _context166.t0 = _context166["catch"](1);
                return _context166.abrupt("return", 400 === (null == _context166.t0 || null === (r = _context166.t0.response) || void 0 === r ? void 0 : r.status) ? t(Ks()) : t({
                  type: "GET_VOUCHERS_ERROR",
                  error: _context166.t0
                }));
              case 12:
              case "end":
                return _context166.stop();
            }
          }
        }, _callee166, null, [[1, 9]]);
      }));
      return function (_x156) {
        return _ref243.apply(this, arguments);
      };
    }();
  },
  addVouchers: function addVouchers(_ref244) {
    var e = _ref244.voucherIds,
      t = _objectWithoutProperties(_ref244, _excluded10);
    return /*#__PURE__*/function () {
      var _ref245 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee167(r) {
        return _regeneratorRuntime.wrap(function _callee167$(_context167) {
          while (1) {
            switch (_context167.prev = _context167.next) {
              case 0:
                r({
                  type: "ADD_VOUCHERS_LOADING"
                });
                _context167.prev = 1;
                _context167.t0 = r;
                _context167.next = 5;
                return js(_objectSpread(_objectSpread({}, t), {}, {
                  voucherIdsToAdd: e
                }));
              case 5:
                _context167.t1 = _context167.sent;
                _context167.t2 = _objectSpread({
                  voucherIds: e
                }, t);
                _context167.t3 = {
                  type: "ADD_VOUCHERS_SUCCESS",
                  payload: _context167.t1,
                  meta: _context167.t2
                };
                return _context167.abrupt("return", (0, _context167.t0)(_context167.t3));
              case 11:
                _context167.prev = 11;
                _context167.t4 = _context167["catch"](1);
                return _context167.abrupt("return", r({
                  type: "ADD_VOUCHERS_ERROR",
                  error: _context167.t4,
                  meta: _objectSpread({
                    voucherIds: e
                  }, t)
                }));
              case 14:
              case "end":
                return _context167.stop();
            }
          }
        }, _callee167, null, [[1, 11]]);
      }));
      return function (_x157) {
        return _ref245.apply(this, arguments);
      };
    }();
  },
  removeVouchers: function removeVouchers(_ref246) {
    var e = _ref246.voucherIds,
      t = _objectWithoutProperties(_ref246, _excluded11);
    return /*#__PURE__*/function () {
      var _ref247 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee168(r) {
        return _regeneratorRuntime.wrap(function _callee168$(_context168) {
          while (1) {
            switch (_context168.prev = _context168.next) {
              case 0:
                r({
                  type: "REMOVE_VOUCHERS_LOADING"
                });
                _context168.prev = 1;
                _context168.t0 = r;
                _context168.next = 5;
                return js(_objectSpread(_objectSpread({}, t), {}, {
                  voucherIdsToRemove: e
                }));
              case 5:
                _context168.t1 = _context168.sent;
                _context168.t2 = _objectSpread({
                  voucherIds: e
                }, t);
                _context168.t3 = {
                  type: "REMOVE_VOUCHERS_SUCCESS",
                  payload: _context168.t1,
                  meta: _context168.t2
                };
                return _context168.abrupt("return", (0, _context168.t0)(_context168.t3));
              case 11:
                _context168.prev = 11;
                _context168.t4 = _context168["catch"](1);
                return _context168.abrupt("return", r({
                  type: "REMOVE_VOUCHERS_ERROR",
                  error: _context168.t4,
                  meta: _objectSpread({
                    voucherIds: e
                  }, t)
                }));
              case 14:
              case "end":
                return _context168.stop();
            }
          }
        }, _callee168, null, [[1, 11]]);
      }));
      return function (_x158) {
        return _ref247.apply(this, arguments);
      };
    }();
  }
});
var Qs = function Qs(e) {
    return {
      type: "RETRIEVE_DOCUMENT_DETAILS_SUCCESS",
      value: e
    };
  },
  eu = function eu(e) {
    return {
      type: "DELETE_DOCUMENT_SUCCESS",
      value: e
    };
  },
  tu = function tu(e) {
    return {
      type: "UPLOAD_DOCUMENT_SUCCESS",
      value: e
    };
  },
  ru = /*#__PURE__*/function () {
    var _ref248 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee169(e) {
      var t, r, n, o;
      return _regeneratorRuntime.wrap(function _callee169$(_context169) {
        while (1) {
          switch (_context169.prev = _context169.next) {
            case 0:
              t = e.contactId, r = e.productOrderReferenceNumber, n = e.indentType, o = O[n];
              _context169.next = 3;
              return function (e) {
                var t = e.contactId,
                  r = e.productOrderReferenceNumber,
                  n = e.documentType;
                return nt("".concat(i, "/ecommerce/document/upload/needed/contact-person/").concat(t, "/order/").concat(r), {
                  method: "POST",
                  queryParams: {
                    sc: "SS",
                    lo: "en_US"
                  },
                  body: JSON.stringify({
                    ImplIsUploadDocumentNeededResInput: {
                      documentType: n,
                      isHighEndDevice: !1
                    }
                  })
                }).then(function (e) {
                  return e.ImplIsUploadDocumentNeededResOutput;
                });
              }({
                contactId: t,
                productOrderReferenceNumber: r,
                documentType: o
              });
            case 3:
              return _context169.abrupt("return", _context169.sent.answer);
            case 4:
            case "end":
              return _context169.stop();
          }
        }
      }, _callee169);
    }));
    return function ru(_x159) {
      return _ref248.apply(this, arguments);
    };
  }(),
  nu = function nu(e) {
    var t = e.productOrderReferenceNumber,
      r = e.contactId,
      n = e.indentType,
      o = e.simOnlyPlan,
      a = e.newOrder;
    return /*#__PURE__*/function () {
      var _ref249 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee170(e) {
        var c;
        return _regeneratorRuntime.wrap(function _callee170$(_context170) {
          while (1) {
            switch (_context170.prev = _context170.next) {
              case 0:
                e({
                  type: "RETRIEVE_DOCUMENT_DETAILS_LOADING"
                });
                _context170.next = 3;
                return function (e) {
                  var t = e.productOrderReferenceNumber;
                  return nt("".concat(i, "/ecommerce/retrieve/documentdetails/store/order/").concat(t), {
                    method: "GET",
                    queryParams: {
                      sc: "SS",
                      lo: "en_US"
                    }
                  }).then(function (e) {
                    return e.ImplRetrieveDocumentsDetailsForOrderRestOutput;
                  });
                }({
                  productOrderReferenceNumber: t
                });
              case 3:
                c = _context170.sent;
                if (!(c && c.implFileDetails)) {
                  _context170.next = 6;
                  break;
                }
                return _context170.abrupt("return", (e({
                  type: "RETRIEVE_DOCUMENT_DETAILS_SUCCESS_DATA",
                  value: c
                }), c));
              case 6:
                if (!(o && a)) {
                  _context170.next = 8;
                  break;
                }
                return _context170.abrupt("return", (e(Qs(!0)), !0));
              case 8:
                _context170.next = 10;
                return ru({
                  contactId: r,
                  productOrderReferenceNumber: t,
                  indentType: n
                });
              case 10:
                if (!_context170.sent) {
                  _context170.next = 12;
                  break;
                }
                return _context170.abrupt("return", (e(Qs(!0)), !0));
              case 12:
                return _context170.abrupt("return", (e(Qs(!1)), !1));
              case 13:
              case "end":
                return _context170.stop();
            }
          }
        }, _callee170);
      }));
      return function (_x160) {
        return _ref249.apply(this, arguments);
      };
    }();
  },
  ou = function ou(e) {
    var t = e.productOrderReferenceNumber,
      r = e.blob,
      _e$fileName = e.fileName,
      n = _e$fileName === void 0 ? "image.jpeg" : _e$fileName,
      _e$fieldName = e.fieldName,
      o = _e$fieldName === void 0 ? "" : _e$fieldName;
    return /*#__PURE__*/function () {
      var _ref250 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee171(e) {
        var _a22, _c23;
        return _regeneratorRuntime.wrap(function _callee171$(_context171) {
          while (1) {
            switch (_context171.prev = _context171.next) {
              case 0:
                if (!(e({
                  type: "UPLOAD_DOCUMENT_LOADING"
                }), r)) {
                  _context171.next = 6;
                  break;
                }
                _context171.next = 3;
                return function (e) {
                  var t = e.productOrderReferenceNumber,
                    r = e.blob,
                    n = e.fileName,
                    o = "".concat(i, "/ecommerce/document/upload/store/order/").concat(t),
                    a = new FormData();
                  return a.append("UploadedFile1", r, n), rt(o, {
                    method: "POST",
                    queryParams: {
                      sc: "SS",
                      lo: "en_US"
                    },
                    body: a
                  }).then(function (e) {
                    return e.ImplUploadDocumentStoreRestOutput;
                  });
                }({
                  productOrderReferenceNumber: t,
                  blob: r,
                  fileName: n
                });
              case 3:
                _a22 = _context171.sent;
                _c23 = _a22 ? _objectSpread(_objectSpread({}, _a22), {}, {
                  fileName: n,
                  fieldName: o
                }) : _a22;
                return _context171.abrupt("return", e(tu(_c23)));
              case 6:
                return _context171.abrupt("return", e(tu(!1)));
              case 7:
              case "end":
                return _context171.stop();
            }
          }
        }, _callee171);
      }));
      return function (_x161) {
        return _ref250.apply(this, arguments);
      };
    }();
  },
  iu = function iu(e) {
    var t = e.productOrderReferenceNumber,
      r = e.documentId;
    return /*#__PURE__*/function () {
      var _ref251 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee172(e) {
        var n;
        return _regeneratorRuntime.wrap(function _callee172$(_context172) {
          while (1) {
            switch (_context172.prev = _context172.next) {
              case 0:
                e({
                  type: "RETRIEVE_DOCUMENT_CONTENT_LOADING"
                });
                _context172.next = 3;
                return function (e) {
                  var t = e.productOrderReferenceNumber,
                    r = e.documentId;
                  return nt("".concat(i, "/ecommerce/retrieve/document/order/").concat(t, "/document/").concat(r), {
                    method: "GET",
                    queryParams: {
                      sc: "SS",
                      lo: "en_US"
                    }
                  }).then(function (e) {
                    return e.ImplRetrieveDocumentFromStoreRestOutput;
                  });
                }({
                  productOrderReferenceNumber: t,
                  documentId: r
                });
              case 3:
                n = _context172.sent;
                return _context172.abrupt("return", n && n.implFileDetails ? (e({
                  type: "RETRIEVE_DOCUMENT_CONTENT_SUCCESS_DATA",
                  value: n.implFileDetails
                }), n) : (e(Qs(!1)), !1));
              case 5:
              case "end":
                return _context172.stop();
            }
          }
        }, _callee172);
      }));
      return function (_x162) {
        return _ref251.apply(this, arguments);
      };
    }();
  };
var au = Object.freeze({
  __proto__: null,
  retrieveDocumentDetails: nu,
  uploadDocument: ou,
  retrieveDocumentContent: iu,
  deleteUploadedDocument: function deleteUploadedDocument(e) {
    var t = e.productOrderReferenceNumber,
      r = e.documentId;
    return /*#__PURE__*/function () {
      var _ref252 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee173(e) {
        return _regeneratorRuntime.wrap(function _callee173$(_context173) {
          while (1) {
            switch (_context173.prev = _context173.next) {
              case 0:
                e({
                  type: "RETRIEVE_DOCUMENT_CONTENT_LOADING"
                });
                _context173.next = 3;
                return function (e) {
                  var t = e.productOrderReferenceNumber,
                    r = e.documentId;
                  return nt("".concat(i, "/ecommerce/delete/document/order/").concat(t), {
                    method: "POST",
                    queryParams: {
                      sc: "SS",
                      lo: "en_US"
                    },
                    body: JSON.stringify({
                      ImplRemoveDocumentFromStoreRestInput: {
                        documentIDs: r
                      }
                    })
                  });
                }({
                  productOrderReferenceNumber: t,
                  documentId: r
                });
              case 3:
                if (!_context173.sent) {
                  _context173.next = 7;
                  break;
                }
                _context173.t0 = (e(eu(!0)), !0);
                _context173.next = 8;
                break;
              case 7:
                _context173.t0 = (e(eu(!1)), !1);
              case 8:
                return _context173.abrupt("return", _context173.t0);
              case 9:
              case "end":
                return _context173.stop();
            }
          }
        }, _callee173);
      }));
      return function (_x163) {
        return _ref252.apply(this, arguments);
      };
    }();
  }
});
var cu = function cu(e) {
    var t;
    t = e.split(",")[0].indexOf("base64") >= 0 ? atob(e.split(",")[1]) : unescape(e.split(",")[1]);
    var r = e.split(",")[0].split(":")[1].split(";")[0];
    var n = new Uint8Array(t.length);
    for (var _e85 = 0; _e85 < t.length; _e85++) {
      n[_e85] = t.charCodeAt(_e85);
    }
    new Blob([n], {
      type: r
    });
    return new Blob([n], {
      type: r
    });
  },
  du = function du(e) {
    var t = e.customerId,
      r = e.productOrderId,
      n = e.isOrderConfirm;
    return nt("".concat(i, "/ecommerce/customer/").concat(t, "/order/").concat(r, "/update-order/payment-details-cod"), {
      method: "POST",
      queryParams: n ? {
        isOrderConfirm: !0
      } : null,
      body: JSON.stringify({})
    });
  },
  su = function su() {
    return {
      type: "SUBMIT_ORDER_LOADING"
    };
  },
  uu = function uu(e) {
    return {
      type: "SUBMIT_ORDER_SUCCESS",
      value: e
    };
  },
  lu = function lu(e) {
    return {
      type: "SUBMIT_ORDER_ERROR",
      value: e
    };
  },
  pu = function pu(_ref253) {
    var e = _ref253.customerId,
      t = _ref253.productOrderReferenceNumber,
      _ref253$promoCriteria = _ref253.promoCriteria,
      r = _ref253$promoCriteria === void 0 ? "####" : _ref253$promoCriteria;
    return /*#__PURE__*/function () {
      var _ref254 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee174(n) {
        var o;
        return _regeneratorRuntime.wrap(function _callee174$(_context174) {
          while (1) {
            switch (_context174.prev = _context174.next) {
              case 0:
                o = r.split("####")[1].replace(/\s/g, "+").replace(/@@/g, "&");
                _context174.prev = 1;
                n({
                  type: "DISTRIBUTING_PROMO_CODE"
                });
                _context174.next = 5;
                return ba({
                  customerId: e,
                  productOrderReferenceNumber: t,
                  encodedPromoStr: o
                });
              case 5:
                return _context174.abrupt("return", n({
                  type: "DISTRIBUTE_PROMO_CODE_SUCCESS"
                }));
              case 8:
                _context174.prev = 8;
                _context174.t0 = _context174["catch"](1);
                return _context174.abrupt("return", n({
                  type: "DISTRIBUTE_PROMO_CODE_FAILED"
                }));
              case 11:
              case "end":
                return _context174.stop();
            }
          }
        }, _callee174, null, [[1, 8]]);
      }));
      return function (_x164) {
        return _ref254.apply(this, arguments);
      };
    }();
  },
  Iu = function Iu() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee175() {
      var t, r, n, o, _e$deviceResDetails, i, a, c, s, u, l, _e86, _t74, _r59, _t75, _i21, _e87, _t76, p;
      return _regeneratorRuntime.wrap(function _callee175$(_context175) {
        while (1) {
          switch (_context175.prev = _context175.next) {
            case 0:
              t = e.userInfo, r = e.productOrder, n = e.cartOrder, o = e.collectNowData, _e$deviceResDetails = e.deviceResDetails, i = _e$deviceResDetails === void 0 ? [] : _e$deviceResDetails, a = e.productChanges, c = e.isOrderConfirm;
              s = a;
              if (!s) {
                _e86 = i.filter(function (e) {
                  return n.productOrderItemId === e.orderActionIDX9;
                }), _t74 = [], _r59 = [];
                if (null === (u = n.deviceDetails) || void 0 === u || null === (l = u[0]) || void 0 === l ? void 0 : l.deviceProductId) {
                  _t75 = _e86.find(function (e) {
                    return e.itemCodeX9 === n.deviceDetails[0].skuId;
                  }), _i21 = {
                    characteristicID: "8425972",
                    value: "Yes"
                  };
                  if (_t75) {
                    _e87 = {
                      characteristicID: "8425962",
                      value: _t75.reservationId && !o ? _t75.reservationId : ""
                    };
                    if (_r59.push({
                      productID: n.deviceDetails[0].deviceProductId,
                      changedCharacteristics: [{
                        characteristicID: "8322",
                        value: _t75.storeID
                      }, _i21, _e87]
                    }), o) {
                      _t76 = {
                        characteristicID: "8302",
                        value: o.imei
                      };
                      _r59.length > 0 ? _r59[0].changedCharacteristics.push(_t76) : _r59.push({
                        productID: n.deviceDetails[0].deviceProductId,
                        changedCharacteristics: [_t76, _i21, _e87]
                      });
                    }
                  }
                  n.isNewSimAdded && n.simProductId && _r59.push({
                    productID: n.simProductId,
                    changedCharacteristics: [{
                      characteristicID: "8322",
                      value: null == _t75 ? void 0 : _t75.storeID
                    }, {
                      characteristicID: "8832",
                      value: d["5G3IN1"]
                    }, {
                      characteristicID: "8425972",
                      value: "Yes"
                    }, {
                      characteristicID: "8425962",
                      value: (null == _t75 ? void 0 : _t75.simReservationId) || n.deviceDetails[0].deviceProductId
                    }]
                  });
                }
                n.freeGifts && n.freeGifts.length > 0 && n.freeGifts.forEach(function (t) {
                  if (t && t.skuId) {
                    var _n40 = _e86.find(function (e) {
                      return e.itemCodeX9 === t.skuId;
                    });
                    _n40 && _r59.push({
                      productID: t.productID,
                      changedCharacteristics: [{
                        characteristicID: "8425972",
                        value: "Yes"
                      }, {
                        characteristicID: "8425962",
                        value: _n40.reservationId
                      }]
                    });
                  }
                }), s = [{
                  links: [],
                  resumedContainedProducts: [],
                  changedContainedProducts: _r59,
                  newContainedProducts: [],
                  removedContainedProducts: [],
                  suspendedContainedProducts: [],
                  changedSimpleProducts: _t74
                }];
              }
              p = {
                UpdateProductInOrderConfigurationRequest: {
                  links: [],
                  confirmationMessagesApproved: !1,
                  runCompatibilityRules: !1,
                  activityForConfiguration: "QuoteSDAllDiscounts",
                  productChanges: s,
                  configurationLevel: "FULL",
                  settingsView: "FULL",
                  updateEvenIfNotValid: !1,
                  returnConfiguration: "ALL",
                  returnConfigurationData: {
                    catalogDataInd: !0,
                    crossProductsDiscountsDataInd: !0,
                    previousQuotedRecurringPricesInd: !1,
                    productConfigurationInd: !0,
                    quotedPricesInd: !0,
                    quotedProrationInd: !0,
                    quotedTaxInd: !0,
                    summaryInd: !0
                  }
                }
              };
              return _context175.abrupt("return", nn({
                customerId: t.customerId,
                productOrderItemId: r.productOrderItemId,
                payload: p,
                rpNeeded: !1,
                isOrderConfirm: c
              }));
            case 5:
            case "end":
              return _context175.stop();
          }
        }
      }, _callee175);
    }));
  },
  mu = function mu() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return /*#__PURE__*/function () {
      var _ref256 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee176(t) {
        var r, n, o, _e88, i;
        return _regeneratorRuntime.wrap(function _callee176$(_context176) {
          while (1) {
            switch (_context176.prev = _context176.next) {
              case 0:
                r = e.userInfo, n = e.productOrder, o = e.isOrderConfirm;
                t({
                  type: Sr.PAYMENT.CASH_ON_DELIVERY_LOADING
                });
                _context176.prev = 2;
                _context176.next = 5;
                return du({
                  customerId: r.customerId,
                  productOrderId: n.productOrderId,
                  isOrderConfirm: o
                });
              case 5:
                _e88 = _context176.sent;
                if (!_e88) {
                  _context176.next = 8;
                  break;
                }
                return _context176.abrupt("return", t((i = _e88, {
                  type: Sr.PAYMENT.CASH_ON_DELIVERY_SUCCESS,
                  value: i
                })));
              case 8:
                _context176.next = 13;
                break;
              case 10:
                _context176.prev = 10;
                _context176.t0 = _context176["catch"](2);
                return _context176.abrupt("return", t(function (e) {
                  return {
                    type: Sr.PAYMENT.CASH_ON_DELIVERY_ERROR,
                    value: e
                  };
                }(_context176.t0)));
              case 13:
              case "end":
                return _context176.stop();
            }
          }
        }, _callee176, null, [[2, 10]]);
      }));
      return function (_x165) {
        return _ref256.apply(this, arguments);
      };
    }();
  },
  Eu = function Eu() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return /*#__PURE__*/function () {
      var _ref257 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee177(t) {
        var r, n, o, a, c, s, _e$activateNewSim, u, l, p, I, m, E, R, S, _e90, _t77, _r60, _e91, _e89, _, O, _t78, _n41, _a23, _d14, C, _e92;
        return _regeneratorRuntime.wrap(function _callee177$(_context177) {
          while (1) {
            switch (_context177.prev = _context177.next) {
              case 0:
                r = e.userInfo, n = e.billType, o = e.productOrder, a = e.deviceResDetails, c = e.cartOrder, s = e.collectNowData, _e$activateNewSim = e.activateNewSim, u = _e$activateNewSim === void 0 ? !0 : _e$activateNewSim, l = e.paymentMethodType, p = e.promoCriteria, I = e.isNgnisImsiRequired, m = e.isOrderConfirm;
                E = null, R = null, S = null;
                if (!(t({
                  type: "SUBMIT_ORDER_LOADING"
                }), !["cod", "no-payment", "singtel-pop-station", "pop-station", "collect-now", "kiosk-payment", "NA"].includes(l) && !Cr.ONLINE_PAYMENT_TYPES.includes(l))) {
                  _context177.next = 4;
                  break;
                }
                return _context177.abrupt("return", t(lu("Invalid Payment Method - " + l)));
              case 4:
                if (!("no-payment" === l)) {
                  _context177.next = 13;
                  break;
                }
                _context177.prev = 5;
                _context177.next = 8;
                return function (e) {
                  var t = e.contactId,
                    r = e.orderId;
                  return nt("".concat(i, "/ordering/order/").concat(r, "/contact-person/").concat(t, "/confirmCredit"), {
                    method: "GET",
                    queryParams: {
                      lo: "en_US",
                      sc: "SS",
                      flowType: "eshop",
                      isOrderConfirm: !0
                    }
                  }).then(function (e) {
                    return e.ImplValidateAndConfirmCreditLimitRestOutput;
                  });
                }({
                  contactId: r.contactId,
                  orderId: o.productOrderId
                });
              case 8:
                _context177.next = 13;
                break;
              case 10:
                _context177.prev = 10;
                _context177.t0 = _context177["catch"](5);
                return _context177.abrupt("return", t(lu(_context177.t0)));
              case 13:
                if (Cr.ONLINE_PAYMENT_TYPES.includes(l)) {
                  _context177.next = 22;
                  break;
                }
                _context177.prev = 14;
                _context177.next = 17;
                return du({
                  customerId: r.customerId,
                  productOrderId: o.productOrderId,
                  isOrderConfirm: m
                });
              case 17:
                _context177.next = 22;
                break;
              case 19:
                _context177.prev = 19;
                _context177.t1 = _context177["catch"](14);
                return _context177.abrupt("return", t(lu(_context177.t1)));
              case 22:
                if (!I) {
                  _context177.next = 36;
                  break;
                }
                R = "5G3IN1";
                _context177.prev = 24;
                _e90 = {
                  productOrderId: o.productOrderId,
                  productOrderItemId: o.productOrderItemId,
                  productId: o.productId,
                  numberOfResources: 1,
                  type: "SIM",
                  oaType: "CH",
                  isOrderConfirm: !0
                };
                _context177.next = 28;
                return Hr(_objectSpread({}, _e90));
              case 28:
                _t77 = _context177.sent;
                _r60 = _t77.ImplSearchAviableOutput;
                E = _r60.implSimSpec[0].number, S = _r60.implSimSpec[0].signature;
                _context177.next = 36;
                break;
              case 33:
                _context177.prev = 33;
                _context177.t2 = _context177["catch"](24);
                return _context177.abrupt("return", t(lu(_context177.t2)));
              case 36:
                if (!E) {
                  _context177.next = 45;
                  break;
                }
                _context177.prev = 37;
                _context177.next = 40;
                return function (e) {
                  var t = e.data,
                    _e$isOrderConfirm2 = e.isOrderConfirm,
                    r = _e$isOrderConfirm2 === void 0 ? !1 : _e$isOrderConfirm2,
                    n = i + "/sdp/manageResource/updateStatus";
                  var o = {
                    sc: "SS",
                    lo: "en_US"
                  };
                  return r && (o = _objectSpread(_objectSpread({}, o), {}, {
                    isOrderConfirm: !0
                  })), nt(n, {
                    method: "POST",
                    queryParams: o,
                    body: JSON.stringify({
                      ImplUpdateStatusInput: {
                        resourceData: t
                      }
                    })
                  }).then(function (e) {
                    return e.StatusResponse;
                  });
                }({
                  data: [{
                    toReserveSIM: !0,
                    simNumber: E,
                    signature: S
                  }],
                  isOrderConfirm: !0
                });
              case 40:
                _context177.next = 45;
                break;
              case 42:
                _context177.prev = 42;
                _context177.t3 = _context177["catch"](37);
                return _context177.abrupt("return", t(lu(_context177.t3)));
              case 45:
                if (!(E || s && u)) {
                  _context177.next = 57;
                  break;
                }
                R = (null == s ? void 0 : s.simType) || R;
                _context177.prev = 47;
                _e91 = [{
                  links: [],
                  resumedContainedProducts: [],
                  changedContainedProducts: [{
                    productID: c.simProductId,
                    productSpecContainmentID: "8363722",
                    changedCharacteristics: [{
                      characteristicID: "8858992",
                      value: E || (null == s ? void 0 : s.imsi)
                    }, {
                      characteristicID: 132395,
                      value: E || (null == s ? void 0 : s.imsi)
                    }]
                  }],
                  newContainedProducts: [],
                  removedContainedProducts: [],
                  suspendedContainedProducts: []
                }];
                R && _e91[0].changedContainedProducts[0].changedCharacteristics.push({
                  characteristicID: "8832",
                  value: d[R]
                });
                _context177.next = 52;
                return t(Iu({
                  userInfo: r,
                  productOrder: o,
                  cartOrder: c,
                  collectNowData: s,
                  deviceResDetails: a,
                  productChanges: _e91,
                  isOrderConfirm: m
                }));
              case 52:
                _context177.next = 57;
                break;
              case 54:
                _context177.prev = 54;
                _context177.t4 = _context177["catch"](47);
                return _context177.abrupt("return", t(lu(_context177.t4)));
              case 57:
                _context177.prev = 57;
                _context177.next = 60;
                return function (e) {
                  var t = e.contactId,
                    r = e.productOrderReferenceNumber,
                    n = e.isOrderConfirm;
                  return nt("".concat(i, "/ecommerce/document/upload/persist/order/").concat(r, "/contact-person/").concat(t), {
                    method: "POST",
                    queryParams: _objectSpread({
                      sc: "SS",
                      lo: "en_US"
                    }, n && {
                      isOrderConfirm: !0
                    })
                  });
                }({
                  contactId: r.contactId,
                  productOrderReferenceNumber: o.productOrderReferenceNumber,
                  isOrderConfirm: m
                });
              case 60:
                _context177.next = 65;
                break;
              case 62:
                _context177.prev = 62;
                _context177.t5 = _context177["catch"](57);
                return _context177.abrupt("return", t(lu(_context177.t5)));
              case 65:
                _e89 = !1;
                _context177.prev = 66;
                _t78 = [];
                _n41 = !1;
                (null == c || null === (_ = c.deviceDetails) || void 0 === _ || null === (O = _[0]) || void 0 === O ? void 0 : O.deviceProductId) && (_n41 = !0);
                _a23 = {
                  orderActionId: o.productOrderItemId,
                  implUpdateOrderAction: {
                    orderActionType: "CH"
                  },
                  isMTCalledForSave: !1
                };
                _n41 ? _a23.implUpdateOrderAction.implUpdateWirelessAppointmentDetails = {
                  paymentMethod: l,
                  msisdn: r.serviceNumber
                } : s && s.simType && (_a23.implUpdateOrderAction.implUpdateWirelessAppointmentDetails = {
                  paymentMethod: l
                }), _t78.push(_a23);
                _context177.next = 74;
                return function (e) {
                  var t = e.customerId,
                    r = e.productOrderReferenceNumber,
                    n = e.data,
                    o = e.isOrderConfirm;
                  return nt("".concat(i, "/ecommerce/customer/").concat(t, "/order/").concat(r, "/update-order-actions"), {
                    method: "POST",
                    queryParams: _objectSpread({
                      sc: "SS",
                      lo: "en_US"
                    }, o && {
                      isOrderConfirm: !0
                    }),
                    body: JSON.stringify({
                      ImplUpdateOrderActionsRequest: {
                        implUpdateOrderActionDataList: n
                      }
                    })
                  }).then(function (e) {
                    return e.ImplUpdateOrderActionsResponse;
                  });
                }({
                  customerId: r.customerId,
                  productOrderReferenceNumber: o.productOrderReferenceNumber,
                  data: _t78,
                  isOrderConfirm: m
                });
              case 74:
                _d14 = _context177.sent;
                _e89 = null == _d14 ? void 0 : _d14.isOperationSuccessful;
                _context177.next = 81;
                break;
              case 78:
                _context177.prev = 78;
                _context177.t6 = _context177["catch"](66);
                return _context177.abrupt("return", t(lu(_context177.t6)));
              case 81:
                if (!_e89) {
                  _context177.next = 106;
                  break;
                }
                _context177.t7 = p;
                if (!_context177.t7) {
                  _context177.next = 86;
                  break;
                }
                _context177.next = 86;
                return t(pu({
                  customerId: r.customerId,
                  productOrderReferenceNumber: o.productOrderReferenceNumber,
                  promoCriteria: p
                }));
              case 86:
                _context177.prev = 86;
                _context177.next = 89;
                return t(Iu({
                  userInfo: r,
                  productOrder: o,
                  cartOrder: c,
                  collectNowData: s,
                  deviceResDetails: a,
                  isOrderConfirm: m
                }));
              case 89:
                _context177.next = 94;
                break;
              case 91:
                _context177.prev = 91;
                _context177.t8 = _context177["catch"](86);
                return _context177.abrupt("return", t(lu(_context177.t8)));
              case 94:
                if (!(!s && (null == a || null === (C = a[0]) || void 0 === C ? void 0 : C.reservationId))) {
                  _context177.next = 106;
                  break;
                }
                _context177.prev = 95;
                _context177.next = 98;
                return fi({
                  contactId: r.contactId,
                  allocationId: a[0].reservationId,
                  isOrderConfirm: m
                });
              case 98:
                _e92 = _context177.sent;
                if (!(_e92 && !_e92.allocationStatusResponse[0].updateStatus)) {
                  _context177.next = 101;
                  break;
                }
                throw new Error();
              case 101:
                _context177.next = 106;
                break;
              case 103:
                _context177.prev = 103;
                _context177.t9 = _context177["catch"](95);
                return _context177.abrupt("return", t(lu("update status failed")));
              case 106:
                if (!n) {
                  _context177.next = 114;
                  break;
                }
                _context177.prev = 107;
                _context177.next = 110;
                return t(Xd({
                  contactId: r.contactId,
                  nric: r.indentValue,
                  indentType: r.indentType,
                  update: !0,
                  billType: n
                }));
              case 110:
                _context177.next = 114;
                break;
              case 112:
                _context177.prev = 112;
                _context177.t10 = _context177["catch"](107);
              case 114:
                _context177.prev = 114;
                _context177.next = 117;
                return ga({
                  productOrderId: o.productOrderId,
                  billingAccountId: r.billingAccountId
                });
              case 117:
                _context177.next = 122;
                break;
              case 119:
                _context177.prev = 119;
                _context177.t11 = _context177["catch"](114);
                return _context177.abrupt("return", t(lu("generate contract failed")));
              case 122:
                _context177.prev = 122;
                _context177.next = 125;
                return function (e) {
                  var t = e.customerId,
                    r = e.productOrderReferenceNumber,
                    n = e.isOrderConfirm;
                  return nt("".concat(i, "/ecommerce/customer/").concat(t, "/submitOrder"), {
                    method: "POST",
                    queryParams: _objectSpread({
                      sc: "SS",
                      lo: "en_US",
                      us: !0,
                      orderIds: r
                    }, n && {
                      isOrderConfirm: !0
                    }),
                    body: JSON.stringify({
                      customerId: t
                    })
                  }).then(function (e) {
                    return e.SubmitOrderResponse;
                  });
                }({
                  customerId: r.customerId,
                  productOrderReferenceNumber: o.productOrderReferenceNumber
                });
              case 125:
                return _context177.abrupt("return", t(uu()));
              case 128:
                _context177.prev = 128;
                _context177.t12 = _context177["catch"](122);
                return _context177.abrupt("return", t(lu(_context177.t12)));
              case 131:
              case "end":
                return _context177.stop();
            }
          }
        }, _callee177, null, [[5, 10], [14, 19], [24, 33], [37, 42], [47, 54], [57, 62], [66, 78], [86, 91], [95, 103], [107, 112], [114, 119], [122, 128]]);
      }));
      return function (_x166) {
        return _ref257.apply(this, arguments);
      };
    }();
  };
var Ru = Object.freeze({
  __proto__: null,
  submitOrderLoading: su,
  submitOrderSuccess: uu,
  distributePromoCode: pu,
  updateDeviceConfiguration: Iu,
  verifyPaymentsViaCOD: mu,
  onVerifyPayment: Eu
});
var Su = function Su(e) {
    return {
      type: "FULFILLMENT_ERROR",
      error: e
    };
  },
  _u = function _u(e, t) {
    var r = {
      type: "SUBMIT_FULFILLMENT_ERROR",
      error: e
    };
    return t ? _objectSpread(_objectSpread({}, r), {}, {
      errorInfo: t
    }) : r;
  },
  Ou = function Ou(e, t) {
    var r = null == e ? void 0 : e.map(function (e) {
      return e.skuId;
    });
    return null == r ? void 0 : r.filter(function (e) {
      return !(null == t ? void 0 : t.find(function (t) {
        return t.availableQty > 0 && "NA" !== t.status && t.itemCode === e;
      }));
    });
  };
var Cu = Object.freeze({
  __proto__: null,
  startFulfillment: function startFulfillment(e) {
    var t = e.productOrderReferenceNumber,
      r = e.cart,
      n = e.type,
      o = e.simOnlyPlan,
      _e$documentRequired3 = e.documentRequired,
      i = _e$documentRequired3 === void 0 ? !0 : _e$documentRequired3;
    return /*#__PURE__*/function () {
      var _ref258 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee178(e) {
        var a, c, d, s, u, l, p, I, m;
        return _regeneratorRuntime.wrap(function _callee178$(_context178) {
          while (1) {
            switch (_context178.prev = _context178.next) {
              case 0:
                e({
                  type: "FULFILLMENT_LOADING"
                });
                _context178.prev = 1;
                _context178.next = 4;
                return Dt();
              case 4:
                c = _context178.sent;
                _context178.next = 10;
                break;
              case 7:
                _context178.prev = 7;
                _context178.t0 = _context178["catch"](1);
                return _context178.abrupt("return", e(Su()));
              case 10:
                if (null === (a = c) || void 0 === a ? void 0 : a.clientContext) {
                  _context178.next = 12;
                  break;
                }
                return _context178.abrupt("return", e(Su()));
              case 12:
                d = c.clientContext.contact, s = d.contactId, u = d.indentType, l = "NEW" === n;
                _context178.prev = 13;
                _context178.t1 = i;
                if (!_context178.t1) {
                  _context178.next = 19;
                  break;
                }
                _context178.next = 18;
                return e(nu({
                  productOrderReferenceNumber: t,
                  contactId: s,
                  indentType: u,
                  simOnlyPlan: o,
                  newOrder: l
                }));
              case 18:
                p = _context178.sent;
              case 19:
                _context178.next = 24;
                break;
              case 21:
                _context178.prev = 21;
                _context178.t2 = _context178["catch"](13);
                e(Su(_context178.t2));
              case 24:
                I = l, m = r.order.hasSim;
                return _context178.abrupt("return", e({
                  type: "FULFILLMENT_SUCCESS",
                  payload: {
                    isDocumentUploadRequired: p,
                    isBillingRequired: I,
                    isDeliveryRequired: m
                  }
                }));
              case 26:
              case "end":
                return _context178.stop();
            }
          }
        }, _callee178, null, [[1, 7], [13, 21]]);
      }));
      return function (_x167) {
        return _ref258.apply(this, arguments);
      };
    }();
  },
  getDocumentFulfillment: function getDocumentFulfillment(e) {
    var t = e.productOrderReferenceNumber,
      r = e.documentId;
    return /*#__PURE__*/function () {
      var _ref259 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee179(e) {
        return _regeneratorRuntime.wrap(function _callee179$(_context179) {
          while (1) {
            switch (_context179.prev = _context179.next) {
              case 0:
                e({
                  type: "FULFILLMENT_LOADING"
                });
                _context179.prev = 1;
                _context179.next = 4;
                return e(iu({
                  productOrderReferenceNumber: t,
                  documentId: r
                }));
              case 4:
                _context179.next = 9;
                break;
              case 6:
                _context179.prev = 6;
                _context179.t0 = _context179["catch"](1);
                e(Su(_context179.t0));
              case 9:
              case "end":
                return _context179.stop();
            }
          }
        }, _callee179, null, [[1, 6]]);
      }));
      return function (_x168) {
        return _ref259.apply(this, arguments);
      };
    }();
  },
  checkFulfillmentStocks: function checkFulfillmentStocks(e) {
    var t = e.deviceSkus,
      _e$simSkus = e.simSkus,
      r = _e$simSkus === void 0 ? [] : _e$simSkus,
      n = e.simType;
    return r.length || r.push(d[n || c]), ( /*#__PURE__*/function () {
      var _ref260 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee180(e) {
        var _yield$Promise$all3, _yield$Promise$all4, n, o;
        return _regeneratorRuntime.wrap(function _callee180$(_context180) {
          while (1) {
            switch (_context180.prev = _context180.next) {
              case 0:
                e({
                  type: "CHECK_FULFILLMENT_STOCK_LOADING"
                });
                _context180.next = 3;
                return Promise.all([e(ji({
                  skuList: [].concat(_toConsumableArray(t), _toConsumableArray(r))
                })), e(Ki({
                  skuList: t
                }))]);
              case 3:
                _yield$Promise$all3 = _context180.sent;
                _yield$Promise$all4 = _slicedToArray(_yield$Promise$all3, 2);
                n = _yield$Promise$all4[0];
                o = _yield$Promise$all4[1];
                return _context180.abrupt("return", n || o ? (e({
                  type: "CHECK_FULFILLMENT_STOCK_SUCCESS",
                  payload: {
                    collectNow: n,
                    mtpos: o
                  }
                }), {
                  collectNow: n,
                  mtpos: o
                }) : e({
                  type: "CHECK_FULFILLMENT_STOCK_ERROR"
                }));
              case 8:
              case "end":
                return _context180.stop();
            }
          }
        }, _callee180);
      }));
      return function (_x169) {
        return _ref260.apply(this, arguments);
      };
    }());
  },
  getOutOfStockFreebies: Ou,
  proceedToOrderSummary: function proceedToOrderSummary(e) {
    var t = e.productOrderId,
      r = e.productOrderItemId,
      n = e.productId,
      o = e.productOrderReferenceNumber,
      c = e.equipment,
      d = e.selectedTimeSlot,
      s = e.userInfo,
      u = e.serviceId,
      l = e.addressId,
      p = e.address,
      I = e.selectedFulfilmentMode,
      _e$isNewSimAdded2 = e.isNewSimAdded,
      m = _e$isNewSimAdded2 === void 0 ? !1 : _e$isNewSimAdded2,
      _e$isPayChannelRequir = e.isPayChannelRequired,
      E = _e$isPayChannelRequir === void 0 ? !0 : _e$isPayChannelRequir,
      _e$isAllocateEquipmen = e.isAllocateEquipmentRequired,
      R = _e$isAllocateEquipmen === void 0 ? !0 : _e$isAllocateEquipmen,
      _e$isReserveEquipment = e.isReserveEquipmentRequired,
      S = _e$isReserveEquipment === void 0 ? !1 : _e$isReserveEquipment,
      _e$selectedStoreId = e.selectedStoreId,
      _ = _e$selectedStoreId === void 0 ? a : _e$selectedStoreId,
      _e$ignoreCheckFreeGif = e.ignoreCheckFreeGiftOutOfStock,
      O = _e$ignoreCheckFreeGif === void 0 ? !0 : _e$ignoreCheckFreeGif,
      _e$type2 = e.type,
      C = _e$type2 === void 0 ? "" : _e$type2,
      f = e.simOnlyPlan,
      _e$isDocumentUploadRe = e.isDocumentUploadRequired,
      y = _e$isDocumentUploadRe === void 0 ? !1 : _e$isDocumentUploadRe,
      T = e.imageFrontBase64,
      A = e.imageBackBase64,
      D = e.eApptCancelData,
      P = e.eApptCreateData,
      v = e.selectedCollectAtStore,
      h = e.msisdn,
      g = e.billingAccountId,
      N = e.customerId,
      b = e.reserveSlotType,
      L = e.isSnailMail,
      _e$isBackOrder2 = e.isBackOrder,
      U = _e$isBackOrder2 === void 0 ? !1 : _e$isBackOrder2,
      _e$isPreOrder2 = e.isPreOrder,
      M = _e$isPreOrder2 === void 0 ? !1 : _e$isPreOrder2,
      _e$isRrpIppOrder7 = e.isRrpIppOrder,
      w = _e$isRrpIppOrder7 === void 0 ? !1 : _e$isRrpIppOrder7,
      _e$deliveryTimeSlot2 = e.deliveryTimeSlot,
      G = _e$deliveryTimeSlot2 === void 0 ? null : _e$deliveryTimeSlot2,
      _e$itemSkuToOrderIdMa3 = e.itemSkuToOrderIdMapping,
      F = _e$itemSkuToOrderIdMa3 === void 0 ? {} : _e$itemSkuToOrderIdMa3,
      k = "NEW" === C && f,
      B = "singtel-store" === I,
      V = "no-fulfilment" === I;
    return /*#__PURE__*/function () {
      var _ref261 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee181(e) {
        var O, C, f, Y, x, H, $, q, W, X, j, K, J, Z, z, _e93, _t79, Q, _t80, _r61, ee, te, re, _e94, _t81, _t82, _ref262, _r62, _n42, _o21, ne, oe, ie, ae, ce, _t83, de, se, _r63, _n43, ue, le, _t84, _t85, pe, _n44, Ie, me, Ee, Re, Se, _e, _t86, Oe, Ce, _t87, fe, ye;
        return _regeneratorRuntime.wrap(function _callee181$(_context181) {
          while (1) {
            switch (_context181.prev = _context181.next) {
              case 0:
                e({
                  type: "SUBMIT_FULFILLMENT_LOADING"
                });
                H = N || s.clientContext.customers[0].customerId, $ = s.clientContext.contact.contactId, q = g || (null === (O = s.clientContext.billingArrangements) || void 0 === O || null === (C = O[0]) || void 0 === C ? void 0 : C.barId), W = null == (null == c || null === (f = c.sims) || void 0 === f ? void 0 : f.length) || 0 === (null == c || null === (Y = c.sims) || void 0 === Y ? void 0 : Y.length);
                X = [].concat(_toConsumableArray((null == c ? void 0 : c.freebies) || []), _toConsumableArray((null == c ? void 0 : c.devices) || []), _toConsumableArray((null == c ? void 0 : c.sims) || []));
                j = X.map(function (e) {
                  return e.skuId;
                }), K = W ? [].concat(_toConsumableArray(j), ["381187630N"]) : j;
                z = [];
                if (!E) {
                  _context181.next = 18;
                  break;
                }
                _context181.prev = 6;
                _context181.next = 9;
                return Hs({
                  billingAccountId: q
                });
              case 9:
                _e93 = _context181.sent;
                _context181.next = 12;
                return Hd({
                  customerId: H,
                  productOrderId: t,
                  productOrderItemId: r,
                  pcnId: _e93
                });
              case 12:
                J = _context181.sent;
                _context181.next = 18;
                break;
              case 15:
                _context181.prev = 15;
                _context181.t0 = _context181["catch"](6);
                return _context181.abrupt("return", e(_u("PRODUCT_ORDER_PAY_CHANNEL")));
              case 18:
                if (!D) {
                  _context181.next = 32;
                  break;
                }
                _t79 = {
                  apptId: D,
                  customerId: H,
                  contactId: $
                };
                _context181.prev = 20;
                _context181.t1 = e;
                _context181.next = 24;
                return hi(_t79);
              case 24:
                _context181.t2 = _context181.sent;
                _context181.t3 = {
                  type: "EAPPOINTMENT_CANCEL",
                  response: _context181.t2
                };
                (0, _context181.t1)(_context181.t3);
                _context181.next = 32;
                break;
              case 29:
                _context181.prev = 29;
                _context181.t4 = _context181["catch"](20);
                return _context181.abrupt("return", e(_u("EAPPOINTMENT_CANCEL")));
              case 32:
                if (!B) {
                  _context181.next = 48;
                  break;
                }
                _context181.prev = 33;
                _t80 = _objectSpread(_objectSpread({}, P), {}, {
                  contactId: $
                });
                _context181.next = 37;
                return vi(_t80);
              case 37:
                _r61 = _context181.sent;
                if (!_r61.errorInfo) {
                  _context181.next = 40;
                  break;
                }
                return _context181.abrupt("return", e({
                  type: "EAPPOINTMENT_CREATE_EXISTING_APPT",
                  payload: _r61.errorInfo
                }));
              case 40:
                if (!(Z = null == _r61 || null === (Q = _r61.appointment) || void 0 === Q ? void 0 : Q.apptId, !Z)) {
                  _context181.next = 42;
                  break;
                }
                return _context181.abrupt("return", e(_u("EAPPOINTMENT_CREATE")));
              case 42:
                e({
                  type: "EAPPOINTMENT_CREATE",
                  response: _r61
                });
                _context181.next = 48;
                break;
              case 45:
                _context181.prev = 45;
                _context181.t5 = _context181["catch"](33);
                return _context181.abrupt("return", e(_u("EAPPOINTMENT_CREATE")));
              case 48:
                if (!("courier" === I || "mailbox-delivery" === I || "Drop Shipping" === I)) {
                  _context181.next = 58;
                  break;
                }
                _context181.prev = 49;
                _e94 = d, _t81 = {
                  contactId: $,
                  msisdn: (null == s || null === (ee = s.clientContext) || void 0 === ee || null === (te = ee.subscriptions) || void 0 === te || null === (re = te[0]) || void 0 === re ? void 0 : re.primaryResource) || h,
                  slotCode: _e94.slotCode,
                  slotStartDate: _e94.slotStartDate,
                  slotType: b
                };
                _context181.next = 53;
                return function (e) {
                  var t = e.contactId,
                    r = e.msisdn,
                    n = e.slotCode,
                    o = e.slotStartDate,
                    _e$paymentMode = e.paymentMode,
                    c = _e$paymentMode === void 0 ? "CASH" : _e$paymentMode,
                    _e$dealerCode = e.dealerCode,
                    d = _e$dealerCode === void 0 ? a : _e$dealerCode,
                    _e$slotType = e.slotType,
                    s = _e$slotType === void 0 ? "M" : _e$slotType;
                  return nt("".concat(i, "/sdp/manageAppointment/contact-person/").concat(t, "/reserve-logistics-appointment"), {
                    method: "POST",
                    queryParams: {
                      sc: "SS",
                      lo: "en_US"
                    },
                    body: JSON.stringify({
                      ImplReserveLogisticsDispatchAppointmentInput: {
                        action: "R",
                        slotType: s,
                        contactId: t,
                        msisdn: r,
                        slotQuantity: 1,
                        paymentMode: c,
                        dealerCode: d,
                        implTimeSlot: {
                          slotCode: n,
                          slotStartDate: o
                        }
                      }
                    })
                  });
                }(_t81);
              case 53:
                _context181.next = 58;
                break;
              case 55:
                _context181.prev = 55;
                _context181.t6 = _context181["catch"](49);
                return _context181.abrupt("return", e(_u("RESERVE_LOGISTICS_APPOINTMENT")));
              case 58:
                if (!B) {
                  _context181.next = 81;
                  break;
                }
                _context181.prev = 59;
                _t82 = c.devices.map(function (e) {
                  return e.skuId;
                });
                _ref262 = (null == v ? void 0 : v.selectedStore) || {};
                _r62 = _ref262.mtposId;
                if (!Ui) {
                  _context181.next = 69;
                  break;
                }
                _context181.next = 66;
                return Fi(j, _r62);
              case 66:
                _context181.t7 = _context181.sent;
                _context181.next = 72;
                break;
              case 69:
                _context181.next = 71;
                return Ri(j, _r62);
              case 71:
                _context181.t7 = _context181.sent;
              case 72:
                _n42 = _context181.t7;
                _o21 = xi(_n42, _t82);
                if (!(z = Ou(c.freebies, _n42), _o21)) {
                  _context181.next = 76;
                  break;
                }
                return _context181.abrupt("return", e(_u("OUT_OF_STORE_STOCK")));
              case 76:
                _context181.next = 81;
                break;
              case 78:
                _context181.prev = 78;
                _context181.t8 = _context181["catch"](59);
                return _context181.abrupt("return", e(_u("OUT_OF_STORE_STOCK")));
              case 81:
                ce = [];
                if (!("collect-now" === I && !k)) {
                  _context181.next = 91;
                  break;
                }
                _t83 = p;
                _context181.next = 86;
                return e(ji({
                  skuList: K
                }));
              case 86:
                ce = _context181.sent;
                if (ce) {
                  _context181.next = 89;
                  break;
                }
                return _context181.abrupt("return", e(_u("OUT_OF_LAMP_STOCK")));
              case 89:
                if (ce.find(function (e) {
                  return e.KioskId === _t83.KioskId;
                })) {
                  _context181.next = 91;
                  break;
                }
                return _context181.abrupt("return", e(_u("OUT_OF_LAMP_STOCK")));
              case 91:
                _context181.t9 = R && ("pop-station" === I || "courier" === I);
                if (!_context181.t9) {
                  _context181.next = 97;
                  break;
                }
                _context181.next = 95;
                return e(na({
                  productOrderId: t,
                  items: X,
                  itemSkuToOrderIdMapping: F
                }));
              case 95:
                ne = _context181.sent;
                _context181.t9 = !ne;
              case 97:
                if (!_context181.t9) {
                  _context181.next = 99;
                  break;
                }
                return _context181.abrupt("return", e(_u("ALLOCATE_EQUIPMENT")));
              case 99:
                if (!(S && ("pop-station" === I || "courier" === I || B))) {
                  _context181.next = 107;
                  break;
                }
                X = null === (de = X) || void 0 === de ? void 0 : de.filter(function (e) {
                  var t;
                  return !(null === (t = z) || void 0 === t ? void 0 : t.includes(e.skuId));
                });
                _context181.next = 103;
                return e(ra({
                  productOrderId: t,
                  items: X,
                  customerId: H,
                  selectedStoreId: _,
                  itemSkuToOrderIdMapping: F
                }));
              case 103:
                _r63 = _context181.sent;
                _n43 = null == _r63 || null === (se = _r63.reservationStatusX9) || void 0 === se ? void 0 : se.some(function (e) {
                  return !e.reservationOKX9;
                });
                if (!(!_r63 || _n43)) {
                  _context181.next = 107;
                  break;
                }
                return _context181.abrupt("return", e(_u("RESERVE_EQUIPMENT")));
              case 107:
                if (!("pop-station" === I && d)) {
                  _context181.next = 113;
                  break;
                }
                _t84 = d;
                _context181.next = 111;
                return e(Xi({
                  timeSlotId: _t84.id,
                  serviceId: u,
                  nric: s.userDetails.custId || (null == s || null === (ue = s.clientContext) || void 0 === ue || null === (le = ue.contact) || void 0 === le ? void 0 : le.indentValue)
                }));
              case 111:
                if (_context181.sent) {
                  _context181.next = 113;
                  break;
                }
                return _context181.abrupt("return", e(_u("RESERVE_SELF_COLLECTION_TIME_SLOT")));
              case 113:
                if (!("collect-now" === I && !k)) {
                  _context181.next = 120;
                  break;
                }
                _t85 = p;
                _context181.next = 117;
                return e(ta({
                  skuList: K,
                  collectionPointCode: _t85.KioskId,
                  collectionPointType: _t85.collectionPointType
                }));
              case 117:
                oe = _context181.sent;
                if (oe) {
                  _context181.next = 120;
                  break;
                }
                return _context181.abrupt("return", e(_u("RESERVE_LAMP_EQUIPMENT")));
              case 120:
                _context181.t10 = l || k || B || V;
                if (_context181.t10) {
                  _context181.next = 126;
                  break;
                }
                _context181.next = 124;
                return e(ia(p, I));
              case 124:
                ie = _context181.sent;
                _context181.t10 = ie;
              case 126:
                if (_context181.t10) {
                  _context181.next = 128;
                  break;
                }
                return _context181.abrupt("return", e(_u("RETRIEVE_ADDRESS_ID")));
              case 128:
                if (!(B && (ie = ""), !k || "collect-now" !== I)) {
                  _context181.next = 136;
                  break;
                }
                _context181.next = 131;
                return e(ca({
                  customerId: H,
                  userInfo: s,
                  addressId: l || ie,
                  selectedTimeSlot: d,
                  selectedFulfilmentMode: I,
                  productOrderReferenceNumber: o,
                  productOrderItemId: r,
                  address: p,
                  isNewSimAdded: m,
                  isSnailMail: L,
                  selectedCollectAtStore: _objectSpread(_objectSpread({}, v), {}, {
                    collectATStoreAppt: Z
                  }),
                  isBackOrder: U,
                  isPreOrder: M,
                  isRrpIppOrder: w,
                  deliveryTimeSlot: G
                }));
              case 131:
                ae = _context181.sent;
                if (ae) {
                  _context181.next = 134;
                  break;
                }
                return _context181.abrupt("return", e(_u("UPDATE_DELIVERY")));
              case 134:
                if (!(null === (pe = ae) || void 0 === pe ? void 0 : pe.errorInfo)) {
                  _context181.next = 136;
                  break;
                }
                return _context181.abrupt("return", e(_u("UPDATE_DELIVERY", ae.res)));
              case 136:
                if (!("collect-now" === I && !k)) {
                  _context181.next = 146;
                  break;
                }
                _n44 = p;
                _context181.prev = 138;
                _context181.next = 141;
                return Hc({
                  productOrderId: t,
                  payload: {
                    ImplUpdateOrderDetailRequest: {
                      orderActionData: [{
                        orderActionId: r,
                        orderActionType: "CH",
                        attributes: [{
                          name: "popStationName",
                          value: _n44.POPStationName
                        }, {
                          name: "popStationAddress",
                          value: aa(_n44)
                        }, {
                          name: "popStationCode",
                          value: _n44.KioskId
                        }, {
                          name: "lampTrackingId",
                          value: oe.lampTrackingID
                        }, {
                          name: "trackingID",
                          value: oe.trackingID
                        }, {
                          name: "collectionPointType",
                          value: "LOCKER"
                        }]
                      }]
                    }
                  }
                });
              case 141:
                _context181.next = 146;
                break;
              case 143:
                _context181.prev = 143;
                _context181.t11 = _context181["catch"](138);
                return _context181.abrupt("return", e(_u("UPDATE_ORDER_ACTION_ATTRIBUTES")));
              case 146:
                Ie = [], me = [];
                if (null === (x = z) || void 0 === x ? void 0 : x.length) {
                  me = (null == c || null === (Ee = c.freebies) || void 0 === Ee || null === (Re = Ee.filter(function (e) {
                    return z.includes(e.skuId);
                  })) || void 0 === Re ? void 0 : Re.map(function (e) {
                    return {
                      productID: e.productID
                    };
                  })) || [];
                }
                _context181.next = 150;
                return e(oa({
                  customerId: H,
                  productOrderId: t,
                  productId: n,
                  productOrderItemId: r,
                  removedContainedProducts: me
                }));
              case 150:
                Se = _context181.sent;
                if (Se) {
                  _context181.next = 153;
                  break;
                }
                return _context181.abrupt("return", e(_u("UPDATE_ORDER_PRODUCT")));
              case 153:
                if (!("collect-now" === I && k && y)) {
                  _context181.next = 180;
                  break;
                }
                if (!T) {
                  _context181.next = 166;
                  break;
                }
                _t86 = cu(T);
                _context181.prev = 156;
                _context181.next = 159;
                return e(ou({
                  productOrderReferenceNumber: o,
                  blob: _t86,
                  fileName: "NricFront.jpeg"
                }));
              case 159:
                _e = _context181.sent;
                Ie.push(null === (Oe = _e) || void 0 === Oe || null === (Ce = Oe.value) || void 0 === Ce ? void 0 : Ce.documentIds[0]);
                _context181.next = 166;
                break;
              case 163:
                _context181.prev = 163;
                _context181.t12 = _context181["catch"](156);
                return _context181.abrupt("return", e(_u("UPLOAD_DOCUMENT_NRIC_FRONT")));
              case 166:
                if (!A) {
                  _context181.next = 178;
                  break;
                }
                _t87 = cu(A);
                _context181.prev = 168;
                _context181.next = 171;
                return e(ou({
                  productOrderReferenceNumber: o,
                  blob: _t87,
                  fileName: "NricBack.jpeg"
                }));
              case 171:
                _e = _context181.sent;
                Ie.push(null === (fe = _e) || void 0 === fe || null === (ye = fe.value) || void 0 === ye ? void 0 : ye.documentIds[0]);
                _context181.next = 178;
                break;
              case 175:
                _context181.prev = 175;
                _context181.t13 = _context181["catch"](168);
                return _context181.abrupt("return", e(_u("UPLOAD_DOCUMENT_NRIC_BACK")));
              case 178:
                if (!(!Ie || !Ie.length)) {
                  _context181.next = 180;
                  break;
                }
                return _context181.abrupt("return", e(_u("UPLOAD_DOCUMENT")));
              case 180:
                return _context181.abrupt("return", e(function (e) {
                  return {
                    type: "SUBMIT_FULFILLMENT_SUCCESS",
                    payload: e
                  };
                }({
                  selectedFulfilmentMode: I,
                  delivery: ae,
                  orderProduct: Se,
                  addressId: ie,
                  payChannel: J,
                  allocateMtpos: ne,
                  mtposStock: [],
                  lampStock: ce,
                  document: Ie,
                  outOfStockFreebies: z
                })));
              case 181:
              case "end":
                return _context181.stop();
            }
          }
        }, _callee181, null, [[6, 15], [20, 29], [33, 45], [49, 55], [59, 78], [138, 143], [156, 163], [168, 175]]);
      }));
      return function (_x170) {
        return _ref261.apply(this, arguments);
      };
    }();
  },
  getPopstations: Vi,
  getAddressInfo: Yi,
  checkEquipmentsIsOutOfStock: xi,
  getDeliveryDetails: Hi,
  getLogisticAppointmentsSlots: $i,
  getCollectAtStoreTimeSlots: qi,
  getSelfCollectionTimeSlots: Wi,
  reserveSelfCollectionTimeSlot: Xi,
  getCollectNowStock: ji,
  getMTPOSStock: Ki,
  STORE_AVAILABILITY_ACTIONS: Ji,
  getStoreAvailabilityForMultipleSkus: Zi,
  getStoreAvailability: zi,
  EXTEND_EQUIPMENT_RESERVATION_ACTIONS: Qi,
  extendEquipmentReservation: ea,
  reserveCollectNowStock: ta,
  reserveEquipment: ra,
  allocateEquipment: na,
  updateOrderProduct: oa,
  retrieveAddressId: ia,
  getCollectNowAddress: aa,
  updateDelivery: ca,
  contactView: da,
  eAppointmentCreate: sa,
  eAppointmentCancel: ua,
  DELIVERY_ACTIONS: la,
  submitOrderLoading: su,
  submitOrderSuccess: uu,
  distributePromoCode: pu,
  updateDeviceConfiguration: Iu,
  verifyPaymentsViaCOD: mu,
  onVerifyPayment: Eu,
  BILLING_DETAILS: qd,
  isEBillMethod: Wd,
  setBillingPreference: Xd,
  fetchBillingAccountDetails: jd,
  setBillingAccount: Kd
});
var fu = {
  SAVE_BRIDGE_DATA_ERROR: "SAVE_BRIDGE_DATA_ERROR",
  SAVE_BRIDGE_DATA_LOADING: "SAVE_BRIDGE_DATA_LOADING",
  SAVE_BRIDGE_DATA_SUCCESS: "SAVE_BRIDGE_DATA_SUCCESS",
  RETRIEVE_BRIDGE_DATA_ERROR: "RETRIEVE_BRIDGE_DATA_ERROR",
  RETRIEVE_BRIDGE_DATA_LOADING: "RETRIEVE_BRIDGE_DATA_LOADING",
  RETRIEVE_BRIDGE_DATA_SUCCESS: "RETRIEVE_BRIDGE_DATA_SUCCESS"
};
var yu = Object.freeze({
  __proto__: null,
  BRIDGE_ACTIONS: fu,
  saveBridgeData: function saveBridgeData(e) {
    return /*#__PURE__*/function () {
      var _ref263 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee182(t) {
        return _regeneratorRuntime.wrap(function _callee182$(_context182) {
          while (1) {
            switch (_context182.prev = _context182.next) {
              case 0:
                _context182.prev = 0;
                t({
                  type: fu.SAVE_BRIDGE_DATA_LOADING
                });
                _context182.next = 4;
                return function (e) {
                  return nt(i + "/cache", {
                    method: "PUT",
                    body: JSON.stringify(e)
                  }).then(function (e) {
                    return e;
                  });
                }(e);
              case 4:
                t({
                  type: fu.SAVE_BRIDGE_DATA_SUCCESS
                });
                _context182.next = 10;
                break;
              case 7:
                _context182.prev = 7;
                _context182.t0 = _context182["catch"](0);
                t({
                  type: fu.SAVE_BRIDGE_DATA_ERROR
                });
              case 10:
              case "end":
                return _context182.stop();
            }
          }
        }, _callee182, null, [[0, 7]]);
      }));
      return function (_x171) {
        return _ref263.apply(this, arguments);
      };
    }();
  },
  retrieveBridgeData: function retrieveBridgeData(e) {
    return /*#__PURE__*/function () {
      var _ref264 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee183(t) {
        var r;
        return _regeneratorRuntime.wrap(function _callee183$(_context183) {
          while (1) {
            switch (_context183.prev = _context183.next) {
              case 0:
                t({
                  type: fu.RETRIEVE_BRIDGE_DATA_LOADING
                });
                _context183.prev = 1;
                _context183.next = 4;
                return function (e) {
                  var t = e.uxfToken,
                    r = e.apigeeAuthToken,
                    n = e.key,
                    o = i + "/cache";
                  return t && We(t), r && Ke(r), nt(o, {
                    method: "GET",
                    queryParams: {
                      key: n
                    }
                  }).then(function (e) {
                    return e;
                  });
                }(e);
              case 4:
                r = _context183.sent;
                return _context183.abrupt("return", (t(function (e) {
                  return {
                    type: fu.RETRIEVE_BRIDGE_DATA_SUCCESS,
                    payload: e
                  };
                }(r)), r));
              case 8:
                _context183.prev = 8;
                _context183.t0 = _context183["catch"](1);
                t({
                  type: fu.RETRIEVE_BRIDGE_DATA_ERROR
                });
              case 11:
              case "end":
                return _context183.stop();
            }
          }
        }, _callee183, null, [[1, 8]]);
      }));
      return function (_x172) {
        return _ref264.apply(this, arguments);
      };
    }();
  }
});
var Tu = function Tu(e) {
    var t = e.flowType,
      r = e.redirectUrl;
    return nt(i + "/myInfo/retrieveUrl", {
      method: "POST",
      queryParams: _objectSpread({
        sc: "SS",
        lo: "en_US"
      }, t && {
        flowType: t
      }),
      body: JSON.stringify({
        ImplMyInfoUrlRequest: {
          redirectUrl: r
        }
      })
    }).then(function (e) {
      return e.ImplRetrieveUrlResponse;
    });
  },
  Au = function Au(e) {
    return nt(i + "/myInfo/customer/info", {
      method: "GET",
      queryParams: _objectSpread({
        sc: "SS",
        lo: "en_US"
      }, e && {
        flowType: e
      })
    }).then(function (e) {
      return e;
    });
  };
var Du = Kr(function (e, t) {
    var r, n, o, i, a, c, d, s, u, l;
    e.exports = (n = /(\[[^[]*\])|([-:/.()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, a = /\d*[^\s\d-:/()]+/, d = [/[+-]\d\d:?\d\d/, function (e) {
      var t, r;
      (this.zone || (this.zone = {})).offset = 0 == (r = 60 * (t = e.match(/([+-]|\d\d)/g))[1] + +t[2]) ? 0 : "+" === t[0] ? -r : r;
    }], s = function s(e) {
      var t = r[e];
      return t && (t.indexOf ? t : t.s.concat(t.f));
    }, u = {
      A: [/[AP]M/, function (e) {
        this.afternoon = "PM" === e;
      }],
      a: [/[ap]m/, function (e) {
        this.afternoon = "pm" === e;
      }],
      S: [/\d/, function (e) {
        this.milliseconds = 100 * +e;
      }],
      SS: [o = /\d\d/, function (e) {
        this.milliseconds = 10 * +e;
      }],
      SSS: [/\d{3}/, function (e) {
        this.milliseconds = +e;
      }],
      s: [i = /\d\d?/, (c = function c(e) {
        return function (t) {
          this[e] = +t;
        };
      })("seconds")],
      ss: [i, c("seconds")],
      m: [i, c("minutes")],
      mm: [i, c("minutes")],
      H: [i, c("hours")],
      h: [i, c("hours")],
      HH: [i, c("hours")],
      hh: [i, c("hours")],
      D: [i, c("day")],
      DD: [o, c("day")],
      Do: [a, function (e) {
        var t = r.ordinal,
          n = e.match(/\d+/);
        if (this.day = n[0], t) for (var o = 1; o <= 31; o += 1) {
          t(o).replace(/\[|\]/g, "") === e && (this.day = o);
        }
      }],
      M: [i, c("month")],
      MM: [o, c("month")],
      MMM: [a, function (e) {
        var t = s("months"),
          r = (s("monthsShort") || t.map(function (e) {
            return e.substr(0, 3);
          })).indexOf(e);
        if (r < 0) throw new Error();
        this.month = (r + 1) % 12;
      }],
      MMMM: [a, function (e) {
        var t = s("months").indexOf(e);
        if (t < 0) throw new Error();
        this.month = (t + 1) % 12;
      }],
      Y: [/[+-]?\d+/, c("year")],
      YY: [o, function (e) {
        e = +e, this.year = e + (e > 68 ? 1900 : 2e3);
      }],
      YYYY: [/\d{4}/, c("year")],
      Z: d,
      ZZ: d
    }, l = function l(e, t, r) {
      try {
        var o = function (e) {
            for (var t = e.match(n), r = t.length, o = 0; o < r; o += 1) {
              var i = t[o],
                a = u[i],
                c = a && a[0],
                d = a && a[1];
              t[o] = d ? {
                regex: c,
                parser: d
              } : i.replace(/^\[|\]$/g, "");
            }
            return function (e) {
              for (var n = {}, o = 0, i = 0; o < r; o += 1) {
                var a = t[o];
                if ("string" == typeof a) i += a.length;else {
                  var c = a.regex,
                    d = a.parser,
                    s = e.substr(i),
                    u = c.exec(s)[0];
                  d.call(n, u), e = e.replace(u, "");
                }
              }
              return function (e) {
                var t = e.afternoon;
                if (void 0 !== t) {
                  var r = e.hours;
                  t ? r < 12 && (e.hours += 12) : 12 === r && (e.hours = 0), delete e.afternoon;
                }
              }(n), n;
            };
          }(t)(e),
          i = o.year,
          a = o.month,
          c = o.day,
          d = o.hours,
          s = o.minutes,
          l = o.seconds,
          p = o.milliseconds,
          I = o.zone,
          m = new Date(),
          E = c || (i || a ? 1 : m.getDate()),
          R = i || m.getFullYear(),
          S = 0;
        i && !a || (S = a > 0 ? a - 1 : m.getMonth());
        var _ = d || 0,
          O = s || 0,
          C = l || 0,
          f = p || 0;
        return I ? new Date(Date.UTC(R, S, E, _, O, C, f + 60 * I.offset * 1e3)) : r ? new Date(Date.UTC(R, S, E, _, O, C, f)) : new Date(R, S, E, _, O, C, f);
      } catch (e) {
        return new Date("");
      }
    }, function (e, t, n) {
      var o = t.prototype,
        i = o.parse;
      o.parse = function (e) {
        var t = e.date,
          o = e.utc,
          a = e.args;
        this.$u = o;
        var c = a[1];
        if ("string" == typeof c) {
          var d = !0 === a[2],
            s = !0 === a[3],
            u = d || s,
            p = a[2];
          s && (p = a[2]), d || (r = p ? n.Ls[p] : this.$locale()), this.$d = l(t, c, o), this.init(), p && !0 !== p && (this.$L = this.locale(p).$L), u && t !== this.format(c) && (this.$d = new Date(""));
        } else if (c instanceof Array) for (var I = c.length, m = 1; m <= I; m += 1) {
          a[1] = c[m - 1];
          var E = n.apply(this, a);
          if (E.isValid()) {
            this.$d = E.$d, this.$L = E.$L, this.init();
            break;
          }
          m === I && (this.$d = new Date(""));
        } else i.call(this, e);
      };
    });
  }),
  Pu = Kr(function (e, t) {
    e.exports = function (e, t) {
      t.prototype.isSameOrAfter = function (e, t) {
        return this.isSame(e, t) || this.isAfter(e, t);
      };
    };
  });
bn.extend(Du), bn.extend(Pu), bn.extend(Un);
var vu = function vu(e, t) {
    var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
      now: new Date()
    };
    var n = bn(e, "DD/MM/YYYY");
    return bn(gu(n, t), "DD/MM/YYYY").isSameOrBefore(r.now);
  },
  hu = function hu(e, t) {
    var r = bn(e.valueName, "DD/MM/YYYY"),
      n = bn(t.valueName, "DD/MM/YYYY");
    return r.isBefore(n) ? 1 : -1;
  },
  gu = function gu() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : bn();
    var t = arguments.length > 1 ? arguments[1] : undefined;
    return bn(e, "DD/MM/YYYY").add(t, "month").date(1).hour(0).minute(0).second(0).millisecond(0).format("DD/MM/YYYY");
  },
  Nu = function Nu() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : bn();
    return bn(e, "DD/MM/YYYY").add(12, "month").date(1).hour(0).minute(0).second(0).millisecond(0).format("DD/MM/YYYY");
  };
var bu = function bu(e) {
    var t = e.contactId;
    return nt("".concat(i, "/contact-person/").concat(t, "/retrieve-data-for-li-hook-for-eshop"), {
      method: "GET",
      queryParams: {
        sc: "SS",
        lo: "en_US"
      }
    }).then(function (e) {
      return e.ImplRetrieveDataLiHookOutput;
    });
  },
  Lu = {
    aem: {
      offlineStockAvailability: function offlineStockAvailability(e) {
        var t = "".concat(Ni, "/bin/services/singtel/getEshopStockData.:groupId=").concat(e, ".json");
        return window.mockEnabled && "function" == typeof window.fetchMock ? window.fetchMock(t, {}, Ni) : fetch(encodeURI(t), {
          method: "GET"
        }).then(function (e) {
          return e.json();
        });
      }
    },
    mcss: {
      billingOffer: cn,
      callerByContact: is,
      cceValidateSessiontoken: ht,
      numberPort: sc,
      onePassHeaders: Ct,
      productConfiguration: nn,
      productOrder: ai,
      rrpRetrieveMasterOrder: dd,
      rrpSetDeliveryDetails: function rrpSetDeliveryDetails(e) {
        var t = e.rrpMasterOrderId,
          r = e.payload;
        return nt("".concat(i, "/rrp/order/rrp-master-order-id/").concat(t, "/set-delivery-details"), {
          method: "POST",
          queryParams: {
            sc: "SS",
            lo: "en_US"
          },
          body: JSON.stringify({
            ImplRRPOrdersDeliveryDetailRequest: {
              detailsForOrders: r
            }
          })
        }).then(function (e) {
          return e.ImplRRPOrderDeliveryDetailsResponse;
        });
      },
      rrpReserveLogisticsAppointment: function rrpReserveLogisticsAppointment(e) {
        var t = e.rrpMasterOrderId,
          r = e.rrpOrderId,
          n = e.payload;
        return nt("".concat(i, "/rrp/order/rrp-master-order-id/").concat(t, "/rrp-order-id/").concat(r, "/reserve-logistics-appointment"), {
          method: "POST",
          queryParams: {
            sc: "SS",
            lo: "en_US"
          },
          body: JSON.stringify({
            ImplReserveLogisticsDispatchAppointmentInput: n
          })
        }).then(function (e) {
          return null == e ? void 0 : e.ImplReserveLogisticsDispatchAppointmentOutput;
        });
      },
      rrpAddMasterOrder: sd,
      rrpRemoveMasterOrder: ud,
      rrpCancelMasterOrder: ld,
      productOrderDelete: we,
      reserveResource: dn,
      retrieveProductConfigurationOptions: sn,
      searchNumbers: Hr,
      stockAvailability: Ri,
      storeAvailability: Si,
      submitProductConfiguration: an,
      userInformation: Dt,
      userOrders: Fe,
      customerProduct: vt,
      userProducts: Pt,
      worryFreeDelete: At,
      worryFreeOtpSend: ft,
      worryFreeVerify: yt,
      contactPerson: Vd,
      helpers: Ot,
      helpersAddons: io,
      helpersCart: Xo,
      helpersCheckout: os,
      helpersService: Object.freeze({
        __proto__: null,
        isCI12Eligible: function isCI12Eligible(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : bn();
          var r = bn(e, "DD/MM/YYYY");
          if (r.isSameOrAfter(bn("17/09/2019", "DD/MM/YYYY"))) {
            return bn(Nu(r), "DD/MM/YYYY").isSameOrBefore(bn(t, "DD/MM/YYYY"));
          }
          return !0;
        },
        isCIEligible: vu,
        isCIEligibleForRecontract: function isCIEligibleForRecontract(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var r = e.devices;
          if (r && r.length > 0) {
            var _e95 = r.filter(function (e) {
                return "Device_Contract" === e.catalogItemDescription;
              }).map(function (e) {
                return e.parameters.find(function (e) {
                  return e.catalogId === s.DEVICE_CONTRACT_START_DATE;
                });
              }).filter(Boolean).sort(hu),
              _n45 = _e95.length > 0 && _e95[0].valueName;
            if (_n45) return vu(_n45, t.contractEligibleMonths || 12);
          }
          return !0;
        },
        isCI10Eligible: function isCI10Eligible(e) {
          var t = e.services;
          if ((null == t ? void 0 : t.length) > 0) {
            var _t$find = t.find(function (_ref265) {
                var e = _ref265.catalogItemID;
                return e === s.PLAN_SERVICES_ITEM;
              }),
              _e96 = _t$find.containedServices,
              r = _e96.filter(function (_ref266) {
                var e = _ref266.catalogItemName;
                return "Service Contract" === e;
              }).map(function (_ref267) {
                var e = _ref267.parameters;
                return e.find(function (_ref268) {
                  var e = _ref268.catalogId;
                  return e === s.SERVICE_CONTRACT_END_DATE;
                });
              }).filter(Boolean),
              _n46 = r.length > 0 && r[0].valueName;
            if (_n46) {
              var _e97 = bn(_n46, "DD/MM/YYYY").subtract(2, "month").date(1).hour(0).minute(0).second(0).millisecond(0).format("DD/MM/YYYY");
              return bn(bn(), "DD/MM/YYYY").isSameOrAfter(bn(_e97, "DD/MM/YYYY"));
            }
          }
          return !0;
        },
        isCINoContract: function isCINoContract(e) {
          var t = e.services;
          if ((null == t ? void 0 : t.length) > 0) {
            var _t$find2 = t.find(function (_ref269) {
                var e = _ref269.catalogItemID;
                return e === s.PLAN_SERVICES_ITEM;
              }),
              _e98 = _t$find2.containedServices,
              r = _e98.filter(function (_ref270) {
                var e = _ref270.catalogItemName;
                return "Service Contract" === e;
              }).map(function (_ref271) {
                var e = _ref271.parameters;
                return e.find(function (_ref272) {
                  var e = _ref272.catalogId;
                  return e === s.SERVICE_CONTRACT_DURATION;
                });
              }).filter(Boolean);
            if ("1 Months" === (r.length > 0 && r[0].valueName)) return !0;
          }
          return !1;
        },
        isPPRecontractEligible: function isPPRecontractEligible(e) {
          var t = e.services;
          if ((null == t ? void 0 : t.length) > 0) {
            var _t$find3 = t.find(function (_ref273) {
                var e = _ref273.catalogItemID;
                return e === s.PLAN_SERVICES_ITEM;
              }),
              _e99 = _t$find3.containedServices,
              r = _e99.filter(function (_ref274) {
                var e = _ref274.catalogItemName;
                return "Service Contract" === e;
              }).map(function (_ref275) {
                var e = _ref275.parameters;
                return e.find(function (_ref276) {
                  var e = _ref276.catalogId;
                  return e === s.SERVICE_CONTRACT_END_DATE;
                });
              }).filter(Boolean),
              _n47 = r.length > 0 && r[0].valueName;
            if (_n47) {
              var _e100 = bn(_n47, "DD/MM/YYYY").subtract(1, "month").date(1).hour(0).minute(0).second(0).millisecond(0).format("DD/MM/YYYY");
              return bn(bn(), "DD/MM/YYYY").isSameOrAfter(bn(_e100, "DD/MM/YYYY"));
            }
          }
          return !0;
        },
        getCIEligibleDate: gu,
        getCI12EligibleDate: Nu,
        getCIEligibleDateForRecontract: function getCIEligibleDateForRecontract(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var r = e.devices;
          if (r && r.length > 0) {
            var _e101 = r.filter(function (e) {
                return "Device_Contract" === e.catalogItemDescription;
              }).map(function (e) {
                return e.parameters.find(function (e) {
                  return e.catalogId === s.DEVICE_CONTRACT_START_DATE;
                });
              }).filter(Boolean).sort(hu),
              _n48 = _e101.length > 0 && _e101[0].valueName;
            if (_n48) return gu(_n48, t.contractEligibleMonths || 12);
          }
          return null;
        }
      }),
      getPopstations: Ei,
      apiSelfCollectionTimeSlots: mi,
      apiRetrieveLogisticAppointmentsSlots: Ti,
      apiRetrieveCollectAtStoreTimeSlots: Ai,
      apiRetrieveAddress: Di,
      apiEAppointmentView: Pi,
      apiEAppointmentCancel: hi,
      apiEAppointmentCreate: vi,
      apiMyinfoRetrieveUrl: Tu,
      apiMyinfoCustomerInfo: Au,
      apiCreditLimitReview: function apiCreditLimitReview(_ref277) {
        var e = _ref277.myInfoUserData,
          t = _ref277.flowType;
        return nt(i + "/credit/platform/review/credit/limit", {
          method: "POST",
          queryParams: {
            sc: "SS",
            lo: "en_US",
            flowType: t
          },
          body: JSON.stringify({
            ImplCustomerInfoRequest: e
          })
        }).then(function (e) {
          return e.ImplReviewCreditLimitResponse;
        });
      },
      apiVerifyPaymentApi: Na,
      apiRrpSubmitOrder: function apiRrpSubmitOrder(e) {
        var t = e.rrpMasterOrderId;
        return nt("".concat(i, "/rrp/order/rrp-master-order-id/").concat(t, "/submit-order"), {
          method: "POST",
          queryParams: {
            sc: "SS",
            lo: "en_US"
          },
          body: JSON.stringify({
            ImplRRPSubmitOrderRequest: {}
          })
        }).then(function (e) {
          return e;
        });
      },
      retrievePublicKey: bu
    },
    onlineApi: {
      revokeToken: function revokeToken(e) {
        var t = bi + "/api/sg/v1/idpf-auth/token/revoke",
          r = {
            method: "DELETE",
            body: JSON.stringify({
              accessToken: e
            })
          };
        return nt(t, r, !0).then(function (e) {
          return e.body;
        });
      },
      eShopLogisticAppointmentsSlots: Bi,
      eShopSelfCollectionTimeslots: Gi,
      eShopStockAvailability: Fi,
      eShopStoreAvailability: ki,
      eShopInitiateEkyc: Fs,
      eShopVerifyEkyc: Gs
    }
  },
  Uu = function Uu(e) {
    return {
      type: "ORDER_SUBMISSION_ERROR",
      value: e
    };
  },
  Mu = function Mu(e) {
    var t, r;
    var n = e.userInfo,
      o = e.productOrderId,
      i = e.productOrderReferenceNumber,
      a = n.clientContext,
      c = a.billingArrangements,
      d = a.contact,
      s = a.customers,
      u = null === (t = s[0]) || void 0 === t ? void 0 : t.customerId,
      l = null == d ? void 0 : d.contactId,
      p = null === (r = c[0]) || void 0 === r ? void 0 : r.barId;
    return /*#__PURE__*/function () {
      var _ref278 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee184(e) {
        var t, r, _e102, _t88;
        return _regeneratorRuntime.wrap(function _callee184$(_context184) {
          while (1) {
            switch (_context184.prev = _context184.next) {
              case 0:
                e(function () {
                  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
                  return {
                    type: "ORDER_SUBMISSION_LOADING",
                    value: e
                  };
                }());
                _context184.prev = 1;
                _context184.next = 4;
                return Ia({
                  customerId: u,
                  productOrderId: o,
                  productOrderReferenceNumber: i
                });
              case 4:
                _context184.next = 9;
                break;
              case 6:
                _context184.prev = 6;
                _context184.t0 = _context184["catch"](1);
                return _context184.abrupt("return", e(Uu()));
              case 9:
                _context184.prev = 9;
                _context184.next = 12;
                return Id({
                  contactId: l
                });
              case 12:
                _e102 = _context184.sent;
                _context184.t1 = "0" !== (null == _e102 ? void 0 : _e102.currentCreditRating);
                if (!_context184.t1) {
                  _context184.next = 18;
                  break;
                }
                _context184.next = 17;
                return pd({
                  contactId: l
                });
              case 17:
                r = _context184.sent;
              case 18:
                _context184.next = 23;
                break;
              case 20:
                _context184.prev = 20;
                _context184.t2 = _context184["catch"](9);
                return _context184.abrupt("return", e(Uu()));
              case 23:
                if (!(r && !(null === (t = r) || void 0 === t ? void 0 : t.success))) {
                  _context184.next = 25;
                  break;
                }
                return _context184.abrupt("return", e(Uu()));
              case 25:
                _context184.prev = 25;
                _context184.next = 28;
                return La({
                  baStatuses: ["X", "T"],
                  barId: p,
                  isOrderConfirm: !0
                });
              case 28:
                _t88 = _context184.sent;
                return _context184.abrupt("return", e({
                  type: "ORDER_SUBMISSION_SUCCESS",
                  value: {
                    billEntity: _t88
                  }
                }));
              case 32:
                _context184.prev = 32;
                _context184.t3 = _context184["catch"](25);
                return _context184.abrupt("return", e(Uu()));
              case 35:
              case "end":
                return _context184.stop();
            }
          }
        }, _callee184, null, [[1, 6], [9, 20], [25, 32]]);
      }));
      return function (_x173) {
        return _ref278.apply(this, arguments);
      };
    }();
  },
  wu = function wu(e) {
    return {
      type: Sr.UIAM.GET_UIAM_STATE_ERROR,
      value: e
    };
  },
  Gu = function Gu(e) {
    return {
      type: Sr.UIAM.SET_UIAM_TARGET_URL_ERROR,
      value: e
    };
  };
var Fu = Object.freeze({
  __proto__: null,
  getUIAMStateId: function getUIAMStateId(t) {
    return /*#__PURE__*/function () {
      var _ref279 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee185(r) {
        var o, n;
        return _regeneratorRuntime.wrap(function _callee185$(_context185) {
          while (1) {
            switch (_context185.prev = _context185.next) {
              case 0:
                r({
                  type: Sr.UIAM.GET_UIAM_STATE_LOADING,
                  value: !0
                });
                _context185.prev = 1;
                _context185.next = 4;
                return function (t) {
                  return nt(e + "/api/sg/v1/baas/relocator/states/retrieve", {
                    method: "POST",
                    body: JSON.stringify(t)
                  }).then(function (e) {
                    return e;
                  });
                }({
                  targetUrl: t
                });
              case 4:
                o = _context185.sent;
                o.error ? r(wu(o)) : r((n = o.body, {
                  type: Sr.UIAM.GET_UIAM_STATE_ID_SUCCESS,
                  value: n
                }));
                _context185.next = 11;
                break;
              case 8:
                _context185.prev = 8;
                _context185.t0 = _context185["catch"](1);
                r(wu(_context185.t0));
              case 11:
              case "end":
                return _context185.stop();
            }
          }
        }, _callee185, null, [[1, 8]]);
      }));
      return function (_x174) {
        return _ref279.apply(this, arguments);
      };
    }();
  },
  retrieveUIAMTargetUrl: function retrieveUIAMTargetUrl(t) {
    return /*#__PURE__*/function () {
      var _ref280 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee186(r) {
        var o, n;
        return _regeneratorRuntime.wrap(function _callee186$(_context186) {
          while (1) {
            switch (_context186.prev = _context186.next) {
              case 0:
                r({
                  type: Sr.UIAM.SET_UIAM_TARGET_URL_LOADING,
                  value: !0
                });
                _context186.prev = 1;
                _context186.next = 4;
                return function (t) {
                  var r = t.accessToken,
                    n = t.refreshToken,
                    o = t.stateId,
                    i = {
                      accessToken: r,
                      refreshToken: n,
                      stateId: o
                    };
                  return nt(e + "/api/sg/v1/baas/relocator/targets/retrieve", {
                    method: "POST",
                    body: JSON.stringify(i)
                  }).then(function (e) {
                    return e.body;
                  });
                }(t);
              case 4:
                o = _context186.sent;
                o.error ? r(Gu()) : r((n = o, {
                  type: Sr.UIAM.SET_UIAM_TARGET_URL_SUCCESS,
                  value: n
                }));
                _context186.next = 11;
                break;
              case 8:
                _context186.prev = 8;
                _context186.t0 = _context186["catch"](1);
                r(Gu());
              case 11:
              case "end":
                return _context186.stop();
            }
          }
        }, _callee186, null, [[1, 8]]);
      }));
      return function (_x175) {
        return _ref280.apply(this, arguments);
      };
    }();
  }
});
var ku = {
    "blocked-otp-verification": fr.OTP_LIMIT_REACHED,
    "otp-not-verified": fr.INVALID_OTP,
    "exceed-otp-limit": fr.OTP_LIMIT_REACHED,
    "expired-otp": fr.EXPIRED_OTP,
    "internal-server-error": fr.OTP_API_DOWN,
    "mfa-api-failed": fr.OTP_API_DOWN
  },
  Bu = function Bu(e) {
    var t = Ea(e.backendErrorInfo.replace(/(^.*\[|\].*$)/g, ""));
    return ku[t] || fr.OTP_API_DOWN;
  };
var Vu = Object.freeze({
  __proto__: null,
  registerCustomer: function registerCustomer(e) {
    return /*#__PURE__*/function () {
      var _ref281 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee187(t) {
        var r, _e103;
        return _regeneratorRuntime.wrap(function _callee187$(_context187) {
          while (1) {
            switch (_context187.prev = _context187.next) {
              case 0:
                _context187.prev = 0;
                t({
                  type: Sr.RRP.REGISTER_CUSTOMER_LOADING
                });
                _context187.next = 4;
                return function (e) {
                  var t = e.rrpMasterOrderId,
                    r = e.userInfo,
                    n = r.email,
                    o = r.name,
                    a = r.otp,
                    c = r.phone;
                  return nt("".concat(i, "/rrp/customer/rrp-master-order-id/").concat(t, "/register-customer"), {
                    method: "POST",
                    body: JSON.stringify({
                      ImplRRPCustomerDetailsRequest: {
                        name: o,
                        email: n,
                        phone: c,
                        otp: a
                      }
                    })
                  }).then(function (e) {
                    return e;
                  }).catch(function (e) {
                    return _r(e);
                  });
                }(e);
              case 4:
                r = _context187.sent;
                if (!(null == r ? void 0 : r.ImplRRPCustomerRegistrationResponse)) {
                  _context187.next = 7;
                  break;
                }
                return _context187.abrupt("return", (t({
                  type: Sr.RRP.REGISTER_CUSTOMER_SUCCESS,
                  data: r.ImplRRPCustomerRegistrationResponse
                }), null == r ? void 0 : r.ImplRRPCustomerRegistrationResponse));
              case 7:
                _e103 = Bu(null == r ? void 0 : r.ErrorInfo);
                return _context187.abrupt("return", (t({
                  type: Sr.RRP.REGISTER_CUSTOMER_ERROR,
                  data: {
                    errorCode: _e103
                  }
                }), _objectSpread(_objectSpread({}, r), {}, {
                  errorCode: _e103
                })));
              case 11:
                _context187.prev = 11;
                _context187.t0 = _context187["catch"](0);
                t({
                  type: Sr.RRP.REGISTER_CUSTOMER_ERROR,
                  errorCode: fr.OTP_API_DOWN
                });
              case 14:
              case "end":
                return _context187.stop();
            }
          }
        }, _callee187, null, [[0, 11]]);
      }));
      return function (_x176) {
        return _ref281.apply(this, arguments);
      };
    }();
  },
  sendOtp: function sendOtp(e) {
    return /*#__PURE__*/function () {
      var _ref282 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee188(t) {
        var r, _e104;
        return _regeneratorRuntime.wrap(function _callee188$(_context188) {
          while (1) {
            switch (_context188.prev = _context188.next) {
              case 0:
                _context188.prev = 0;
                t({
                  type: Sr.RRP.SEND_OTP_LOADING
                });
                _context188.next = 4;
                return function (e) {
                  var t = e.rrpMasterOrderId,
                    r = e.userInfo,
                    n = r.email,
                    o = r.name,
                    a = r.phone;
                  return nt("".concat(i, "/rrp/customer/rrp-master-order-id/").concat(t, "/send-otp"), {
                    method: "POST",
                    body: JSON.stringify({
                      ImplRRPCustomerDetailsRequest: {
                        name: o,
                        email: n,
                        phone: a
                      }
                    })
                  }).then(function (e) {
                    return e.ImplRRPCustomerRegistrationResponse;
                  }).catch(function (e) {
                    return _r(e);
                  });
                }(e);
              case 4:
                r = _context188.sent;
                if (!(null == r ? void 0 : r.isOtpSend)) {
                  _context188.next = 7;
                  break;
                }
                return _context188.abrupt("return", (t({
                  type: Sr.RRP.SEND_OTP_SUCCESS,
                  data: r
                }), r));
              case 7:
                _e104 = Bu(null == r ? void 0 : r.ErrorInfo);
                return _context188.abrupt("return", (t({
                  type: Sr.RRP.SEND_OTP_ERROR,
                  data: {
                    errorCode: _e104,
                    errorInfo: null == r ? void 0 : r.ErrorInfo
                  }
                }), _objectSpread(_objectSpread({}, r), {}, {
                  errorCode: _e104
                })));
              case 11:
                _context188.prev = 11;
                _context188.t0 = _context188["catch"](0);
                t({
                  type: Sr.RRP.SEND_OTP_ERROR,
                  errorCode: fr.OTP_API_DOWN
                });
              case 14:
              case "end":
                return _context188.stop();
            }
          }
        }, _callee188, null, [[0, 11]]);
      }));
      return function (_x177) {
        return _ref282.apply(this, arguments);
      };
    }();
  },
  resendOtp: function resendOtp(e) {
    return /*#__PURE__*/function () {
      var _ref283 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee189(t) {
        var r, _e105;
        return _regeneratorRuntime.wrap(function _callee189$(_context189) {
          while (1) {
            switch (_context189.prev = _context189.next) {
              case 0:
                _context189.prev = 0;
                t({
                  type: Sr.RRP.RESEND_OTP_LOADING
                });
                _context189.next = 4;
                return function (e) {
                  var t = e.rrpMasterOrderId,
                    r = e.userInfo,
                    n = r.email,
                    o = r.name,
                    a = r.phone;
                  return nt("".concat(i, "/rrp/customer/rrp-master-order-id/").concat(t, "/resend-otp"), {
                    method: "POST",
                    body: JSON.stringify({
                      ImplRRPCustomerDetailsRequest: {
                        name: o,
                        email: n,
                        phone: a
                      }
                    })
                  }).then(function (e) {
                    return null == e ? void 0 : e.ImplRRPCustomerRegistrationResponse;
                  }).catch(function (e) {
                    return _r(e);
                  });
                }(e);
              case 4:
                r = _context189.sent;
                if (!(null == r ? void 0 : r.isOtpSend)) {
                  _context189.next = 7;
                  break;
                }
                return _context189.abrupt("return", (t({
                  type: Sr.RRP.RESEND_OTP_SUCCESS,
                  data: r
                }), r));
              case 7:
                _e105 = Bu(null == r ? void 0 : r.ErrorInfo);
                return _context189.abrupt("return", (t({
                  type: Sr.RRP.RESEND_OTP_ERROR,
                  errorCode: _e105
                }), _objectSpread(_objectSpread({}, r), {}, {
                  errorCode: _e105
                })));
              case 11:
                _context189.prev = 11;
                _context189.t0 = _context189["catch"](0);
                t({
                  type: Sr.RRP.RESEND_OTP_ERROR,
                  errorCode: fr.OTP_API_DOWN
                });
              case 14:
              case "end":
                return _context189.stop();
            }
          }
        }, _callee189, null, [[0, 11]]);
      }));
      return function (_x178) {
        return _ref283.apply(this, arguments);
      };
    }();
  }
});
var Yu = {
  RETRIEVE_TOKEN_LOADING: "RETRIEVE_TOKEN_LOADING",
  RETRIEVE_TOKEN_SUCCESS: "RETRIEVE_TOKEN_SUCCESS",
  RETRIEVE_TOKEN_ERROR: "RETRIEVE_TOKEN_ERROR"
};
var xu = Object.freeze({
  __proto__: null,
  getEncryptionToken: function getEncryptionToken(_ref284) {
    var e = _ref284.contactId;
    return /*#__PURE__*/function () {
      var _ref285 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee190(t) {
        var r;
        return _regeneratorRuntime.wrap(function _callee190$(_context190) {
          while (1) {
            switch (_context190.prev = _context190.next) {
              case 0:
                t({
                  type: Yu.RETRIEVE_TOKEN_LOADING
                });
                _context190.prev = 1;
                _context190.next = 4;
                return bu({
                  contactId: e
                });
              case 4:
                r = _context190.sent;
                return _context190.abrupt("return", (t({
                  type: Yu.RETRIEVE_TOKEN_SUCCESS
                }), r));
              case 8:
                _context190.prev = 8;
                _context190.t0 = _context190["catch"](1);
                return _context190.abrupt("return", t({
                  type: Yu.RETRIEVE_TOKEN_ERROR
                }));
              case 11:
              case "end":
                return _context190.stop();
            }
          }
        }, _callee190, null, [[1, 8]]);
      }));
      return function (_x179) {
        return _ref285.apply(this, arguments);
      };
    }();
  },
  actionType: Yu
});
var Hu = function Hu() {
    return {
      type: Sr.CUSTOMER_MY_INFO.RETRIEVE_MY_INFO_URL_FAILURE
    };
  },
  $u = function $u() {
    return {
      type: Sr.CUSTOMER_MY_INFO.GET_CUSTOMER_MY_INFO_FAILURE
    };
  };
var qu = Object.freeze({
  __proto__: null,
  retrieveMyInfoURL: function retrieveMyInfoURL(e) {
    return /*#__PURE__*/function () {
      var _ref286 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee191(t) {
        var _n49, r;
        return _regeneratorRuntime.wrap(function _callee191$(_context191) {
          while (1) {
            switch (_context191.prev = _context191.next) {
              case 0:
                t({
                  type: Sr.CUSTOMER_MY_INFO.RETRIEVE_MY_INFO_URL_LOADING
                });
                _context191.prev = 1;
                _context191.next = 4;
                return Tu(e);
              case 4:
                _n49 = _context191.sent;
                t(_n49 ? (r = _n49, {
                  type: Sr.CUSTOMER_MY_INFO.RETRIEVE_MY_INFO_URL_SUCCESS,
                  value: r
                }) : Hu());
                _context191.next = 11;
                break;
              case 8:
                _context191.prev = 8;
                _context191.t0 = _context191["catch"](1);
                t(Hu());
              case 11:
              case "end":
                return _context191.stop();
            }
          }
        }, _callee191, null, [[1, 8]]);
      }));
      return function (_x180) {
        return _ref286.apply(this, arguments);
      };
    }();
  },
  getCustomerMyInfo: function getCustomerMyInfo() {
    return /*#__PURE__*/function () {
      var _ref287 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee192(e) {
        var r, t;
        return _regeneratorRuntime.wrap(function _callee192$(_context192) {
          while (1) {
            switch (_context192.prev = _context192.next) {
              case 0:
                e({
                  type: Sr.CUSTOMER_MY_INFO.GET_CUSTOMER_MY_INFO_LOADING
                });
                _context192.prev = 1;
                _context192.next = 4;
                return Au();
              case 4:
                r = _context192.sent;
                e(r ? (t = r, {
                  type: Sr.CUSTOMER_MY_INFO.GET_CUSTOMER_MY_INFO_SUCCESS,
                  value: t
                }) : $u());
                _context192.next = 11;
                break;
              case 8:
                _context192.prev = 8;
                _context192.t0 = _context192["catch"](1);
                e($u());
              case 11:
              case "end":
                return _context192.stop();
            }
          }
        }, _callee192, null, [[1, 8]]);
      }));
      return function (_x181) {
        return _ref287.apply(this, arguments);
      };
    }();
  }
});
export { Sr as ACTION_TYPES, ar as ADDITIONAL_VERIFY_ERROR, Rr as CIS_GET_MYINFO_ERROR, mr as CIS_GET_MYINFO_ERROR_STATUS, pr as CIS_GET_MYINFO_LOADING, Er as CIS_GET_MYINFO_MISMATCH_ERROR, Ir as CIS_GET_MYINFO_SUCCESS, Ls as EKYC_INITIALIZATION_FAILURE, Ns as EKYC_INITIALIZATION_LOADING, bs as EKYC_INITIALIZATION_SUCCESS, ws as EKYC_VERIFICATION_FAILURE, Us as EKYC_VERIFICATION_LOADING, Ms as EKYC_VERIFICATION_SUCCESS, Yd as EquipmentType, mc as GA_TRACKING_PORT_IN_SUCCESS, lr as LOGGED_IN, dr as NEW_CUSTOMER_TO_MOBILE, cr as NEW_NEW_CUSTOMER, uc as ORDER_GENERIC_ERROR, lc as ORDER_PENDING_ORDER, fr as OTP_ERROR_CODES, tr as OTP_EXCEED_LIMIT_ERROR, ir as OTP_GENERIC_ERROR, er as OTP_MISMATCH_ERROR, Qt as OTP_RESEND_SUCCESS, zt as OTP_SENT, or as OTP_TIMEOUT_ERROR, rr as OTP_VERIFIED, nr as OTP_VERIFY_ERROR, Ic as PORT_IN_NUMBER_GENERIC_ERROR, pc as PORT_IN_SUBMITTED_ORDER_FOUND, Ht as RESET_AUTH, $t as RESET_WORRY_FREE, Wt as RESET_WORRY_FREE_STATUS, Xt as SET_AUTH_STATUS, Kt as SET_UXF_AUTH_TOKEN, jt as SET_WORRY_FREE_DETAILS, Jt as SET_WORRY_FREE_LOADING, qt as SET_WORRY_FREE_STATUS, Zt as WORRY_FREE_ACCOUNT_VERIFIED, sr as WORRY_FREE_FA_CHECK, ur as WORRY_FREE_OTP, Wc as accessoryActions, cd as addonsActions, Lu as api, Gr as apigeeAuthActions, wr as authActions, yu as bridgeActions, va as cartActions, xr as catalogBannerActions, Ws as checkoutActions, g as config, qu as customerMyInfoActions, Vs as ekycActions, ss as errorScenarioActions, Cu as fulFillmentActions, au as fulFillmentDocActions, Jd as fulfillmentBillingDetailsActions, pa as fulfillmentDeliveryActions, Qd as fulfillmentDocumentUploadActions, Ru as fulfillmentSummaryActions, _r as getDataFromErrorRes, Fd as iphoneActions, Xr as ngnisActions, Pc as orderActions, Mu as orderSubmissionSuccessActions, Va as orderSummaryActions, Vc as planActions, Ii as planHelpers, Lt as productActions, oi as promoActions, xc as rootActions, Gd as rrpCartActions, Vu as rrpCheckoutActions, Bc as rrpOrderSummaryActions, xu as tokenActions, Fu as uiamActions, xt as userActions, si as userHelpers, zs as voucherActions };